{
  "monitors": {
    "alwaysOffer": "Continuar sugerindo monitoramento para: {{type}}",
    "watching": "Monitorando",
    "tasks": "A fazer",
    "tabsLabel": "Visualização da DoBox",
    "newWatcher": "Novo monitor",
    "watchSomething": "Acompanhe algo",
    "createDescription": "Uma entrega, um contrato, uma aprovação. Defina o que esperar e onde acompanhar.",
    "emptyTitle": "Nenhum monitor ativo",
    "emptyDescription": "Quando um e-mail em Principal ou Atualizações indicar uma entrega ou contrato pendente, sugerimos um monitor aqui. Você também pode criar um agora.",
    "allOnTrack": "Nenhum problema sinalizado",
    "needsAttention_one": "{{count}} acompanhamento precisa de atenção",
    "needsAttention_other": "{{count}} acompanhamentos precisam de atenção",
    "until": "até {{goal}}",
    "everyHours_one": "a cada hora",
    "everyHours_other": "a cada {{count}} horas",
    "since": "Desde {{date}}",
    "lastCheck": "Última checagem",
    "nextCheck": "Próxima checagem",
    "email": "E-mail",
    "website": "Site",
    "trackingPage": "Página de acompanhamento",
    "pullRequestSource": "Pull request: {{label}}",
    "emailSource": "E-mail: {{label}}",
    "reviewSuggestion": "Revisar sugestão",
    "suggestionTitle": "Monitorar este item de {{type}}?",
    "progress": "Etapas do acompanhamento",
    "history": "Histórico ({{count}})",
    "hideHistory": "Ocultar histórico",
    "loadError": "Não foi possível carregar os monitores.",
    "retry": "Tentar novamente",
    "actionError": "Não foi possível salvar. Confira as fontes e o prazo, atualize a lista e tente novamente.",
    "title": "Título",
    "type": "Tipo",
    "stops": "Condição de conclusão",
    "goalPlaceholder": "Avise quando o pedido for entregue.",
    "checkSentence": "Vou verificar estas fontes no ritmo escolhido até a condição acontecer.",
    "cadence": "Verificar a cada",
    "safetyDeadline": "Prazo de segurança",
    "tellMe": "Avise-me",
    "sources": "Onde vou acompanhar",
    "trackingUrl": "Link público de acompanhamento",
    "addUrl": "Adicionar link",
    "removeSource": "Remover fonte",
    "safetyNote": "Se o prazo terminar sem desfecho, o monitor para e pede sua atenção. Sites que exigem login precisam de outra fonte.",
    "cancel": "Cancelar",
    "save": "Salvar monitor",
    "start": "Começar a monitorar",
    "notNow": "Agora não",
    "close": "Fechar",
    "checkNow": "Verificar agora",
    "pause": "Pausar",
    "resume": "Continuar monitorando",
    "edit": "Editar",
    "stop": "Parar de monitorar",
    "updates": "Atualizações",
    "howItWatches": "Como acompanha",
    "waitingFirstCheck": "Aguardando a primeira checagem",
    "linkedTask": "Abrir tarefa relacionada",
    "loadMore": "Ver atualizações anteriores",
    "noChangeChecks_one": "{{count}} checagem sem mudança · mostrar",
    "noChangeChecks_other": "{{count}} checagens sem mudança · mostrar",
    "types": {
      "invoice": "Invoice enviada",
      "approval": "Aprovação",
      "contract": "Contrato",
      "delivery": "Entrega",
      "refund": "Reembolso",
      "reply": "Resposta",
      "custom": "Personalizado",
      "pull_request": "Pull request"
    },
    "states": {
      "suggested": "Sugestão",
      "watching": "Monitorando",
      "needs_you": "Precisa de você",
      "paused": "Pausado",
      "done": "Concluído",
      "expired": "Prazo encerrado",
      "stopped": "Encerrado",
      "dismissed": "Dispensado",
      "cleared": "Limpo"
    },
    "health": {
      "on_track": "Sem problemas",
      "at_risk": "Precisa de atenção"
    },
    "policies": {
      "on_problem_and_done": "Em caso de problema e ao concluir",
      "every_change": "A cada mudança",
      "only_done": "Somente ao concluir"
    },
    "stages": {
      "sent": "Enviado",
      "received": "Recebido",
      "approved": "Aprovado",
      "scheduled": "Agendado",
      "paid": "Pago",
      "requested": "Solicitado",
      "seen": "Visto",
      "decided": "Decidido",
      "partially_signed": "Assinado parcialmente",
      "signed": "Assinado",
      "ordered": "Pedido confirmado",
      "shipped": "Despachado",
      "in_transit": "Em trânsito",
      "out_for_delivery": "Saiu para entrega",
      "delivered": "Entregue",
      "open": "Aberto",
      "checks_passing": "Checks aprovados",
      "merged": "Mesclado"
    },
    "events": {
      "analysisFailed": "Não foi possível analisar as fontes nesta checagem. Uma nova tentativa será feita no próximo ciclo.",
      "noReadableSource": "Nenhuma fonte deste monitor pode ser lida, então ele parou de checar. Adicione uma fonte legível, ou ele volta quando chegar um e-mail correspondente.",
      "quiet": "Nada de novo por enquanto. Continuo de olho.",
      "suggested": "Acompanhamento sugerido a partir deste e-mail.",
      "started": "Monitoramento iniciado.",
      "start": "Monitoramento iniciado.",
      "pause": "Monitoramento pausado.",
      "resume": "Monitoramento retomado.",
      "stop": "Monitoramento encerrado.",
      "dismiss": "Sugestão dispensada.",
      "check": "Checagem solicitada.",
      "update": "Configuração atualizada.",
      "expired": "O prazo de segurança terminou. Escolha um novo prazo, altere as fontes ou encerre o acompanhamento.",
      "check_failed": "Não foi possível consultar as fontes. Confira o link ou escolha outra fonte para continuar.",
      "partialFailure": "Uma das fontes não pôde ser consultada; a checagem usou as outras fontes disponíveis."
    },
    "ui": {
      "finished": "Concluídos ({{count}})",
      "needsYou": "Precisa de você",
      "cantCheck": "Não é possível checar",
      "unreadableSource": "Não dá para ler ({{reason}}) · não está mais checando",
      "checkingStopped": "checagem parada",
      "noReadableSourceShort": "Nenhuma fonte legível",
      "addSource": "Adicionar uma fonte",
      "nextCheck": "Próxima checagem {{time}}",
      "nextCheckInline": "próxima checagem {{time}}",
      "dates": {
        "tomorrow": "Amanhã"
      },
      "openOn": "Abrir {{name}}",
      "sourcesTitle": "Fontes",
      "cantReadSince": "Não é possível ler desde {{time}} ({{reason}})",
      "editSources": "Editar fontes",
      "connectGithub": "Conectar GitHub",
      "failingReasons": {
        "needs_sign_in": "precisa fazer login",
        "not_found": "página não encontrada",
        "blocked": "bloqueada",
        "unreachable": "inacessível",
        "unreadable": "ilegível",
        "mailbox_unavailable": "caixa de entrada indisponível"
      },
      "notifySentences": {
        "on_problem_and_done": "Avisa em caso de problema e quando terminar.",
        "every_change": "Avisa a cada mudança.",
        "only_done": "Avisa somente quando terminar."
      },
      "stopsOn": "Encerra em {{date}} se nada acontecer até lá.",
      "menu": "Mais ações",
      "watch": "Monitorar",
      "dismiss": "Dispensar",
      "dontSuggestLikeThis": "Não sugerir assim",
      "suggestionRules": "Regras de sugestão",
      "suggestionRulesDescription": "Monitores que combinam com uma regra nunca são sugeridos.",
      "suggestionRulesEmpty": "Nenhuma regra ainda.",
      "suggestionRulesCount": "{{count}}/{{max}} regras",
      "suggestionRulesLimitReached": "Você atingiu o limite de {{max}} regras.",
      "ruleSentenceFrom": "De {{domain}}",
      "ruleSenderDomain": "Domínio do remetente",
      "ruleSenderDomainPlaceholder": "exemplo.com",
      "ruleTypeAny": "Qualquer tipo",
      "ruleText": "Texto correspondente",
      "ruleTextPlaceholder": "ex.: faturas deste fornecedor",
      "addRule": "Adicionar regra",
      "ruleRequiredField": "Defina ao menos o domínio do remetente, o tipo ou o texto.",
      "ruleTextTooLong": "Mantenha até {{max}} caracteres.",
      "deleteRule": "Excluir regra",
      "suggestedHeading": "Sugeridos",
      "suggestedHelper": "Nada roda até você aprovar",
      "watchingHeading": "Monitorando",
      "needsYouHeading": "Precisa de você",
      "watchingTabName": "{{label}} {{count}}",
      "needsYouTabName_one": "{{count}} precisa de você",
      "needsYouTabName_other": "{{count}} precisam de você",
      "tabNameSeparator": ", ",
      "finishedHeading": "Finalizados",
      "clear": "Limpar",
      "clearAll": "Limpar tudo",
      "clearTitle": "Limpar {{title}}",
      "watchAgain": "Monitorar de novo",
      "seeCleared": "Ver limpos ({{count}})",
      "newBadge_one": "{{count}} nova",
      "newBadge_other": "{{count}} novas",
      "titleWithCondition": "{{title}} · {{condition}}",
      "suggestionSupport": "De {{origin}} · {{cadence}}",
      "stoppedOn": "Encerrado em {{date}} · não concluiu",
      "breadcrumb": "DoBox / {{section}}"
    },
    "agent": {
      "create": {
        "title": "Novo monitor com agente",
        "intro": "Descreva em uma frase. Vou sugerir onde olhar, sobre o que avisar e com que frequência checar. Tudo é editável.",
        "goalLabel": "O que devo acompanhar?",
        "goalPlaceholder": "Acompanhe o que está em Fazendo e Revisão no quadro e os PRs relacionados. Avise se algo parecer parado ou não fechar até 31/10.",
        "suggest": "Sugerir",
        "suggesting": "Pensando na sugestão…",
        "suggestError": "Não consegui montar uma sugestão. O seu texto foi mantido, é só tentar de novo.",
        "measureLabel": "O que vou medir",
        "measureType": "número · {{unit}}",
        "sourcesLabel": "Onde vou olhar",
        "addSource": "+ Adicionar uma fonte",
        "addSourceConfirm": "Adicionar",
        "sourceUrlLabel": "Link HTTPS público",
        "sourcePlaceholder": "https://",
        "sourceInvalid": "Use um link público que comece com https://.",
        "removeSource": "Remover {{name}}",
        "notConnected": "{{name}} · não conectado",
        "triggersLabel": "Quando avisar",
        "noTriggers": "Sem avisos. Vou só manter o resumo atualizado.",
        "cadenceLabel": "Checar a cada",
        "weekdaysOnly": "Só em dias úteis",
        "digestLabel": "Resumo",
        "digestWeekday": "Dia do resumo",
        "digestHour": "Horário do resumo",
        "readOnlyNote": "Somente leitura. Se algo precisar de uma decisão, vou avisar você em vez de agir.",
        "manual": "Configurar manualmente",
        "backToAgent": "Voltar ao monitor com agente"
      },
      "sourceKinds": {
        "dobox": "DoBox",
        "connection": "Conexão",
        "pullRequest": "Pull request",
        "web": "Web",
        "email": "E-mail",
        "optional": "{{kind}} · opcional"
      },
      "triggers": {
        "stale_one": "Um card não se mexe há {{count}} dia",
        "stale_other": "Um card não se mexe há {{count}} dias",
        "pace": "No ritmo atual, não termina até {{date}}",
        "beforeDeadline_one": "{{count}} dia antes de {{date}}, se algo ainda estiver aberto",
        "beforeDeadline_other": "{{count}} dias antes de {{date}}, se algo ainda estiver aberto",
        "thresholdBelow": "Cai abaixo de {{value}}",
        "thresholdAbove": "Passa de {{value}}",
        "changePctDay": "Varia mais de {{pct}}% em um dia",
        "changePctWeek": "Varia mais de {{pct}}% em uma semana",
        "onDate": "Em {{date}}, me diga como terminou",
        "anyChange": "Qualquer coisa na página mudar",
        "sectionChange": "O trecho {{hint}} mudar"
      },
      "triggersShort": {
        "stale": "cards parados",
        "pace": "ritmo",
        "beforeDeadline_one": "{{count}} dia antes de {{date}}",
        "beforeDeadline_other": "{{count}} dias antes de {{date}}",
        "thresholdBelow": "cair abaixo de {{value}}",
        "thresholdAbove": "passar de {{value}}",
        "changePctDay": "variações diárias de {{pct}}%",
        "changePctWeek": "variações semanais de {{pct}}%",
        "onDate": "o dia {{date}}",
        "anyChange": "qualquer mudança",
        "sectionChange": "mudanças em {{hint}}"
      },
      "fields": {
        "days": "Dias",
        "byDate": "Data",
        "value": "Valor",
        "pct": "Percentual",
        "date": "Data",
        "hint": "Trecho"
      },
      "digest": {
        "none": "Nenhum",
        "daily": "Diário",
        "weekly": "Semanal"
      },
      "weekdays": {
        "mon": "Segunda",
        "tue": "Terça",
        "wed": "Quarta",
        "thu": "Quinta",
        "fri": "Sexta",
        "sat": "Sábado",
        "sun": "Domingo"
      },
      "warnsOn": "Avisa sobre {{list}}.",
      "warnsWhen": "Avisa quando {{list}}.",
      "warnsOnAndWhen": "Avisa sobre {{nouns}} e quando {{clauses}}.",
      "warnsNothing": "Nenhum aviso configurado.",
      "everyHoursOnWeekdays_one": "a cada hora em dias úteis",
      "everyHoursOnWeekdays_other": "a cada {{count}} horas em dias úteis",
      "view": {
        "itemListTitle": "O que estou acompanhando",
        "atRisk": "Em risco",
        "onTrack": "No caminho",
        "before": "Antes",
        "after": "Depois",
        "noChangeSince": "Sem mudança desde {{date}}",
        "firstCheck": "A primeira checagem está a caminho"
      },
      "metric": {
        "today": "{{change}} hoje",
        "aboveAlert": "{{distance}} acima do seu alerta de {{alert}}",
        "belowAlert": "{{distance}} abaixo do seu alerta de {{alert}}",
        "alertLabel": "Alerta {{value}}",
        "rangeLabel": "Período",
        "ranges": {
          "1w": "1S",
          "1m": "1M",
          "all": "Desde o início"
        },
        "chartLabel": "{{label}} no período selecionado: de {{from}} para {{to}}, mínima {{low}}, máxima {{high}}",
        "seriesLoading": "Carregando o histórico…",
        "seriesError": "Não foi possível carregar o histórico.",
        "seriesEmpty": "Ainda não há histórico suficiente."
      },
      "row": {
        "atRisk": "Em risco",
        "changed": "Mudou",
        "noChangeSince": "Sem mudança desde {{date}}",
        "sparklineLabel": "Tendência de {{from}} para {{to}}"
      }
    }
  },
  "appName": "this+that",
  "suggestionTabAlerts": {
    "tabTitle_one": "({{displayCount}}) Nova sugestão · {{appName}}",
    "tabTitle_other": "({{displayCount}}) Novas sugestões · {{appName}}"
  },
  "adminGuard": {
    "accessDeniedTitle": "Acesso negado",
    "accessDeniedSubtitle": "Você não tem a permissão necessária para acessar este app."
  },
  "auth": {
    "logoAlt": "this+that",
    "theme": {
      "light": "Tema claro",
      "dark": "Tema escuro"
    },
    "terms": {
      "agreement": "Ao continuar, você concorda com nossos",
      "terms": "Termos",
      "and": "e",
      "privacyPolicy": "Política de Privacidade"
    },
    "viewLinkedin": "Ver perfil no LinkedIn",
    "testimonials": {
      "davidCorts": {
        "quote": "“O t+t transforma threads de comunicação dispersas em ação sintetizada. A combinação do DoBox com fluxos de trabalho personalizados muda a forma como eu trabalho. Em resumo, ele entrega ganhos reais de produtividade de um jeito que outras ferramentas de IA apenas prometem.”",
        "name": "David Corts",
        "role": "CEO · Fresh Technology"
      },
      "kailyIronsFuda": {
        "quote": "“Uso o this+that há alguns meses e mudou completamente o jogo. Adoro como ele puxa automaticamente os itens de ação do meu e-mail e do Slack e coloca tudo em uma única lista de tarefas. É fácil se distrair com uma caixa de entrada cheia e um feed do Slack que nunca sossega. O t+t funciona como minha rede de segurança, me dando um lugar único para revisar todas as minhas tarefas e agir sobre elas direto do app, sem perder o contexto de onde vieram.”",
        "name": "Kaily Irons-Fuda",
        "role": "Líder de Operações e Programas"
      },
      "jasonPinto": {
        "quote": "“O t+t silencia o ruído das mensagens e me leva rapidamente à ação nas questões importantes.”",
        "name": "Jason Pinto",
        "role": "CEO · Appendix 3"
      },
      "artiModhwadia": {
        "quote": "“Como CFO fracionada, descobri no this+that uma forma genuinamente útil de ficar em dia com tudo o que normalmente escapa em uma semana corrida. Ele reúne discretamente tarefas e follow-ups de e-mails, do Slack e de reuniões, para que eu não precise depender da memória ou de listas de tarefas espalhadas. O mais útil é como ele transforma todo esse ruído em algo estruturado e acionável. Em vez de gastar tempo tentando lembrar o que eu disse que faria e onde anotei, posso focar em prioridades, decisões e em fazer as coisas andarem. Basicamente, reduziu muito a sobrecarga mental de equilibrar vários clientes e conversas ao mesmo tempo.”",
        "name": "Arti Modhwadia",
        "role": "CFO Fracionada · The Art of Numbers"
      },
      "jonathanKennell": {
        "quote": "“Uso minha caixa de entrada como lista de tarefas há muito tempo, mas, a menos que eu etiquetasse as mensagens, era difícil saber o que era o quê. Com o this+that, os e-mails com tarefas vão para o DoBox, onde posso gerenciá-los, e todo o resto fica na minha caixa de entrada.”",
        "name": "Jonathan Kennell",
        "role": "Diretor de Gestão de Produtos · Canary Technologies"
      },
      "tyranSpeed": {
        "quote": "“A this+that mudou o jogo para o nosso escritório. Como dono de um escritório de contabilidade, o e-mail pode tomar uma parte significativa do dia, e os rascunhos automáticos de resposta deixaram esse processo muito mais eficiente. Eles dão a mim e à minha equipe um ótimo ponto de partida para a comunicação com os clientes, o que nos ajuda a responder mais rápido, manter a organização e dedicar mais tempo a atender os nossos clientes.”",
        "name": "Tyran Speed",
        "role": "Sócio · Speed Financial Group"
      }
    },
    "security": {
      "passwordNote": "Nós nunca vemos nem armazenamos sua senha.",
      "trustHeading": "Feito para proteger sua privacidade",
      "commitmentsLink": "Nossos compromissos de segurança",
      "encrypted": "Criptografado em trânsito e em repouso",
      "noTraining": "Nunca usado para treinar IA",
      "bedrock": "A IA roda apenas dentro do AWS Bedrock",
      "soc2": "SOC 2 Type I",
      "soc2Type2": "SOC 2 Type II em andamento",
      "gdpr": "GDPR, CCPA e DPA"
    }
  },
  "markdown": {
    "imageLink": "Imagem de {{host}}",
    "imageUnavailable": "Imagem"
  },
  "meta": {
    "description": "this+that - seu assistente para gerenciar suas comunicações sem esforço"
  },
  "roles": {
    "admin": "Admin",
    "member": "Membro",
    "owner": "Proprietário"
  },
  "dateFormats": {
    "hoursMinutes": "h:mm A",
    "longDate": "D MMMM YYYY",
    "longDateWithDay": "dddd D MMMM YYYY",
    "24HourTime": "HH:mm",
    "longDateTime": "D MMMM YYYY, h:mm A",
    "day": "DD",
    "shortDate": "DD/MM/YYYY",
    "middleDate": "D MMMM YYYY",
    "inFullDateFormat": "ddd, DD MMMM YYYY - h:mm A",
    "shortDateWithMonth": "D MMM",
    "shortDateWithMonthAndYear": "D/M/YYYY",
    "today": "Hoje",
    "yesterday": "Ontem",
    "fullMonthYear": "MMMM yyyy",
    "shortMonthDayYear": "d MMM yyyy",
    "shortWeekdayMonthOrdinalDayYear": "EEE, do MMM yyyy",
    "dayOfTheWeekFullName": "EEEE",
    "dayOrdinal": "do",
    "numericDate": "dd/MM/yyyy",
    "shortDateWithTime": "d MMM, HH:mm",
    "shortDateWithMonthDateFns": "d MMM",
    "shortDateTimeWithYear": "D MMM YYYY HH:mm",
    "shortDateWithMonthAndYearDayjs": "D MMM YYYY",
    "shortDateTimeAmPm": "D MMM YYYY h:mm A",
    "shortDateTime": "DD/MM/YYYY, HH:mm",
    "shortDayMonthNumeric": "DD/MM",
    "weekdayDateTimeAmPm": "ddd D MMM YYYY · h:mm A",
    "noDueDate": "Definir prazo"
  },
  "common": {
    "previous": "Anterior",
    "close": "Fechar",
    "me": "eu",
    "you": "Você",
    "gotIt": "Entendi!",
    "to": "Para",
    "required": "campo obrigatório",
    "return": "Voltar",
    "scrollToViewAll": "Role para ver todo o conteúdo",
    "cancel": "Cancelar",
    "remove": "Remover",
    "next": "Próximo",
    "move": "Mover",
    "create": "Criar",
    "schedule": "Agendar",
    "show": "Mostrar",
    "hide": "Ocultar",
    "loading": {
      "label": "Carregando...",
      "message": "Aguarde um momento...",
      "topicsMessage": "Processando tópicos..."
    },
    "and": "e",
    "errorLoadingData": "Erro ao carregar os dados",
    "processing": "Processando...",
    "form": {
      "emailLabel": "E-mail",
      "emailPlaceholder": "jane@thisandthat.chat",
      "emailRequired": "O e-mail é obrigatório",
      "validEmailRequired": "Insira um endereço de e-mail válido",
      "firstNameLabel": "Nome",
      "firstNamePlaceholder": "Jane",
      "firstNameRequired": "O nome é obrigatório",
      "lastNameLabel": "Sobrenome",
      "lastNamePlaceholder": "Smith",
      "lastNameRequired": "O sobrenome é obrigatório",
      "titleLabel": "Cargo",
      "titlePlaceholder": "Gerente sênior",
      "titleRequired": "O cargo é obrigatório"
    },
    "confirmationModal": {
      "confirmAction": "Confirmar",
      "confirmDeletionTitle": "Confirmar exclusão",
      "deleteConfirmationDescription": "Tem certeza de que deseja excluir o(s) item(ns) selecionado(s)? Esta ação não pode ser desfeita.",
      "deleteActionButtonLabel": "Excluir",
      "cancelButtonLabel": "Cancelar",
      "leaveTaskGroup": {
        "title": "Sair deste grupo de tarefas?",
        "description": "Se você sair, perderá o acesso a este grupo de tarefas, a menos que alguém adicione você novamente.",
        "actionLabel": "Sair do grupo de tarefas"
      }
    },
    "signupFooterBanner": {
      "dontHaveAnAccount": "Não tem uma conta?",
      "signup": "Criar conta"
    },
    "sidebar": {
      "home": "Início",
      "doBox": "DoBox",
      "tutorial": "Tutorial",
      "account": "Configurações da conta",
      "integration": "Integrações",
      "team": "Equipe",
      "inbox": "Caixa de entrada",
      "support": "Ajuda + suporte",
      "defaultUserName": "Usuário sem nome",
      "signOut": "Sair",
      "terms": "Termos",
      "dotSeparator": "⏺",
      "policy": "Política",
      "website": "Visite nosso site",
      "websiteUrl": "https://www.thisandthat.chat",
      "hiUser": {
        "title": "Oi, {{firstName}}!",
        "subtitle": "Selecione abaixo para trocar seu e-mail atual",
        "addEmail": "Adicionar novo e-mail"
      },
      "logo": "this+that",
      "logoContracted": "t+t",
      "flows": "Flows",
      "mcpConnections": "Servidores MCP",
      "billing": "Cobrança",
      "assistant": "Assistente",
      "brain": "Brain",
      "calendar": "Agenda",
      "contacts": "Contatos",
      "teamSettings": "Configurações da equipe",
      "teamSwitcher": {
        "label": "EQUIPE ATIVA",
        "ariaLabel": "Seletor de equipe ativa",
        "manageTeams": "Gerenciar equipes",
        "switchTeam": "TROCAR DE EQUIPE",
        "membersAndRole_one": "{{count}} membro · {{role}}",
        "membersAndRole_other": "{{count}} membros · {{role}}",
        "pendingInvitesCount_one": "{{count}} convite pendente",
        "pendingInvitesCount_other": "{{count}} convites pendentes",
        "reviewAndRespond": "Revisar e responder"
      }
    },
    "theme_light": "Claro",
    "theme_dark": "Escuro",
    "theme_label": "Tema",
    "calendarSelection": {
      "selectCalendar": "Selecionar agenda",
      "chooseCalendar": "Escolha uma agenda para conectar:",
      "googleCalendar": "Google Calendar",
      "outlookCalendar": "Agenda do Outlook"
    },
    "save": "Salvar",
    "edit": "Editar",
    "delete": "Excluir",
    "saving": "Salvando...",
    "maxEmailCounter": "99+",
    "partialCounter": "{{count}}+",
    "back": "Voltar",
    "ellipsis": "...",
    "timeInputPlaceholder": "--:--"
  },
  "login": {
    "inAppBrowserTitle": "Navegador interno detectado",
    "inAppBrowserMessage": "Para entrar com segurança, abra esta página no navegador do seu sistema. Toque no menu (⋮ ou ⋯) e selecione \"Abrir no navegador\".",
    "signIn": "Entrar",
    "orLogInWith": "ou entre com",
    "dontHaveAnAccount": "Não tem uma conta?",
    "signUp": "Criar conta",
    "passwordLabel": "Senha",
    "passwordPlaceholder": "*********",
    "forgetPassword": "Esqueceu sua senha?",
    "loginError": "Verifique suas credenciais e tente novamente.",
    "loginWithGoogle": "Google",
    "loginWithMicrosoft": "Microsoft",
    "loginWithSSO": "SSO",
    "validEmail": "Insira um endereço de e-mail válido",
    "passwordRequired": "A senha é obrigatória",
    "autoSigningIn": "Entrando…",
    "mfa": {
      "title": "Verificação em duas etapas",
      "instruction": "Digite o código de 6 dígitos do seu aplicativo autenticador.",
      "backupInstruction": "Digite um dos seus códigos de backup (apenas um, não todos).",
      "codeLabel": "Código de verificação",
      "codePlaceholder": "123456",
      "backupCodePlaceholder": "ex.: z77kx90r",
      "useBackupCode": "Usar um código de backup",
      "useAuthenticator": "Usar o aplicativo autenticador",
      "verify": "Verificar",
      "error": "Código inválido. Tente novamente.",
      "clientTrust": "Precisamos verificar este dispositivo antes de continuar. Siga as instruções de verificação."
    },
    "welcomeBack": "Que bom ter você de volta ao seu assistente",
    "continueWithGoogle": "Continuar com o Google",
    "continueWithMicrosoft": "Continuar com a Microsoft",
    "moreSignInOptions": "Mais opções de login",
    "orUseEmail": "ou use seu e-mail"
  },
  "ssoLogin": {
    "title": "Entrar",
    "subTitle": "Sua organização usa Single Sign-On (SSO). Entre com suas credenciais de SSO.",
    "emailPlaceholder": "Digite seu e-mail de trabalho",
    "validEmail": "Insira um endereço de e-mail válido",
    "orLogInWith": "ou",
    "loginWithoutSSO": "Entrar sem SSO",
    "loginButton": "Entrar",
    "unauthorizedError": "O SSO não está habilitado para o seu domínio. Entre em contato com nosso suporte para obter ajuda."
  },
  "stats": {
    "dataHealth": {
      "title": "Verificações de integridade",
      "asOf": "atualizado em {{value}}",
      "columns": {
        "check": "Verificação",
        "description": "O que significa",
        "trend": "Tendência",
        "value": "Valor",
        "status": "Status"
      },
      "status": {
        "passing": "Normal",
        "warning": "Atenção",
        "failing": "Crítico"
      },
      "descriptions": {
        "brokenTeams": "Times sem dono ou registro de cobrança",
        "brokenTeamInvites": "Convites para times que não existem mais",
        "orphanedTeamMembers": "Membros apontando para usuários excluídos",
        "orphanedInboxEntries": "Entradas sem um dono válido",
        "orphanedTaskGroups": "Grupos cujo dono ou time não existe mais",
        "orphanedRecurrenceEntries": "Entradas recorrentes sem uma entrada pai",
        "staleWebSockets": "Conexões com mais de 24h ainda registradas"
      }
    },
    "focusChart": {
      "min": "mín {{value}}",
      "max": "máx {{value}}",
      "deltaSuffix": "no período"
    },
    "counterGrid": {
      "ariaLabel": "Selecione uma métrica para destacar"
    },
    "fieldSubLabels": {
      "users": "todas as contas",
      "teams": "incl. starter",
      "inboxEntries": "tarefas, sugestões, aprovações",
      "contacts": "CRM criado automaticamente",
      "taskGroups": "listas compartilhadas",
      "pushSubscriptions": "push web",
      "invitedUsers": "convites pendentes",
      "googleCredentials": "Gmail, Agenda, Drive",
      "microsoftCredentials": "Outlook e-mail + agenda",
      "slackCredentials": "workspaces do Slack",
      "slackUserCredentials": "tokens de usuário do Slack",
      "integrationRequests": "pedidos de usuários",
      "userCommunications": "mensagens ingeridas",
      "activityLogs": "linhas de auditoria",
      "doBoxConfigs": "usuários com regras",
      "recurrenceInboxEntries": "tarefas recorrentes",
      "bannerContent": "banners ativos",
      "userCommunicationAgents": "automações",
      "agentExecutions": "execuções de fluxo",
      "orphanedTeamMembers": "sem time correspondente",
      "brokenTeams": "sem dono",
      "orphanedInboxEntries": "sem usuário correspondente",
      "orphanedTaskGroups": "sem usuário correspondente",
      "orphanedRecurrenceEntries": "sem entrada correspondente",
      "staleWebSockets": "conexões mortas",
      "brokenTeamInvites": "convites inválidos"
    },
    "pageTitle": "Estatísticas do banco de dados",
    "mobilePageTitle": "Estatísticas",
    "pageDescription": "Os horários são exibidos no fuso horário local",
    "loadingChart": "Carregando {{name}}...",
    "loadingCharts": "Carregando gráficos...",
    "tabs": {
      "ariaLabel": "Abas de estatísticas",
      "overview": "Visão geral",
      "integrations": "Integrações",
      "engagement": "Engajamento",
      "aiAgents": "Agentes de IA",
      "dataHealth": "Saúde dos dados"
    },
    "fieldLabels": {
      "users": "Usuários",
      "teams": "Equipes",
      "invitedUsers": "Usuários convidados",
      "googleCredentials": "Google",
      "microsoftCredentials": "Microsoft",
      "slackCredentials": "Slack",
      "slackUserCredentials": "Slack (usuário)",
      "orphanedTeamMembers": "Membros de equipe órfãos",
      "brokenTeams": "Equipes quebradas",
      "orphanedInboxEntries": "Entradas de caixa de entrada órfãs",
      "orphanedTaskGroups": "Grupos de tarefas órfãos",
      "orphanedRecurrenceEntries": "Entradas de recorrência órfãs",
      "staleWebSockets": "Websockets obsoletos",
      "brokenTeamInvites": "Convites de equipe quebrados",
      "bannerContent": "Conteúdo de banner",
      "userCommunications": "Comunicações de usuários",
      "integrationRequests": "Solicitações de integração",
      "inboxEntries": "Entradas da caixa de entrada",
      "recurrenceInboxEntries": "Entradas recorrentes da caixa de entrada",
      "taskGroups": "Grupos de tarefas",
      "contacts": "Contatos",
      "doBoxConfigs": "Configurações do DoBox",
      "pushSubscriptions": "Inscrições de push",
      "userCommunicationAgents": "Agentes de comunicação",
      "agentExecutions": "Execuções de agentes",
      "activityLogs": "Logs de atividade"
    },
    "window": {
      "label_one": "{{start}} → {{end}} · {{count}} snapshot",
      "label_other": "{{start}} → {{end}} · {{count}} snapshots"
    },
    "staleSnapshotBanner": {
      "title": "Os dados de snapshot estão congelados",
      "body_one": "Último snapshot em {{date}}, há {{count}} dia",
      "body_other": "Último snapshot em {{date}}, há {{count}} dias"
    }
  },
  "adminTeams": {
    "pageTitle": "Times",
    "pageDescription": "Plano, membros, carteiras e créditos por time",
    "search": {
      "mode": {
        "ariaLabel": "Modo de busca",
        "email": "Email",
        "name": "Nome do time",
        "id": "ID"
      },
      "placeholder": {
        "email": "cliente@empresa.com",
        "name": "Nome do time",
        "id": "tm_… ou user_…"
      },
      "hint": {
        "email": "Exato e rápido: o email é a chave da tabela de usuários e é armazenado em texto plano.",
        "name": "Compara com os nomes de times já descriptografados.",
        "id": "Id do time, id de usuário do Clerk, ou chave da carteira."
      },
      "inputAriaLabel": "Buscar times",
      "noMatches": "Nenhum time ou carteira encontrado para “{{query}}”.",
      "matchNote": {
        "member": "membro {{value}}",
        "name": "nome correspondente",
        "teamId": "id do time",
        "memberId": "id do membro {{value}}"
      },
      "columns": {
        "team": "Time",
        "plan": "Plano",
        "subscription": "Assinatura",
        "trial": "Trial",
        "members": "Membros",
        "teamWallet": "Carteira do time"
      },
      "noTeamWallet": "Sem carteira do time",
      "memberCount": "{{count}} membros",
      "orphanedWallets": {
        "title": "Carteiras órfãs",
        "deletedAccount": "Conta excluída",
        "personalWallet": "Carteira pessoal · {{balance}} créditos",
        "note": "Linha do usuário removida; a carteira foi mantida porque um saldo é dinheiro."
      },
      "submit": "Buscar",
      "loading": "Buscando…",
      "errors": {
        "nameTooShort": "Digite pelo menos {{min}} caracteres para buscar por nome do time.",
        "invalidEmail": "Informe um e-mail válido.",
        "failed": "A busca falhou. Tente novamente."
      }
    },
    "status": {
      "active": "Ativa",
      "pastDue": "Em atraso",
      "none": "Sem assinatura Stripe",
      "trialing": "Em trial",
      "unpaid": "Não paga",
      "canceled": "Cancelada",
      "incomplete": "Incompleta",
      "incompleteExpired": "Incompleta (expirada)",
      "paused": "Pausada"
    },
    "trial": {
      "appEnds": "Trial no app termina em {{date}}",
      "stripeEnded": "Trial Stripe terminou em {{date}}",
      "none": "Nenhum"
    },
    "detail": {
      "addCredits": "Adicionar créditos",
      "teamIdSubtitle": "Id do time: {{id}}",
      "loading": "Carregando time…",
      "errors": {
        "failed": "Não foi possível carregar este time. Tente novamente."
      }
    },
    "tabs": {
      "ariaLabel": "Seções do time",
      "overview": "Visão geral",
      "members": "Membros",
      "history": "Histórico",
      "usage": "Uso"
    },
    "overview": {
      "wallet": {
        "title": "Carteira do time",
        "balance": "Saldo",
        "updatedMeta": "créditos · atualizado em {{date}}",
        "negativeBanner": "Saldo negativo. Nada bloqueia o gasto antes de uma chamada ao modelo, então isso continua caindo até ser creditado.",
        "grantedPlan": "Concedido · plano",
        "grantedPurchased": "Concedido · comprado",
        "grantedTransferIn": "Concedido · transferência recebida",
        "spent": "Gasto",
        "adjustments": "Ajustes e transferências enviadas",
        "footnote": "Ajustes movem apenas o saldo, por isso aparecem separados dos contadores de concedido/gasto.",
        "emptyHeading": "Sem carteira do time",
        "emptyBody": "Nenhuma movimentação foi registrada para este time, então a linha não existe. Isso não é um saldo zero. Enquanto o time não tiver créditos, o gasto de cada membro é cobrado da carteira pessoal dele e marcado com este time.",
        "emptyCreates": "Adicionar créditos aqui cria a carteira.",
        "noWallet": "sem carteira"
      },
      "billing": {
        "title": "Cobrança",
        "source": "da linha do dono",
        "plan": "Plano",
        "status": "Status",
        "seats": "Assentos",
        "seatsValue": "{{seats}} cobrados · {{members}} membros",
        "currentPeriod": "Período atual",
        "inAppTrial": "Trial no app",
        "stripeTrial": "Trial Stripe",
        "trialEnds": "Termina em {{date}}",
        "trialEnded": "Terminou em {{date}}",
        "owner": "Dono",
        "footnote": "Não existe limite de plano em nenhum registro, então não há um número de “usado de” — apenas o saldo absoluto.",
        "periodValue": "{{start}} – {{end}}"
      },
      "usage": {
        "title": "Uso de {{month}}",
        "measured": "medido",
        "creditsMeasured": "créditos medidos",
        "modelCost": "custo do modelo",
        "billedToTeamWallet": "Cobrado da carteira do time (ledger)",
        "billedToMembers": "Cobrado de membros em nome do time",
        "footnote": "Uso medido e créditos cobrados são propositalmente diferentes.",
        "seeWhy": "Ver por quê"
      }
    },
    "members": {
      "columns": {
        "name": "Nome",
        "email": "Email",
        "role": "Papel",
        "personalWallet": "Carteira pessoal",
        "usageThisMonth": "Uso este mês",
        "lastActivity": "Última atividade"
      },
      "sort": {
        "ariaLabel": "Ordenar membros",
        "balance": "Saldo",
        "usage": "Uso",
        "name": "Nome"
      },
      "noWallet": "Sem carteira ainda",
      "usageThisMonth": "Uso {{value}}",
      "lastActivity": "Última {{date}}",
      "add": "Adicionar",
      "footer": "Ordenado por saldo crescente: negativos primeiro, depois zero, depois positivos; membros sem carteira ficam por último. Uso é medido, não cobrado."
    },
    "history": {
      "walletSelectAriaLabel": "Selecionar carteira",
      "walletOption": {
        "team": "Carteira do time — {{balance}} créditos",
        "teamNoWallet": "Carteira do time — sem carteira",
        "member": "{{name}} — {{balance}} créditos",
        "memberNoWallet": "{{name}} — sem carteira"
      },
      "kindAriaLabel": "Filtrar por tipo",
      "kind": {
        "all": "Todos",
        "grants": "Concessões",
        "spend": "Gasto",
        "adjustments": "Ajustes",
        "expiries": "Expirações"
      },
      "rangeAriaLabel": "Filtrar por período",
      "range": {
        "allTime": "Todo o período",
        "days30": "30 dias",
        "days7": "7 dias"
      },
      "addCreditsToWallet": "Adicionar créditos a esta carteira",
      "columns": {
        "date": "Data",
        "kind": "Tipo",
        "amount": "Valor",
        "context": "Contexto",
        "actor": "Ator",
        "onBehalfOf": "Em nome de"
      },
      "context": {
        "debitMain": "{{feature}} · {{family}}",
        "debitSub": "{{in}} entrada · {{out}} saída · {{cacheRead}} leitura de cache · {{usd}} · taxa {{rate}}",
        "grantPlan": "Concessão mensal do plano",
        "grantPlanUntil": "Concessão mensal do plano · até {{date}}",
        "expirePlan": "Saldo do plano anterior expirado",
        "purchase": "Compra de créditos",
        "transferIn": "Transferência recebida",
        "transferOut": "Transferência enviada",
        "adjustment": "Ajuste manual",
        "onBehalf": "{{teamName}} (sem crédito)"
      },
      "actor": {
        "operator": "{{email}} (suporte)",
        "deletedAccount": "Conta excluída",
        "system": "Sistema"
      },
      "loadOlder": "Carregar mais antigos",
      "empty": {
        "default": {
          "title": "Nenhuma movimentação corresponde a estes filtros",
          "body": "Tente um período maior ou outro tipo."
        },
        "noWallet": {
          "title": "Sem carteira",
          "body": "Nada foi registrado em {{walletKey}}, então a linha da carteira não existe. Adicionar créditos a cria."
        },
        "noSpend": {
          "title": "Sem linhas de gasto",
          "body": "Débitos estão desativados, então nada é cobrado no ledger. O que este time usou está na aba Uso, como uso medido."
        }
      },
      "kindPill": {
        "grantPlan": "Concessão de plano",
        "purchase": "Compra",
        "transferIn": "Transferência recebida",
        "debit": "Débito",
        "adjustment": "Ajuste",
        "transferOut": "Transferência enviada",
        "expirePlan": "Expiração do plano"
      },
      "loading": "Carregando histórico",
      "errors": {
        "failed": "Não foi possível carregar o histórico desta carteira.",
        "loadMoreFailed": "Não foi possível carregar movimentações mais antigas. Tente novamente."
      }
    },
    "usage": {
      "monthAriaLabel": "Selecionar mês",
      "unitAriaLabel": "Selecionar unidade",
      "unit": {
        "credits": "Créditos",
        "usd": "USD"
      },
      "note": "Uso medido a partir dos contadores de uso — não são créditos cobrados.",
      "exempt": "isento",
      "totalLabelCredits": "créditos medidos",
      "totalLabelUsd": "custo do modelo, medido",
      "byFeature": "Por funcionalidade",
      "byModelFamily": "Por família de modelo",
      "byFlow": "Por fluxo",
      "explainer": {
        "title": "Por que uso medido e créditos cobrados diferem",
        "items": {
          "debitsOff": "Débitos estão desativados, ou o usuário não está na lista permitida: o uso é registrado, sem linha no ledger.",
          "exemptFeatures": "Oito funcionalidades são isentas de créditos (geração estilo onboarding, embeddings, avaliação interna): registradas, nunca cobradas.",
          "unfundedTeam": "O gasto de um time sem créditos é cobrado da carteira pessoal do membro, marcado com o time.",
          "usageExpiry": "As linhas diárias de uso expiram após 400 dias; linhas do ledger nunca expiram.",
          "failedDebit": "Um débito que falha é descartado silenciosamente para nunca quebrar uma requisição: uso registrado, sem linha no ledger."
        }
      },
      "loading": "Carregando uso",
      "errors": {
        "failed": "Não foi possível carregar o uso deste mês."
      },
      "flowDeleted": "Fluxo excluído"
    },
    "addCredits": {
      "titleForm": "Adicionar créditos",
      "titleReview": "Confirmar movimentação",
      "titleDone": "Créditos adicionados",
      "walletLabel": "Carteira",
      "amountLabel": "Valor (créditos)",
      "amountWarning": "Acima de 500 créditos. Ainda não está definido se isso precisa de um segundo aprovador.",
      "before": "Antes",
      "after": "Depois",
      "createsWallet": "Esta carteira ainda não existe. Esta movimentação vai criá-la.",
      "reasonLabel": "Motivo",
      "reasonNote": "obrigatório, armazenado na linha do ledger",
      "reasonPlaceholder": "O que aconteceu e quem aprovou",
      "hint": {
        "enterAmount": "Informe um valor acima de zero.",
        "addReason": "Adicione um motivo.",
        "ready": "Pronto para revisar.",
        "amountTooHigh": "O valor está acima do limite de {{max}} créditos."
      },
      "reviewButton": "Revisar",
      "back": "Voltar",
      "confirm": "Confirmar e creditar",
      "review": {
        "wallet": "Carteira",
        "kind": "Tipo",
        "amount": "Valor",
        "balance": "Saldo",
        "balanceValue": "{{before}} → {{after}}",
        "reason": "Motivo",
        "operator": "Operador",
        "movementId": "Id da movimentação",
        "walletTeam": "Carteira do time {{team}}",
        "walletPersonal": "{{name}} (pessoal)",
        "idempotencyNote": "O id da movimentação é fixo para esta requisição. Enviá-la duas vezes não credita duas vezes.",
        "submitFailed": "Não foi possível aplicar esta movimentação",
        "submitFailedBody": "Nada foi confirmado. Você pode confirmar de novo: o mesmo id de movimentação é reutilizado, então não há risco de creditar duas vezes."
      },
      "done": {
        "credited": "Creditado {{amount}} para {{target}}",
        "newBalance": "Novo saldo {{balance}} créditos.",
        "meta": "{{movementId}} · registrado por {{email}} · {{recordedAt}}",
        "viewHistory": "Ver histórico",
        "done": "Concluir",
        "alreadyApplied": "Esta movimentação já tinha sido aplicada",
        "alreadyAppliedBody": "O mesmo id de movimentação foi registrado antes, então nada novo foi creditado."
      }
    },
    "notAvailable": "—",
    "plan": {
      "teamMonthly": "Team · mensal",
      "teamAnnual": "Team · anual",
      "none": "Sem plano"
    }
  },
  "signup": {
    "errorGenericMessage": "Não foi possível criar sua conta. Tente novamente.",
    "quotes": {
      "1": {
        "text": "“Uma riqueza de informação cria uma pobreza de atenção”",
        "author": "Herbert A. Simon (psicólogo, economista, Prêmio Nobel)"
      },
      "2": {
        "text": "“Leva em média 23 minutos e 15 segundos para retomar uma tarefa depois de uma interrupção”",
        "author": "Gloria Mark, University of California, Irvine"
      },
      "3": {
        "text": "“Se tudo é prioridade, então nada é”",
        "author": "Patrick Lencioni"
      },
      "4": {
        "text": "“O trabalhador do conhecimento médio gasta 28% da semana de trabalho gerenciando e-mail — quase 11 horas por semana”",
        "author": "McKinsey Global Institute"
      },
      "5": {
        "text": "“Clareza sobre o que importa traz clareza sobre o que não importa”",
        "author": "Cal Newport, Deep Work (2016)"
      },
      "6": {
        "text": "“A maior parte do que chamamos de gestão consiste em dificultar que as pessoas façam seu trabalho”",
        "author": "Peter Drucker, The Essential Drucker (2001)"
      },
      "7": {
        "text": "“Quando tentamos fazer malabarismo com muitas tarefas ao mesmo tempo, inevitavelmente pagamos um preço em precisão e tempo.”",
        "author": "Daniel Levitin, The Organized Mind (2014)"
      },
      "8": {
        "text": "“O e-mail tem um efeito cada vez mais pernicioso. O imediato sufoca cada vez mais o importante.”",
        "author": "Noreena Hertz (economista, escritora)"
      },
      "9": {
        "text": "“Ninguém nunca ficou rico checando o e-mail com mais frequência”",
        "author": "Noah Kagan, CEO da AppSumo"
      },
      "10": {
        "text": "“Profissionais checam o e-mail a cada 6 minutos — cerca de 80 vezes por dia de trabalho — mas apenas 30% dessas mensagens exigem ação”",
        "author": "Pesquisa sobre produtividade no trabalho, 2025"
      }
    },
    "waitlist": {
      "title": "Lista de espera",
      "validEmail": "Insira um e-mail válido",
      "waitlistButton": "Entrar na lista de espera",
      "joiningWaitlist": "Entrando na lista de espera...",
      "receiveUpdates": "Gostaria de receber atualizações por e-mail sobre produtos, serviços, eventos e outras novidades da This and That Technologies, Inc. ('t+t'). Se tiver alguma dúvida, visite nosso",
      "receiveUpdatesLink": "FAQ.",
      "onSubmit": {
        "success": "Você entrou na lista de espera!",
        "error": "Algo deu errado. Tente novamente.",
        "networkError": "Erro de rede. Tente novamente."
      },
      "successScreen": {
        "title": "Você está na lista!",
        "message": "Obrigado por entrar na lista de espera do this+that. Você está um passo mais perto de recuperar sua caixa de entrada e transformar sua produtividade.",
        "secondaryMessage": "Em breve entraremos em contato com acesso antecipado exclusivo e novidades.",
        "thankYou": "Fique de olho — sua caixa de entrada mais inteligente está chegando!",
        "submitAnotherButton": "Enviar outra inscrição"
      }
    },
    "title": "Criar conta",
    "validEmail": "Insira um e-mail válido",
    "passwordLength": "A senha deve ter pelo menos 12 caracteres",
    "passwordsMustMatch": "As senhas devem coincidir",
    "passwordLabel": "Senha",
    "passwordPlaceholder": "Nova senha",
    "passwordRequired": "A senha é obrigatória",
    "confirmPasswordLabel": "Confirmar senha",
    "confirmPasswordPlaceholder": "Confirme a nova senha",
    "receiveUpdates": "Gostaria de receber atualizações por e-mail sobre produtos, serviços, eventos e atividades relacionadas da This and That Technologies, Inc. ('t+t'). Para saber mais sobre como a t+t trata seus dados pessoais, consulte nossa Política de Privacidade.",
    "signUpButton": "Criar conta",
    "privacyAgreement": "Ao se cadastrar, você concorda com nossa",
    "privacyPolicy": "Política de privacidade",
    "privacyNote": "Saiba que não compartilharemos suas informações pessoais com ninguém de fora da nossa empresa. Também odiamos spam, então você nunca receberá e-mails de spam da gente.",
    "successMessage": "Boas-vindas à plataforma!",
    "errorMessage": "Não foi possível criar sua conta. Tente novamente.",
    "scrollToBottomToProceed": "Você precisa rolar até o final do documento para continuar.",
    "enterPin": "Enviamos um código de 6 dígitos para o seu e-mail. Digite-o abaixo para concluir a configuração da sua conta.",
    "login": "Entrar",
    "alreadyHaveAnAccount": "Já tem uma conta?",
    "verificationCodeError": "Código de verificação inválido",
    "orSignupInWith": "ou cadastre-se com",
    "createAccountTitle": "Crie sua conta",
    "freeTrialSubtitle": "Comece seu período de teste gratuito — sem cartão de crédito",
    "signUpWithGoogle": "Cadastre-se com o Google",
    "signUpWithMicrosoft": "Cadastre-se com a Microsoft",
    "moreSignUpOptions": "Mais opções de cadastro",
    "orUseEmail": "ou cadastre-se com e-mail",
    "startFreeTrial": "Começar teste gratuito"
  },
  "resetPassword": {
    "title": "Redefinir senha",
    "subtitle": "Digite seu e-mail e enviaremos um código de verificação para redefinir sua senha.",
    "passwordLabel": "Senha",
    "passwordPlaceholder": "Nova senha",
    "confirmPasswordLabel": "Confirmar senha",
    "codeLabel": "Código",
    "resetButton": "Redefinir",
    "backToLogin": "Voltar para o login",
    "successResettingPassword": "Senha redefinida com sucesso.",
    "errorRequestingCode": "Erro ao solicitar o código. Você pode não ter uma conta, pode não ter uma senha porque entrou com Google ou Apple, ou pode precisar tentar novamente mais tarde.",
    "errorResettingPassword": "Erro ao redefinir a senha, tente novamente mais tarde.",
    "codeSentMessage": "Enviamos um código de seis dígitos para o seu e-mail. Digite-o abaixo e defina uma nova senha.",
    "validation": {
      "emailInvalid": "Insira um e-mail válido",
      "passwordRequired": "A senha é obrigatória",
      "passwordsMustMatch": "As senhas devem coincidir",
      "codeRequired": "O código é obrigatório",
      "codeInvalid": "Código inválido"
    }
  },
  "onboarding": {
    "progress": "Etapa {{currentStep}} de {{totalSteps}}",
    "welcome": {
      "greeting": "Oi, {{firstName}},",
      "greetingFallback": "Oi,",
      "titleWelcome": "Boas-vindas ao",
      "titleThisThat": "this+that",
      "valueProp1": "Mesmo cérebro. Mesma página.",
      "valueProp2": "Seu assistente com IA que transforma mensagens em tarefas e tarefas em ações",
      "getStartedButton": "Começar",
      "closingTitle": "Tudo o que importa em um só lugar",
      "closingParagraph": "De 120 mensagens para 5 tarefas.",
      "continueButton": "Continuar",
      "scrollHint": "Role para baixo",
      "chaosFrame": {
        "title": "Seu dia provavelmente é assim",
        "subtitle": "Mensagens de todos os canais, ao mesmo tempo — antes mesmo do seu café"
      },
      "destillationFrame": {
        "title": "Mas e se não precisasse ser assim?",
        "subtitle": "Cada mensagem organizada e destilada até o que realmente precisa da sua atenção"
      },
      "flowsFrame": {
        "title": "E molde a forma como você trabalha",
        "subtitle": "Configure fluxos e agentes para transformar mensagens em ação"
      }
    },
    "chrome": {
      "stepProgress": "Etapa {{current}} de {{total}}",
      "goToStep": "Ir para a etapa {{index}}",
      "stepsNav": "Etapas do onboarding"
    },
    "story": {
      "next": "Próximo",
      "welcome": {
        "valueProp": "Mesmo cérebro. Mesma página. Seu assistente com IA que transforma mensagens em tarefas e tarefas em ações."
      },
      "payoff": {
        "pillMessages": "120 mensagens",
        "pillTasks": "5 tarefas",
        "headlineL1": "Tudo o que importa",
        "headlineL2": "em um só lugar",
        "subPre": "Chega de alternar entre abas.",
        "subBrand": "this+that",
        "subPost": "reúne todo o seu dia em uma única visão focada.",
        "continueButton": "Continuar"
      },
      "chaos": {
        "title": "Seu dia provavelmente é assim",
        "subtitle": "E-mail, Slack, GitHub, Figma — todos os canais disparando ao mesmo tempo, antes mesmo do seu café.",
        "inboxLabel": "Caixa de entrada",
        "inboxHeader": "CAIXA DE ENTRADA · 9:02",
        "unread": "não lidas",
        "channels": "{{count}} CANAIS",
        "newMessages": "novas",
        "newToday": "{{count}} novas hoje",
        "email": {
          "github": {
            "subject": "Novo pull request aguardando sua revisão",
            "preview": "Nadia Osei abriu um PR em your-repo/main"
          },
          "figma": {
            "subject": "Dana compartilhou um arquivo com você",
            "preview": "Design system v2 — abrir no Figma"
          },
          "nadia": {
            "subject": "Re: Revisão do orçamento do Q4",
            "preview": "Por favor, devolva suas marcações no NDA até…"
          },
          "notion": {
            "subject": "Você foi mencionado em uma página",
            "preview": "Tom mencionou você em Planejamento do roadmap do Q4"
          },
          "jira": {
            "subject": "3 issues atribuídas a você",
            "preview": "PROJ-412, PROJ-418, PROJ-420 precisam de triagem"
          },
          "linkedin": {
            "subject": "InMail de recrutador",
            "preview": "Você toparia uma vaga de Staff Eng?"
          },
          "calendar": {
            "subject": "Revisão de design · 15 min",
            "preview": "Com Sarah, Mike + 3 pessoas — 10:00"
          },
          "zendesk": {
            "subject": "Ticket #5521 escalado",
            "preview": "Cliente esperando resposta há 26h"
          }
        },
        "slack": {
          "eng": "O deploy falhou — alguém está vendo isso?",
          "design": "Arquivo do Figma atualizado, preciso de aprovação",
          "dm": "PR bloqueado — preciso de um segundo revisor",
          "leadership": "Atenção — o CEO quer uma demo na sexta",
          "product": "Você pode revisar o fluxo de onboarding?",
          "incidents": "P2 disparado: pico de latência na api",
          "random": "quem pegou o último café ☕",
          "support": "cliente pedindo o reembolso de novo"
        }
      },
      "distilled": {
        "title": "Mas e se não precisasse ser assim?",
        "subtitle": "Veja o ruído desaparecer — cada mensagem capturada e transformada em uma tarefa clara no seu DoBox.",
        "windowTitle": "DoBox",
        "yourTasks": "Suas tarefas",
        "summary": "{{messages}} mensagens → {{tasks}} tarefas",
        "setPriority": "Definir prioridade",
        "setDueDate": "Definir prazo",
        "addLabel": "Adicionar etiqueta",
        "done": "Concluído",
        "priority": {
          "urgent": "Urgente",
          "high": "Alta",
          "medium": "Média",
          "low": "Baixa"
        },
        "labels": {
          "email": "E-mail",
          "inProgress": "Em andamento",
          "feature": "Funcionalidade",
          "design": "Design",
          "inReview": "Em revisão",
          "backend": "Backend",
          "frontend": "Frontend"
        },
        "tasks": {
          "nadia": {
            "title": "Responder a Nadia Osei com as marcações do orçamento do Q4",
            "desc": "Enviar de volta o NDA com as marcações revisadas e confirmar os novos números de headcount antes da reunião com o financeiro.",
            "due": "12 jun"
          },
          "ceo": {
            "title": "Preparar os slides para a demo do CEO",
            "desc": "Montar seis slides cobrindo roadmap, métricas principais e a demonstração ao vivo do produto para sexta-feira.",
            "due": "13 jun"
          },
          "figma": {
            "title": "Aprovar o design system v2 no Figma",
            "desc": "Resolver os comentários do Mike sobre tokens de espaçamento e aprovar os componentes v2 para o handoff de engenharia.",
            "due": "14 jun"
          },
          "pr": {
            "title": "Revisar e fazer merge do PR em your-repo/main",
            "desc": "Verificar a correção da Nadia para a race condition no stream-receiver e fazer o merge quando o CI estiver verde.",
            "due": "16 jun"
          }
        },
        "chips": {
          "eng": {
            "label": "Sarah · #eng",
            "sub": "O deploy falhou — alguém está vendo isso?"
          },
          "github": {
            "label": "GitHub",
            "sub": "PR aguardando sua revisão na main"
          },
          "nadia": {
            "label": "Nadia Osei",
            "sub": "Re: Orçamento do Q4 — marcações anexadas"
          },
          "jordan": {
            "label": "Jordan · Liderança",
            "sub": "O CEO quer uma demo na sexta"
          },
          "mike": {
            "label": "Mike · #design",
            "sub": "Figma v2 pronto para aprovação"
          },
          "pagerduty": {
            "label": "PagerDuty",
            "sub": "P2: pico de latência na api"
          }
        }
      },
      "flows": {
        "title": "E molde a forma como você trabalha",
        "subtitle": "Descreva o que você quer em linguagem natural e a IA constrói o fluxo inteiro — agentes, ferramentas e tudo mais.",
        "suggestion1": "Me envie um resumo diário dos e-mails não lidos",
        "suggestion2": "Etiquete e-mails com itens de ação",
        "suggestion3": "Me atualize sobre as mensagens do Slack",
        "suggestion4": "Acompanhe e-mails que precisam de follow-up",
        "suggestionsLabel": "Experimente um destes prompts para começar",
        "teamFlow": "Tornar este um fluxo de equipe",
        "tabBuilder": "Construtor",
        "tabAiChat": "Chat de IA",
        "save": "Salvar",
        "untitledFlow": "Fluxo sem título",
        "flowTitle": "Arquivar e-mails de promoções",
        "generatingFlow": "Gerando seu fluxo...",
        "buildingFlow": "Construindo seu fluxo...",
        "inputPlaceholder": "Descreva o que você quer que seu agente faça...",
        "nodeChooseStarter": "Escolha um ponto de partida",
        "nodeWhenEmail": "Quando eu receber um e-mail",
        "nodeAgentTask": "Tarefa de agente",
        "addStep": "Adicionar etapa",
        "step1": "ETAPA 1",
        "detailsTitle": "Só mais alguns detalhes",
        "detailsSubtitle": "Ajude a gente a construir o fluxo perfeito para você",
        "detailsNameLabel": "Nome:",
        "detailsNameValue": "Arquivar e-mails de promoções",
        "detailsTriggerLabel": "Gatilho:",
        "detailsTriggerValue": "Quando um e-mail chega na categoria \"Promoções\"",
        "detailsAgentWillLabel": "O que o agente vai fazer:",
        "detailsAgentAction": "Arquivar automaticamente o e-mail recebido",
        "detailsNotesLabel": "Observações:",
        "detailsNote1": "Todo e-mail que o Gmail marca como promoção é arquivado automaticamente",
        "detailsNote2": "O e-mail não é excluído — apenas removido da caixa de entrada (continua em \"Todos os e-mails\")",
        "detailsYes": "Sim, criar o agente",
        "detailsNo": "Não, quero fazer alterações",
        "generateFlow": "Gerar fluxo",
        "configureStep": "Configurar etapa",
        "configureStepSub": "Configure um agente de IA que decide de forma autônoma quais ferramentas usar para atingir um objetivo.",
        "configStepName": "Nome da etapa (para variáveis)",
        "configStepNamePlaceholder": "ex.: loadMessages",
        "systemPromptLabel": "System Prompt (papel / persona)",
        "systemPromptPlaceholder": "Opcional. Defina quem é o agente — seu papel, tom e persona. É adicionado antes das regras de execução internas para você não precisar incluir isso no objetivo.",
        "goalLabel": "Objetivo",
        "goalVariables": "(x) Variáveis",
        "goalText": "Quando um e-mail promocional chegar, arquive-o imediatamente usando",
        "goalTextMid": ". O e-mail recebido tem o assunto",
        "goalTextSentBy": "enviado por",
        "toolSetsLabel": "Conjuntos de ferramentas",
        "subAgentsLabel": "Subagentes",
        "createAgent": "+ Criar agente",
        "subAgentName": "this+that Brand Builder",
        "subAgentMeta": "Haiku · 5 turnos · 0 conjuntos de ferramentas",
        "subAgentShared": "Compartilhado por This and That",
        "addStepTitle": "Adicionar uma etapa",
        "addStepSubtitle": "Escolha uma ação para adicionar ao seu fluxo",
        "aiSkills": "HABILIDADES DE IA",
        "toolAiAsk": "Perguntar à IA",
        "toolDecide": "Decidir",
        "toolSummarize": "Resumir",
        "toolAgentTask": "Tarefa de agente",
        "toolNotify": "Notificar assistente",
        "toolRunAssistant": "Executar assistente",
        "toolAskUser": "Perguntar ao usuário",
        "toolset": {
          "emailActions": "Ações de e-mail (enviar, rascunhar, arquivar, etiquetas)",
          "loadComms": "Carregar comunicações (ler e-mails, mensagens do Slack)",
          "notifications": "Notificações (mensagens do Slack e e-mails do sistema)",
          "conversational": "Conversacional (fazer perguntas, aguardar respostas)",
          "dobox": "DoBox (tarefas, entradas)",
          "externalTools": "Ferramentas externas (MCP)",
          "memory": "Memória (lembrar, salvar, histórico)",
          "brainReadOnly": "Brain somente leitura (buscar e ler páginas)",
          "calendar": "Agenda (eventos, reuniões, RSVP)"
        }
      }
    },
    "workAreas": {
      "title": "Qual é o seu tipo de trabalho?",
      "subtitle": "Escolha a área mais próxima do seu trabalho. Vamos usar isso para mostrar as automações que outras pessoas na sua função realmente mantêm em uso — você pode alterar isso quando quiser.",
      "footnote": "Conectar o Gmail ou o Slack depois refina ainda mais essa lista.",
      "cta": {
        "continue": "Continuar",
        "skip": "Pular por enquanto"
      },
      "errors": {
        "save": "Não foi possível salvar suas áreas de trabalho. Tente novamente."
      },
      "areas": {
        "engineering": {
          "hint": "Logs de deploy, incidentes, releases"
        },
        "hr_people": {
          "hint": "Contratação, integração, check-ins"
        },
        "sales": {
          "hint": "Leads, follow-ups, pipeline"
        },
        "marketing": {
          "hint": "Concorrentes, conteúdo, campanhas"
        },
        "support_cs": {
          "hint": "Tickets, escalações, saúde da conta"
        },
        "finance": {
          "hint": "Faturas, aprovações, relatórios"
        },
        "operations": {
          "hint": "Fornecedores, processos, logística"
        },
        "legal": {
          "hint": "Contratos, revisões, renovações"
        },
        "founder_leadership": {
          "hint": "Resumos de tudo"
        }
      }
    },
    "teamInvites": {
      "pendingBadge": "{{count}} convite pendente",
      "pendingBadge_other": "{{count}} convites pendentes",
      "title": "Você foi convidado para colaborar",
      "subtitle": "Entre agora para compartilhar tarefas, agendas e contexto — ou deixe para decidir depois em Configurações.",
      "accessLabel": "Acesso",
      "entities": {
        "team": "Equipe"
      },
      "invitedBy": "Convidado por",
      "members": "{{count}} membro",
      "members_other": "{{count}} membros",
      "roles": {
        "owner": "Proprietário",
        "admin": "Admin",
        "consultant": "Consultor",
        "member": "Membro",
        "viewer": "Visualizador"
      },
      "features": {
        "full": "Acesso total",
        "view": "Pode visualizar",
        "create": "Pode criar",
        "edit": "Pode editar",
        "delete": "Pode excluir"
      },
      "actions": {
        "accept": "Aceitar",
        "decline": "Recusar",
        "later": "Depois"
      },
      "status": {
        "joinedAs": "Entrou como {{role}}",
        "declined": "Convite recusado",
        "savedForLater": "Salvo para depois"
      },
      "cta": {
        "skip": "Pular por enquanto",
        "continue": "Continuar"
      },
      "footerHelp": "Você pode aceitar qualquer convite depois em Configurações → Equipes.",
      "errors": {
        "accept": "Não foi possível aceitar o convite. Tente novamente.",
        "decline": "Não foi possível recusar o convite. Tente novamente."
      }
    },
    "step2": {
      "bodyText": "O this+that lê seus e-mails e mensagens, identifica o que precisa de ação e organiza tudo no seu DoBox, uma lista de tarefas focada, criada a partir das suas comunicações. Use os Flows para automatizar o que acontece depois, como etiquetar feedback de clientes, rascunhar respostas para colegas, encaminhar notas fiscais para o financeiro ou encontrar um documento solicitado e enviá-lo.",
      "soundsGood": "Parece ótimo"
    },
    "step3": {
      "speechSubtext": "Conecte suas contas e o this+that vai começar a organizar suas mensagens, separando o que precisa de ação de todo o resto. Leva menos de um minuto.",
      "gmail": {
        "title": "Gmail",
        "description": "Conecte sua conta do Google",
        "altText": "Logo do Gmail"
      },
      "outlook": {
        "title": "Outlook",
        "description": "Conecte sua conta da Microsoft",
        "altText": "Logo do Outlook"
      },
      "errors": {
        "gmailConnection": "Falha ao conectar o Gmail. Tente novamente.",
        "outlookConnection": "Falha ao conectar o Outlook. Tente novamente."
      }
    },
    "connect": {
      "title": "Conecte suas contas",
      "subtitle": "O this+that funciona melhor com o seu e-mail. O Slack é opcional, mas recomendado.",
      "emailRequired": "E-mail",
      "emailRequiredBadge": "Obrigatório",
      "emailRecommendedBadge": "Recomendado",
      "slackOptional": "Slack",
      "slackOptionalBadge": "Opcional",
      "slackDescription": "Receba tarefas também das suas conversas no Slack",
      "connected": "Conectado",
      "connectSlack": "Conectar Slack",
      "continueButton": "Continuar",
      "continueWithoutEmailButton": "Continuar sem e-mail",
      "errors": {
        "emailConnection": "Falha ao conectar o e-mail. Tente novamente.",
        "slackConnection": "Falha ao conectar o Slack. Tente novamente."
      },
      "introTitle": "Tudo começa conectando seu e-mail",
      "introSubtitle": "Vamos monitorar sua caixa de entrada, destacar o que importa e transformar ruído em ação — tudo com um clique.",
      "postEmailTitle": "Seu e-mail está conectado — que tal o Slack?",
      "postEmailSubtitle": "Receba tarefas também das suas conversas no Slack. Ou pule por enquanto — você pode conectá-lo depois, de dentro do app."
    },
    "discoverFlows": {
      "title": "Descubra fluxos",
      "subtitle": "Explore modelos para acelerar sua configuração",
      "continueButton": "Continuar"
    },
    "emailSync": {
      "title": "Configurando tudo para você",
      "subtitle": "Isso leva só um instante",
      "progressLabel": "Progresso da sincronização",
      "steps": {
        "connecting": {
          "title": "Conectando ao seu e-mail"
        },
        "importing": {
          "title": "Importando suas mensagens"
        },
        "indexing": {
          "title": "Organizando tudo"
        },
        "preparing": {
          "title": "Preparando seu espaço de trabalho"
        }
      },
      "complete": {
        "title": "Tudo pronto!"
      },
      "fallback": {
        "title": "Configuração concluída"
      },
      "errors": {
        "syncFailed": "A sincronização de e-mail falhou. Tente novamente."
      }
    },
    "welcomeDoBox": {
      "subject": "Boas-vindas ao DoBox! 👋",
      "description": "O DoBox é o seu centro de ação. É onde vive tudo o que precisa da sua atenção.\n\nFunciona assim:\n- E-mails, mensagens do Slack e do Teams e tarefas que precisam de ação aparecem aqui automaticamente\n- Você também pode criar itens manualmente\n- Organize itens em listas para agrupar tarefas relacionadas\n- Defina prazos, adicione etiquetas e atribua membros da equipe\n- Quando terminar algo, marque como concluído para manter seu DoBox limpo\n\nDicas para começar:\n- Confira sua caixa de entrada. Nossa IA vai mover itens para o DoBox automaticamente\n- Crie um fluxo para organizar automaticamente as mensagens recebidas\n\nVocê pode marcar este item como concluído quando quiser. Boa organização!",
      "descriptionNoEmail": "O DoBox é o seu centro de ação. É onde vive tudo o que precisa da sua atenção.\n\nPara aproveitar ao máximo, vale conectar seu e-mail, Slack, Teams e outras ferramentas — assim, mensagens e tarefas que precisam de ação vão aparecer aqui automaticamente. Acesse a página de Integrações quando quiser conectá-los.\n\nFunciona assim:\n- Conecte seus canais (e-mail, Slack, Teams etc.) na página de Integrações para que os itens apareçam aqui automaticamente\n- Você também pode criar itens manualmente agora mesmo\n- Organize itens em listas para agrupar tarefas relacionadas\n- Defina prazos, adicione etiquetas e atribua membros da equipe\n- Quando terminar algo, marque como concluído para manter seu DoBox limpo\n\nDicas para começar:\n- Abra a página de Integrações e conecte pelo menos um canal — e-mail ou Slack é um ótimo começo\n- Crie um fluxo para organizar automaticamente as mensagens recebidas assim que seus canais estiverem conectados\n\nVocê pode marcar este item como concluído quando quiser. Boa organização!"
    }
  },
  "account": {
    "pageTitle": "Conta",
    "pageDescription": "Esta é a página da sua conta. Acesse-a para gerenciar suas configurações.",
    "section": {
      "profileInformation": "Informações do perfil",
      "notifications": "Notificações",
      "email": "E-mail"
    },
    "email": {
      "taskResolutionSection": "Resolução de tarefas",
      "taskResolutionHelper": "Quando ativado, resolver uma tarefa arquiva o e-mail dela no Gmail ou no Outlook, mas só depois que todas as outras tarefas abertas ligadas a esse e-mail também forem resolvidas. Desativado por padrão.",
      "archiveOnLastTaskResolvedToggle": "Arquivar o e-mail quando a última tarefa for resolvida"
    },
    "connect": {
      "setUpIntegration": "Configurar integração",
      "setUpIntegrationMessage": "Para ativar sua integração com o {{platform}}, você precisa concluir a configuração inicial. Você será redirecionado para a página de configuração.",
      "confirmAction": "Confirmar"
    },
    "disconnect": {
      "disconnectIntegrationError": "Houve um problema ao desconectar sua integração com o {{provider}}. Tente novamente.",
      "userIdNotFound": "ID de usuário não encontrado. Tente novamente.",
      "noDisconnectFunction": "Nenhuma função de desconexão disponível para o provedor selecionado.",
      "teamsHomeAccountIdNotFound": "Não foi possível encontrar as informações da conta do Teams. Tente novamente.",
      "disconnectIntegrationSuccess": "Sua integração com o {{provider}} foi desconectada com sucesso."
    },
    "notifications": {
      "emailSection": "Newsletter e resumo diário",
      "receiveUpdates": "Receber atualizações por e-mail sobre produtos, serviços, eventos e atividades relacionadas da This and That Technologies, Inc.",
      "receiveUpdatesDelay": "Alterações nas suas preferências de e-mail podem levar até 24 horas para entrar em vigor.",
      "dailyNotification": "Receber um resumo diário com sugestões de tarefas e tarefas",
      "transactionSection": "Notificações sobre tarefas",
      "newDiscussionAdded": "Novos comentários foram adicionados a uma discussão",
      "youHaveBeenAssignedTo": "Um colega de equipe atribuiu uma tarefa a você",
      "pushSection": "Notificações push",
      "pushSectionHelper": "Escolha quais notificações push você recebe nos seus dispositivos. Alertas de e-mail ficam desativados por padrão.",
      "pushEmailToggle": "Notificações de novos e-mails",
      "pushDoboxToggle": "Notificações de tarefas e do DoBox",
      "browserSection": "Alertas no navegador",
      "browserSectionHelper": "Avisos nesta aba do navegador quando o assistente cria novas sugestões no seu DoBox pessoal.",
      "suggestionSoundToggle": "Tocar um som quando chegarem novas sugestões"
    },
    "preferences": {
      "languageLabel": "Idioma",
      "timeZoneLabel": "Fuso horário",
      "selectPlaceholder": "Selecionar",
      "languageRequired": "O idioma é obrigatório",
      "timeZoneRequired": "O fuso horário é obrigatório",
      "languages": {
        "enUS": "Inglês (EUA)",
        "enGB": "Inglês (Reino Unido)",
        "ptBR": "Português (Brasil)"
      }
    },
    "buttons": {
      "saveInformationsButton": "Salvar informações",
      "deleteAccountButton": "Encerrar conta"
    },
    "form": {
      "validationError": "Corrija os campos destacados antes de salvar"
    },
    "confirmationModal": {
      "deleteAccountConfirmationTitle": "Encerrar a sua conta?",
      "deleteAccountConfirmationDescription": "Tem certeza de que deseja encerrar a sua conta?",
      "deleteAccountConfirmationAction": "Encerrar"
    },
    "deleteFeedback": {
      "title": "Encerrar a sua conta?",
      "subtitle": "Encerramos o seu acesso, paramos de sincronizar as contas que você conectou e apagamos as suas mensagens, tarefas, páginas do Brain, dados de calendário, contatos e arquivos.",
      "helpText": "Conte por que está saindo (opcional). Mantemos o seu nome, e-mail, cargo, áreas de trabalho, se você fazia parte de um time, a data em que encerrou a conta e estes motivos por 24 meses, para podermos avisar se o this+that mudar de um jeito que possa trazer você de volta. Envie um e-mail para support@thisandthat.chat e nós os removemos antes.",
      "reasonsGroupLabel": "Motivos para encerrar a sua conta",
      "reasons": {
        "tooExpensive": "É muito caro",
        "missingIntegration": "Falta uma integração que eu preciso",
        "aiNotUseful": "Os recursos de IA não foram úteis para mim",
        "tooComplex": "É muito complexo de usar",
        "switchingTool": "Estou mudando para outra ferramenta",
        "notUsingEnough": "Não estou usando o suficiente",
        "privacy": "Preocupações com privacidade",
        "other": "Outro"
      },
      "otherPlaceholder": "Conte mais (opcional)...",
      "otherMinLengthHint": "Escreva pelo menos {{min}} caracteres (ou deixe em branco)",
      "otherCharacterCount": "{{count}}/{{max}}",
      "confirm": "Encerrar minha conta"
    },
    "deleteAccountSuccess": "Sua conta foi encerrada",
    "deleteAccountError": "Houve um problema ao encerrar a sua conta. Tente novamente.",
    "profileUpdatedSuccess": "Conta atualizada com sucesso.",
    "profileUpdateError": "Houve um problema ao atualizar sua conta. Tente novamente.",
    "calendarPrivacy": {
      "toggleLabel": "Compartilhar minha disponibilidade de agenda com minha equipe",
      "toggleAriaLabel": "Compartilhar disponibilidade de agenda com membros da equipe",
      "description": "Quando ativado, colegas de equipe podem ver seu status de livre/ocupado e eventos públicos para ajudar a agendar reuniões. Desative para ocultar sua disponibilidade de agenda da sua equipe.",
      "errors": {
        "saveFailed": "Falha ao atualizar sua configuração de privacidade da agenda. Tente novamente."
      }
    },
    "security": {
      "section": "Segurança",
      "twoFactor": {
        "title": "Autenticação em dois fatores",
        "description": "Adicione uma camada extra de segurança exigindo um código do seu aplicativo autenticador ao entrar.",
        "statusEnabled": "Ativada",
        "statusDisabled": "Desativada",
        "enable": "Ativar",
        "remove": "Remover",
        "manageBackupCodes": "Gerenciar códigos de backup",
        "setup": {
          "title": "Configurar aplicativo autenticador",
          "scanInstruction": "Escaneie este QR code com seu aplicativo autenticador.",
          "cantScan": "Não consegue escanear o código?",
          "manualInstruction": "Digite este código manualmente no seu aplicativo autenticador:",
          "codeLabel": "Código de verificação",
          "codePlaceholder": "123456",
          "verify": "Verificar e ativar",
          "success": "A autenticação em dois fatores está ativada.",
          "cancel": "Cancelar",
          "copySecret": "Copiar chave secreta"
        },
        "backupCodes": {
          "title": "Códigos de backup",
          "description": "Cada código pode ser usado uma vez para entrar caso você perca o acesso ao seu aplicativo autenticador.",
          "warning": "Guarde estes códigos em um lugar seguro. Você não poderá vê-los novamente.",
          "copy": "Copiar códigos",
          "copied": "Copiado",
          "download": "Baixar",
          "regenerate": "Gerar novos códigos",
          "done": "Concluído",
          "regenerateConfirm": {
            "title": "Gerar novos códigos de backup?",
            "description": "Seus códigos de backup atuais deixarão de funcionar. Não esqueça de salvar os novos.",
            "action": "Gerar novos"
          }
        },
        "removeConfirm": {
          "title": "Remover a autenticação em dois fatores?",
          "description": "Isso desativa a autenticação em dois fatores e remove seus códigos de backup. Sua conta ficará menos segura.",
          "action": "Remover"
        },
        "errors": {
          "verify": "Código inválido. Tente novamente.",
          "generic": "Algo deu errado. Tente novamente.",
          "copy": "Não foi possível copiar para a área de transferência. Copie os códigos manualmente."
        },
        "removeSuccess": "A autenticação em dois fatores foi desativada."
      }
    }
  },
  "integration": {
    "pageTitle": "Integrações",
    "pageDescription": "Acesse esta página para configurar suas integrações. Sincronize suas ferramentas mais usadas para começar a assumir o controle dos seus e-mails, conversas e tarefas.",
    "analysisSection": {
      "title": "Configurando a análise",
      "description": "Conecte suas ferramentas de comunicação para que o assistente possa fazer sugestões."
    },
    "teamSection": {
      "title": "Integrações da equipe",
      "description": "Estas integrações são compartilhadas com toda a sua equipe. Uma vez conectadas, todos os membros da equipe aproveitam a mesma configuração."
    },
    "exportsSection": {
      "title": "Configurando as exportações",
      "description": "Conecte suas ferramentas favoritas de gestão de projetos para encaminhar e transformar itens sugeridos em tarefas ou tickets sem esforço."
    },
    "mcpSection": {
      "title": "Servidores MCP",
      "description": "Conecte servidores MCP externos para ampliar as capacidades do seu assistente com ferramentas adicionais."
    },
    "integrationOptions": {
      "slack": "Conecte seu workspace do Slack: <br/><ul><li><b>Canais</b></li><li><b>Mensagens diretas</b></li></ul>",
      "slackMobile": "Conecte seu workspace do Slack: <br/><ul><li><b>Canais</b></li><li><b>Mensagens diretas</b></li></ul>",
      "google": "Conecte sua conta do Google: <br/><ul><li><b>Gmail</b></li><li><b>Agenda</b></li></ul>",
      "googleMobile": "Conecte sua conta do Google: <br/><ul><li><b>Gmail</b></li><li><b>Agenda</b></li></ul>",
      "outlook": "Conecte sua conta do Outlook:<br/><ul><li><b>Outlook</b></li><li><b>Agenda</b></li></ul>",
      "outlookMobile": "Conecte sua conta do Outlook: <br/><ul><li><b>Outlook</b></li><li><b>Agenda</b></li></ul>",
      "teams": "Conecte sua conta do Teams: <br/><ul><li><b>Chats</b></li></ul>",
      "teamsMobile": "Conecte sua conta do Teams: <br/><ul><li><b>Chats</b></li></ul>",
      "slackBot": "Conecte o bot do t+t ao seu workspace do Slack para:<br/><ul><li><b>Adicionar o bot a canais</b></li><li><b>Disparar fluxos a partir de mensagens do Slack</b></li></ul>",
      "slackBotMobile": "Conecte o bot do t+t ao seu workspace do Slack para:<br/><ul><li><b>Adicionar o bot a canais</b></li><li><b>Disparar fluxos a partir de mensagens do Slack</b></li></ul>",
      "instagram": "Conecte sua conta do Instagram:<ul><li><b>Conversas</b></li><li><b>Mensagens diretas</b></li></ul>",
      "instagramMobile": "Conecte sua conta do Instagram:<ul><li><b>Conversas</b></li><li><b>Mensagens diretas</b></li></ul>",
      "github": "Conecte as organizações do GitHub da sua equipe:<ul><li><b>Issues e pull requests</b></li><li><b>Comentários e revisões</b></li></ul>Acesso somente leitura. Suporte a várias organizações.",
      "githubMobile": "Conecte as organizações do GitHub da sua equipe:<ul><li><b>Issues e pull requests</b></li><li><b>Comentários e revisões</b></li></ul>",
      "googleChat": "Habilite o Google Chat na sua conta conectada do Google:<br/><ul><li><b>Espaços</b></li><li><b>Mensagens diretas</b></li></ul>",
      "googleChatMobile": "Habilite o Google Chat na sua conta conectada do Google:<br/><ul><li><b>Espaços</b></li><li><b>Mensagens diretas</b></li></ul>",
      "googleDrive": "Conecte o Google Drive para permitir que o assistente leia e busque seus arquivos:<br/><ul><li><b>Meu Drive</b></li><li><b>Drives compartilhados</b></li></ul>",
      "googleDrivePrerequisite": "Conecte sua conta do Google antes de habilitar o Drive.",
      "googleBusiness": "Conecte o Google Business Profile para permitir que o assistente acompanhe e responda às suas avaliações:<br/><ul><li><b>Avaliações</b></li><li><b>Locais do negócio</b></li></ul>",
      "googleBusinessPrerequisite": "Conecte sua conta do Google antes de habilitar o Business Profile.",
      "whatsApp": "Conecte sua conta do WhatsApp Business para transformar mensagens em <b>sugestões</b> na sua caixa de entrada.",
      "whatsAppMobile": "Conecte sua conta do WhatsApp Business para transformar mensagens em <b>sugestões</b> na sua caixa de entrada."
    },
    "statusTag": {
      "connected": "Conectado",
      "notConnected": "Não conectado",
      "pendingApproval": "Pending approval"
    },
    "status": {
      "connecting": "Conectando…"
    },
    "connecting": {
      "waiting": "Aguardando a confirmação da conexão…"
    },
    "integrateButton": "Conectar",
    "connectAccountsButton": "Conectar contas",
    "manageAccounts": "Gerenciar contas",
    "addAccount": "Adicionar conta",
    "disconnectButton": "Desconectar",
    "disconnectModal": {
      "title": "Confirmação",
      "individualDescription": "Tem certeza de que deseja desconectar o {{platform}}? Todos os dados salvos serão excluídos do this+that."
    },
    "adminsOnly": "Apenas admins",
    "integrationSuccess": "Sua integração foi conectada com sucesso.",
    "integrationError": "Houve um problema ao conectar sua integração. Tente novamente.",
    "instagramUnsupportedLoginMethodError": "Não foi possível conectar esta conta do Instagram. Tente de novo entrando com o usuário e a senha da sua conta profissional do Instagram, em vez de continuar com o Facebook.",
    "microsoftAccountHeldByAnotherUser": "Esta conta da Microsoft já está conectada por outra pessoa no this+that, então não dá para conectá-la de novo. O acesso que você acabou de aprovar vale para a conexão dessa pessoa.",
    "microsoftPermissionsNotGranted": "A Microsoft não concedeu as permissões de que esta conexão precisa. Tente de novo e aceite as permissões; se sua organização gerencia sua conta, peça ao administrador de TI para liberar o this+that.",
    "teamsPersonalAccountNotSupported": "O Teams precisa de uma conta Microsoft corporativa ou de estudante. Contas pessoais (Outlook.com, Hotmail, Live) não conectam o Teams.",
    "googleAccountHeldByAnotherUser": "Esta conta do Google já está conectada por outra pessoa no this+that, então não dá para conectá-la de novo. O acesso que você acabou de aprovar vale para a conexão dessa pessoa — não conseguimos desfazê-lo sem desconectá-la.",
    "oauthRefusal": {
      "title": "Conexão não concluída",
      "canceled": "Você cancelou a conexão. Nada foi vinculado.",
      "consentNotGranted": "O consentimento não foi concedido. Se pediu aprovação, tente depois.",
      "blockedByOrganization": "Seu admin bloqueou uma permissão que esta integração precisa.",
      "orgInternal": "A organização desta conta não pode usar o app. Tente outra conta.",
      "embeddedBrowser": "Abra o app no Chrome, Safari ou Edge e tente de novo.",
      "providerUnavailable": "O provedor está indisponível. Tente de novo em instantes.",
      "integrationSuspended": "Esta integração está indisponível. Fale com o suporte.",
      "generic": "Falha ao conectar ({{code}}). Tente de novo ou fale com o suporte."
    },
    "googleDrive": {
      "disconnectSuccess": "Google Drive desconectado com sucesso.",
      "disconnectError": "Houve um problema ao desconectar o Google Drive. Tente novamente.",
      "manageModalSubtitle": "Veja e gerencie quais contas do Google têm o Drive conectado. Você pode desconectar ou adicionar o acesso ao Drive quando quiser."
    },
    "googleBusiness": {
      "disconnectSuccess": "Google Business Profile desconectado com sucesso.",
      "disconnectError": "Houve um problema ao desconectar o Google Business Profile. Tente novamente.",
      "manageModalSubtitle": "Veja e gerencie quais contas do Google têm o Business Profile conectado. Você pode desconectar ou gerenciar os locais quando quiser.",
      "manageLocationsButton": "Gerenciar locais",
      "locationsModal": {
        "title": "Gerenciar locais",
        "monitorAllLabel": "Monitorar todos os locais",
        "monitorAllHint": "Por padrão, o assistente monitora todos os locais desta conta. Desative para escolher locais específicos.",
        "emptyState": "Nenhum local foi encontrado para esta conta ainda. Isso pode acontecer enquanto o Google analisa o acesso à API do Business Profile — volte em breve.",
        "loadError": "Não foi possível carregar os locais do seu Business Profile. Tente novamente.",
        "retryButton": "Tentar novamente",
        "selectAtLeastOneHint": "Selecione pelo menos um local ou reative Monitorar todos os locais.",
        "saveButton": "Salvar",
        "cancelButton": "Cancelar",
        "saveSuccess": "Preferências de locais salvas.",
        "saveError": "Houve um problema ao salvar suas preferências de locais. Tente novamente."
      }
    },
    "requestIntegration": {
      "title": "Não encontrou a integração que você precisa?",
      "description": "Nossa lista de integrações está crescendo. Se a que você precisa ainda não está aqui, fique à vontade para solicitá-la e nos ajudar a priorizar.",
      "button": "Solicitar integração"
    },
    "requestIntegrationModal": {
      "title": "Solicitar integração",
      "subtitle": "Ajude a gente a entender o que você gostaria de conectar. Sua sugestão pode definir nosso próximo lançamento!",
      "integrationRequested": "Nome da integração",
      "integrationRequestedPlaceholder": "ex.: Microsoft Planner",
      "integrationRequestedRequired": "O nome da integração é obrigatório",
      "integrationReason": "Por que você precisa desta integração?",
      "integrationReasonPlaceholder": "Descreva brevemente seu caso de uso ou objetivo",
      "integrationReasonRequired": "Este campo é obrigatório",
      "successTitle": "Integração solicitada com sucesso!",
      "successMessage": "Sua solicitação de integração foi enviada com sucesso.",
      "errorTitle": "Falha ao solicitar a integração",
      "errorMessage": "Houve um problema ao solicitar a integração. Tente novamente.",
      "cancel": "Cancelar",
      "submit": "Enviar"
    },
    "whatsApp": {
      "connectSuccess": "WhatsApp Business conectado com sucesso.",
      "connectError": "Houve um problema ao conectar o WhatsApp Business. Tente novamente.",
      "connectTimeout": "A conexão com o WhatsApp expirou. Tente novamente."
    },
    "slackSettingsModal": {
      "title": "Selecionar canais do Slack",
      "subtitle": "Escolha os canais onde você quer adicionar o assistente do t+t. Apenas canais públicos estão listados abaixo",
      "success": "Configurações do Slack salvas com sucesso!",
      "error": "Falha ao salvar as configurações do Slack. Tente novamente.",
      "cancel": "Cancelar",
      "save": "Salvar",
      "channelsSearch": "Buscar...",
      "channelsSelectAll": "Selecionar todos os canais"
    },
    "manageAccountsModal": {
      "title": "Gerenciar contas",
      "subtitle": "Veja e gerencie suas contas conectadas. Você pode desconectar ou adicionar novas quando quiser.",
      "addAnotherAccountButton": "Adicionar outra conta",
      "addAnotherGmailButton": "Adicionar outra conta do Gmail",
      "addAnotherGoogleCalendarButton": "Adicionar outra conta do Google Calendar",
      "addAnotherGoogleChatButton": "Adicionar outra conta do Google Chat",
      "addAnotherGoogleDriveButton": "Adicionar outra conta do Google Drive",
      "addAnotherGoogleBusinessButton": "Adicionar outra conta do Google Business Profile",
      "addAnotherOutlookButton": "Adicionar outra conta do Outlook Mail",
      "addAnotherOutlookCalendarButton": "Adicionar outra conta do Outlook Calendar",
      "addAnotherTeamsButton": "Adicionar outra conta do Teams",
      "addAnotherSlackWorkspaceButton": "Adicionar outro workspace do Slack",
      "addAnotherInstagramButton": "Adicionar outra conta do Instagram",
      "addAnotherFacebookPageButton": "Adicionar outra página do Facebook",
      "addAnotherGitHubOrgButton": "Adicionar outra organização do GitHub",
      "addAnotherWhatsAppNumberButton": "Adicionar outro número do WhatsApp",
      "channelsButton": "Canais",
      "githubAllRepositoriesSelected": "Todos os repositórios selecionados",
      "githubMoreRepositories": "+{{remaining}} outros",
      "closeButton": "Fechar",
      "unsubscribeSuccess": "{{account}} desconectada com sucesso!",
      "unsubscribeError": "Falha ao desconectar. Tente novamente.",
      "urlError": "Falha ao conectar. Tente novamente mais tarde."
    },
    "disconnectAccountModal": {
      "title": "Desconectar conta",
      "subtitle": "Como você quer desconectar <b>{{account}}</b>?",
      "cancelButton": "Cancelar",
      "confirmButton": "Desconectar conta",
      "keepDataOption": "Manter meus dados",
      "keepDataDescription": "Interrompe a sincronização e revoga o acesso, mas mantém suas mensagens e dados existentes.",
      "outlookKeepDataDescription": "Interrompe a sincronização e mantém o que já foi sincronizado.",
      "outlookSharedSignInNote": "O Outlook Mail e o Outlook Calendar compartilham o mesmo login da Microsoft, que continua conectado até os dois serem desconectados.",
      "deleteDataOption": "Excluir meus dados",
      "deleteDataDescription": "Exclui permanentemente os dados sincronizados do que você está desconectando aqui. Tudo o mais conectado a esta conta mantém seus dados.",
      "typeToConfirm": "Isso não pode ser desfeito — digite <b>{{account}}</b> para confirmar.",
      "typeToConfirmInputLabel": "Digite o nome da conta para confirmar a exclusão"
    },
    "telegramAssistant": {
      "description": "Fale com o Assistente no Telegram para <b>executar ações remotamente</b> do seu celular, de onde estiver:<br/><ul><li><b>Executar ações e disparar fluxos</b></li><li><b>Respostas rápidas em movimento</b></li></ul>",
      "status": {
        "connected": "Conectado",
        "notConnected": "Não conectado"
      },
      "pending": {
        "waiting": "Aguardando você iniciar o bot…"
      },
      "actions": {
        "connect": "Conectar bot",
        "openInTelegram": "Abrir no Telegram",
        "disconnect": "Desconectar"
      },
      "connectError": "Não foi possível abrir o Telegram. Tente novamente.",
      "disconnectSuccess": "Telegram desconectado.",
      "disconnectError": "Não foi possível desconectar o Telegram. Tente novamente.",
      "disconnectModal": {
        "title": "Desconectar bot do Telegram",
        "description": "Você deixará de ter o Assistente no Telegram até conectar novamente.",
        "confirm": "Desconectar"
      }
    },
    "refreshFailed": "Não foi possível atualizar algumas integrações. Mostrando o último status conhecido.",
    "mobileBanner": "Configurar integrações é mais fácil em um computador do que em um dispositivo móvel",
    "catalog": {
      "view": {
        "grid": "Visualização em grade",
        "list": "Visualização em lista"
      },
      "scopeToggleAriaLabel": "Escopo da integração",
      "viewToggleAriaLabel": "Visualização das integrações",
      "title": "Integrações",
      "subtitle": "Conecte suas ferramentas para o assistente triar e-mails, conversas e tarefas por você.",
      "connectedCount": "{{connected}} de {{total}} conectadas",
      "scope": {
        "personal": "Pessoais",
        "team": "Da equipe",
        "ariaLabel": "Escopo da integração"
      },
      "teamBannerText": "Estas integrações pertencem à sua equipe — conectadas uma vez por um admin e válidas para todos os membros. As integrações que só você usa ficam em <strong>Pessoais</strong>.",
      "searchInput": {
        "clearLabel": "Limpar pesquisa"
      },
      "searchPlaceholderPersonal": "Procurar integrações…",
      "searchPlaceholderTeam": "Procurar integrações da equipe…",
      "sort": {
        "recent": "Recentes",
        "alpha": "A – Z",
        "status": "Por status"
      },
      "viewToggle": {
        "ariaLabel": "Modo de exibição",
        "gridLabel": "Visualização em grade",
        "listLabel": "Visualização em lista"
      },
      "tabs": {
        "all": "Todas",
        "connected": "Conectadas",
        "available": "Disponíveis"
      },
      "categories": {
        "all": "Tudo",
        "communication": "Comunicação",
        "emailCalendar": "E-mail & Agenda",
        "productivity": "Produtividade",
        "dataAi": "Dados & IA",
        "design": "Design",
        "marketingCrm": "Marketing & CRM",
        "dev": "Dev"
      },
      "status": {
        "connected": "Conectada",
        "available": "Disponível",
        "connecting": "Conectando…",
        "error": "Erro na conexão"
      },
      "actions": {
        "connect": "Conectar",
        "manage": "Gerenciar",
        "connecting": "Conectando…",
        "retry": "Tentar novamente",
        "configure": "Configurar",
        "sync": "Sincronizar agora",
        "disconnect": "Desconectar",
        "disconnectTeam": "Desconectar da equipe",
        "editMcp": "Editar MCP",
        "openInTelegram": "Abrir no Telegram"
      },
      "busy": {
        "syncing": "Sincronizando…",
        "disconnecting": "Desconectando…"
      },
      "disconnectSuccess": "{{name}} desconectado.",
      "disconnectError": "Não foi possível desconectar {{name}}. Tente novamente.",
      "disconnectConfirm": {
        "title": "Desconectar {{name}}?",
        "description": "O assistente deixa de usar essa conexão. Você pode conectar de novo depois.",
        "action": "Desconectar"
      },
      "teamBadge": "Equipe",
      "mcpBadge": "MCP",
      "teamOwnerFallback": "Compartilhada com a equipe",
      "emptyState": {
        "title": "Nenhuma integração encontrada",
        "subtitle": "Tente outro termo de busca ou troque os filtros selecionados.",
        "clearFilters": "Limpar filtros"
      },
      "requestFooter": {
        "titlePersonal": "Não encontrou a integração que precisa?",
        "subtitlePersonal": "Nossa lista está crescendo. Solicite e ajude a priorizar.",
        "titleTeam": "Precisa de outra integração para a equipe?",
        "subtitleTeam": "Solicite e nossa equipe avalia a inclusão no catálogo compartilhado."
      },
      "configModal": {
        "subtitle": "Configurações da integração",
        "permissionsTitle": "Permissões concedidas",
        "mcpTitle": "Também disponível como MCP",
        "mcpActiveBadge": "Servidor ativo",
        "mcpDescription": "Por expor um servidor Model Context Protocol, o assistente consulta esta ferramenta em tempo real — sem sincronização agendada.",
        "mcpEndpointLabel": "Endpoint do servidor",
        "mcpToolsLabel": "Ferramentas expostas ao assistente",
        "scopePersonal": "Pessoal",
        "scopeTeam": "Equipe",
        "footNotePersonal": "Válida apenas para a sua conta.",
        "footNoteTeam": "Válida para todos os membros da equipe."
      },
      "descriptions": {
        "outlookMail": "Leia, busque e responda seus e-mails do Outlook.",
        "outlookCalendar": "Veja sua agenda do Outlook e crie ou atualize eventos.",
        "googleChat": "Espaços e mensagens diretas do Google Chat.",
        "slack": "Canais e mensagens diretas do Slack.",
        "teams": "Chats e conversas do Microsoft Teams.",
        "whatsApp": "Transforme mensagens do WhatsApp em sugestões.",
        "googleDrive": "Acesse e gerencie arquivos e pastas do Drive.",
        "googleBusiness": "Gerencie avaliações e informações do seu perfil no Google.",
        "telegram": "Execute ações e dispare fluxos pelo Telegram.",
        "slackBot": "Adicione o bot do t+t a canais e dispare fluxos a partir de mensagens do Slack.",
        "instagram": "Conversas e mensagens diretas do Instagram da equipe.",
        "messenger": "Páginas do Facebook para responder comentários e mensagens pelo assistente.",
        "github": "Issues, pull requests e código dos repositórios da equipe.",
        "gmail": "Leia, busque e responda seus e-mails.",
        "googleCalendar": "Veja sua agenda e crie ou atualize eventos."
      }
    },
    "github": {
      "installationRequested": "Installation requested. A GitHub organization owner has to approve it — we'll connect automatically once they do.",
      "pendingApprovalRowDescription": "Waiting for an organization owner to approve. It connects on its own once approved."
    },
    "googleSurfaces": {
      "gmail": "Gmail",
      "calendar": "Google Agenda",
      "chat": "Google Chat",
      "drive": "Google Drive",
      "businessProfile": "Perfil da Empresa no Google"
    },
    "googleRevokeWarning": {
      "title": "Isso desconecta sua conta Google inteira",
      "intro": "Desconectar vai remover todas as integrações Google de",
      "reason": "O Google concede acesso à conta como um todo, então não há como desconectar um serviço e manter os outros. É assim que o Google funciona, não é uma limitação do app.",
      "dataKept": "Suas mensagens, eventos e arquivos continuam no app. Reconecte quando quiser para voltar a sincronizar.",
      "confirm": "Desconectar tudo",
      "cancel": "Manter conectado",
      "heading": "Desconectar remove todos os serviços Google desta conta:",
      "reconnect": "Você vai precisar reconectar os que quiser continuar usando.",
      "accountDisconnected": "Conta Google desconectada. Reconecte os serviços que quiser continuar usando."
    },
    "googleRestoreBanner": {
      "title": "Você desconectou {{account}}",
      "surfaces": "Reconecte {{surfaces}} em uma única etapa clicando no botão deste banner.",
      "restore": "Reconectar",
      "dismiss": "Dispensar",
      "restoreError": "Não foi possível iniciar a reconexão. Tente novamente."
    }
  },
  "server": {
    "calendar": {
      "defaultMeetingName": "Reunião da agenda"
    }
  },
  "support": {
    "haveQuestions": "Tem dúvidas sobre o produto?",
    "consultFAQ": "Consulte o FAQ",
    "home": {
      "title": "Ajuda + suporte",
      "description": "Tem dúvidas? Encontre respostas aqui ou fale com a gente — estamos prontos para ajudar!",
      "gettingStartedCta": "Novo no this+that? Leia o guia de primeiros passos",
      "systemStatus": "Status do sistema",
      "sections": [
        {
          "id": "getting-setup",
          "title": "Configuração inicial",
          "bgColor": "green",
          "description": "Acabou de chegar? Aqui está o guia para configurar e sincronizar tudo!",
          "contentKey": "getting-setup"
        },
        {
          "id": "using-the-tool",
          "title": "Usando a ferramenta",
          "bgColor": "blue",
          "description": "Visite esta página para se familiarizar com a ferramenta.",
          "contentKey": "using-the-tool"
        },
        {
          "id": "faqs",
          "title": "FAQ | Geral",
          "bgColor": "blue",
          "description": "Tem dúvidas? Talvez a gente já tenha respondido!",
          "contentKey": "faqs"
        },
        {
          "id": "security-privacy-FAQ",
          "title": "FAQ | Segurança + privacidade",
          "bgColor": "green",
          "description": "Nosso FAQ dedicado à segurança.",
          "contentKey": "security-privacy-FAQ"
        },
        {
          "id": "mcp-server",
          "title": "this+that nas suas ferramentas de IA",
          "bgColor": "green",
          "description": "Use seu DoBox e seu Brain em assistentes de IA como o Claude.",
          "contentKey": "mcp-server"
        }
      ]
    },
    "sections": {
      "second": {
        "getAnswers": "Encontre as respostas de que você precisa",
        "letsConnect": "Vamos nos conectar",
        "letsConnectDescription": "Conecte-se com a gente nas redes sociais e fique por dentro das novidades, ou escreva para support@thisandthat.chat!",
        "letsConnectInline": "Mais dúvidas? Escreva para support@thisandthat.chat ou siga a gente:"
      }
    }
  },
  "toast": {
    "success": "Sucesso",
    "error": "Erro",
    "info": "Info",
    "warning": "Aviso",
    "loading": "Carregando..."
  },
  "team": {
    "chooseTeamName": "Escolha um nome para a equipe",
    "pageTitle": "Equipe",
    "noTeamMembers": "Ainda não há membros na equipe",
    "pageAdminDescription": "Convide os membros da sua equipe e fiquem em dia com as comunicações — juntos.",
    "pageMemberDescription": "Veja os membros da sua equipe.",
    "addMember": "Adicionar membro",
    "editMember": "Editar membro",
    "delete": "Remover",
    "edit": "Editar",
    "leaveTeam": "Sair da equipe",
    "pendingInvitation": "Convite pendente",
    "resend": "Reenviar",
    "loadingMessage": "Carregando, aguarde.",
    "successMessages": {
      "deleteMember": "Membro removido com sucesso!",
      "updateTeamName": "Nome da equipe atualizado com sucesso!",
      "inviteSent": "Convite de equipe enviado com sucesso!",
      "updateMember": "Membro da equipe atualizado com sucesso"
    },
    "errorMessage": {
      "somethingWentWrong": "Ops, algo deu errado. Tente novamente."
    },
    "tableTitles": {
      "name": "nome",
      "email": "e-mail",
      "title": "cargo"
    },
    "modal": {
      "title": "Adicionar novo membro",
      "editTitle": "Editar membro",
      "deleteTitle": "Sair da equipe",
      "deleteDescription": "Tem certeza de que deseja sair desta equipe? Esta ação não pode ser desfeita.",
      "deleteActionButtonLabel": "Sair",
      "cancelButtonLabel": "Cancelar"
    },
    "form": {
      "roleLabel": "Função",
      "rolePlaceholder": "Selecionar",
      "roleRequired": "A função é obrigatória",
      "emailPlaceholder": "E-mail do membro da equipe"
    },
    "buttons": {
      "addAndClose": "Adicionar e fechar",
      "addAnother": "Adicionar outro",
      "save": "Salvar"
    }
  },
  "components": {
    "connectProviderEmptyState": {
      "connectButton": "Conectar {{provider}}",
      "seeAllIntegrations": "Ver todas as integrações",
      "providers": {
        "gmail": "Gmail",
        "google": "Google",
        "outlook": "Outlook"
      }
    },
    "privacyBlock": {
      "heading": "Feito para manter tudo privado",
      "commitmentsLink": "Nossos compromissos de segurança",
      "encrypted": "Criptografado em trânsito e em repouso",
      "soc2": "SOC 2 Type I",
      "soc2Tag": "Type II em andamento",
      "noTraining": "Nunca usado para treinar IA"
    },
    "deleteModal": {
      "cancel": "Cancelar"
    },
    "lists": {
      "searchPlaceholder": "Buscar...",
      "noResults": "Nenhuma etiqueta encontrada"
    },
    "managePerson": {
      "searchPlaceholder": "Nome ou e-mail",
      "addMember": "Adicionar um novo membro",
      "closeButton": "Fechar",
      "searchNotFound": "Nenhum membro da equipe corresponde à sua busca.",
      "askAdminToAddMember": "Peça ao administrador para adicionar um membro."
    },
    "timePicker": {
      "title": "Digite a duração",
      "doneButton": "Concluído",
      "minutes": "min",
      "suggestionsLabel": "Sugestões de horário"
    },
    "timezoneSelector": {
      "searchPlaceholder": "Buscar fusos horários...",
      "ariaLabel": "Selecionar fuso horário",
      "placeholder": "Fuso horário",
      "noResults": "Nenhum fuso horário encontrado"
    },
    "assigneeDrawer": {
      "title": "Responsáveis"
    },
    "priorityDrawer": {
      "title": "Prioridade"
    },
    "activityLog": {
      "title": "Registro de atividades",
      "closeButton": "Fechar"
    },
    "discussion": {
      "title": "Discussões",
      "send": "Enviar",
      "noDiscussion": "Ainda não há discussões",
      "placeholder": "Escreva um comentário",
      "collapseAll": "Recolher tudo",
      "expandAll": "Expandir tudo",
      "openSource": "Ver mensagem original"
    },
    "durationDrawer": {
      "title": "Duração",
      "minutes": "minutos",
      "setCustomDuration": "Definir duração personalizada",
      "closeButton": "Fechar"
    },
    "moveToDoBoxModal": {
      "title": "Mover para o DoBox",
      "loadError": "Falha ao carregar as entradas do DoBox",
      "noDoBoxEntries": "Nenhuma entrada do DoBox encontrada. Crie uma nova para começar.",
      "noDoBoxEntriesMultipleEmails": "Nenhuma entrada do DoBox encontrada. Para gerar uma nova entrada do DoBox com IA, selecione apenas um e-mail.",
      "communicationCount": "{{count}} e-mail{{s}}",
      "moving": "Movendo...",
      "moveButton": "Mover",
      "successSingle": "E-mail movido para o DoBox com sucesso",
      "successMultiple": "{{count}} e-mails movidos para o DoBox com sucesso",
      "error": "Falha ao mover os e-mails. Tente novamente.",
      "segmentExisting": "DoBox existente",
      "segmentGenerate": "Gerar novo",
      "generateTaskButton": "Gerar tarefa",
      "selectAriaLabel": "Selecionar {{subject}}",
      "infoPanelTitle": "A IA vai redigir uma nova tarefa do DoBox",
      "infoPanelDescription": "Ela lê este e-mail e propõe um título, um resumo e o contexto de prazo. Você pode revisar e editar tudo antes da criação.",
      "infoPanelDestLabel": "Ela será adicionada a",
      "generatingTitle": "Analisando e-mail…",
      "generatingDescription": "Redigindo um título, um resumo e o contexto de prazo para a sua tarefa",
      "generating": "Gerando...",
      "participantIdsCount": "{{count}} membro{{s}}",
      "alreadyLinked": "Já vinculado"
    },
    "moveTaskToAnotherList": {
      "title": "Mover tarefa para outra lista",
      "selectedTask": "Tarefa selecionada",
      "selectList": "Selecione uma lista para mover a sua tarefa",
      "selectPlaceholder": "Selecione uma lista"
    },
    "inboxEntryDetailsModal": {
      "suggestionNotice": {
        "title": "Sugestão da IA",
        "acceptWithList": "<b>Aceitar</b> cria a tarefa em {{listName}}.",
        "acceptWithoutList": "<b>Aceitar</b> transforma em tarefa.",
        "rejectWithSource": "<b>Rejeitar</b> exclui só a sugestão; a mensagem de origem continua onde está.",
        "rejectWithoutSource": "<b>Rejeitar</b> exclui a sugestão."
      },
      "assistantPanel": {
        "openAssistant": "Abrir assistente",
        "closeAssistant": "Fechar assistente",
        "executorPlaceholder": "Diga o que resolver aqui…"
      },
      "doBoxReplyPanel": {
        "backToOptionsAriaLabel": "Voltar para as opções",
        "sentReceiptLabel": "Enviado para {{name}} · {{time}}",
        "sentNoteMarkedDone": "Marquei este DoBox como concluído.",
        "sentNoteStillOpen": "Este DoBox ainda está aberto, então eu o mantive na sua lista. Ainda disponíveis:",
        "relativeTime": {
          "justNow": "agora mesmo",
          "minutesAgo": "{{count}}min atrás",
          "hoursAgo": "{{count}}h atrás",
          "daysAgo": "{{count}}d atrás"
        },
        "title": {
          "reply": "Responder a {{name}}",
          "replyAll": "Responder a todos",
          "forward": "Encaminhar",
          "replySlack": "Responder no Slack"
        },
        "subtitle": "E-mail · {{subject}}",
        "subtitleSlackChannel": "#{{channel}}",
        "subtitleSlackDm": "DM com {{name}}",
        "generatingLabel": "Gerando sua resposta…",
        "revisingLabel": "Aplicando suas alterações…",
        "generateError": "Não foi possível gerar uma resposta. Tente novamente.",
        "reviseError": "Não foi possível aplicar essa alteração. Tente novamente.",
        "sendPreparationError": "Não foi possível enviar: não foi possível identificar a conta deste e-mail.",
        "draftCard": {
          "toLabel": "Para",
          "ccLabel": "Cc",
          "subjectLabel": "Assunto",
          "bodyAriaLabel": "Corpo da resposta",
          "bodyPlaceholder": "Escreva sua resposta…",
          "openFullEditor": "Abrir editor completo",
          "send": "Enviar",
          "sendAndMarkDone": "Enviar e marcar como concluído",
          "moreSendOptionsAriaLabel": "Mais opções de envio"
        },
        "replyWith": {
          "chip": {
            "label": "Escrever com IA"
          },
          "intent": {
            "placeholder": "Responda com… ex.: 'concordo, sugira quinta-feira'",
            "inputLabel": "Enviar este ajuste",
            "helper": "Diga o que mudar, ou o que você quer dizer."
          },
          "context": {
            "label": "Contexto",
            "thisThread": "Esta conversa",
            "escToClose": "Esc para voltar"
          }
        }
      },
      "agentSetupPanel": {
        "header": {
          "backToTaskAriaLabel": "Voltar para a tarefa",
          "backAriaLabel": "Voltar",
          "cancelSetupAriaLabel": "Cancelar configuração",
          "title": "Novo agente",
          "stepOf": "Passo {{step}} de {{total}}"
        },
        "advancedPartialSaveError": "O agente foi salvo, mas algumas configurações avançadas não puderam ser aplicadas. Abra-o em seus agentes para revisar.",
        "saveError": "Não foi possível salvar este agente. Tente novamente.",
        "step1": {
          "title": "O que ele deve fazer?",
          "helper": "Explique como se fosse para um novo colega de equipe. Montei isto com base no que você me contou.",
          "jobLabel": "O trabalho",
          "learnedFromTaskTitle": "Aprendido nesta tarefa",
          "learnedFromTaskAuthorChannel": "{{author}} · {{channel}}",
          "nameLabel": "Nome",
          "nameHint": "Você pode renomear quando quiser.",
          "advancedSettings": "Configurações avançadas",
          "continue": "Continuar",
          "buildingYourAgent": "Montando seu agente…",
          "regenerateError": "Não foi possível refazer este agente. Tente novamente.",
          "resultDelivery": "O resultado volta como {{delivery}}",
          "resultDeliveryLabel": {
            "doBoxComment": "um comentário nesta tarefa",
            "replyDraft": "um rascunho de resposta por e-mail",
            "notification": "uma notificação"
          }
        },
        "conversation": {
          "greeting": "O que este agente deve fazer por você? Descreva o trabalho como explicaria para um novo colega de equipe. Vou conferir suas integrações conectadas e perguntar como você quer receber o resultado.",
          "placeholder": "Descreva o que o agente deve fazer",
          "send": "Enviar",
          "listAriaLabel": "Conversa de configuração do agente",
          "thinking": "Pensando…",
          "thinkingSlow": "Ainda trabalhando nisso. Pode levar mais alguns segundos…",
          "limitReached": "Esta conversa ficou longa. Recomece para continuar descrevendo o agente.",
          "restart": "Recomeçar",
          "turnFailed": "Isso não foi enviado. Sua mensagem foi mantida.",
          "retry": "Tentar novamente",
          "draftReadyMessage": "Seu agente está pronto para revisar. Volte aqui quando quiser para mudar o que ele faz.",
          "blocked": {
            "title": "Ainda não conectado",
            "connectLink": "Conectar integrações"
          },
          "placeholderReply": "Escreva sua resposta…"
        },
        "step2": {
          "title": "O que ele pode usar?",
          "helper": "Suas conexões. Liguei só o que este trabalho precisa.",
          "builtInToolsTitle": "O que ele vai usar",
          "otherToolSetsNote": "Também ligado para este agente: {{names}}",
          "connectionsTitle": "Conexões que ele vai usar",
          "otherConnections": "Outras conexões ({{count}})",
          "yourConnection": "Sua conexão",
          "connected": "Conectado",
          "viewOnly": "Só consulta",
          "changesData": "Altera dados",
          "limitLabel": "Máximo de {{param}} por pedido",
          "limitLabelGeneric": "Máximo de resultados por pedido",
          "limitError": "Informe um número maior que 0",
          "continueBlocked": "Informe um número maior que 0 em \"{{tool}}\" para continuar.",
          "whoCanUseIt": "Quem pode usar",
          "onlyMe": "Só eu",
          "myTeam": "Meu time",
          "connectMoreLink": "Precisa de um sistema que não está aqui? Conecte em Integrações",
          "back": "Voltar",
          "continue": "Continuar",
          "missingConnection": {
            "title": "Ainda não conectado",
            "body": "Este trabalho precisa de {{connection}}. Conecte em Integrações e volte depois.",
            "connectLink": "Conectar em Integrações",
            "saveAsDraft": "Salvar como rascunho",
            "savedAsDraftToast": "Salvo como rascunho"
          },
          "noToolsSelected": "Nada ligado ainda. Abra a lista abaixo para adicionar o que ele precisa.",
          "moreToolsTitle": "Mais coisas que ele poderia usar ({{count}})",
          "tools": {
            "EMAIL_ACTIONS": "Enviar, rascunhar e organizar e-mails",
            "NOTIFICATIONS": "Avisar você por Slack ou e-mail",
            "DOBOX": "Ler e editar suas tarefas",
            "CALENDAR": "Gerenciar sua agenda e convites",
            "LOAD_MEETINGS": "Consultar suas reuniões",
            "KNOWLEDGE": "Buscar e ler suas páginas do Brain",
            "KNOWLEDGE_WRITE": "Buscar, ler e editar suas páginas do Brain",
            "PEOPLE": "Consultar e atualizar seus contatos"
          }
        },
        "step3": {
          "title": "Testar nesta tarefa",
          "helper": "Veja o que {{name}} faria aqui. Nada muda até você aprovar.",
          "loading": "Trabalhando nisso…",
          "viewOnlyDone": "Só leitura · concluído",
          "changesDataDone": "Fez uma alteração · concluído",
          "changesDataNeedsApproval": "Faz uma alteração · precisa do seu OK",
          "changesDataOnApprove": "Faz uma alteração · aplicada quando você aprovar",
          "partialPreviewNote": "Esta prévia mostra só parte do trabalho: {{name}} cria algo primeiro, e os passos que dependem disso acontecem numa execução completa.",
          "limitLabel": "Máximo de {{param}} por pedido",
          "limitLabelGeneric": "Máximo de resultados por pedido",
          "limitHint": "limite {{max}}",
          "limitError": "Informe um número de 1 a {{max}}",
          "limitErrorRequired": "Informe um número maior que 0",
          "stepFailedGeneric": "Esta etapa falhou.",
          "editJob": "Editar o trabalho",
          "backToActions": "Voltar para as ações",
          "approveAndSave": "Aprovar e salvar agente",
          "wouldSendBot": "Enviaria para {{destination}} como o bot",
          "wouldSendUser": "Enviaria para {{destination}} em seu nome",
          "previewOnlyBadge": "Prévia · nada é enviado",
          "previewNote": "Esta é uma prévia: nada é enviado daqui. Entregue uma tarefa a {{name}} para enviar a mensagem de verdade.",
          "saveWithoutRunning": "Salvar sem executar",
          "emptyState": "{{name}} não encontrou nada para fazer nesta tarefa. Se esta tarefa deveria ter servido para ele, tente de novo ou refine o trabalho. Se não, você ainda pode salvá-lo e ele estará pronto quando uma tarefa precisar.",
          "tryAgain": "Tentar de novo",
          "refineJob": "Refinar o trabalho",
          "runningEmpty": "Testando nesta tarefa…",
          "saveAgent": "Salvar agente",
          "startError": "Não foi possível iniciar o teste. Tente novamente.",
          "timeoutError": "Isso está demorando mais do que o esperado. Tente novamente.",
          "previewStillRunningError": "A prévia ainda está em andamento. Aguarde terminar e aprove.",
          "approveError": "Não foi possível salvar este agente. Tente novamente.",
          "showFullText": "Ver texto completo",
          "hideFullText": "Ver menos",
          "shortenedNote": "Esta é uma prévia resumida do que será escrito.",
          "safetyNoteAsk": "{{name}} vai perguntar antes de cada alteração.",
          "safetyNoteSkip": "Depois de salvo, {{name}} vai fazer as alterações na hora nas próximas tarefas. Uma mensagem do Slack só sai sem pedir aprovação quando vai para um destino escolhido aqui, é enviada como o bot e foi você quem iniciou a execução.",
          "safetyNoteAutonomous": "{{name}} vai enviar e-mails e mensagens para as pessoas e os lugares salvos nele e marcar eventos no calendário com convite, sem pedir sua aprovação. Um e-mail não pode ser desfeito.",
          "safetyNoteAutonomousStillAsks": "Ainda pede aprovação antes quando for alguém não salvo neste agente, apagar, apps conectados, dinheiro ou assuntos jurídicos, um canal compartilhado com outra empresa, uma resposta cujo remetente não pôde ser verificado e sempre que um colega executa o agente.",
          "wouldSendWithoutAsking": "Enviaria sem pedir",
          "wouldCreateWithoutAsking": "Criaria sem pedir",
          "safetyNoteSkipStillAsks": "Ainda pede aprovação antes quando a mensagem é enviada em seu nome, vai para qualquer outro lugar, menciona dinheiro ou assuntos jurídicos, vai para um canal compartilhado com outra empresa ou quando um colega executa o agente.",
          "changeInSettings": "Mude isso em Flows › seus agentes",
          "wouldAskAndWait_one": "Perguntaria a {{recipients}} e esperaria até {{count}} hora",
          "wouldAskAndWait_other": "Perguntaria a {{recipients}} e esperaria até {{count}} horas"
        },
        "done": {
          "readyTitle": "{{name}} está pronto",
          "readySubtitle": "Você pode passar qualquer tarefa para {{name}} pelo menu \"Para\".",
          "readySubtitleApplied": "{{name}} já fez isso nesta tarefa. Veja abaixo o que foi feito.",
          "readySubtitleSetupOnly": "{{name}} só preparou o terreno até agora. Entregue esta tarefa a ele para o trabalho de verdade.",
          "whatItDid": "O que ele fez",
          "previewNote": "Nada foi enviado: isto foi uma prévia. Entregue uma tarefa a {{name}} para enviar a mensagem de verdade.",
          "approvedByYou": "{{label}} · aprovado por você",
          "partiallyApplied_one": "{{applied}} de {{count}} etapa aprovada foi aplicada. As demais não foram. Veja a lista abaixo e abra a conversa da tarefa para tentar de novo.",
          "partiallyApplied_other": "{{applied}} de {{count}} etapas aprovadas foram aplicadas. As demais não foram. Veja a lista abaixo e abra a conversa da tarefa para tentar de novo.",
          "noneApplied_one": "A etapa aprovada não foi aplicada. Veja a lista abaixo e abra a conversa da tarefa para tentar de novo.",
          "noneApplied_other": "Nenhuma das {{count}} etapas aprovadas foi aplicada. Veja a lista abaixo e abra a conversa da tarefa para tentar de novo.",
          "openConversation": "Abrir a conversa da tarefa",
          "cannotUndoMcp": "Não pode ser desfeito automaticamente",
          "next": "Próximos passos",
          "replyToRequester": "Responder quem pediu",
          "replyToRequesterBadge": "Rascunho · você revisa",
          "shareWithTeam": "Compartilhar {{name}} com meu time",
          "shareWithTeamBadge": "Configurações",
          "shareSuccess": "Compartilhado com seu time.",
          "shareError": "Esta tarefa não está compartilhada com um time.",
          "outcome": {
            "executed": "Feito",
            "failed": "Não funcionou",
            "previewOnly": "Prévia · nada foi enviado",
            "wouldSendBot": "Enviaria para {{destination}} como o bot",
            "wouldSendUser": "Enviaria para {{destination}} em seu nome",
            "notStarted": "Não foi executado",
            "noReason": "Nenhum motivo foi informado.",
            "wouldAskAndWait_one": "Perguntaria a {{recipients}} e esperaria até {{count}} hora",
            "wouldAskAndWait_other": "Perguntaria a {{recipients}} e esperaria até {{count}} horas"
          },
          "delegateTask": "Passar esta tarefa para {{name}}",
          "delegateAgain": "Passar esta tarefa para {{name}} de novo",
          "delegateAgainBadge": "Executa uma segunda vez"
        },
        "leaveConfirm": {
          "title": "Sair sem terminar?",
          "body": "Este agente ainda não está pronto e não vai aparecer na sua lista de Agentes. Se você sair agora, vai precisar configurá-lo de novo desde o início.",
          "keepEditing": "Continuar editando",
          "leave": "Sair"
        },
        "caveats": {
          "title": "Antes de o agente poder trabalhar"
        },
        "saveOutboundError": "Não foi possível salvar onde este agente pode enviar. Confira se cada workspace do Slack está conectado para o \"Enviar como\" que você escolheu."
      },
      "activity": {
        "title": "Atividade",
        "filterActivity": "Atividade",
        "filterComments": "Comentários"
      },
      "header": {
        "title": "Detalhes da tarefa",
        "copyLink": "Copiar link",
        "copyLinkAriaLabel": "Copiar link de {{subject}}",
        "copyLinkSuccess": "Link copiado para a área de transferência",
        "copyLinkError": "Falha ao copiar o link para a área de transferência",
        "complete": "Concluído",
        "completeAriaLabel": "Marcar {{subject}} como concluída",
        "markDone": "Concluir",
        "completed": "Concluída",
        "deleteTask": "Excluir tarefa",
        "moveSuccess": "Tarefa movida com sucesso",
        "maximize": "Maximizar",
        "minimize": "Minimizar",
        "maximizeAriaLabel": "Maximizar janela",
        "minimizeAriaLabel": "Minimizar janela"
      },
      "notFound": "Este DoBox não foi encontrado. Ele pode ter sido excluído, ou você pode não ter acesso.",
      "removed": {
        "suggestion": "Esta sugestão foi removida: foi excluída, ou uma mensagem mais recente da conversa mostrou que já estava resolvida.",
        "task": "Este DoBox foi excluído.",
        "taskViewOnly": "Você ainda pode visualizá-lo, mas não pode editá-lo.",
        "writeRejected": "Este DoBox foi excluído, então sua alteração não foi salva."
      },
      "deleteSuccess": "Tarefa sugerida excluída com sucesso.",
      "deleteError": "Falha ao excluir a tarefa sugerida. Tente novamente.",
      "updateSuccess": "Tarefa atualizada com sucesso.",
      "updateError": "Falha ao atualizar a tarefa. Tente novamente.",
      "updateDueDateSuccess": "Prazo atualizado com sucesso.",
      "updateDueDateError": "Falha ao atualizar o prazo. Tente novamente.",
      "confirmDelete": {
        "title": "Excluir tarefa sugerida",
        "message": "Tem certeza de que deseja excluir esta tarefa sugerida? Esta ação não pode ser desfeita.",
        "confirm": "Excluir"
      },
      "entryInfo": {
        "subject": "Assunto",
        "description": "Descrição",
        "createdFor": "Criada para",
        "createdAt": "Criada em",
        "communications": "Comunicações",
        "noDescription": "Nenhuma descrição fornecida",
        "addDescriptionPlaceholder": "Adicionar descrição",
        "showMore": "Ver mais",
        "showLess": "Ver menos",
        "editDescription": "Editar descrição",
        "noSubjectText": "Nenhum assunto disponível",
        "priority": "Prioridade",
        "noPriority": "Sem prioridade",
        "labelsTitle": "Etiquetas",
        "descriptionTitle": "Descrição",
        "markdownBadge": "MARKDOWN",
        "originFlow": "Criada por <flow>{{flowName}}</flow>",
        "originFlowDeleted": "Criada por um flow removido",
        "openOriginFlow": "Abrir flow"
      },
      "communications": {
        "title": "Comunicações",
        "emptyTitle": "Ainda não há comunicações",
        "emptySubtitle": "Chats e e-mails vinculados a esta tarefa aparecerão aqui automaticamente.",
        "emptyTitleChat": "Nenhum chat ainda",
        "emptySubtitleChat": "Chats vinculados a esta tarefa aparecerão aqui automaticamente.",
        "emptyTitleEmail": "Nenhum e-mail ainda",
        "emptySubtitleEmail": "E-mails vinculados a esta tarefa aparecerão aqui automaticamente.",
        "filterAriaLabel": "Filtrar comunicações",
        "recipients": "Destinatários",
        "replyingBadge": "Respondendo →",
        "newReplyCount_one": "{{count}} nova resposta",
        "newReplyCount": "{{count}} novas respostas",
        "newReplyLabel": "Nova resposta",
        "optimisticSentAuthor": "Você",
        "optimisticRelativeTime": {
          "justNow": "agora mesmo",
          "minutesAgo": "{{count}}min atrás",
          "hoursAgo": "{{count}}h atrás",
          "daysAgo": "{{count}}d atrás"
        },
        "chatActivity": {
          "truncated": "Mostrando as {{count}} mensagens mais recentes desde a criação da tarefa",
          "hiddenForViewer": "Só quem é dono da conversa pode ler as mensagens mais recentes dela."
        },
        "tabs": {
          "all": "Todas",
          "chat": "Chat",
          "email": "E-mail"
        },
        "thread": {
          "replies": "{{count}} respostas na conversa",
          "reply": "1 resposta na conversa",
          "lastReply": "Última resposta de {{author}} {{time}}"
        },
        "body": {
          "showMore": "Ver mais",
          "showLess": "Ver menos"
        }
      },
      "taskLabelSelector": {
        "buttonLabel": "Etiquetas",
        "title": "Selecionar etiquetas",
        "saveError": "Falha ao atualizar as etiquetas. Tente novamente.",
        "addLabel": "Adicionar etiqueta",
        "removeLabel": "Remover etiqueta {{labelTitle}}",
        "showHiddenLabels": "Mostrar mais {{count}} etiquetas"
      },
      "actionsBar": {
        "dueDate": "Prazo",
        "recurrencePopover": "Tarefa recorrente"
      },
      "propertiesGrid": {
        "agentLabel": "Agente",
        "groupLabel": "Propriedades",
        "priorityLabel": "Prioridade",
        "recurringLabel": "Recorrente",
        "repeatLabel": "Repetir",
        "timezoneLabel": "Fuso horário",
        "changeTimezoneAriaLabel": "Alterar fuso horário de {{timezone}}",
        "dueDateLabel": "Prazo",
        "membersLabel": "Membros",
        "noMembersDefaultGroup": "Este grupo de tarefas não tem membros",
        "checklistLabel": "Checklist",
        "linkedLabel": "Vinculadas",
        "labelsLabel": "Etiquetas",
        "setPriority": "+ Definir",
        "setDueDate": "+ Definir",
        "setRecurring": "+ Definir",
        "addMembers": "+ Adicionar",
        "addChecklist": "+ Adicionar",
        "addLinked": "+ Adicionar",
        "noneValue": "Nenhum"
      },
      "checklistPopover": {
        "sectionTitle": "Checklists",
        "buttonLabel": "Checklist",
        "popoverTitle": "Novo checklist",
        "inputPlaceholder": "Título do checklist",
        "itemsLabel": "Itens",
        "itemsOptional": "(opcional)",
        "addAnotherItem": "Adicionar outro item",
        "itemPlaceholderIndexed": "Item {{index}}",
        "removeItem": "Remover item",
        "save": "Salvar",
        "close": "Fechar",
        "delete": "Excluir",
        "deleteChecklist": "Excluir checklist",
        "deleteSubtask": "Excluir subtarefa",
        "editTitle": "Renomear checklist",
        "editSubtask": "Renomear item",
        "menuAriaLabel": "Ações do checklist",
        "rename": "Renomear",
        "hideCheckedItems": "Ocultar itens concluídos",
        "showCheckedItems": "Mostrar itens concluídos",
        "keyboardHint": "Enter para adicionar, Esc para fechar",
        "confirmDeleteChecklist": "Excluir este checklist?",
        "checklistDeleted": "Checklist excluído",
        "undo": "Desfazer",
        "showCheckedCount_one": "Mostrar {{count}} item concluído",
        "showCheckedCount_other": "Mostrar {{count}} itens concluídos",
        "addSubtask": "Adicionar subtarefa",
        "addItem": "Adicionar item",
        "addItemPlaceholder": "Adicione um item",
        "add": "Adicionar",
        "cancel": "Cancelar"
      },
      "participantsModal": {
        "buttonLabel": "Membros",
        "title": "Gerenciar membros",
        "subtitle": "Adicione ou remova membros desta entrada",
        "done": "Concluído",
        "save": "Salvar",
        "cancel": "Cancelar",
        "saveError": "Falha ao atualizar os membros. Tente novamente.",
        "noParticipants": "Nenhum membro disponível",
        "searchPlaceholder": "Buscar membros..."
      },
      "dueDateSaveError": "Falha ao salvar o prazo. Tente novamente.",
      "checklistCreateError": "Falha ao criar o checklist. Tente novamente.",
      "checklistDeleteError": "Falha ao excluir o checklist. Tente novamente.",
      "checklistRenameError": "Falha ao renomear o checklist. Tente novamente.",
      "checklistTitleRequired": "O título do checklist não pode ficar vazio.",
      "checklistLimitReached": "Esta entrada já atingiu o limite de {{max}} checklists.",
      "subtaskLimitReached": "Esta entrada já atingiu o limite de {{max}} itens de checklist.",
      "subtaskTitleRequired": "O título do item não pode ficar vazio.",
      "subtaskAddError": "Falha ao adicionar a subtarefa. Tente novamente.",
      "subtaskDeleteError": "Falha ao excluir a subtarefa. Tente novamente.",
      "subtaskRenameError": "Falha ao renomear a subtarefa. Tente novamente.",
      "subtaskToggleError": "Falha ao atualizar a subtarefa. Tente novamente.",
      "comments": {
        "title": "Comentários",
        "emptyTitle": "Ainda não há comentários",
        "emptySubtitle": "Seja o primeiro a comentar. Mencione colegas com @ para incluí-los na conversa.",
        "editorPlaceholder": "Escreva um comentário...",
        "collapsedPlaceholder": "Comente ou mencione um colega com @",
        "mentionsLoading": "Carregando membros...",
        "mentionsEmpty": "Nenhum membro neste grupo de tarefas.",
        "send": "Enviar",
        "sendComment": "Enviar comentário",
        "characters": "caracteres",
        "loadMore": "Carregar mais comentários",
        "fetchError": "Falha ao carregar os comentários. Tente novamente.",
        "createError": "Falha ao enviar o comentário. Tente novamente.",
        "deleteError": "Falha ao excluir o comentário. Tente novamente.",
        "updateError": "Falha ao atualizar o comentário. Tente novamente.",
        "editComment": "Editar comentário",
        "deleteComment": "Excluir comentário",
        "editAction": "Editar",
        "deleteAction": "Excluir",
        "enterToSend": "Pressione Enter para enviar",
        "saveComment": "Salvar",
        "cancelEdit": "Cancelar",
        "unknownAuthor": "Alguém",
        "addAttachment": "Adicionar anexo",
        "removeAttachment": "Remover {{name}}",
        "openAttachment": "Abrir {{name}}",
        "downloadAttachment": "Baixar {{name}}",
        "attachmentUploadError": "Falha ao enviar {{name}}. Tente novamente.",
        "attachmentUploading": "Enviando {{name}}...",
        "dropToAttach": "Solte os arquivos para anexar",
        "attachmentFailed": "Falha ao anexar",
        "imageViewer": {
          "closeAria": "Fechar visualizador de imagem",
          "zoomLevel": "{{percent}}%",
          "imageArea": "Área da imagem"
        }
      },
      "updatePrioritySuccess": "Prioridade atualizada com sucesso.",
      "updatePriorityError": "Falha ao atualizar a prioridade. Tente novamente.",
      "linkedTasks": {
        "linkError": "Falha ao atualizar as tarefas vinculadas. Tente novamente.",
        "resolveError": "Falha ao atualizar a tarefa. Tente novamente.",
        "title": "Tarefas vinculadas",
        "doneOfTotal": "{{resolved}} de {{total}} concluídas",
        "emptyTitle": "Nenhuma tarefa vinculada ainda",
        "emptySubtitle": "Conecte as tarefas que estão relacionadas a esta.",
        "addLinkedTask": "Adicionar tarefa",
        "addShort": "Adicionar",
        "linkTask": "Vincular tarefa",
        "ceilingReached": "Você atingiu o limite de {{max}} tarefas vinculadas.",
        "cardMenuAriaLabel": "Mais ações",
        "openTask": "Abrir tarefa",
        "markAsDone": "Marcar como concluída",
        "markAsNotDone": "Marcar como não concluída",
        "unlink": "Desvincular",
        "unlinked": "Desvinculada \"{{subject}}\"",
        "doneGroupTitle": "Concluídas",
        "picker": {
          "title": "Vincular tarefa",
          "searchLabel": "Buscar tarefas",
          "searchPlaceholder": "Buscar tarefas por palavra-chave",
          "searching": "Buscando...",
          "alreadyLinked": "Já vinculada",
          "allowanceReason": "Você só pode vincular mais {{remaining}}",
          "remainingAllowance": "Você pode vincular mais {{remaining}}.",
          "confirm": "Vincular selecionadas ({{count}})",
          "noResults": "Nenhuma tarefa corresponde a \"{{term}}\".",
          "createOption": "Criar \"{{term}}\" e vincular",
          "createdButNotLinked": "\"{{subject}}\" foi criada, mas não foi vinculada. Selecione-a na lista para tentar de novo.",
          "emptyTaskGroup": "Nenhuma tarefa para vincular ainda. Busque para encontrar uma.",
          "searchFailed": "Não foi possível concluir a busca. Verifique sua conexão e tente de novo.",
          "loadingTasks": "Carregando tarefas...",
          "loadFailed": "Não foi possível carregar as tarefas. Verifique sua conexão e tente de novo.",
          "loadingMoreTasks": "Carregando mais tarefas...",
          "loadMoreFailed": "Não foi possível carregar mais tarefas.",
          "retry": "Tentar de novo"
        }
      }
    },
    "tableFooterActions": {
      "selected": "Selecionados",
      "delete": "Excluir",
      "done": "Concluído"
    },
    "gradientAlert": {
      "checkNow": "Confira",
      "addNow": "Adicionar agora",
      "completeNow": "Completar agora",
      "invitationMessage": "{{name}} convidou você para entrar em {{team}}! Abra seu convite para começar.",
      "title": "um cargo",
      "firstName": "seu nome",
      "lastName": "seu sobrenome",
      "accountWithoutAInformation": "Adicione {{missingInfo}} à sua conta para uma experiência melhor! 😊",
      "accountWithMissingInformation": "Complete o perfil da sua conta para uma experiência melhor! 😊",
      "view": "Ver",
      "ok": "Ok",
      "notificationAlertTitle": "Nova notificação",
      "syncFailedAlertTitle": "Sincronização não concluída",
      "googleRevokeFailedAlertTitle": "Confira suas permissões do Google",
      "inviteBannerTitle": "{{team}} convidou você para entrar",
      "dismissAlert": "Dispensar alerta"
    },
    "tooltips": {
      "userCommunication": {
        "forward": "Encaminhar",
        "reply": "Responder",
        "replyAll": "Responder a todos",
        "deleteSelected": "Excluir",
        "back": "Voltar",
        "archiveSelected": "Arquivar",
        "refresh": "Atualizar",
        "markAsRead": "Marcar como lida",
        "markAsUnread": "Marcar como não lida",
        "reportAsSpam": "Denunciar como spam",
        "moveToInbox": "Mover para a caixa de entrada",
        "menu": "Menu",
        "unlink": "Desvincular",
        "manageLabels": "Gerenciar etiquetas",
        "snooze": "Adiar",
        "moveTo": "Mover para",
        "toDoBoxTooltip": "Converter em tarefa e mover para o DoBox",
        "delegateToAgent": "Delegar ao agente",
        "delegateToAgentTooltip": "Delegar ao agente",
        "expandAll": "Expandir todas as mensagens",
        "collapseAll": "Recolher todas as mensagens"
      },
      "inboxEntry": {
        "delete": "Excluir tarefa sugerida"
      }
    },
    "attachmentModalViewer": {
      "title": "Anexos"
    },
    "multiSelect": {
      "placeholder": "Selecionar…",
      "searchPlaceholder": "Buscar…",
      "searchAriaLabel": "Buscar opções",
      "loadingCaption": "Carregando opções",
      "emptyMessage": "Nenhum resultado",
      "selectAll": "Selecionar tudo",
      "clear": "Limpar",
      "selectedSummary": "{{count}} selecionado(s)",
      "selectedOfTotal": "{{selected}} de {{total}} selecionados",
      "applyWithCount": "Aplicar · {{count}} selecionados",
      "overflowCount": "+{{count}}"
    },
    "select": {
      "placeholder": "Selecionar…",
      "searchPlaceholder": "Buscar…",
      "searchAriaLabel": "Buscar opções",
      "loadingCaption": "Carregando opções",
      "emptyMessage": "Nenhum resultado"
    },
    "warningModal": {
      "okButton": "Entendi"
    },
    "notification": {
      "inviteReject": "Recusar",
      "inviteAccept": "Aceitar",
      "title": "Notificações",
      "noNotifications": "Ainda não há notificações",
      "markAllRead": "Marcar todas como lidas",
      "clearAll": "Limpar tudo",
      "preferences": "Preferências",
      "viewAll": "Ver todas as notificações",
      "updatedJustNow": "Atualizado agora mesmo",
      "needsDecision": "Precisa da sua decisão",
      "emptyTitle": "Você está em dia",
      "emptySubtitle": "Nenhuma notificação nova. Avisaremos quando algo precisar da sua atenção.",
      "unreadCount_one": "{{count}} nova",
      "unreadCount_other": "{{count}} novas",
      "tabUnread": "Não lidas",
      "tabRead": "Lidas",
      "emptyReadTitle": "Nenhuma notificação lida",
      "emptyReadSubtitle": "As notificações que você já leu aparecerão aqui.",
      "doBoxResolved": "Concluída",
      "inviteAccepted": "Aceito",
      "inviteDeclined": "Recusado"
    },
    "messageEditor": {
      "send": "Enviar",
      "scheduleSend": "Agendar envio",
      "scheduleSendMenuItem": "Agendar envio",
      "scheduleSendCaretLabel": "Mais opções de envio",
      "placeholder": "Digite sua mensagem ou digite \"/\" para opções de IA...",
      "discardLabel": "Descartar rascunho"
    },
    "scheduleSendModal": {
      "title": "Agendar envio",
      "submit": "Agendar envio",
      "datetimeLabel": "Enviar em",
      "dateLabel": "Data",
      "timeLabel": "Hora"
    },
    "aiAssistant": {
      "defaultInstructions": {
        "email": "Melhore este e-mail para ficar mais profissional e claro",
        "title": "Melhore este título para ficar mais claro e acionável",
        "description": "Melhore esta descrição para ficar mais detalhada e clara"
      },
      "instructionModal": {
        "title": "Assistente de IA",
        "originalMessage": "Mensagem original",
        "noTextCaptured": "Nenhum texto capturado",
        "instructionLabel": "Instrução para a IA",
        "instructionPlaceholder": "Digite a instrução para o assistente de IA...",
        "cancelButton": "Cancelar",
        "applyButton": "Aplicar",
        "processingText": "Processando..."
      }
    },
    "search": {
      "defaultPlaceholder": "Buscar por assunto ou usar from:, subject:…",
      "closeSearch": "Fechar busca",
      "tooltip": {
        "closeSearch": "Fechar busca",
        "openSearch": "Abrir busca"
      }
    },
    "emailSearchResults": {
      "loading": "Carregando e-mails...",
      "emptyTitle": "Nenhum e-mail encontrado",
      "emptyDescription": "Tente ajustar os termos da busca ou verifique a ortografia.",
      "resultCount": "{{count}} e-mail{{s}} encontrado{{s}}",
      "listLabel": "Resultados da busca de e-mails"
    },
    "emailSearchResultItem": {
      "noSubject": "Sem assunto",
      "emailFromAriaLabel": "E-mail de {{author}}: {{subject}}",
      "hasAttachments": "Possui anexos",
      "unknownAuthor": "Desconhecido",
      "authorWithMe": "{{author}}, eu"
    },
    "doBoxSearch": {
      "placeholder": "Buscar no DoBox..."
    },
    "doBoxSearchResults": {
      "emptyTitle": "Nenhum resultado encontrado",
      "emptyDescription": "Tente ajustar os termos da busca ou verifique a ortografia.",
      "resultCount": "{{count}} resultado{{s}} encontrado{{s}}",
      "listLabel": "Resultados da busca no DoBox",
      "noSubject": "Sem assunto"
    },
    "boardHeader": {
      "publicBoard": "Público"
    },
    "boardColumn": {
      "pendingTasks": "{{count}} tarefa{{s}} pendente{{s}}"
    },
    "saveStatusIndicator": {
      "saving": "Salvando...",
      "saved": "Salvo",
      "savedJustNow": "Salvo agora",
      "savedMinutesAgo": "Salvo há {{minutes}}min",
      "savedHoursAgo": "Salvo há {{hours}}h",
      "failedToSave": "Falha ao salvar",
      "retrying": "Não salvo · tentando de novo",
      "payloadTooLarge": "Anexos grandes demais",
      "conflict": "Rascunho alterado em outro lugar",
      "deleting": "Excluindo..."
    },
    "taskManagerMenu": {
      "menu": "Configurações",
      "updateList": "Atualizar lista",
      "updateListTitle": "Atualizar lista",
      "updateListSubtitle": "Escolha uma cor e um nome para a sua lista",
      "updateListPlaceholder": "Nome da lista",
      "participantsLabel": "Membros",
      "participantsPlaceholder": "Selecione os membros",
      "participantsSearch": "Buscar...",
      "participantsSelectAll": "Selecionar todos os membros",
      "updateListSuccess": "Lista atualizada com sucesso",
      "updatingList": "Atualizando lista...",
      "updateListError": "Falha ao atualizar a lista. Tente novamente.",
      "createLabel": "Criar etiqueta",
      "createLabelTitle": "Criar etiqueta",
      "createLabelSubtitle": "Escolha uma cor e um nome para a sua etiqueta",
      "createLabelPlaceholder": "Nome da etiqueta",
      "createLabelSuccess": "Etiqueta criada com sucesso",
      "createLabelError": "Falha ao criar a etiqueta. Tente novamente.",
      "updateLabelTitle": "Atualizar etiqueta",
      "updateLabelSubtitle": "Escolha uma cor e um nome para a sua etiqueta",
      "updateLabelPlaceholder": "Nome da etiqueta",
      "updatingLabel": "Atualizando etiqueta...",
      "updateLabelSuccess": "Etiqueta atualizada com sucesso",
      "updateLabelError": "Falha ao atualizar a etiqueta. Tente novamente.",
      "duplicate": "Duplicar",
      "duplicateInProgress": "Duplicando lista...",
      "duplicateSuccess": "Lista duplicada com sucesso",
      "duplicateError": "Falha ao duplicar a lista. Tente novamente.",
      "delete": "Excluir",
      "deleteInProgress": "Excluindo lista...",
      "deleteSuccess": "Lista excluída com sucesso",
      "deleteError": "Falha ao excluir a lista. Tente novamente.",
      "leave": "Sair da lista",
      "deleteConfirmTitle": "Excluir lista",
      "deleteConfirmDescription": "Tem certeza de que deseja excluir esta lista? Esta ação não pode ser desfeita.",
      "leaveConfirmActionButtonLabel": "Sair",
      "leaveAsOwnerConfirmTitle": "Sair e excluir lista",
      "leaveAsOwnerConfirmDescription": "Você é o proprietário desta lista. Ao sair, você será removido e a propriedade poderá ser transferida ou a lista poderá ser excluída. Esta ação não pode ser desfeita."
    },
    "taskGroup": {
      "cannotRemoveOwner": "O proprietário do grupo de tarefas não pode ser removido."
    },
    "moveEmailPopover": {
      "title": "Mover para:",
      "spam": "Spam",
      "trash": "Lixeira"
    },
    "createBoardList": {
      "title": "Criar lista",
      "pickListColor": "Escolha uma cor para a sua lista",
      "inputPlaceholder": "Digite o título da lista",
      "colorGridAriaLabel": "Selecionar cor do quadro",
      "colorAriaLabel": "Cor {{color}}"
    },
    "inboxPreview": {
      "header": {
        "generateDoBoxLoading": "Gerando sua tarefa do DoBox...",
        "generateDoBoxSuccess": "Tarefa do DoBox criada com sucesso! Seu e-mail será movido automaticamente.",
        "generateDoBoxError": "Falha ao gerar a tarefa do DoBox. Tente novamente.",
        "generateDoBoxInvalidLabelError": "Não é possível gerar uma tarefa do DoBox a partir de mensagens de rascunho, spam ou lixeira.",
        "generateDoBoxEmptyContentError": "Não é possível gerar uma tarefa do DoBox a partir de uma mensagem vazia."
      }
    },
    "composeButton": {
      "compose": "Escrever",
      "createEmail": "E-mail",
      "createDoBox": "Tarefa",
      "openMenu": "Abrir menu de criação"
    },
    "manageList": {
      "title": "Criar",
      "pickListColor": "Escolha uma cor para a lista",
      "enterListTitle": "Digite o título da sua lista",
      "cancelButton": "Cancelar",
      "deleteButton": "Excluir",
      "createButton": "Criar",
      "updateButton": "Atualizar"
    },
    "boardMembers": {
      "title": "Membros do quadro",
      "searchPlaceholder": "Buscar membros"
    },
    "doBoxOptions": {
      "schedule": "Agendar",
      "setRecurrence": "Definir recorrência",
      "changeList": "Mudar de lista",
      "delete": "Excluir"
    },
    "RSVP": {
      "replyFor": "Resposta de ",
      "organizer": "Organizador",
      "button": {
        "yes": "Sim",
        "no": "Não",
        "maybe": "Talvez"
      }
    },
    "unsubscribeModal": {
      "title": "Cancelar inscrição",
      "description": "Tem certeza de que deseja cancelar a inscrição nesta lista de e-mails?",
      "messages": {
        "success": "Inscrição na lista de e-mails cancelada com sucesso",
        "error": "Falha ao cancelar a inscrição. Tente novamente.",
        "manualActionRequired": "Conclua o cancelamento da inscrição na aba que foi aberta"
      }
    },
    "datePicker": {
      "selectDate": "Selecionar data",
      "next": "Avançar",
      "datesSelected": "datas selecionadas",
      "rangeSeparator": "→"
    },
    "setRecurrenceContent": {
      "pickDate": "Escolher data",
      "noRepeat": "Não repetir",
      "everyDay": "Todos os dias",
      "everyWeekday": "Todo dia útil",
      "everyWeekOnDay": "A cada {{day}}",
      "everyMonthOnDay": "Todo mês no dia {{day}}",
      "everyMonthOnNthWeekday_ordinal_other": "Mensalmente na {{count}}ª {{weekday}}",
      "timezoneLabel": "Fuso horário",
      "priorityLabel": "Prioridade"
    },
    "dueDate": {
      "title": "Datas",
      "startDate": "Data de início",
      "dueDate": "Prazo",
      "datePlaceholder": "D/M/YYYY"
    },
    "recurrenceEntryDetailsModal": {
      "header": {
        "closeTooltip": "Fechar",
        "deleteTooltip": "Excluir recorrência",
        "recurringBadge": "Recorrente"
      },
      "confirmDeleteModal": {
        "title": "Excluir recorrência",
        "message": "Tem certeza de que deseja excluir esta recorrência? Esta ação não pode ser desfeita.",
        "confirmButton": "Excluir"
      }
    },
    "participantBubblesPicker": {
      "soloTeamUpsell": {
        "message": "Este produto fica melhor com uma equipe. Colaborem e façam mais, juntos!",
        "cta": "Traga sua equipe!"
      }
    },
    "attachmentViewer": {
      "openPdfAria": "Abrir PDF {{name}}",
      "downloadAria": "Baixar {{name}}",
      "toolbar": {
        "zoomIn": "Aumentar zoom",
        "zoomOut": "Diminuir zoom",
        "previousPage": "Página anterior",
        "nextPage": "Próxima página",
        "download": "Baixar",
        "toolbarAria": "Barra de ferramentas do visualizador"
      },
      "pdf": {
        "closeAria": "Fechar visualizador de PDF",
        "documentArea": "Área do documento PDF",
        "pageLabel": "{{current}} / {{total}}",
        "zoomLevel": "{{percent}}%",
        "loading": "Carregando documento…",
        "loadError": "Não foi possível carregar este PDF."
      }
    },
    "agentApprovalModeChoice": {
      "label": "Quando o agente quiser mudar alguma coisa",
      "ask": {
        "title": "Pedir minha aprovação antes de mudar qualquer coisa",
        "hint": "Você aprova cada mudança antes de ela ser feita."
      },
      "skip": {
        "title": "Deixar trabalhar sem pedir",
        "hint": "As mudanças são feitas na hora. Uma mensagem do Slack só sai sem pedir aprovação quando vai para um destino escolhido aqui, é enviada como o bot e foi você quem iniciou a execução.",
        "hintPeople": "As mudanças são feitas na hora. Uma mensagem do Slack só sai sem pedir aprovação quando vai para um destino escolhido aqui ou para um colega de equipe que você permitiu, é enviada como o bot e foi você quem iniciou a execução. Quem não é da sua equipe sempre pede aprovação antes.",
        "stillAsks": "Ainda pede aprovação antes quando a mensagem é enviada em seu nome, vai para qualquer outro lugar, menciona dinheiro ou assuntos jurídicos, vai para um canal compartilhado com outra empresa ou quando um colega executa o agente."
      },
      "autonomous": {
        "title": "Deixar fazer tudo sozinho",
        "hint": "Ele envia e-mails e mensagens para as pessoas e os lugares que você salvou aqui. Depois que alguém responde, confirma com a pessoa e cria o evento no calendário com o convite, tudo sem pedir sua aprovação.",
        "hintPeople": "Ele envia e-mails e mensagens para as pessoas e os lugares que você salvou aqui e para os colegas de equipe que você permitiu no Slack. Depois que alguém responde, confirma com a pessoa e cria o evento no calendário com o convite, tudo sem pedir sua aprovação. Quem não é da sua equipe sempre pede aprovação antes.",
        "stillAsks": "Ainda pede aprovação antes quando for alguém não salvo neste agente, apagar, apps conectados, mensagens sobre dinheiro ou assuntos jurídicos, um canal compartilhado com outra empresa, uma resposta cujo remetente não pôde ser verificado e sempre que um colega executa o agente.",
        "warning": "Isso tira a sua revisão antes de mensagens e convites saírem. Um e-mail não pode ser desfeito.",
        "teamNote": "Este agente é compartilhado com um time: este nível vale só quando você o executa.",
        "confirm": "Entendo que mensagens e convites sairão sem a minha revisão",
        "participantsCaution": "Junto com \"Qualquer pessoa envolvida na tarefa\": uma tarefa que vem do e-mail de um desconhecido faz desse desconhecido alguém a quem o agente responde sozinho."
      },
      "ownerOnlyNote": "Só quem criou este agente pode mudar isso."
    },
    "agentOutboundSettings": {
      "title": "Onde ele pode enviar mensagens?",
      "helper": "Escolha os lugares do Slack onde este agente pode publicar. Ele não publica em nenhum outro.",
      "helperPeople": "Escolha os lugares do Slack onde este agente pode publicar. Além deles, ele só envia mensagem para as pessoas que você permitir abaixo.",
      "noWorkspace": "Nenhum workspace do Slack está conectado ainda, então não há para onde enviar.",
      "connectSlack": "Conectar o Slack em Integrações",
      "titleEmail": "Com quem ele pode falar?",
      "helperEmail": "Escolha as pessoas para quem este agente pode enviar e-mail e, se quiser, os lugares do Slack onde ele pode postar. Ele não contata mais ninguém.",
      "helperEmailPeople": "Escolha as pessoas para quem este agente pode enviar e-mail e, se quiser, os lugares do Slack onde ele pode postar. Além deles, ele só envia mensagem para as pessoas que você permitir abaixo.",
      "scope": {
        "label": "Quem ele pode contatar",
        "savedOnly": {
          "title": "Só as pessoas que eu listar aqui"
        },
        "taskParticipants": {
          "title": "Qualquer pessoa envolvida na tarefa",
          "who": "Isso inclui quem enviou o e-mail ou a mensagem de onde a tarefa veio, as pessoas dessa conversa, um endereço escrito na tarefa e quem o agente já consultou.",
          "never": "Ele nunca escreve para um endereço que só aparece dentro de uma resposta, de uma página do Brain ou de um resultado de busca.",
          "currently": "Para esta tarefa, agora: {{people}}."
        }
      },
      "noRecipients": {
        "title": "Ainda não há ninguém para enviar e-mail",
        "body": "Do jeito que está, este agente não tem ninguém para quem possa enviar e-mail, então o primeiro envio seria recusado. Adicione alguém abaixo ou deixe-o contatar as pessoas envolvidas em cada tarefa.",
        "add": "Adicionar {{name}}",
        "switch": "Qualquer pessoa envolvida na tarefa"
      },
      "emailNeedsRecipients": "Até você adicionar pessoas aqui, este agente só vai conseguir enviar e-mail para quem você @mencionar ao entregar uma tarefa a ele.",
      "slackSection": "Destinos do Slack (opcional)",
      "cannotSendYet": "Este agente não vai conseguir enviar mensagens no Slack até você adicionar um destino. Você também pode adicionar depois.",
      "ownerNotification": "O bot do this+that vai mandar uma mensagem direta para você no Slack. Não precisa de destino.",
      "botDirectMessageError": "O bot não pode escrever numa conversa privada da qual ele não faz parte. Envie como você mesmo, ou deixe que ele avise você diretamente.",
      "peopleScope": {
        "label": "Pessoas a quem ele pode escrever no Slack",
        "helper": "Além dos lugares acima, o agente pode enviar uma mensagem direta no Slack para uma pessoa que ele encontra pelo nome.",
        "none": {
          "title": "Ninguém",
          "hint": "Ele só publica nos lugares que você escolheu acima."
        },
        "teammates": {
          "title": "Meus colegas de equipe",
          "hint": "Ele pode escrever para pessoas que estão em um dos seus times."
        },
        "teammatesAndContacts": {
          "title": "Meus colegas de equipe e meus contatos",
          "hint": "Ele também pode escrever para pessoas dos seus contatos, sempre depois da sua aprovação."
        },
        "rules": {
          "teammatesOnTheirOwn": "Colegas de equipe podem receber mensagens sem pedir sua aprovação quando o agente trabalha sozinho.",
          "othersAlwaysAsk": "Quem não é da sua equipe sempre pede aprovação antes, e só com \"Meus colegas de equipe e meus contatos\".",
          "unclearNameAsksOnce": "Quando um nome não está claro, o agente pergunta uma vez e lembra da sua resposta.",
          "connectedWorkspaceOnly": "Ele só alcança pessoas de um workspace do Slack que você conectou.",
          "sentByBot": "As mensagens saem do bot do this+that."
        },
        "errors": {
          "disabled": "Escrever para pessoas pelo nome ainda não está disponível na sua conta, então esta configuração não foi salva.",
          "needsNotifications": "O agente precisa da ferramenta \"Avisar você por Slack ou e-mail\" ligada antes de poder escrever para pessoas."
        }
      },
      "trialSendGap": {
        "noSendPath": "Este agente ainda não consegue enviar mensagens no Slack: ele não tem um destino para enviar. Adicione um e tente de novo.",
        "sendNotProposed": "Esta prévia tem textos, mas nenhuma mensagem para enviar, então um texto pode descrever uma mensagem que ninguém recebeu. Refaça a prévia antes de aprovar."
      },
      "unavailableChannel": "Canal indisponível",
      "unavailableHint": "Não encontramos mais este canal ou esta conversa. Remova-o e escolha outro.",
      "removeDestination": "Remover {{name}}",
      "kind": {
        "channel": "Canal",
        "directMessage": "Mensagem direta"
      },
      "destinations": {
        "label": "Destinos",
        "workspace": "Workspace do Slack",
        "workspacePlaceholder": "Escolha um workspace",
        "destination": "Canal ou pessoa",
        "destinationPlaceholder": "Escolha para onde enviar",
        "search": "Buscar canais e pessoas",
        "loading": "Carregando canais e pessoas...",
        "loadError": "Não conseguimos carregar os canais deste workspace. Tente de novo em instantes.",
        "capReached": "Você pode adicionar até {{max}} destinos."
      },
      "sendAs": {
        "label": "Enviar como",
        "bot": {
          "title": "O bot do workspace",
          "hint": "As pessoas veem a mensagem vindo do bot do this+that, não de você."
        },
        "user": {
          "title": "Eu",
          "hint": "As pessoas veem a mensagem como se você a tivesse escrito, da sua própria conta do Slack."
        }
      },
      "mentions": {
        "label": "Pessoas que ele pode mencionar",
        "helper": "Ele só pode marcar as pessoas que você escolher aqui.",
        "addDestinationFirst": "Adicione um destino primeiro e depois escolha pessoas do workspace dele.",
        "loading": "Carregando pessoas...",
        "search": "Buscar pessoas",
        "noPeople": "Nenhuma pessoa para mostrar ainda.",
        "selectedCount_one": "{{count}} pessoa selecionada",
        "selectedCount_other": "{{count}} pessoas selecionadas",
        "capReached": "Você pode escolher até {{max}} pessoas.",
        "unknownPerson": "Pessoa desconhecida",
        "broadcast": {
          "title": "Permitir @channel e @here",
          "warning": "Desligado por padrão. Eles avisam todas as pessoas do canal."
        }
      },
      "readOnly": {
        "title": "Onde ele envia mensagens",
        "none": "Ele não consegue enviar mensagens no Slack.",
        "summary_bot_one": "Envia para {{count}} destino como o bot",
        "summary_bot_other": "Envia para {{count}} destinos como o bot",
        "summary_user_one": "Envia para {{count}} destino em nome do dono",
        "summary_user_other": "Envia para {{count}} destinos em nome do dono",
        "ownerOnly": "Só quem criou este agente pode mudar isto.",
        "scopeSavedOnly": "Contata só as pessoas salvas neste agente",
        "scopeTaskParticipants": "Também contata qualquer pessoa envolvida na tarefa",
        "peopleTeammates": "Pode escrever para seus colegas de equipe no Slack",
        "peopleTeammatesAndContacts": "Pode escrever para seus colegas de equipe e contatos no Slack",
        "emailSummary_one": "Pode enviar e-mail para {{count}} pessoa",
        "emailSummary_other": "Pode enviar e-mail para {{count}} pessoas",
        "emailNone": "Ele só pode enviar e-mail para pessoas mencionadas quando uma tarefa é entregue a ele.",
        "waitSummary": "Espera até {{duration}} por respostas"
      },
      "emailRecipients": {
        "title": "Pessoas para quem ele pode enviar e-mail",
        "helper": "Adicione os endereços para os quais este agente pode escrever. Ele não pode enviar e-mail para mais ninguém.",
        "addressLabel": "Endereço de e-mail",
        "addressPlaceholder": "nome@empresa.com",
        "nameLabel": "Nome (opcional)",
        "namePlaceholder": "Nome (opcional)",
        "add": "Adicionar",
        "remove": "Remover {{name}}",
        "capReached": "Você pode adicionar até {{max}} pessoas.",
        "alwaysAsks": "Um e-mail para uma dessas pessoas sempre pede sua aprovação antes de sair, mesmo quando o agente trabalha sem perguntar.",
        "errors": {
          "invalid": "Isso não parece um endereço de e-mail.",
          "duplicate": "Esse endereço já está na lista.",
          "cap": "Você pode adicionar até {{max}} pessoas.",
          "labelTooLong": "Esse nome é muito longo."
        }
      },
      "replyWait": {
        "title": "Esperar respostas",
        "helper": "Depois de fazer uma pergunta a alguém no Slack ou por e-mail, o agente para e espera a resposta, e então continua com ela.",
        "nobodyToAsk": "Adicione um destino do Slack ou um endereço de e-mail acima, para que ele tenha a quem perguntar.",
        "waitUpTo": "Esperar até",
        "waitUpToHint": "Se ninguém tiver respondido até lá, o agente continua sem resposta.",
        "duration": {
          "hours_one": "{{count}} hora",
          "hours_other": "{{count}} horas",
          "days_one": "{{count}} dia",
          "days_other": "{{count}} dias"
        },
        "remind": {
          "title": "Oferecer um lembrete na metade do prazo",
          "hint": "Na metade da espera, o agente pede que você aprove um lembrete. Nada é enviado sozinho, e a resposta a esse lembrete não é captada."
        },
        "rule": {
          "label": "Continuar quando",
          "all": "Todos os consultados responderem",
          "any": "Qualquer um dos consultados responder"
        },
        "notes": {
          "pickedUp": "Uma resposta é captada em cerca de dois minutos.",
          "slackDirectMessage": "Em um canal do Slack ele espera as pessoas que marcou; em uma mensagem direta enviada como você, a outra pessoa. Respostas em uma mensagem direta do bot não podem ser vistas, então envie perguntas a uma pessoa como \"Eu\" ou em uma conversa de canal.",
          "stillAsks": "Tudo o que ele quiser enviar ou agendar depois de uma resposta ainda pede sua aprovação antes."
        }
      }
    },
    "aiInlinePrompt": {
      "newLineHint": "nova linha"
    }
  },
  "emailProcessing": {
    "progressNotification": "Ainda estamos sincronizando e analisando as mensagens de e-mail de {{emailAddress}}. Carregamos da mais recente para a mais antiga e já chegamos a {{month}} de {{year}}. Algumas operações podem ficar lentas",
    "completedNotification": "Todas as mensagens de e-mail de {{emailAddress}} foram sincronizadas e analisadas!",
    "failedNotification": "Não conseguimos terminar a sincronização de {{emailAddress}}. Reconecte a conta para continuar de onde paramos."
  },
  "slackProcessing": {
    "progressNotification": "Ainda estamos sincronizando e analisando suas mensagens do Slack. Já processamos {{processedChannels}} dos seus {{totalChannels}} canais.",
    "completedNotification": "Todos os canais do Slack foram sincronizados! {{totalChannels}} canais processados",
    "failedNotification": "Não conseguimos terminar a sincronização do seu workspace do Slack. Processamos {{processedChannels}} canais antes de parar — reconecte o Slack para concluir.",
    "disconnectedNotification": "O Slack foi desconectado, então paramos de sincronizar seu workspace. Processamos {{processedChannels}} canais."
  },
  "priority": {
    "high": "Alta",
    "medium": "Média",
    "low": "Baixa",
    "urgent": "Urgente",
    "placeholder": "Sem prioridade",
    "setPriority": "Definir prioridade"
  },
  "copyActionToaster": {
    "linkCopied": "Link copiado!",
    "linkCopiedDescription": "O link foi copiado para a área de transferência.",
    "errorCopying": "Erro ao copiar",
    "unableToCopy": "Não foi possível copiar o link. Tente novamente."
  },
  "notifications": {
    "defaultEmailSubject": "Um aviso do this+that",
    "dailyDoBoxEmailSubject": "t+t | Suas tarefas de {{date}} estão prontas! Confira",
    "dailyDoBoxEmailSubjectWithPreview": "t+t | {{preview}} + mais {{count}}",
    "dailyDoBoxEmailSubjectSingle": "t+t | {{preview}}",
    "openDoBoxes": "Tarefas ativas",
    "suggestedDoBoxes": "Tarefas sugeridas",
    "teamInvitationEmailSubject": "t+t | {{author}} convidou você para uma equipe! Entre agora",
    "appIntegrationIssueEmailSubject": "t+t | Sua integração com {{appName}} não está funcionando! Confira",
    "googleRevokeFailedEmailSubject": "t+t | Ação necessária: remova nosso acesso da sua Conta Google",
    "googleRevokeFailed": "Seus dados foram excluídos — falta um passo no Google",
    "googleRevokeFailedDescription": "Sua conta e todos os seus dados foram excluídos, como você pediu. Uma coisa não conseguimos concluir: remover o acesso do nosso app à sua Conta Google. As credenciais necessárias para isso já haviam expirado e, com a conta excluída, não resta nada do nosso lado para tentar de novo. Remova você mesmo agora — leva poucos segundos.",
    "googleRevokeFailedCtaText": "Remover acesso no Google",
    "highestPriorities": "Prioridades mais altas",
    "openTheApp": "Abrir o app",
    "ourWebsite": "Nosso site",
    "support": "Suporte",
    "unsubscribe": "Cancelar inscrição",
    "addedBy": "por {{author}}",
    "assignedTo": "Você foi adicionado a uma tarefa",
    "latestUpdates": "Aqui estão as últimas atualizações",
    "viewUpdates": "Ver atualizações",
    "teamInvitation": "Você foi convidado para uma equipe",
    "acceptInvitation": "Clique aqui para começar!",
    "teamInvitationDescription": "Olá,<br><strong>{{author}}</strong> convidou você para entrar na equipe no <strong>this+that</strong>. Somos um assistente de produtividade para seus apps de e-mail e mensagens, que sintetiza grandes volumes de conversas de projeto em tarefas acionáveis. Pense no this+that como seu Chief of Staff pessoal ou assistente, que organiza tudo em uma única visão amigável. Aqui, as pendências podem ser marcadas como concluídas offline ou arrastadas direto para pautas de reunião.<br><strong>“Você pode transformar tarefas em uma ciência exata, mas a comunicação sempre terá surpresas na manga.”</strong><br>Esperamos que você entre em <strong>{{teamName}}</strong> e comece a ler menos e fazer mais!{{extraMessage}}",
    "teamInvitationExtraMessage": "<br><strong>P.S.</strong> Como você já faz parte de outra equipe e só pode estar em uma equipe por vez, se você entrar nesta equipe, os seus dados com a equipe atual serão <strong>perdidos</strong>. Confirme que você realmente quer trocar.",
    "whatChanged": "Veja o que mudou",
    "detailsUpdated": "&#8226; Valor anterior de {{mappedKey}}: <strong>{{oldValue}}</strong> <br> &#8226; Novo valor de {{mappedKey}}: <strong>{{newValue}}</strong>",
    "attachmentAdded": "<strong>{{userName}}</strong> enviou {{count}} anexo(s).",
    "messageAdded": "<strong>{{userName}}</strong> enviou uma mensagem: {{message}}",
    "messageAndAttachmentAdded": "<strong>{{userName}}</strong> enviou uma mensagem: {{message}} e {{count}} anexo(s).",
    "appIntegrationIssue": "Ação necessária! <br> Reconecte seu {{appName}}.",
    "appIntegrationIssueBanner": "Ação necessária! Reconecte seu {{appName}}.",
    "googleReconnectBanner": "Ação necessária! Reconecte sua conta do Google {{account}}.",
    "whatsAppReconnectBanner": "Ação necessária! O WhatsApp {{phoneNumber}} foi desconectado. Reconecte sua conta do WhatsApp Business.",
    "microsoftReconnectBanner": {
      "outlookMail": "Ação necessária! Reconecte o Outlook Mail da conta {{account}}.",
      "outlookCalendar": "Ação necessária! Reconecte o Outlook Calendar da conta {{account}}.",
      "outlookMailAndCalendar": "Ação necessária! Reconecte o Outlook Mail e o Outlook Calendar da conta {{account}}.",
      "teams": "Ação necessária! Reconecte o Microsoft Teams da conta {{account}}."
    },
    "slackWorkspaceReconnectBanner": "Ação necessária! Reconecte seu workspace do Slack '{{workspaceName}}'.",
    "appIntegrationIssueDescription": "Percebemos que seu {{appName}} foi desconectado acidentalmente. Para continuar recebendo suporte e atualizações sem interrupção, reconecte-o assim que possível.",
    "reconnectNow": "Reconectar agora",
    "evalAnnotationEmailSubject": "Novas anotações de avaliação prontas para revisão",
    "evalAnnotationTitle_one": "{{count}} nova anotação de avaliação pronta para revisão",
    "evalAnnotationTitle_other": "{{count}} novas anotações de avaliação prontas para revisão",
    "evalAnnotationCtaText": "Revisar anotações",
    "doBoxGenerated": "O DoBox \"{{subject}}\" foi gerado",
    "doBoxAssigned": "Você foi atribuído a \"{{subject}}\"",
    "doBoxGeneratedResolved": "O DoBox \"{{subject}}\" foi concluído pelo seu assistente",
    "doBoxAssignedResolved": "O DoBox \"{{subject}}\" ao qual você foi atribuído foi concluído pelo seu assistente",
    "taskGroupAdded": "Você foi adicionado ao grupo de tarefas \"{{taskGroupTitle}}\"",
    "doBoxCommentMention": "{{mentionedByName}} mencionou você em \"{{subject}}\"",
    "knowledgePageMention": "{{mentionedByName}} mencionou você em \"{{pageTitle}}\"",
    "teamInvitationPending": "{{inviterUserName}} convidou você para {{teamName}}",
    "teamInvitationAccepted": "Você entrou em {{teamName}}",
    "teamInvitationRejected": "Você recusou o convite para {{teamName}}"
  },
  "attachments": {
    "success": "Sua mensagem foi enviada com sucesso!",
    "deletion": {
      "success": "Anexo excluído com sucesso!",
      "error": "Erro ao excluir o anexo. Tente novamente mais tarde."
    },
    "errors": {
      "notFound": "Ainda estamos verificando {{fileName}}. Tente novamente em instantes.",
      "threatsFound": "{{fileName}} foi bloqueado porque contém malware.",
      "accessDenied": "Não foi possível verificar {{fileName}} por um problema de permissão. Nossa equipe foi notificada — tente novamente mais tarde.",
      "unsupported": "Não foi possível verificar {{fileName}}. O arquivo pode estar protegido por senha ou criptografado — envie uma versão desbloqueada.",
      "default": "Algo deu errado ao processar {{fileName}}. Tente novamente.",
      "fileTooLarge": "O arquivo {{fileName}} é grande demais. O tamanho máximo é {{maxSize}}MB.",
      "fileTypeNotSupported": "O tipo de arquivo {{fileType}} não é aceito para {{fileName}}.",
      "fileContentMismatch": "O conteúdo do arquivo {{fileName}} não corresponde ao tipo declarado. Envio bloqueado por segurança.",
      "fileUnreadable": "Não foi possível ler {{fileName}}. O arquivo parece vazio ou corrompido — tente novamente com outra cópia.",
      "fileAlreadyAttached": "O arquivo {{fileName}} já está anexado.",
      "failedToProcessFile": "Falha ao processar o arquivo {{fileName}}",
      "failedToAddFiles": "Falha ao adicionar os arquivos",
      "presignedUrlFailed": "Falha ao preparar o envio de {{fileName}}. Tente novamente.",
      "uploadFailed": "Falha ao enviar {{fileName}}. Tente novamente."
    }
  },
  "googleDisconnect": {
    "revokeFailedNotification": "Não conseguimos confirmar se a desconexão de {{gmailAddress}} removeu nosso acesso no Google. Abra as permissões da sua conta Google e remova este app se ele ainda estiver na lista."
  },
  "inbox": {
    "pageTitle": "Caixa de entrada",
    "pageDescription": "Esta é a sua caixa de entrada de e-mails e mensagens. Ela é organizada em torno das suas tarefas.",
    "header": {
      "mobile": {
        "title": "Caixa de entrada",
        "openMenu": "Abrir menu lateral",
        "searchLabel": "Buscar",
        "filterLabel": "Filtrar",
        "selectLabel": "Selecionar",
        "selectAll": "Selecionar tudo",
        "moreActions": "Mais ações",
        "exitSelectionMode": "Sair do modo de seleção"
      },
      "moreActions": "Mais ações"
    },
    "settings": {
      "title": "Configurações da Caixa de entrada",
      "subtitle": "Personalize as configurações da sua caixa de entrada para mantê-la organizada do seu jeito",
      "categories": "Categorias",
      "tabs": {
        "primary": "Principal",
        "promotions": "Promoções",
        "social": "Social",
        "updates": "Atualizações",
        "forums": "Fóruns"
      },
      "signature": {
        "title": "Assinatura",
        "enable": "Adicionar minha assinatura automaticamente em novos e-mails, respostas e encaminhamentos",
        "placeholder": "Escreva sua assinatura",
        "tooLong": "Sua assinatura é muito longa. Mantenha abaixo de {{max}} caracteres.",
        "hint": "Inserida quando você escreve neste aplicativo. Você ainda pode editá-la em cada e-mail. Imagens não são suportadas.",
        "accountLabel": "Conta de e-mail",
        "tooLargeTotal": "Suas assinaturas são grandes demais para salvar juntas. Encurte uma delas.",
        "tooLongOtherAccount": "A assinatura de outra conta é muito longa. Mantenha cada uma abaixo de {{max}} caracteres.",
        "importFromGmail": "Importar do Gmail",
        "importEmpty": "Nenhuma assinatura definida no Gmail.",
        "importFailed": "Não foi possível importar sua assinatura do Gmail. Tente novamente."
      },
      "saving": "Salvando configurações da caixa de entrada...",
      "saveSuccess": "Configurações da caixa de entrada salvas com sucesso.",
      "saveError": "Falha ao salvar as configurações da caixa de entrada. Tente novamente."
    },
    "tabs": {
      "inbox": "Principal",
      "promotions": "Promoções",
      "forums": "Fóruns",
      "social": "Social",
      "updates": "Atualizações",
      "aria": {
        "tabListLabel": "Abas de filtro da caixa de entrada"
      }
    },
    "sidebar": {
      "inbox": "Mensagens",
      "collapseMessages": "Recolher mensagens",
      "expandMessages": "Expandir mensagens",
      "main": "Caixa de entrada",
      "sent": "Enviados",
      "draft": "Rascunhos",
      "scheduled": "Agendados",
      "snoozed": "Adiados",
      "spam": "Spam",
      "trash": "Lixeira",
      "archived": "Arquivados",
      "all": "Todos os e-mails",
      "labels": "Etiquetas",
      "dm": "Diretas",
      "chats": "Conversas",
      "channels": "Canais"
    },
    "scheduled": {
      "title": "Agendados",
      "subtitle": "E-mails aguardando envio",
      "emptyState": {
        "title": "Nenhum e-mail agendado",
        "description": "Use a seta ao lado de Enviar no editor para agendar o envio."
      },
      "item": {
        "title": "E-mail agendado",
        "to": "Para",
        "noSubject": "(sem assunto)",
        "scheduledFor": "Agendado para",
        "status": "Status",
        "id": "ID",
        "reschedule": "Reagendar",
        "cancel": "Cancelar"
      },
      "modal": {
        "title": "Reagendar e-mail",
        "submit": "Salvar agendamento"
      },
      "toast": {
        "createSuccess": "E-mail agendado",
        "createError": "Não foi possível agendar o e-mail",
        "updateSuccess": "Agendamento atualizado",
        "updateError": "Não foi possível reagendar o e-mail",
        "cancelSuccess": "E-mail agendado cancelado",
        "cancelError": "Não foi possível cancelar o e-mail agendado"
      },
      "cancelConfirm": {
        "title": "Cancelar e-mail agendado?",
        "description": "Este e-mail não será enviado. Esta ação não pode ser desfeita.",
        "confirm": "Cancelar e-mail"
      },
      "errors": {
        "invalidDate": "Insira uma data e hora válidas",
        "minLead": "Escolha um horário com pelo menos cinco minutos de antecedência"
      },
      "row": {
        "to": "Para: {{recipient}}",
        "noRecipient": "Sem destinatário",
        "cancelButton": "Cancelar"
      },
      "relativeDay": {
        "today": "Hoje",
        "tomorrow": "Amanhã"
      },
      "composer": {
        "saveChanges": "Salvar alterações"
      }
    },
    "snooze": {
      "options": {
        "laterToday": "Mais tarde hoje",
        "tomorrow": "Amanhã",
        "thisWeekend": "Este fim de semana",
        "nextWeek": "Próxima semana",
        "pickDateTime": "Escolher data e hora",
        "unsnooze": "Remover adiamento"
      },
      "custom": {
        "timeLabel": "Horário",
        "save": "Salvar",
        "minLeadWarning": "Deve ser pelo menos 6 minutos a partir de agora"
      },
      "toast": {
        "success": "Adiado até {{time}}",
        "successMultiple": "{{count}} mensagens adiadas até {{time}}",
        "error": "Falha ao adiar a mensagem",
        "partialError": "Falha ao adiar {{failed}} de {{total}} mensagens",
        "cancelSuccess": "Adiamento cancelado",
        "cancelError": "Falha ao cancelar o adiamento",
        "updateSuccess": "Horário do adiamento atualizado",
        "updateSuccessMultiple": "{{count}} adiamentos atualizados",
        "updatePartialError": "Falha ao atualizar {{failed}} de {{total}} adiamentos",
        "updateError": "Falha ao atualizar o horário do adiamento"
      },
      "view": {
        "emptyState": {
          "title": "Nenhuma mensagem adiada",
          "description": "Adie uma mensagem da sua caixa de entrada para vê-la aqui."
        }
      }
    },
    "userCommunication": {
      "selectedCount": "{{count}} selecionadas",
      "draft": "Rascunho",
      "unsavedSnapshot": {
        "label": "Não salvo",
        "hint": "Este e-mail tem um texto guardado só neste navegador. Clique para abrir."
      },
      "noRecipient": "Sem destinatário",
      "to": "Para: {{email}}",
      "platformNames": {
        "gmail": "Gmail",
        "outlook": "Outlook",
        "slack": "Slack",
        "teams": "Teams",
        "instagram": "Instagram"
      },
      "actions": {
        "partialDeleteError": "Falha ao excluir {{failed}} de {{total}} mensagens",
        "createSuccess": "Mensagem criada",
        "createError": "Falha ao criar a mensagem. Tente novamente mais tarde.",
        "replySuccess": "Resposta enviada",
        "replyError": "Falha ao responder a mensagem. Tente novamente mais tarde.",
        "forwardSuccess": "Mensagem encaminhada",
        "forwardError": "Falha ao encaminhar a mensagem. Tente novamente mais tarde.",
        "archiving": "Arquivando mensagens...",
        "archiveSuccess": "Mensagem arquivada",
        "archiveMultipleSuccess": "{{count}} mensagens arquivadas",
        "archiveError": "Falha ao arquivar a(s) mensagem(ns)",
        "partialArchiveError": "Falha ao arquivar {{failed}} de {{total}} mensagens",
        "deleting": "Excluindo mensagens...",
        "deleteSuccess": "Mensagem excluída",
        "deleteMultipleSuccess": "{{count}} mensagens excluídas",
        "deleteError": "Falha ao excluir a(s) mensagem(ns)",
        "trashing": "Movendo mensagens para a lixeira...",
        "trashSuccess": "Mensagem movida para a lixeira",
        "trashMultipleSuccess": "{{count}} mensagens movidas para a lixeira",
        "trashError": "Falha ao mover a(s) mensagem(ns) para a lixeira",
        "markingAsRead": "Marcando mensagens como lidas...",
        "markAsReadSuccess": "Mensagem marcada como lida",
        "markAsReadMultipleSuccess": "{{count}} mensagens marcadas como lidas",
        "markAsReadError": "Falha ao marcar a(s) mensagem(ns) como lida(s)",
        "markingAsUnread": "Marcando mensagens como não lidas...",
        "markAsUnreadSuccess": "Mensagem marcada como não lida",
        "markAsUnreadMultipleSuccess": "{{count}} mensagens marcadas como não lidas",
        "markAsUnreadError": "Falha ao marcar a(s) mensagem(ns) como não lida(s)",
        "partialMarkAsReadError": "Falha ao marcar {{failed}} de {{total}} mensagens como lidas",
        "partialMarkAsUnreadError": "Falha ao marcar {{failed}} de {{total}} mensagens como não lidas",
        "partialTrashError": "Falha ao mover {{failed}} de {{total}} mensagens para a lixeira",
        "reportingAsSpam": "Denunciando mensagens como spam...",
        "reportAsSpamSuccess": "Mensagem denunciada como spam",
        "reportAsSpamMultipleSuccess": "{{count}} mensagens denunciadas como spam",
        "reportAsSpamError": "Falha ao denunciar a(s) mensagem(ns) como spam",
        "partialReportAsSpamError": "Falha ao denunciar {{failed}} de {{total}} mensagens como spam",
        "movingToInbox": "Movendo mensagens para a caixa de entrada...",
        "moveToInboxSuccess": "Mensagem movida para a caixa de entrada",
        "moveToInboxMultipleSuccess": "{{count}} mensagens movidas para a caixa de entrada",
        "moveToInboxError": "Falha ao mover a(s) mensagem(ns) para a caixa de entrada",
        "keptLocallyOnClose": "Não foi possível salvar no servidor. Uma cópia ficou neste navegador.",
        "saveDraftError": "Falha ao salvar o rascunho. Tente novamente mais tarde.",
        "savePayloadTooLargeError": "Anexos grandes demais para salvar o rascunho. Remova algum e tente de novo.",
        "draftConflictError": "Rascunho alterado em outro lugar. Seu texto está seguro; reabra para escolher.",
        "deleteDraftError": "Falha ao excluir o rascunho. Tente novamente mais tarde.",
        "deleteDraftSuccess": "Rascunho excluído",
        "deleteDraftMultipleSuccess": "{{count}} rascunhos excluídos",
        "partialDeleteDraftError": "Falha ao excluir {{failed}} de {{total}} rascunhos",
        "deletingDraft": "Excluindo rascunho…",
        "deletingDrafts": "Excluindo {{count}} rascunhos…",
        "sendDraftError": "Falha ao enviar o rascunho. Tente novamente mais tarde.",
        "sendPayloadTooLargeError": "Anexos grandes demais para enviar. Remova algum e tente de novo.",
        "sendDraftSuccess": "E-mail enviado",
        "draftNotFoundInAccountError": "Não foi possível encontrar o rascunho na conta selecionada. Tente novamente.",
        "sendDraftConflictError": "Rascunho alterado em outro lugar; não foi enviado. Reabra e tente de novo.",
        "noEmailAccountError": "Nenhuma conta de e-mail conectada. Conecte o Gmail ou o Outlook para enviar e-mails.",
        "deleteLoading": "Excluindo mensagem...",
        "archiveLoading": "Arquivando mensagem...",
        "moveToInboxLoading": "Movendo mensagem para a caixa de entrada...",
        "unlinkLoading": "Desvinculando mensagem...",
        "unlinkSuccess": "Mensagem desvinculada",
        "unlinkError": "Falha ao desvincular a mensagem",
        "markReadLoading": "Marcando mensagem como lida...",
        "markReadSuccess": "Mensagem marcada como lida",
        "markReadError": "Falha ao marcar a mensagem como lida",
        "markUnreadLoading": "Marcando mensagem como não lida...",
        "markUnreadSuccess": "Mensagem marcada como não lida",
        "markUnreadError": "Falha ao marcar a mensagem como não lida",
        "reportSpamLoading": "Denunciando mensagem como spam...",
        "reportSpamSuccess": "Mensagem denunciada como spam",
        "reportSpamError": "Falha ao denunciar a mensagem como spam",
        "alreadyInTrash": "Já está na lixeira",
        "markerError": "Não foi possível atualizar o e-mail",
        "markImportantSuccess": "Mensagem marcada como importante",
        "unmarkImportantSuccess": "Mensagem marcada como não importante"
      },
      "connectEmail": {
        "title": "Nenhuma conta de e-mail conectada",
        "subtitle": "Conecte o Gmail ou o Outlook para ver seus e-mails aqui."
      },
      "noCommunications": "Nada na sua caixa de entrada no momento",
      "noCommunicationsSent": "Nada nos seus itens enviados no momento",
      "noCommunicationsDraft": "Nada nos seus rascunhos no momento",
      "noCommunicationsSpam": "Nada no seu spam no momento",
      "noCommunicationsAll": "Nada em todos os e-mails no momento",
      "noCommunicationsArchived": "Nada nos seus arquivados no momento",
      "noCommunicationsPromotions": "Nada nas suas promoções no momento",
      "noCommunicationsForums": "Nada nos seus fóruns no momento",
      "noCommunicationsSocial": "Nada na sua aba social no momento",
      "noCommunicationsUpdates": "Nada nas suas atualizações no momento",
      "noCommunicationsInbox": "Nada na sua caixa de entrada no momento",
      "noCommunicationsTrash": "Nada na sua lixeira no momento",
      "noCommunicationsDirect": "Nada nas suas mensagens diretas no momento",
      "noCommunicationsChats": "Nada na sua lista de conversas no momento",
      "noCommunicationsChannels": "Nada na sua lista de canais no momento",
      "noCommunicationsLabels": "Selecione uma etiqueta para ver os e-mails.",
      "noCommunicationsSearch": "Nenhum resultado encontrado para a sua busca",
      "loadingMessages": "Carregando suas mensagens...",
      "searchingMessages": "Buscando nos seus e-mails..."
    },
    "search": {
      "error": "A busca falhou. Tente novamente.",
      "resultsFor": "Resultados para",
      "semanticHint": "Resultados por relevância entre e-mails indexados. Use operadores como from: ou in:draft para uma busca tradicional.",
      "resultsCount": "{{count}} resultado encontrado",
      "resultsCount_other": "{{count}} resultados encontrados"
    },
    "slack": {
      "direct": "Diretas",
      "channels": "Canais",
      "unknownChannel": "Canal desconhecido",
      "loading": "Carregando comunicações do Slack...",
      "noCommunications": "Nenhuma comunicação do Slack encontrada",
      "noMessages": {
        "channel": "Nenhuma mensagem neste canal",
        "directMessage": "Nenhuma mensagem nesta conversa direta"
      },
      "aria": {
        "tabListLabel": "Abas de comunicações do Slack"
      },
      "channel": {
        "channelName": "# {{channelName}}"
      },
      "manageSlackParticipants": {
        "addPeople": "Adicionar pessoas"
      },
      "messageEditor": {
        "placeholder": {
          "directMessage": "Enviar mensagem para {{userName}}",
          "default": "Digite sua mensagem aqui..."
        },
        "characterCount": "{{count}} caracteres",
        "send": "Enviar",
        "sendShortcut": "Enviar ({{shortcut}})",
        "aria": {
          "messageEditor": "Editor de mensagem",
          "messageContent": "Conteúdo da mensagem",
          "sendMessage": "Enviar mensagem"
        }
      },
      "search": {
        "placeholder": "Buscar canais e mensagens diretas...",
        "openSearch": "Abrir busca",
        "closeSearch": "Fechar busca",
        "loading": "Buscando...",
        "noResults": "Nenhum resultado encontrado"
      },
      "attachments": {
        "count": "{{count}} anexos"
      },
      "reply": {
        "title": "Responder mensagem do Slack",
        "channel": "Canal",
        "dm": "DM",
        "placeholder": "Digite sua mensagem...",
        "sending": "Enviando...",
        "success": "Mensagem do Slack enviada com sucesso",
        "error": {
          "missingWorkspace": "Não é possível responder: faltam informações do workspace",
          "missingChannel": "Não é possível responder: faltam informações do canal",
          "sendFailed": "Falha ao enviar a mensagem do Slack. Tente novamente."
        }
      }
    },
    "teams": {
      "chats": "Conversas",
      "groups": "Grupos",
      "loading": "Carregando comunicações do Teams...",
      "noCommunications": "Nenhuma comunicação do Teams encontrada",
      "noMessages": {
        "chat": "Nenhuma mensagem nesta conversa",
        "group": "Nenhuma mensagem neste grupo"
      },
      "aria": {
        "tabListLabel": "Abas de comunicações do Teams"
      },
      "search": {
        "placeholder": "Buscar conversas e grupos...",
        "openSearch": "Abrir busca",
        "closeSearch": "Fechar busca",
        "loading": "Buscando...",
        "noResults": "Nenhum resultado encontrado"
      },
      "reply": {
        "title": "Responder mensagem do Teams",
        "dm": "DM",
        "channel": "Canal",
        "placeholder": "Digite sua mensagem...",
        "success": "Mensagem do Teams enviada com sucesso",
        "error": {
          "missingAccount": "Não é possível responder: nenhuma conta da Microsoft foi encontrada para esta mensagem",
          "missingChat": "Não é possível responder: faltam informações da conversa",
          "sendFailed": "Falha ao enviar a mensagem do Teams. Tente novamente."
        }
      }
    },
    "googleChat": {
      "reply": {
        "title": "Responder mensagem do Google Chat",
        "placeholder": "Digite sua mensagem...",
        "success": "Mensagem do Google Chat enviada com sucesso",
        "error": {
          "missingAccount": "Não é possível responder: nenhuma conta do Google Chat encontrada para esta mensagem",
          "missingSpace": "Não é possível responder: informações da conversa ausentes",
          "sendFailed": "Falha ao enviar mensagem do Google Chat. Tente novamente."
        }
      }
    },
    "instagram": {
      "dms": "Diretas",
      "loading": "Carregando conversas do Instagram...",
      "noCommunications": "Nenhuma conversa do Instagram encontrada",
      "noMessages": {
        "dm": "Nenhuma mensagem nesta conversa"
      },
      "outsideWindow": "O Instagram só permite responder até 24 horas após a última mensagem desta pessoa.",
      "attachments": {
        "count": "{{count}} anexos"
      },
      "aria": {
        "tabListLabel": "Abas de conversas do Instagram"
      }
    },
    "messaging": {
      "failedSend": "Falha ao enviar a mensagem. Tente novamente.",
      "failedLoadThreadMessages": "Falha ao carregar as mensagens da conversa. Tente novamente."
    },
    "messageDialog": {
      "restoredSnapshot": {
        "recoveredFrom": "Recuperado de {{time}}.",
        "lastSaved": " Salvo às {{time}}.",
        "truncatedAttachments": "Anexe novamente estes arquivos: {{names}}",
        "discard": "Descartar",
        "keepChanges": "Manter alterações",
        "revertedToast": "Rascunho salvo restaurado",
        "undo": "Desfazer"
      },
      "unsentRecovery": {
        "message_one": "Você tem {{count}} e-mail não salvo",
        "message_other": "Você tem {{count}} e-mails não salvos",
        "recover": "Recuperar"
      },
      "recipients": "Destinatários",
      "to": "Para",
      "from": "De",
      "cc": "Cc",
      "bcc": "Cco",
      "ccBcc": "Cc/Cco",
      "subject": "Assunto",
      "title": {
        "newMessage": "Nova mensagem",
        "reply": "Responder",
        "replyAll": "Responder a todos",
        "forward": "Encaminhar"
      },
      "searchingContacts": "Buscando contatos...",
      "noSuggestionsFound": "Nenhuma sugestão encontrada",
      "failedToSearchContacts": "Falha ao buscar contatos. Tente novamente.",
      "more": "+{{count}} mais",
      "cannotChangeEmail": "Não é possível alterar o e-mail enquanto o rascunho é salvo",
      "aiReply": {
        "entryButton": "Resposta com IA",
        "chip": {
          "label": "Escrever com IA"
        },
        "intent": {
          "placeholder": "Responder com… ex.: 'concordar, sugerir quinta'",
          "inputLabel": "Descreva o que você quer responder",
          "helper": "Deixe aqui a ideia desta resposta e nós escrevemos para você."
        },
        "drafting": "Criando o rascunho com seu contexto…",
        "refining": "Refinando seu rascunho…",
        "error": "Não foi possível falar com o assistente. Tente novamente ou continue escrevendo você mesmo.",
        "tabs": {
          "asYouWriteIt": "Do seu jeito",
          "shorter": "Mais curto",
          "moreFormal": "Mais formal"
        },
        "refine": {
          "placeholder": "Refinar… ex.: 'deixe mais curto, sugira dois horários'",
          "inputLabel": "Peça um ajuste à IA"
        },
        "context": {
          "label": "CONTEXTO",
          "thisThread": "Esta conversa",
          "escToClose": "Esc para fechar o Assistente de IA"
        },
        "footer": {
          "sendAsIs": "Enviar como está"
        },
        "manual": {
          "label": "Você está escrevendo este e-mail",
          "bringBack": "Trazer o rascunho de volta"
        }
      },
      "aiCompose": {
        "chip": {
          "label": "Escrever com IA"
        },
        "intent": {
          "placeholder": "Escrever sobre… ex.: 'apresentação, propor uma call na quinta'",
          "inputLabel": "Descreva o que este e-mail deve dizer",
          "helper": "Deixe aqui a ideia deste e-mail e nós escrevemos para você."
        },
        "drafting": "Criando o rascunho com seu contexto…",
        "refining": "Refinando seu rascunho…",
        "error": "Não foi possível falar com o assistente. Tente novamente ou continue escrevendo você mesmo.",
        "tabs": {
          "asYouWriteIt": "Do seu jeito",
          "shorter": "Mais curto",
          "moreFormal": "Mais formal"
        },
        "refine": {
          "placeholder": "Refinar… ex.: 'tire a última linha, ofereça sexta também'",
          "inputLabel": "Peça um ajuste à IA"
        },
        "context": {
          "label": "CONTEXTO",
          "thisThread": "Esta conversa",
          "escToClose": "Esc para fechar o Assistente de IA"
        },
        "footer": {
          "sendAsIs": "Enviar como está"
        },
        "manual": {
          "label": "Você está escrevendo este e-mail",
          "bringBack": "Trazer o rascunho de volta"
        },
        "slashMenu": {
          "ariaLabel": "Ações de escrita com IA",
          "empty": "Nenhuma ação encontrada",
          "sectionWriteWithAi": "Escrever com IA",
          "sectionFormat": "Formatação",
          "continueWriting": "Continuar escrevendo",
          "draftFromPrompt": "Escrever a partir de um prompt",
          "proposeMeetingTimes": "Propor horários de reunião",
          "suggestSubjectLine": "Sugerir uma linha de assunto",
          "askAboutRecipient": "Perguntar sobre este destinatário",
          "bulletedList": "Lista com marcadores",
          "quote": "Citação"
        },
        "toast": {
          "undo": "Desfazer",
          "continued": "Rascunho continuado",
          "proposedTimes": "Horários de reunião adicionados",
          "recipientContext": "Contexto do destinatário adicionado",
          "subjectSuggested": "Assunto sugerido",
          "rewritten": "Reescrito",
          "rewrittenFromInstruction": "Reescrito a partir da sua instrução",
          "toneApplied": "Tom: {{tone}}",
          "translated": "Traduzido para {{language}}",
          "grammarFixed": "Gramática corrigida"
        },
        "suggestSubject": {
          "label": "Sugerir assunto"
        },
        "selectionBubble": {
          "ariaLabel": "Ações de IA na seleção",
          "improve": "Melhorar",
          "shorter": "Mais curto",
          "tone": "Tom",
          "translate": "Traduzir",
          "fixGrammar": "Corrigir gramática",
          "editWithAi": "Editar com IA"
        },
        "toneLabel": {
          "formal": "Formal",
          "warmer": "Mais caloroso",
          "direct": "Direto"
        },
        "languageLabel": {
          "ptBr": "Português (BR)",
          "es": "Espanhol",
          "enUs": "Inglês (EUA)"
        },
        "selectionInlineCard": {
          "placeholder": "Diga à IA como reescrever a seleção…",
          "send": "Enviar",
          "selectedText": "Texto selecionado",
          "escToCancel": "Esc para cancelar"
        }
      }
    },
    "messagePanel": {
      "unsavedChanges": {
        "title": "Rascunho não salvo",
        "description": "O conteúdo do seu rascunho pode ficar desatualizado. Deseja salvar o rascunho?",
        "save": "Salvar rascunho",
        "discard": "Descartar"
      }
    },
    "labels": {
      "createLabel": "Criar etiqueta",
      "tabs": {
        "all": "Todos",
        "labels": "Etiquetas"
      },
      "title": "Etiquetar como:",
      "noLabels": "Nenhuma etiqueta encontrada",
      "searchLabels": "Buscar etiquetas",
      "showAllEmails": "Mostrar todos os e-mails",
      "all": "Todos",
      "filterByLabels": "Filtrar por etiquetas",
      "saveLabels": "Salvar",
      "modifyLabels": "Modificar etiquetas",
      "modifyLabelsSuccess": "Etiquetas atualizadas",
      "modifyLabelsMultipleSuccess": "Etiquetas atualizadas em {{count}} e-mails",
      "modifyLabelsError": "Falha ao atualizar as etiquetas. Tente novamente.",
      "deleteLabelSuccess": "Etiqueta removida",
      "deleteLabelError": "Falha ao remover a etiqueta. Tente novamente.",
      "updateLabelNameError": "Falha ao renomear a etiqueta. Tente novamente.",
      "updateLabelColorError": "Falha ao atualizar a cor da etiqueta. Tente novamente.",
      "createLabelError": "Falha ao criar a etiqueta. Tente novamente.",
      "createLabelSuccess": "Etiqueta criada com sucesso",
      "cannotModifyLabelsMultipleAccounts": "Só é possível mover e-mails da mesma conta para uma etiqueta.",
      "outlookDoesNotSupportLabels": "Etiquetas não são compatíveis com contas do Outlook.",
      "createLabelModal": {
        "createLabel": "Criar etiqueta",
        "editLabel": "Editar etiqueta",
        "labelName": "Nome da etiqueta",
        "email": "E-mail",
        "labelAlreadyExists": "Já existe uma etiqueta com esse nome."
      },
      "updateLabelPopover": {
        "labelOptionsAriaLabel": "Opções da etiqueta",
        "updateColor": "Alterar cor",
        "edit": "Editar",
        "removeLabel": "Remover etiqueta",
        "removeLabelModalTitle": "Remover etiqueta",
        "removeLabelModalDescription": "Tem certeza de que deseja remover esta etiqueta? Esta ação não pode ser desfeita.",
        "removeLabelModalActionButton": "Remover",
        "removeLabelModalCancelButton": "Cancelar"
      }
    },
    "filter": {
      "title": "Filtrar",
      "allEmails": "Todos os e-mails",
      "accounts": "Contas"
    },
    "keyboardShortcuts": {
      "tooltip": "Atalhos de teclado",
      "modalTitle": "Atalhos de teclado",
      "listSection": "Lista de e-mails",
      "previewSection": "Dentro do e-mail",
      "moveItems": "Navegar entre e-mails",
      "switchTabs": "Alternar abas da caixa de entrada",
      "openEmail": "Abrir e-mail",
      "archive": "Arquivar",
      "delete": "Excluir",
      "markAsRead": "Marcar como lida",
      "markAsUnread": "Marcar como não lida",
      "reportSpam": "Denunciar como spam",
      "select": "Selecionar/desmarcar e-mail",
      "compose": "Escrever novo e-mail",
      "openCheatsheet": "Abrir este guia de atalhos",
      "backToList": "Voltar para a lista",
      "nextEmail": "Próximo e-mail",
      "previousEmail": "E-mail anterior",
      "scrollContent": "Rolar o conteúdo do e-mail",
      "reply": "Responder",
      "replyAll": "Responder a todos",
      "forward": "Encaminhar"
    }
  },
  "messageDialog": {
    "windowBehavior": {
      "minimizeWindow": "Minimizar",
      "toggleWindowSize": "Expandir",
      "dockWindow": "Mostrar no canto",
      "closeWindow": "Fechar"
    }
  },
  "inboxPreview": {
    "to": "para {{email}}",
    "toLabel": "para",
    "from": "de",
    "date": "data",
    "subject": "assunto",
    "reply": "Responder",
    "replyAll": "Responder a todos",
    "forward": "Encaminhar",
    "archive": "Arquivar",
    "noSubject": "(sem assunto)",
    "threadMessage": {
      "hide": "Ocultar detalhes"
    },
    "unsubscribe": "Cancelar inscrição",
    "star": "Marcar com estrela",
    "unstar": "Remover estrela",
    "markImportant": "Marcar como importante",
    "unmarkImportant": "Marcar como não importante",
    "doBoxControl": {
      "toDoBox": "Adicionar ao DoBox",
      "inDoBoxes": "Em DoBoxes",
      "mobileSheetTitle": "DoBoxes",
      "addToAnother": "Adicionar a outro DoBox",
      "suggestionSuffix": " · Sugestão",
      "approvalSuffix": " · Precisa da sua aprovação",
      "mobileButtonAriaLabel": "Adicionar ao DoBox",
      "mobileButtonLinkedAriaLabel": "Abrir menu de DoBoxes"
    }
  },
  "doBox": {
    "executor": {
      "slackSend": {
        "sentence": {
          "bot": "Enviar uma mensagem no Slack para {{destination}} como o bot",
          "user": "Enviar uma mensagem no Slack para {{destination}} em seu nome",
          "unknownSender": "Enviar uma mensagem no Slack para {{destination}}",
          "sentBot": "Mensagem enviada no Slack para {{destination}} como o bot",
          "sentUser": "Mensagem enviada no Slack para {{destination}} em seu nome",
          "sentUnknownSender": "Mensagem enviada no Slack para {{destination}}",
          "person": "Enviar uma mensagem direta no Slack para {{name}} ({{kind}}) em {{workspace}} como o bot",
          "personNoWorkspace": "Enviar uma mensagem direta no Slack para {{name}} ({{kind}}) como o bot",
          "sentPerson": "Mensagem direta enviada no Slack para {{name}} ({{kind}}) em {{workspace}} como o bot",
          "sentPersonNoWorkspace": "Mensagem direta enviada no Slack para {{name}} ({{kind}}) como o bot"
        },
        "person": {
          "teammate": "colega de equipe",
          "outsider": "fora da sua equipe"
        },
        "destination": {
          "loading": "…",
          "unavailable": "um canal indisponível",
          "owner": "você",
          "unavailableHint": "Não encontramos mais este destino. Abra as configurações do agente e escolha outro.",
          "channelName": "#{{name}}"
        },
        "messageLabel": "Mensagem",
        "mention": {
          "unknownPerson": "@alguém",
          "unknownChannel": "#canal",
          "channel": "@channel",
          "here": "@here",
          "everyone": "@everyone"
        },
        "failure": {
          "generic": "A mensagem não foi enviada. Confira os destinos do Slack do agente e tente de novo.",
          "destination_removed": "A mensagem não foi enviada porque este destino foi removido do agente. Adicione-o de novo nas configurações do agente ou escolha outro.",
          "bot_not_in_channel": "A mensagem não foi enviada porque o bot não está neste canal. Adicione o bot ao canal no Slack e tente de novo.",
          "channel_archived": "A mensagem não foi enviada porque este canal está arquivado. Escolha outro destino nas configurações do agente.",
          "missing_permission": "A mensagem não foi enviada porque o Slack não permitiu. Reconecte o Slack em Integrações ou escolha outro destino.",
          "workspace_disconnected": "A mensagem não foi enviada porque este workspace do Slack está desconectado. Reconecte em Integrações e tente de novo.",
          "user_not_connected": "A mensagem não foi enviada porque a sua conta do Slack não está conectada. Conecte em Integrações ou configure o agente para enviar como o bot.",
          "channel_not_found": "A mensagem não foi enviada porque o Slack não encontrou este destino. Confira nas configurações do agente ou escolha outro.",
          "rate_limited": "A mensagem não foi enviada porque o Slack pediu uma pausa curta. Aguarde um minuto e tente de novo.",
          "message_too_long": "A mensagem não foi enviada porque é longa demais para o Slack. Peça ao agente para preparar uma mais curta.",
          "send_failed": "A mensagem não foi enviada porque o Slack retornou um erro. Tente de novo e, se continuar, confira os destinos do Slack do agente.",
          "sender_changed": "A mensagem não foi enviada porque a configuração \"enviar como\" do agente mudou depois que este cartão foi criado. Peça ao agente para preparar de novo.",
          "agent_unavailable": "A mensagem não foi enviada porque o agente não está mais disponível. Confira se ele ainda existe e está compartilhado com você, e peça de novo.",
          "unknown_destination": "A mensagem não foi enviada porque este destino não é um dos destinos do Slack do agente. Peça ao dono para adicioná-lo nas configurações do agente.",
          "actor_not_authorised": "A mensagem não foi enviada porque sairia em nome do dono do agente, e o Slack não pode agir por você nesse workspace. Peça ao dono para executar, ou para configurar o agente para enviar como o bot.",
          "mention_not_allowed": "A mensagem não foi enviada porque menciona alguém que o agente não pode mencionar. Peça ao agente para preparar sem a menção.",
          "unknown_mention_handle": "A mensagem não foi enviada porque menciona alguém que o agente não consegue identificar. Peça ao agente para preparar de novo sem essa menção.",
          "broadcast_not_allowed": "A mensagem não foi enviada porque @channel, @here e @everyone não são permitidos. Peça ao agente para preparar sem eles.",
          "send_cap_reached": "A mensagem não foi enviada porque o agente já enviou 3 mensagens para este destino nesta execução. Inicie uma nova execução se precisar de mais.",
          "trial_no_send": "Esta foi uma prévia da configuração do agente, então nada foi enviado. Entregue a tarefa ao agente para enviar de verdade.",
          "membership_check_failed": "A mensagem não foi enviada porque o Slack não conseguiu confirmar quem está neste destino. Tente de novo em instantes.",
          "bot_cannot_dm": "A mensagem não foi enviada porque o bot não pode escrever nesta conversa privada. Mude o agente para enviar como você ou escolha um canal.",
          "owner_slack_not_connected": "O lembrete não foi enviado porque sua conta do Slack não está conectada. Conecte em Integrações e tente de novo.",
          "person_not_resolved": "A mensagem não foi enviada porque o agente ainda não identificou quem é esta pessoa. Peça para ele encontrar a pessoa primeiro e preparar a mensagem de novo.",
          "person_scope_changed": "A mensagem não foi enviada porque as configurações do agente para escrever a pessoas mudaram depois que este cartão foi preparado. Entregue a tarefa ao agente de novo.",
          "person_unavailable": "A mensagem não foi enviada porque esta pessoa não está mais no seu time ou nos seus contatos. Confira se ela ainda está lá antes de pedir de novo.",
          "person_identity_changed": "A mensagem não foi enviada porque os dados desta pessoa mudaram depois que a mensagem foi preparada, e ela poderia ter chegado a outra pessoa. Entregue a tarefa ao agente de novo.",
          "person_class_changed": "A mensagem não foi enviada porque esta pessoa não está mais na sua equipe, então é preciso uma nova aprovação. Entregue a tarefa ao agente de novo.",
          "person_not_reachable": "A mensagem não foi enviada porque esta pessoa não pode ser alcançada no Slack: ela não está em um workspace do Slack que você conectou, ou o bot não pode escrever para ela. Tentar de novo não resolve enquanto isso não mudar.",
          "person_reply_wait_unavailable": "A mensagem não foi enviada porque o agente não pode esperar resposta de uma mensagem direta enviada pelo bot. Peça para ele enviar a mensagem sem esperar.",
          "person_invalid_target": "A mensagem não foi enviada porque o agente não disse com clareza para quem ela era. Entregue a tarefa ao agente de novo e diga o nome da pessoa.",
          "person_outsider_not_allowed": "A mensagem não foi enviada porque este agente só pode escrever para os colegas do seu time, e esta pessoa não está no seu time. Se quiser que ele alcance pessoas de fora do time, mude a configuração de pessoas do Slack do agente para incluir seus contatos.",
          "person_limit_reached": "A mensagem não foi enviada porque o agente atingiu o limite de uma execução: até 5 pessoas e 3 mensagens para cada pessoa.",
          "person_lookup_failed": "A mensagem não foi enviada porque não conseguimos verificar agora quem é esta pessoa. Tente de novo em instantes.",
          "person_identity_unconfirmed": "A mensagem não foi enviada porque o agente precisa que você confirme antes quem é esta pessoa. Responda à pergunta dele na tarefa e ele continua."
        }
      },
      "effect": {
        "unverified": "Não verificado",
        "unsupportedClaim": "Isso não foi encontrado na mensagem de origem",
        "showAll": "Mostrar tudo",
        "moreRecipients": "+{{count}} mais",
        "attachmentsLabel": "Anexos ({{count}})",
        "customServerChip": "Servidor personalizado",
        "flowRunNotice": "Isso vai executar o flow",
        "fromLabel": "De",
        "inLabel": "Em",
        "toLabel": "Para",
        "ccLabel": "Cc",
        "memoryOriginWarning": "Isso não foi dito exatamente com essas palavras",
        "brain": {
          "thisPage": "esta página",
          "namedPage": "“{{title}}”",
          "thisSection": "uma seção",
          "namedSection": "a seção “{{name}}”",
          "contentLabel": "Texto que será escrito",
          "showMore": "Ver mais",
          "showLess": "Ver menos",
          "create": {
            "titled": "Criar a página {{page}}",
            "untitled": "Criar uma nova página"
          },
          "operation": {
            "APPEND": "Adicionar ao final de {{page}}",
            "PREPEND": "Adicionar ao início de {{page}}",
            "INSERT_AFTER_HEADING": "Adicionar abaixo de {{heading}} em {{page}}",
            "REPLACE_SECTION": "Substituir {{heading}} em {{page}}",
            "REPLACE_ALL": "Substituir todo o conteúdo de {{page}}",
            "EDIT": "Editar {{page}}",
            "CREATE_PAGE": "Criar a página {{page}}",
            "RENAME_PAGE": "Renomear {{page}} para “{{newTitle}}”",
            "CREATE_SPACE": "Criar o espaço {{space}}",
            "RENAME_SPACE": "Renomear {{space}} para “{{newTitle}}”"
          },
          "thisSpace": "este espaço",
          "namedSpace": "“{{name}}”"
        },
        "emailSend": {
          "sentence": "Enviar um e-mail para {{recipients}}",
          "sentenceSent": "E-mail enviado para {{recipients}}"
        },
        "omittedDetails_one": "{{count}} detalhe a mais não exibido",
        "omittedDetails_other": "{{count}} detalhes a mais não exibidos"
      },
      "critical": {
        "UNTRUSTED_RECIPIENT": "Destinatário não confiável",
        "NEW_EXTERNAL_DOMAIN": "Novo domínio externo",
        "PUBLIC_OR_SHARED_CHANNEL": "Canal público ou compartilhado",
        "EXT_SHARED_UNKNOWN": "Compartilhamento externo desconhecido",
        "ATTACHMENT": "Tem anexo",
        "TOO_MANY_RECIPIENTS": "Muitos destinatários",
        "TOO_MANY_ITEMS": "Muitos itens",
        "DESTRUCTIVE": "Destrutivo",
        "MONEY_OR_LEGAL": "Dinheiro ou jurídico",
        "FIRST_CONTACT": "Primeiro contato",
        "OTHER_MEMBERS_DOBOX": "Afeta outros membros",
        "PERMANENT_AUTOMATION": "Automação permanente",
        "OUT_OF_THREAD_FACT": "Fato fora da conversa",
        "DOBOX_TRIGGER_MATCH": "Corresponde a um gatilho da DoBox",
        "HEADERS_UNVERIFIED": "Cabeçalhos não verificados",
        "REPLY_TO_EXTERNAL_DOMAIN": "Resposta para domínio externo",
        "LIST_WITHOUT_SEND_AS": "Lista sem remetente configurado",
        "BCC_ONLY": "Somente Cco"
      },
      "provenance": {
        "ONLY_IN_COUNTERPART_MESSAGE": "Somente na mensagem de {{counterpart}}",
        "FROM_YOUR_BRAIN": "Do seu Brain",
        "FROM_DECISION": "Baseado na sua decisão de {{date}}",
        "FROM_YOUR_SENT_MESSAGE": "Da sua mensagem enviada"
      },
      "recipientTrust": {
        "NEW_RECIPIENT": "Novo destinatário",
        "EXTERNAL_DOMAIN": "Domínio externo",
        "SELF_EXCLUDED": "Você está excluído",
        "LIST": "Lista de distribuição"
      },
      "platform": {
        "GMAIL": "Gmail",
        "OUTLOOK": "Outlook",
        "SLACK": "Slack",
        "TEAMS": "Teams",
        "GOOGLE_CHAT": "Google Chat",
        "WHATSAPP": "WhatsApp",
        "INSTAGRAM": "Instagram",
        "MESSENGER": "Messenger",
        "TELEGRAM": "Telegram",
        "THIS_THAT": "this+that",
        "GITHUB": "GitHub",
        "CALENDAR": "Agenda",
        "GOOGLE_CALENDAR": "Google Agenda",
        "OUTLOOK_CALENDAR": "Agenda do Outlook",
        "generic": "essa plataforma"
      },
      "memoryOrigin": {
        "TYPED_VERBATIM": "Suas próprias palavras",
        "APPROVED_CARD": "Um card aprovado",
        "PATTERN_OFFER": "Um padrão sugerido",
        "LEDGER_EXECUTED": "Algo já executado"
      },
      "emptyState": {
        "title": "O que eu resolvo?",
        "subtitle": "Vou trabalhar nesta DoBox a partir da sua origem e só vou te perguntar sobre as etapas críticas."
      },
      "unavailable": {
        "title": "O assistente de tarefas não está disponível",
        "subtitle": "Feche esta tarefa e abra de novo em instantes."
      },
      "legacyConversationLink": "Ver conversa anterior",
      "disabledToast": "O assistente de tarefas está desligado por agora.",
      "notice": {
        "approvalRequiresClick": "Esta ação precisa de um clique no cartão.",
        "capabilityStillMissing": "Ainda não está conectado. Conecte e tente de novo.",
        "capabilityResumeExhausted": "Já tentei duas vezes hoje. Use uma das alternativas no cartão."
      },
      "line": {
        "approval": {
          "executed_one": "Pronto: {{count}} ação concluída.",
          "executed_other": "Pronto: {{count}} ações concluídas.",
          "failed": "A ação não foi concluída.",
          "expired": "Esta aprovação expirou antes de alguém clicar.",
          "stale": "Esta aprovação não está mais atual — a DoBox mudou desde que foi sugerida.",
          "alreadyDone": "Isso já havia sido feito.",
          "needsClick": "Aguardando um clique neste cartão."
        },
        "stop": {
          "batchDone_one": "Por ora é só isso.",
          "batchDone_other": "Por ora é só isso.",
          "askedUser": "Parei para fazer uma pergunta ao usuário.",
          "budget": "Parei — limite de turnos atingido.",
          "dailyCap": "Parei — esta tarefa atingiu o limite de gasto de hoje. Você pode entregá-la ao agente de novo amanhã.",
          "capability": "Parei — falta uma permissão necessária."
        },
        "continuation": {
          "started": "Continuando a partir da execução anterior.",
          "limit": "Limite de continuações atingido ({{count}})."
        },
        "capabilityStillMissing": "{{capability}} ainda não está conectado.",
        "nextStep": {
          "reminderSet": "Lembrete definido para {{date}}.",
          "alreadyDone": "Esta próxima etapa já foi concluída."
        }
      },
      "proposal": {
        "title": {
          "SOURCE_REPLY": "Resposta pronta",
          "OUTBOUND_MESSAGE": "Mensagem pronta",
          "CALENDAR_EVENT": "Evento de agenda pronto",
          "DOBOX_INTERNAL": "Atualização pronta",
          "KNOWLEDGE_WRITE": "Atualização do Brain pronta",
          "FLOW": "Flow pronto",
          "AGENT": "Tarefa do agente pronta",
          "MCP_READ": "Ação pronta",
          "MCP_WRITE": "Ação pronta",
          "MEMORY": "Memória pronta",
          "CODE_DELEGATION": "Tarefa de código pronta",
          "CAPABILITY": "Ação pronta",
          "generic": "Precisa da sua aprovação"
        },
        "titleDecided": {
          "SOURCE_REPLY": "Resposta",
          "OUTBOUND_MESSAGE": "Mensagem",
          "CALENDAR_EVENT": "Evento da agenda",
          "DOBOX_INTERNAL": "Mudança na tarefa",
          "KNOWLEDGE_WRITE": "Mudança no Brain",
          "FLOW": "Fluxo",
          "AGENT": "Tarefa do agente",
          "MCP_READ": "Ação",
          "MCP_WRITE": "Ação",
          "MEMORY": "Memória",
          "CODE_DELEGATION": "Tarefa de código",
          "CAPABILITY": "Ação",
          "generic": "Ação"
        },
        "tier": {
          "approveOnce": "Precisa da sua aprovação",
          "alwaysApprove": "Essa ação sempre precisa de um clique"
        },
        "typedConsentHint": "Você também pode responder \"manda\".",
        "expiresIn": "Expira em {{minutes}} min",
        "runInProgressHint": "O agente ainda está trabalhando. Você pode aprovar quando ele terminar.",
        "actions": {
          "approve": "Aprovar",
          "cancel": "Cancelar",
          "tryAgain": "Tentar de novo",
          "redo": "Refazer",
          "dismiss": "Dispensar"
        },
        "status": {
          "executing": "Trabalhando nisso…",
          "executed": "Aprovado",
          "expired": "Expirado",
          "stale": "Chegou uma mensagem nova depois dessa sugestão",
          "superseded": "Substituída por uma sugestão mais recente",
          "dismissed": "Cancelada"
        },
        "failure": {
          "INTEGRATION_NOT_CONNECTED": "A integração não está mais conectada.",
          "SOURCE_ACCOUNT_DISCONNECTED": "A conta de origem foi desconectada.",
          "NOT_DOBOX_OWNER": "Você não tem mais acesso a essa DoBox.",
          "STALE_ENVELOPE": "Essa solicitação não é mais válida.",
          "CONFIRMATION_NOT_MATCHED": "A confirmação não correspondeu.",
          "INVALID_TOOL_NAME": "Essa ação não está mais disponível.",
          "UNVERIFIED_NEED": "Isso ainda precisa ser verificado.",
          "CAPABILITY_DECLINED": "Essa capacidade foi recusada.",
          "NO_COUNTERPART": "Não há para quem enviar isso.",
          "UNSUPPORTED_PLATFORM": "Essa plataforma não é suportada.",
          "GRANT_MISSING": "Falta uma permissão necessária.",
          "generic": "Esta ação falhou.",
          "notSent": "A mensagem não foi enviada.",
          "notSaved": "O evento não foi salvo.",
          "notApplied": "A mudança não pôde ser aplicada.",
          "nextStep": "Tentar de novo não vai mudar isso. Diga ao agente o que fazer diferente ou faça a mudança você mesmo."
        },
        "toast": {
          "alreadyDone": "Já feito",
          "stale": "Essa sugestão não é mais a atual — atualizando.",
          "rejected": "Não foi possível concluir essa ação."
        },
        "discarded": "Você testou isto na tarefa e não aplicou as alterações."
      },
      "receipt": {
        "action": {
          "SOURCE_REPLY": "Resposta enviada",
          "OUTBOUND_MESSAGE": "Mensagem enviada",
          "CALENDAR_EVENT": "Evento de agenda criado",
          "DOBOX_INTERNAL": "Tarefa atualizada",
          "KNOWLEDGE_WRITE": "Brain atualizado",
          "FLOW": "Flow executado",
          "AGENT": "Tarefa do agente executada",
          "MCP_READ": "Ação feita",
          "MCP_WRITE": "Ação feita",
          "MEMORY": "Memória salva",
          "CODE_DELEGATION": "Tarefa de código iniciada",
          "CAPABILITY": "Ação feita",
          "generic": "Feito",
          "multiple_one": "{{count}} alteração feita",
          "multiple_other": "{{count}} alterações feitas"
        },
        "approvedVia": {
          "click": "Aprovado por você",
          "typedConsent": "Confirmado pela sua mensagem",
          "planClick": "Aprovado a partir do plano",
          "standingPermission": "Enviado sob sua permissão permanente",
          "auto": "Feito sem pedir",
          "autonomous": "Feito sozinho"
        },
        "sendState": {
          "scheduled": "Envia às {{time}}",
          "sending": "Enviando…",
          "sent": "Enviado às {{time}}",
          "done": "Feito às {{time}}",
          "failed": "Envio falhou"
        },
        "undo": {
          "action": "Desfazer",
          "retractAction": "Retratar",
          "retractConfirmQuestion": "Talvez já tenham visto. Excluir mesmo assim?",
          "retractConfirmYes": "Sim",
          "retractConfirmNo": "Não",
          "undone": "Desfeito",
          "retracted": "Retratado",
          "toast": {
            "tooLate": "Tarde demais para desfazer isso.",
            "notUndoable": "Isso não pode ser desfeito.",
            "providerFailed": "Não foi possível desfazer isso — tente de novo.",
            "actionFailed": "Algo deu errado ao desfazer isso."
          },
          "slackToast": {
            "tooLate": "Tarde demais para apagar esta mensagem por aqui. Apague no Slack se ainda precisar remover.",
            "notUndoable": "Esta mensagem não pode ser apagada por aqui. Apague no Slack se precisar remover.",
            "providerFailed": "O Slack não conseguiu apagar a mensagem. Ela pode já ter sido apagada, ou o Slack não permitiu. Tente de novo ou apague no Slack."
          },
          "retry": "Tentar de novo"
        },
        "failure": {
          "INTEGRATION_NOT_CONNECTED": "A integração não está mais conectada.",
          "SOURCE_ACCOUNT_DISCONNECTED": "A conta de origem foi desconectada.",
          "NOT_DOBOX_OWNER": "Você não tem mais acesso a essa DoBox.",
          "STALE_ENVELOPE": "Essa solicitação não é mais válida.",
          "CONFIRMATION_NOT_MATCHED": "A confirmação não correspondeu.",
          "INVALID_TOOL_NAME": "Essa ação não está mais disponível.",
          "UNVERIFIED_NEED": "Isso ainda precisa ser verificado.",
          "CAPABILITY_DECLINED": "Essa capacidade foi recusada.",
          "NO_COUNTERPART": "Não há para quem enviar isso.",
          "UNSUPPORTED_PLATFORM": "Essa plataforma não é suportada.",
          "GRANT_MISSING": "Falta uma permissão necessária.",
          "generic": "Essa ação falhou.",
          "hint": "Me diga como continuar"
        },
        "preview": {
          "show": "Mostrar o que foi feito",
          "hide": "Ocultar"
        },
        "memory": {
          "why": "Por quê?",
          "forget": "Esquecer",
          "forgetConfirmQuestion": "Esquecer esta memória? Isso não pode ser desfeito.",
          "forgetConfirmYes": "Sim, esquecer",
          "forgetConfirmNo": "Não",
          "forgotten": "Esquecido",
          "forgetFailed": "Não foi possível esquecer isso — tente de novo."
        },
        "brainRevertHint": "Você pode desfazer isso pelo histórico de versões da página."
      },
      "nextSteps": {
        "markDone": "Marcar como feita",
        "remindIfNoReply": "Lembrar se não responder em 2 dias"
      },
      "question": {
        "title": "Preciso de uma coisa sua",
        "otherAnswer": {
          "toggle": "Outra resposta",
          "placeholder": "Digite sua resposta…",
          "counter": "{{count}}/{{max}}",
          "submit": "Enviar"
        },
        "status": {
          "answered": "Respondida",
          "stale": "Substituída pela sua mensagem mais recente",
          "expired": "Essa pergunta não está mais aberta.",
          "dismissed": "Descartada."
        },
        "toast": {
          "alreadyDone": "Já respondida",
          "stale": "Essa pergunta não é mais a atual — atualizando.",
          "rejected": "Não foi possível enviar essa resposta."
        }
      },
      "errors": {
        "actionFailed": "Algo deu errado com essa ação.",
        "concurrentRun": "Espere a resposta atual terminar",
        "notOwner": "Você não tem mais acesso a essa DoBox.",
        "itemChanged": "Esse item já mudou — atualizando."
      },
      "plan": {
        "header": "Plano ({{count}})",
        "kind": {
          "REPLY": "Responder",
          "COMPOSE": "Escrever mensagem",
          "ASK_SOMEONE": "Perguntar a alguém",
          "SCHEDULE": "Agendar",
          "INTERNAL_UPDATE": "Atualizar esta DoBox",
          "DELEGATE_CODE": "Delegar para um agente de código"
        },
        "cta": {
          "EXECUTE": "Fazer",
          "REVIEW": "Revisar",
          "UNAVAILABLE": "Indisponível"
        },
        "slot": {
          "type": {
            "TEXT": "Texto",
            "DATE": "Data",
            "DATE_TIME": "Data e hora",
            "PERSON": "Pessoa",
            "EMAIL_ADDRESS": "Endereço de e-mail",
            "CHOICE": "Opção"
          },
          "required": "Obrigatório"
        },
        "alreadyExecuted": "Já foi enviado depois que este plano foi criado",
        "sendAnyway": "Enviar outra mesmo assim",
        "toast": {
          "stale": "A conversa mudou — atualizando o plano",
          "rejected": "Não foi possível concluir esta ação."
        },
        "slotMissingError": "Preencha as informações obrigatórias antes de continuar."
      },
      "panelOptions": {
        "title": {
          "replyTo": "Responder a {{name}}",
          "replyGeneric": "Responder",
          "remind": "Lembrar em {{date}}",
          "delegateAgent": "Delegar para {{agent}}",
          "delegateAgentGeneric": "Delegar para um agente",
          "delegateLocalClaude": "Investigar e corrigir com o Local Claude"
        },
        "badge": {
          "draftReview": "Rascunho · você revisa",
          "draftSaved": "Rascunho salvo",
          "readOnly": "Somente leitura",
          "needsApproval": "Pede sua aprovação antes de agir",
          "followUp": "Cria um acompanhamento",
          "opensReply": "Abre a resposta",
          "delegates": "Delega"
        },
        "execute": {
          "failed": "Isso não foi concluído e nada foi alterado. Você pode passar esta tarefa a um agente pelo menu \"Para\" abaixo.",
          "stale": "Esta sugestão mudou enquanto você olhava. A lista foi atualizada; escolha de novo."
        },
        "remind": {
          "success": "Acompanhamento criado.",
          "error": "Não foi possível criar o acompanhamento."
        },
        "agentSetupOffer": {
          "badge": "Ainda sem agente",
          "line": "Nenhum dos seus agentes consegue {{job}}. Configure um aqui em cerca de um minuto.",
          "panelCta": "+ Configurar um agente",
          "chatCta": "Configurar um agente"
        },
        "agentSetupGeneric": {
          "title": "Ensine um agente a fazer isso",
          "line": "Configure um agente a partir desta tarefa em cerca de um minuto.",
          "cta": "+ Configurar um agente",
          "link": "Isso é recorrente?",
          "linkCta": "Ensine um agente a fazer isso"
        },
        "finishedSetup": {
          "link": "Ver o que {{name}} fez nesta tarefa"
        },
        "delegateLocalClaudeSubtitle": "Roda no seu Mac · planeja antes, você aprova",
        "header": {
          "title": "O que deve acontecer agora?",
          "subtitle": "Entregue a um agente ou escolha uma ação rápida."
        },
        "agentShortcuts": {
          "title": "Ou passe para um dos seus agentes",
          "item": "Pedir para {{name}} cuidar disso"
        }
      },
      "capability": {
        "CONNECT": {
          "title": "Conectar {{integration}}",
          "body": "Para {{action}} {{resource}} no {{integration}} e resolver esta DoBox, conecte o {{integration}}.",
          "cta": "Conectar {{integration}}"
        },
        "GRANT_SCOPE": {
          "title": "Conceder acesso ao {{integration}}",
          "body": "Para {{action}} {{resource}} no {{integration}}, conceda a permissão que falta.",
          "cta": "Conceder acesso"
        },
        "RECONNECT": {
          "title": "Reconectar {{integration}}",
          "body": "Sua conexão com o {{integration}} precisa ser atualizada para {{action}} {{resource}}.",
          "cta": "Reconectar"
        },
        "ENABLE_TOOL": {
          "title": "Habilitar uma ferramenta no {{integration}}",
          "body": "Para {{action}} {{resource}}, habilite esta ferramenta na sua conexão com o {{integration}}.",
          "cta": "Habilitar ferramenta"
        },
        "RESYNC": {
          "title": "Sincronizar {{integration}}",
          "body": "Sua conexão com o {{integration}} precisa sincronizar antes de conseguir {{action}} {{resource}}.",
          "cta": "Sincronizar agora"
        },
        "CONFIGURE_BYO": {
          "title": "Configurar {{integration}}",
          "body": "Termine de configurar sua conexão com o {{integration}} para {{action}} {{resource}}.",
          "cta": "Configurar conexão"
        },
        "PAIR_DEVICE": {
          "title": "Parear um dispositivo",
          "body": "Pareie um dispositivo de código para {{action}} {{resource}}.",
          "cta": "Parear dispositivo"
        },
        "ASK_TEAM_ADMIN": {
          "title": "Pergunte ao admin do seu time",
          "body": "Só um admin do time pode conectar o {{integration}} para {{action}} {{resource}}.",
          "cta": "Perguntar ao admin"
        },
        "REQUEST_INTEGRATION": {
          "title": "Solicitar esta integração",
          "body": "O {{integration}} ainda não é suportado. Solicite para que possamos {{action}} {{resource}}.",
          "cta": "Solicitar integração"
        },
        "UNAVAILABLE": {
          "title": "Não disponível",
          "body": "O {{integration}} não consegue {{action}} {{resource}} agora.",
          "cta": "Não disponível"
        },
        "SET_UP_AGENT": {
          "title": "Configurar um agente",
          "body": "Nenhum agente seu consegue {{action}} {{resource}} ainda. Configure um para resolver esta DoBox.",
          "cta": "Configurar agente"
        },
        "action": {
          "READ_ITEM": "ler",
          "UPDATE_ITEM": "atualizar",
          "CREATE_ITEM": "criar",
          "SEND_MESSAGE": "enviar uma mensagem sobre",
          "SCHEDULE": "agendar",
          "SEARCH_WEB": "buscar na web por",
          "DELEGATE_CODE": "delegar código para"
        },
        "resourceFallback": "isso",
        "alternative": {
          "ASK_TEAMMATE": {
            "label": "Pedir a um colega",
            "prompt": "Você pode pedir a um colega para {{action}} {{resource}} no {{integration}} por mim?"
          },
          "ASK_FOR_CONTENT": {
            "label": "Pedir o conteúdo",
            "prompt": "Você pode pedir que enviem o conteúdo direto, assim eu não preciso do {{integration}}?"
          },
          "REPLY_AT_SOURCE": {
            "label": "Responder na origem",
            "prompt": "Responda na origem em vez de usar o {{integration}}."
          },
          "SEND_FROM_OTHER_ACCOUNT": {
            "label": "Enviar de outra conta",
            "prompt": "Envie isso da minha outra conta em vez do {{integration}}.",
            "warning": "Isso vai enviar de uma conta diferente da habitual."
          }
        },
        "accountMismatch": "Esta conta não é a mesma em que esta DoBox chegou.",
        "othersWaiting": "Continuar em mais {{count}} DoBoxes esperando por {{integration}}",
        "dismiss": "Agora não",
        "status": {
          "dismissed": "Recusado",
          "expired": "Expirado",
          "satisfied": "Conectado"
        },
        "toast": {
          "enableToolSuccess": "Ferramenta habilitada",
          "enableToolError": "Não foi possível habilitar esta ferramenta",
          "resyncSuccess": "Sincronizando…",
          "resyncError": "Não foi possível sincronizar esta conexão",
          "requestIntegrationSuccess": "Solicitação enviada",
          "requestIntegrationError": "Não foi possível enviar a solicitação",
          "othersWaitingFound": "Mais {{count}} DoBoxes estão esperando por isso",
          "othersWaitingNone": "Nenhuma outra DoBox está esperando por isso"
        },
        "connectedContinue": "Conectado · Continuar",
        "resume": {
          "stillNotConnected": "Ainda não conectado",
          "exhausted": "Isso ainda não funciona"
        },
        "othersWaitingList": {
          "continue": "Continuar"
        }
      },
      "code": {
        "title": "Delegar para {{device}} ({{runtime}}) · {{repo}}",
        "unknownDevice": "seu dispositivo",
        "runtime": {
          "CLAUDE": "Claude Code",
          "CODEX": "Codex",
          "AIDER": "Aider"
        },
        "machine": {
          "available": "Disponível",
          "busy": "Ocupado ({{count}})",
          "offline": "Offline · visto {{ago}}",
          "offlineNeverSeen": "Offline",
          "missingGh": "Falta o GitHub CLI"
        },
        "step": {
          "plan": "Plano (só leitura)",
          "approve": "Você aprova",
          "implement": "Implementação e verificação",
          "pr": "PR rascunho"
        },
        "actions": {
          "planOnDevice": "Planejar em {{device}}",
          "delegateWhenOnline": "Delegar quando ficar online",
          "reviewPlan": "Revisar plano",
          "openPr": "Abrir PR #{{number}}",
          "tryAgain": "Tentar de novo",
          "cancel": "Cancelar"
        },
        "queuedOffline": {
          "status": "Vai rodar quando {{device}} voltar · até {{date}}"
        },
        "queuedOnDevice": "{{count}} DoBoxes esperando por {{device}}",
        "notice": {
          "codex": "O conteúdo será enviado para a OpenAI.",
          "externalOrigin": "Remetente externo: a verificação está desligada; o PR rascunho abre sem rodar o comando de verificação."
        },
        "status": {
          "cancelled": "Cancelada"
        }
      },
      "batch": {
        "title_one": "A mesma decisão resolve mais {{count}} DoBox",
        "title_other": "A mesma decisão resolve mais {{count}} DoBoxes",
        "partialLabel": "Correspondência parcial",
        "openDoBox": "Abrir DoBox",
        "actions": {
          "apply": "Aplicar a {{count}}",
          "dismiss": "Dispensar"
        },
        "chip": {
          "sent": "Enviado",
          "failed": "Falhou",
          "alreadyHandled": "Já resolvido"
        },
        "status": {
          "applying": "Aplicando…",
          "applied": "Aplicado",
          "failed": "Não foi possível aplicar",
          "dismissed": "Dispensado"
        },
        "toast": {
          "alreadyDone": "Já aplicado",
          "stale": "Isso não é mais atual — atualizando.",
          "rejected": "Não foi possível aplicar isso."
        }
      },
      "memory": {
        "scope": {
          "THREAD": "Esta conversa",
          "COUNTERPART": "Este contato",
          "WORK_KIND": "Este tipo de trabalho",
          "TASK_GROUP": "Esta lista",
          "GLOBAL": "Em todo lugar"
        },
        "status": {
          "PAUSED": "Pausada",
          "REVIEW_DUE": "Revisão pendente"
        },
        "why": {
          "basedOn": "Baseado na sua decisão de {{date}}",
          "forgottenNote": "Essa memória foi esquecida.",
          "viewAll": "Ver toda a memória"
        },
        "suggestedDecisionNotice": "Uma decisão que você tomou em outro DoBox pode resolver este também.",
        "rememberOffer": {
          "title": "Devo lembrar disso?",
          "actions": {
            "remember": "Lembrar",
            "notNow": "Agora não"
          },
          "status": {
            "answered": "Lembrado",
            "dismissed": "Não salvo.",
            "expired": "Essa oferta não está mais aberta."
          },
          "toast": {
            "alreadyDone": "Já lembrado",
            "stale": "Isso não é mais atual — atualizando.",
            "rejected": "Não foi possível salvar isso."
          }
        },
        "standingPermissionOffer": {
          "title": "Você aprovou {{count}} vezes seguidas para {{counterpart}} por {{channel}}. Fazer isso sem perguntar na próxima vez?",
          "unknownCounterpart": "este contato",
          "actionClass": {
            "SCHEDULE_TIMES": "Propor horários",
            "ACK_NO_DEADLINE": "Confirmar recebimento (sem prazo)",
            "INFO_REQUEST_IN_THREAD": "Responder perguntas na própria conversa"
          },
          "channel": {
            "EMAIL": "E-mail"
          },
          "exclusions": "Nunca para anexos, dinheiro/jurídico, posts públicos, eventos ou exclusões.",
          "actions": {
            "accept": "Sim, sempre",
            "notNow": "Agora não"
          },
          "status": {
            "answered": "Permissão permanente criada",
            "dismissed": "Agora não.",
            "expired": "Esta oferta não está mais disponível."
          },
          "toast": {
            "alreadyDone": "Já configurado",
            "stale": "Isso não é mais atual — atualizando.",
            "rejected": "Não foi possível configurar isso."
          }
        }
      },
      "routes": {
        "section": {
          "suggestions": "Sugestões",
          "routines": "Rotinas",
          "emptyRoutines": "Nenhuma rotina ainda. Sugestões aceitas e rotas que você configurar vão aparecer aqui."
        },
        "workKind": {
          "REPLY_INFO": "Responder com informação",
          "SCHEDULE": "Agendamento",
          "DECIDE_APPROVE": "Decidir ou aprovar",
          "RESEARCH": "Pesquisar",
          "UPDATE_EXTERNAL_TOOL": "Atualizar uma ferramenta externa",
          "CODE_CHANGE": "Alterar código",
          "WRITE_DOCUMENT": "Escrever um documento",
          "FOLLOW_UP": "Fazer follow-up",
          "FYI": "Para seu conhecimento",
          "OTHER": "Outro trabalho"
        },
        "mode": {
          "SUGGEST": "Sugerir",
          "ASSIGN_AND_PLAN": "Planejar",
          "ASSIGN_AND_ACT": "Agir"
        },
        "ariaLabel": "Modo da rotina",
        "modeConfirm": {
          "question": "Vai agir sem pedir aprovação para etapas não críticas.",
          "confirm": "Mudar para Agir",
          "cancel": "Cancelar"
        },
        "modeToast": {
          "success": "Modo da rotina atualizado",
          "error": "Não foi possível atualizar o modo da rotina. Tente novamente."
        },
        "delete": {
          "action": "Excluir",
          "confirmQuestion": "Excluir esta rotina?",
          "confirm": "Excluir",
          "cancel": "Cancelar",
          "success": "Rotina excluída",
          "error": "Não foi possível excluir a rotina. Tente novamente."
        },
        "loadError": "Não foi possível carregar as rotinas. Tente novamente.",
        "recommendation": {
          "pitch": "Isso aconteceu {{count}} vezes em 30 dias · Automatize casos como este",
          "createAgent": "Criar agente",
          "dismiss": "Descartar",
          "toast": {
            "acceptSuccess": "Rotina criada",
            "acceptError": "Não foi possível criar a rotina. Tente novamente.",
            "dismissError": "Não foi possível descartar esta sugestão. Tente novamente."
          },
          "draft": {
            "REPLY_INFO": {
              "name": "Agente de respostas com informação",
              "description": "Redige respostas com as informações que esse tipo de pedido costuma precisar."
            },
            "SCHEDULE": {
              "name": "Agente de agendamento",
              "description": "Cuida da troca de mensagens para encontrar e confirmar um horário."
            },
            "DECIDE_APPROVE": {
              "name": "Agente de aprovação",
              "description": "Revisa pedidos como esse e propõe uma decisão."
            },
            "RESEARCH": {
              "name": "Agente de pesquisa",
              "description": "Investiga pedidos como esse e traz a resposta."
            },
            "UPDATE_EXTERNAL_TOOL": {
              "name": "Agente de atualização",
              "description": "Aplica atualizações como essa na ferramenta conectada."
            },
            "CODE_CHANGE": {
              "name": "Agente de alteração de código",
              "description": "Planeja e aplica alterações de código como essa."
            },
            "WRITE_DOCUMENT": {
              "name": "Agente de documentos",
              "description": "Redige um documento para pedidos como esse."
            },
            "FOLLOW_UP": {
              "name": "Agente de follow-up",
              "description": "Acompanha e cobra retorno em pedidos como esse."
            },
            "FYI": {
              "name": "Agente de avisos",
              "description": "Revisa e arquiva avisos como esse."
            },
            "OTHER": {
              "name": "Agente de automação",
              "description": "Cuida de pedidos como esse."
            }
          }
        }
      },
      "permissions": {
        "emptyState": "Nenhuma permissão permanente ainda.",
        "row": {
          "useCount_one": "Usada {{count}} vez",
          "useCount_other": "Usada {{count}} vezes"
        },
        "revoke": {
          "action": "Revogar",
          "confirmQuestion": "Revogar esta permissão permanente? O assistente vai perguntar novamente na próxima vez.",
          "confirm": "Revogar",
          "cancel": "Cancelar",
          "success": "Revogada",
          "error": "Não foi possível revogar esta permissão"
        }
      },
      "recipientRefusal": {
        "add": "Adicionar {{address}} aos contatos deste agente",
        "scope": "Deixar este agente contatar qualquer pessoa envolvida nas tarefas",
        "dismiss": "Dispensar",
        "ownerOnly": "Só quem criou este agente pode mudar quem ele pode contatar.",
        "failed": "Não conseguimos atualizar este agente. Tente novamente em instantes.",
        "answerAdded": "{{address}} agora é um dos contatos deste agente. Pode enviar.",
        "answerScope": "Este agente agora pode contatar qualquer pessoa envolvida em uma tarefa, inclusive {{address}}. Pode enviar."
      },
      "replyWait": {
        "title": {
          "one": "Aguardando a resposta de {{name}}",
          "many": "Aguardando respostas de {{names}}",
          "slack": "Aguardando uma resposta no Slack",
          "email": "Aguardando uma resposta por e-mail",
          "generic": "Aguardando uma resposta"
        },
        "until": "Até {{moment}}",
        "answered": {
          "one": "Resposta recebida",
          "many": "Respostas recebidas"
        },
        "expired": {
          "nobody": "Ninguém respondeu até {{moment}}",
          "partial": "Nem todos responderam até {{moment}}"
        },
        "cancelled": "Você parou de esperar",
        "cancel": "Cancelar espera",
        "cancelling": "Cancelando...",
        "cancelFailed": {
          "generic": "Não conseguimos encerrar a espera. Tente novamente em instantes.",
          "notFound": "Esta espera não existe mais.",
          "notOpen": "Esta espera já terminou, então não há nada para cancelar.",
          "stale": "Esta pergunta foi substituída por outra mais nova. Recarregue para ver a mais recente.",
          "rejected": "Você não pode cancelar esta espera porque não iniciou esta execução.",
          "alreadyExecuted": "Esta espera já foi concluída."
        },
        "receiptWaiting": {
          "until": "O agente aguarda a resposta dessa pessoa até {{moment}}.",
          "noDeadline": "O agente aguarda a resposta dessa pessoa."
        },
        "recipient": {
          "label": "Pessoas consultadas",
          "answered": "respondeu",
          "waiting": "aguardando"
        },
        "replies": {
          "label": "Respostas",
          "authorSlack": "Alguém no Slack",
          "authorEmail": "Alguém por e-mail",
          "meta": "{{author}} · {{when}}"
        },
        "platform": {
          "slack": "Alguém no Slack",
          "email": "Alguém por e-mail"
        },
        "moment": {
          "today": "hoje {{time}}",
          "tomorrow": "amanhã {{time}}",
          "yesterday": "ontem {{time}}",
          "date": "{{date}} {{time}}"
        }
      }
    },
    "looksResolved": {
      "badge": "Parece resolvida",
      "tooltip": "Uma mensagem recente sugere que isto foi feito. Resolva para confirmar, ou descarte se ainda está pendente.",
      "dismiss": "Não concluída",
      "dismissAriaLabel": "Não concluída: {{subject}}",
      "keepOpen": "Manter aberta",
      "keepOpenAriaLabel": "Manter aberta: {{subject}}",
      "alreadyChanged": "Esta tarefa mudou enquanto isso",
      "dismissSuccess": "Mantida aberta",
      "dismissError": "Não foi possível manter aberta. Tente novamente."
    },
    "newReply": {
      "dismiss": "Dispensar",
      "dismissAriaLabel": "Dispensar a nova resposta: {{subject}}",
      "dismissMenuItem": "Dispensar nova resposta",
      "dismissAllMenuItem": "Dispensar todas as novas respostas",
      "dismissError": "Não foi possível dispensar a resposta. Tente novamente.",
      "inConversation": "Há uma nova mensagem na conversa.",
      "dismissAll": "Dispensar todas",
      "dismissAllAriaLabel": "Dispensar todas: {{subject}}",
      "dismissShown": "Dispensar exibidas",
      "dismissShownAriaLabel": "Dispensar exibidas: {{subject}}",
      "dismissReplyAriaLabel": "Dispensar a resposta de {{name}}",
      "morePreviews_one": "+{{count}} mensagem a mais na conversa",
      "morePreviews": "+{{count}} mensagens a mais na conversa"
    },
    "executorAttention": {
      "SEND_FAILED": {
        "badge": "Falha no envio",
        "tooltip": "Falha no envio"
      },
      "NEEDS_APPROVAL": {
        "badge": "Precisa da sua aprovação",
        "tooltip": "Precisa da sua aprovação"
      },
      "NEEDS_INPUT": {
        "badge": "Precisa da sua resposta",
        "tooltip": "Precisa da sua resposta"
      },
      "NEEDS_CONNECTION": {
        "badge": "Conectar um app",
        "tooltip": "Conectar um app"
      },
      "READY_TO_RESOLVE": {
        "badge": "Pronta para concluir",
        "tooltip": "Pronta para concluir"
      },
      "SUGGESTED_DECISION": {
        "badge": "Decisão sugerida",
        "tooltip": "Decisão sugerida"
      },
      "notify": {
        "openAction": "Abrir",
        "browserBody": "Um dos itens da sua DoBox precisa da sua atenção.",
        "SEND_FAILED": {
          "title": "Falha no envio"
        },
        "NEEDS_APPROVAL": {
          "title": "Precisa da sua aprovação"
        },
        "NEEDS_INPUT": {
          "title": "Precisa da sua resposta"
        }
      }
    },
    "create": "Criar",
    "noSubject": "Sem assunto",
    "generatedChecklistTitle": "Etapas",
    "descriptionTruncated": "[Descrição truncada — o texto original era longo demais para ser exibido por completo]",
    "resolvedByAssistantComment": "O assistente fechou esta sugestão porque uma mensagem mais recente mostra que ela foi concluída ou não é mais necessária.",
    "autoResolvedFallbackComment": "O assistente resolveu esta tarefa porque uma mensagem recente da conversa mostra que ela foi concluída.",
    "looksResolvedFallbackComment": "Uma mensagem recente desta conversa indica que isto foi concluído. Resolva para confirmar, ou marque como não concluído.",
    "delegatedDirectSendComment": {
      "slackReply": "Respondeu automaticamente na conversa de origem.",
      "emailReply": "Respondeu automaticamente ao e-mail de origem.",
      "calendarEvent": "Agendou \"{{title}}\" no calendário."
    },
    "linkedTasksCount_one": "{{count}} tarefa vinculada",
    "linkedTasksCount": "{{count}} tarefas vinculadas",
    "firstRunBanner": {
      "title": "Extraia suas tarefas das suas conversas",
      "subtitle": "O DoBox lê seu e-mail e Slack, mantém apenas o que é realmente trabalho para você e registra isso aqui como um ticket. Nada é lido até você pedir.",
      "status": {
        "noAccount": "Nenhuma conta conectada ainda — Gmail, Outlook, Slack ou Teams.",
        "reading": "Lendo {{sources}}",
        "manage": "Gerenciar",
        "footnote_one": "Uma passada pelo seu último {{count}} dia de e-mails.",
        "footnote_other": "Uma passada pelos seus últimos {{count}} dias de e-mails."
      },
      "action": {
        "connectAccount": "Conectar uma conta",
        "connectAccountHint": "Conecte uma conta primeiro",
        "scanAgain": "Escanear novamente",
        "doneHide": "Pronto, ocultar",
        "hide": "Ocultar isto",
        "scan_one": "Escanear meu último {{count}} dia",
        "scan_other": "Escanear meus últimos {{count}} dias",
        "scanCoverageHint": "Lê apenas e-mails por enquanto",
        "startScanError": "Não foi possível iniciar a varredura. Tente novamente.",
        "activateWatcherError": "Não foi possível ativar o monitoramento, então a varredura não rodou. Tente novamente.",
        "scanEnablesWatchHint": "Escanear também ativa o monitoramento de novas mensagens"
      },
      "scanning": {
        "chip": "Escaneando",
        "title_one": "Lendo seu último {{count}} dia",
        "title_other": "Lendo seus últimos {{count}} dias",
        "counts_one": "{{count}} mensagem lida",
        "counts_other": "{{count}} mensagens lidas",
        "errorFallback": "Não conseguimos terminar de ler suas mensagens. Tente novamente."
      },
      "result": {
        "qualityHint": "Encontrou algo que não é trabalho? Uma regra evita que esse tipo de mensagem vire ticket de novo.",
        "addRule": "Adicionar uma regra",
        "watchOff": "Continuar observando novas mensagens em busca de tarefas",
        "watchOn": "Ainda observando novas mensagens em busca de tarefas",
        "summary_one": "{{count}} mensagem lida",
        "summary_other": "{{count}} mensagens lidas",
        "summaryTruncated_one": "{{count}} mensagem lida (parcial)",
        "summaryTruncated_other": "{{count}} mensagens lidas (parcial)",
        "newTickets": "— o que precisar de ação aparece na sua lista abaixo",
        "truncatedNotice": "— o que precisar de ação aparece abaixo; uma nova varredura pega o restante",
        "watchToggleError": "Não foi possível atualizar. Tente novamente."
      },
      "discovery": {
        "heading": "Tem mais aqui",
        "subheading": "toque em um para ver funcionando",
        "cards": {
          "groups": {
            "title": "Grupos de tarefas",
            "description": "Uma lista compartilhada por time"
          },
          "board": {
            "title": "Visão em quadro",
            "description": "Os mesmos tickets, por etapa"
          },
          "automations": {
            "title": "Automações",
            "description": "Regras, recorrências, agentes"
          },
          "agents": {
            "title": "Agentes",
            "description": "Repasse um ticket"
          }
        }
      },
      "tour": {
        "close": "Fechar",
        "groups": {
          "body": "Um grupo é um DoBox compartilhado. Todos veem os mesmos tickets, sugestões chegam para quem é dono do trabalho, e agentes rodam dentro do grupo.",
          "sampleClientWork": "Trabalho com clientes",
          "sampleEngineering": "Engenharia",
          "ticketCount_one": "{{count}} ticket",
          "ticketCount_other": "{{count}} tickets",
          "cta": "Convide seu time"
        },
        "board": {
          "body": "Os mesmos tickets, organizados por etapa. Arraste um para o lado e o status o acompanha — inclusive um trabalho que um agente está executando.",
          "columnTodo": "A FAZER",
          "columnInProgress": "EM ANDAMENTO",
          "columnDone": "CONCLUÍDO",
          "cta": "Abrir meu quadro"
        },
        "automations": {
          "body": "Descreva uma regra uma vez e o DoBox a mantém. Esta já está pronta para ativar:",
          "ruleChipClient": "E-mail de um cliente",
          "ruleChipCreate": "Criar um ticket",
          "ruleChipDue": "Vencimento em 2 dias",
          "ruleChipPost": "Postar em #sales",
          "headerNote": "Os quatro ficam atrás do ícone de camadas lá no cabeçalho",
          "ctaShowMenu": "Me mostre o menu",
          "ctaOpenFlows": "Abrir no Flows"
        },
        "delegate": {
          "body": "Um ticket não precisa voltar para você. Repasse para um agente e ele trabalha sozinho, reportando cada passo dentro do card.",
          "chipReview": "Aguarda sua revisão",
          "cta": "Gerenciar agentes",
          "examples": {
            "engineering": {
              "chipStep1": "Reproduz o bug",
              "chipStep2": "Escreve a correção",
              "chipStep3": "Abre um PR"
            },
            "hrPeople": {
              "chipStep1": "Lê o e-mail do novo contratado",
              "chipStep2": "Adiciona a pessoa aos Contatos",
              "chipStep3": "Agenda a call de onboarding"
            },
            "sales": {
              "chipStep1": "Lê o lead recebido",
              "chipStep2": "Adiciona ao CRM",
              "chipStep3": "Rascunha a resposta"
            },
            "marketing": {
              "chipStep1": "Lê o pedido de campanha",
              "chipStep2": "Busca o briefing no Brain",
              "chipStep3": "Rascunha a resposta"
            },
            "supportCs": {
              "chipStep1": "Lê o chamado de suporte",
              "chipStep2": "Consulta o Brain pela resposta",
              "chipStep3": "Rascunha a resposta"
            },
            "finance": {
              "chipStep1": "Lê o e-mail da fatura",
              "chipStep2": "Abre um ticket de aprovação",
              "chipStep3": "Define o vencimento"
            },
            "operations": {
              "chipStep1": "Lê o pedido no Slack",
              "chipStep2": "Abre um ticket",
              "chipStep3": "Posta a atualização no Slack"
            },
            "legal": {
              "chipStep1": "Lê o pedido de contrato",
              "chipStep2": "Consulta o Brain pela cláusula",
              "chipStep3": "Abre um ticket de aprovação"
            },
            "founderLeadership": {
              "chipStep1": "Lê o pedido de atualização",
              "chipStep2": "Busca os números no Brain",
              "chipStep3": "Posta o resumo no Slack"
            },
            "default": {
              "chipStep1": "Lê a mensagem",
              "chipStep2": "Rascunha uma resposta",
              "chipStep3": "Abre um ticket"
            }
          }
        }
      },
      "footer": {
        "runsIn": "O DoBox também roda em",
        "chipGmailSidebar": "Barra lateral do Gmail",
        "chipClaudeAi": "claude.ai",
        "chipChromeAgent": "Chrome, conduzido por um agente",
        "chipFlows": "Flows"
      }
    },
    "header": {
      "mobile": {
        "searchLabel": "Buscar",
        "filterLabel": "Filtrar",
        "sortLabel": "Ordenar",
        "openMenu": "Abrir menu lateral",
        "automationsLabel": "Automações"
      }
    },
    "showResolvedItems": "Mostrar concluídas",
    "noDoBoxEntries": "Nenhuma entrada do DoBox encontrada",
    "noResolvedEntries": "Nenhuma tarefa concluída",
    "noApprovedEntries": "Nenhuma tarefa aprovada",
    "noRejectedEntries": "Nenhuma tarefa rejeitada",
    "deepLinkTeamSwitch": {
      "switched": "Equipe ativa alterada para {{teamName}} para abrir este item",
      "switchedGeneric": "Equipe ativa alterada para abrir este item",
      "noAccess": "Você não tem acesso à equipe deste item"
    },
    "loadMore": "Carregar mais",
    "suggestionsLabel": "Sugestões de tarefas",
    "suggestionsSectionSubtitle": "Revise e aceite para adicionar à sua lista",
    "tasksSectionLabel": "Backlog",
    "collapseSuggestions": "Recolher sugestões",
    "expandSuggestions": "Expandir sugestões",
    "approvalsLabel": "Aprovações",
    "approvalsSectionSubtitle": "Revise e aprove ou rejeite",
    "collapseApprovals": "Recolher aprovações",
    "expandApprovals": "Expandir aprovações",
    "filters": {
      "title": "Filtrar",
      "filterByLabel": "Filtrar",
      "members": "Membros",
      "noMembers": "Sem membros",
      "assignedToMe": "Cartões atribuídos a mim",
      "readStatus": "Status de leitura",
      "unreadOnly": "Apenas não lidas",
      "cardStatus": "Status do cartão",
      "markedAsResolved": "Marcadas como concluídas",
      "approved": "Aprovadas",
      "rejected": "Rejeitadas",
      "dueDate": "Prazo",
      "noDates": "Sem datas",
      "overdue": "Atrasadas",
      "dueNextDay": "Vencem no próximo dia",
      "dueNextWeek": "Vencem na próxima semana",
      "dueNextMonth": "Vencem no próximo mês",
      "priority": "Prioridade",
      "labels": "Etiquetas",
      "noLabels": "Sem etiquetas",
      "clearAll": "Limpar filtros",
      "searchMembersPlaceholder": "Buscar membro...",
      "recentMembers": "Recentes",
      "allMembers": "Todos os membros",
      "noMembersFound": "Nenhum membro encontrado",
      "today": "Hoje",
      "week": "Semana",
      "month": "Mês",
      "readTab": "Leitura",
      "statusTab": "Status",
      "board": "Quadro"
    },
    "sort": {
      "tooltip": "Ordenar por campo e ordem",
      "sortBy": "Ordenar por",
      "dueDate": "Prazo",
      "createdAt": "Data de criação",
      "updatedAt": "Data de atualização",
      "priority": "Prioridade",
      "manual": "Manual",
      "order": "Ordem",
      "oldestFirst": "Mais antigas primeiro",
      "newestFirst": "Mais recentes primeiro",
      "lowestFirst": "Menor primeiro",
      "highestFirst": "Maior primeiro",
      "tooltipSortedBy": "Ordenado por {{field}}, {{order}}"
    },
    "search": {
      "genericError": "A busca falhou. Tente novamente."
    },
    "backToTasks": "Voltar para as tarefas",
    "connectEmailPrompt": {
      "title": "Deixe o this+that cuidar da sua caixa de entrada",
      "subtitle": "Conecte seu e-mail e recupere horas por semana sem perder nada importante.",
      "providerSectionLabel": "Provedor",
      "providerGmail": "Gmail",
      "providerOutlook": "Outlook",
      "connectButton": "Conectar {{provider}}"
    },
    "tabs": {
      "tasks": "Tarefas",
      "recurrences": "Tarefas recorrentes"
    },
    "recurrences": {
      "noEntries": "Nenhuma tarefa recorrente encontrada",
      "taskGroupLabel": "Lista:",
      "loadMore": "Carregar mais",
      "moreActions": "Mais ações",
      "edit": "Editar",
      "delete": "Excluir",
      "moveToList": "Mover para lista",
      "timeZoneLabel": "Fuso horário",
      "createError": "Falha ao criar a tarefa recorrente. Tente novamente.",
      "updateError": "Falha ao atualizar a tarefa recorrente. Tente novamente.",
      "deleteSuccess": "Tarefa recorrente excluída com sucesso",
      "deleteError": "Falha ao excluir a tarefa recorrente. Tente novamente.",
      "moveError": "Falha ao mover a tarefa recorrente. Tente novamente."
    },
    "mcp": {
      "noSubject": "(Sem assunto)",
      "aiSuggestion": "Sugestão da IA",
      "looksResolved": "Parece resolvida, aguardando sua confirmação",
      "due": "Prazo: {{date}}",
      "communicationCount_one": "{{count}} comunicação",
      "communicationCount_other": "{{count}} comunicações",
      "noEntries": "Nenhuma entrada do DoBox encontrada ({{filter}}). Seu DoBox está limpo!",
      "foundEntries_one": "{{count}} entrada do DoBox encontrada ({{filter}}):",
      "foundEntries_other": "{{count}} entradas do DoBox encontradas ({{filter}}):",
      "fetchError": "Falha ao buscar as entradas do DoBox. Tente novamente mais tarde.",
      "authRequired": "Autenticação necessária",
      "filter": {
        "unresolved": "pendentes",
        "resolved": "concluídas",
        "all": "todas"
      }
    },
    "taskGroupSelector": {
      "title": "Grupos de tarefas",
      "buttonLabel": "Grupo de tarefas",
      "doBox": "DoBox",
      "createTitle": "Criar lista",
      "createSubtitle": "Escolha uma cor para a sua lista",
      "createPlaceholder": "Digite o nome da lista",
      "viewMode": {
        "label": "Visualização",
        "listDescription": "Tarefas agrupadas em seções, uma abaixo da outra.",
        "boardDescription": "Colunas por etapa. Arraste os cards para movê-los."
      },
      "participantsLabel": "Membros",
      "participantsPlaceholder": "Selecionar membros",
      "participantsSearch": "Buscar...",
      "participantsSelectAll": "Selecionar todos os membros",
      "defaultListTooltip": "Lista padrão — novas tarefas serão adicionadas aqui",
      "mobileBackLabel": "Quadro",
      "mobileSheetTitle": "Listas",
      "mobileCreateButton": "Criar novo grupo de tarefas",
      "mobileSingleGroupBanner": "Adicione mais listas para alternar entre elas.",
      "mobileEmptyTitle": "Nenhuma lista ainda",
      "mobileEmptySubtitle": "Crie sua primeira lista para começar a organizar tarefas."
    },
    "actions": {
      "archiving": "Arquivando itens...",
      "archivedSuccess": "{{count}} itens arquivados com sucesso",
      "archivedError": "Falha ao arquivar os itens",
      "movingToInbox": "Movendo itens para a caixa de entrada...",
      "movedToInboxSuccess": "{{count}} itens movidos para a caixa de entrada com sucesso",
      "movedToInboxError": "Falha ao mover os itens para a caixa de entrada",
      "markingAsRead": "Marcando itens como lidos...",
      "markedAsReadSuccess": "{{count}} itens marcados como lidos com sucesso",
      "markedAsReadError": "Falha ao marcar os itens como lidos",
      "markingAsUnread": "Marcando itens como não lidos...",
      "markedAsUnreadSuccess": "{{count}} itens marcados como não lidos com sucesso",
      "markedAsUnreadError": "Falha ao marcar os itens como não lidos",
      "reportingAsSpam": "Denunciando itens como spam...",
      "reportedAsSpamSuccess": "{{count}} itens denunciados como spam com sucesso",
      "reportedAsSpamError": "Falha ao denunciar os itens como spam",
      "deleting": "Excluindo itens...",
      "deletedSuccess": "{{count}} itens excluídos com sucesso",
      "deletedError": "Falha ao excluir os itens",
      "unlinking": "Desvinculando itens...",
      "unlinkedSuccess": "{{count}} itens desvinculados com sucesso",
      "unlinkedError": "Falha ao desvincular os itens",
      "acceptingSuggestion": "Aceitando sugestão...",
      "acceptSuggestionSuccess": "Sugestão aceita com sucesso",
      "acceptSuggestionError": "Falha ao aceitar a sugestão. Tente novamente.",
      "approvingApproval": "Aprovando...",
      "approveApprovalSuccess": "Fluxo aprovado",
      "approveApprovalError": "Falha ao aprovar. Tente novamente.",
      "rejectingApproval": "Rejeitando...",
      "rejectApprovalSuccess": "Fluxo rejeitado",
      "rejectApprovalError": "Falha ao rejeitar. Tente novamente."
    },
    "inboxEntriesDropDown": {
      "newTask": "Nova tarefa",
      "new": "Novo",
      "newEntry": "Nova tarefa",
      "noSuggestions": "Nenhuma tarefa sugerida",
      "oneSuggestion": "1 tarefa sugerida",
      "multipleSuggestions": "{{count}} tarefas sugeridas",
      "selectedCount_one": "{{count}} selecionada",
      "selectedCount_other": "{{count}} selecionadas",
      "createEmail": "Criar e-mail",
      "createEmailAriaLabel": "Criar e-mail para: {{subject}}",
      "acceptSuggestion": "Aceitar sugestão",
      "acceptSuggestionAriaLabel": "Aceitar sugestão: {{subject}}",
      "openAssistantAriaLabel": "Perguntar ao assistente: {{subject}}",
      "markAsResolved": "Marcar como concluída",
      "markAsResolvedAriaLabel": "Marcar como concluída: {{subject}}",
      "markAsUnresolved": "Marcar como não concluída",
      "markAsUnresolvedAriaLabel": "Marcar como não concluída: {{subject}}",
      "markAsUnresolvedConfirmTitle": "Marcar como não concluída",
      "deleteAriaLabel": "Excluir entrada: {{subject}}",
      "markAsUnresolvedDescription": "Tem certeza de que deseja marcar esta tarefa como não concluída?",
      "resolvedItem": "Este item foi marcado como concluído",
      "moveToList": "Mover para outra lista",
      "doBoxListName": "DoBox",
      "editTask": "Editar tarefa",
      "editTaskAriaLabel": "Editar tarefa: {{subject}}",
      "noCommunications": "Nenhuma mensagem nesta entrada do DoBox",
      "accept": "Aceitar",
      "resolve": "Concluir",
      "unresolve": "Não concluída",
      "moreActions": "Mais ações",
      "delete": "Excluir",
      "feedback": "Feedback",
      "toggleLabelTitles": "Alternar exibição dos títulos das etiquetas",
      "recurringTask": "Tarefa recorrente",
      "labelsNotAvailable": "Etiquetas não disponíveis na lista DoBox",
      "approve": "Aprovar",
      "approveAriaLabel": "Aprovar fluxo: {{subject}}",
      "reject": "Rejeitar",
      "rejectAriaLabel": "Rejeitar fluxo: {{subject}}",
      "rejectSuggestionAriaLabel": "Rejeitar sugestão: {{subject}}",
      "moveToListError": "Falha ao mover a tarefa para a lista"
    },
    "delegation": {
      "menuAriaLabel": "Delegar para um agente",
      "trigger": {
        "delegate": "Delegar"
      },
      "overflowMenuLabel": "Delegar…",
      "askAssistant": {
        "label": "Perguntar ao assistente",
        "subtitle": "Abrir esta tarefa no assistente"
      },
      "sectionHeader": "Delegar para um agente",
      "agentCount_one": "{{count}} agente",
      "agentCount_other": "{{count}} agentes",
      "searchPlaceholder": "Buscar agentes…",
      "searchAriaLabel": "Buscar agentes",
      "createNewAgent": "Criar novo agente",
      "back": "Voltar",
      "noMatchingTargets": "Nenhum agente corresponde à busca.",
      "noTargets": "Nenhum agente disponível no momento",
      "localMachine": {
        "sectionHeader": "Máquina local",
        "notPaired": "Não pareado",
        "deviceCount_one": "{{count}} dispositivo",
        "deviceCount_other": "{{count}} dispositivos",
        "inviteDescription": "Pareie seu Mac para que o assistente possa delegar tarefas de código ao seu Claude Code ou Codex CLI local.",
        "fix": "Corrigir",
        "statusConnected": "Conectado · {{lastSeen}}",
        "statusOffline": "Offline · {{lastSeen}}",
        "statusConnectionError": "Erro de conexão · {{lastSeen}}",
        "statusChecking": "Verificando…"
      },
      "availability": {
        "available": "Disponível",
        "busy_one": "Ocupado com {{count}} tarefa",
        "busy_other": "Ocupado com {{count}} tarefas",
        "offline": "Offline"
      },
      "statusLabel": {
        "queued": "Na fila",
        "dispatching": "Enviando para o seu dispositivo",
        "running": "Em execução",
        "blocked": "Aguardando sua resposta",
        "planReady": "Plano pronto",
        "done": "Concluído",
        "failed": "Falhou",
        "paused": "Pausado",
        "waitingForDevice": "Aguardando o seu dispositivo"
      },
      "statusExplanation": {
        "queued": "Aguardando a vez. Nada é preciso de você.",
        "dispatching": "Passando isto ao agente. Ele começa em alguns segundos.",
        "running": "Trabalhando nisso. Você pode fechar; o progresso fica aqui.",
        "blockedNeedsApproval": "Esperando por você. Aprove ou cancele a mudança abaixo.",
        "blockedNeedsInput": "Esperando sua resposta. Responda abaixo para continuar.",
        "blockedNeedsConnection": "Falta conectar um app. Conecte e tente de novo.",
        "blockedActionFailed": "Uma mudança não foi concluída. Abra o cartão dela abaixo para tentar de novo ou dispensar.",
        "blockedStoppedEarly": "O agente parou antes de terminar. Encerre a execução para delegar de novo.",
        "blockedGeneric": "O agente parou e precisa de você. Leia a última mensagem abaixo ou encerre a execução.",
        "planReady": "O plano está pronto. Revise abaixo e aprove ou peça ajustes.",
        "done": "O agente terminou. Confira abaixo o que ele fez.",
        "failed": "A execução falhou. Veja abaixo o que aconteceu e tente de novo ou encerre a execução.",
        "paused": "Pausado. Toque em Retomar para continuar ou encerre a execução.",
        "waitingForDevice": "Aguardando seu dispositivo voltar a ficar online. Continua sozinho quando voltar.",
        "blockedWaitingReply": "Aguardando uma resposta. Nada para você fazer por enquanto."
      },
      "blockedReason": {
        "needsApproval": "Aguardando sua aprovação",
        "needsInput": "Aguardando sua resposta",
        "needsConnection": "Precisa de um app conectado",
        "sendFailed": "O envio falhou",
        "waitingReply": "Aguardando resposta"
      },
      "activeMenu": {
        "header": "{{targetName}} · {{status}}",
        "cancel": "Cancelar delegação",
        "cancelConfirmPrompt": "Cancelar esta delegação?",
        "cancelConfirmYes": "Sim, cancelar",
        "cancelConfirmNo": "Não",
        "pause": "Pausar delegação",
        "resume": "Retomar delegação",
        "clearLabel": "Limpar conversa",
        "clearConfirmPrompt": "Isso vai excluir permanentemente o histórico desta conversa. Essa ação não pode ser desfeita.",
        "clearConfirmYes": "Sim, excluir",
        "startAnother": "Iniciar outro agente",
        "otherRuns_one": "Mais {{count}} agente também está trabalhando nesta tarefa",
        "otherRuns_other": "Mais {{count}} agentes também estão trabalhando nesta tarefa"
      },
      "taskType": {
        "technicalAnalysis": "Pesquisa e relatório",
        "technicalAnalysisDescription": "Pesquisa e relata as descobertas sobre o ticket",
        "implementAndPr": "Executar ação",
        "implementAndPrDescription": "Executa a tarefa diretamente",
        "instructionsLabel": "Instruções para o agente (opcional)",
        "instructionsPlaceholder": "Adicione dicas, links de páginas com contexto ou quais MCPs usar…",
        "runModeLabel": "Modo de execução",
        "runtimeLabel": "Agente de código",
        "runtimeInstalled": "Runtimes instalados: {{runtimes}}",
        "runtimeClaude": "Claude Code",
        "runtimeCodex": "Codex",
        "runtimeAider": "Aider (local)",
        "modelLabel": "Modelo",
        "modelClaudeOpus": "Claude Opus",
        "modelClaudeSonnet": "Claude Sonnet",
        "modelClaudeHaiku": "Claude Haiku",
        "modelCodexDefault": "Padrão",
        "modelCodexSol": "GPT-5.6 Sol",
        "modelCodexTerra": "GPT-5.6 Terra",
        "modelCodexLuna": "GPT-5.6 Luna",
        "modelQwenCoder7b": "Qwen2.5 Coder 7B",
        "modelQwenCoder14b": "Qwen2.5 Coder 14B",
        "localRuntimeResearchOnlyHint": "Por enquanto, modelos locais suportam apenas Pesquisa e relatório.",
        "agentProfileLabel": "Perfil do agente",
        "agentProfileGenericOption": "Execução genérica (sem perfil)",
        "delegateCta": "Delegar tarefa",
        "execute": "Resolver esta DoBox",
        "runAgent": "Rodar agente",
        "executeDescription": "Age sobre a origem da mesma forma que o painel; pergunta só nas etapas críticas."
      },
      "modelSelection": {
        "title": "Escolha um modelo",
        "description": "Este modelo vai executar a implementação.",
        "confirm": "Confirmar",
        "cancel": "Cancelar"
      },
      "success": {
        "canceled": "Delegação cancelada",
        "paused": "Delegação pausada",
        "resumed": "Delegação retomada",
        "stopped": "Execução interrompida",
        "endRun": "Execução encerrada."
      },
      "errors": {
        "delegateFailed": "Falha ao delegar esta tarefa. Tente novamente.",
        "alreadyDelegated": "Esta tarefa já está sendo tratada por um agente.",
        "runLimitReached": "Esta tarefa já tem o máximo de 3 agentes em execução. Aguarde um deles terminar ou cancele um.",
        "runsItemTooLarge": "Esta tarefa acumulou histórico demais de agentes para iniciar outro. Limpe antes uma execução já concluída.",
        "localRunAlreadyActive": "Esse computador já está executando um agente neste repositório. Aguarde ele terminar ou escolha outro computador.",
        "executorRunAlreadyActive": "O assistente já está executando uma ação nesta tarefa. Aguarde terminar antes de iniciar outra.",
        "answerFailed": "Falha ao enviar sua resposta. Tente novamente.",
        "cancelFailed": "Falha ao cancelar a delegação. Tente novamente.",
        "retryFailed": "Não foi possível repetir a delegação. Tente novamente.",
        "confirmApprovalFailed": "Falha ao enviar sua aprovação. Tente novamente.",
        "cancelApprovalFailed": "Falha ao cancelar as ações propostas. Tente novamente.",
        "pauseFailed": "Falha ao pausar a delegação. Tente novamente.",
        "resumeFailed": "Falha ao retomar a delegação. Tente novamente.",
        "refinePlanFailed": "Falha ao solicitar alterações no plano. Tente novamente.",
        "requestPrChangesFailed": "Falha ao solicitar alterações no PR. Tente novamente.",
        "resolvePrCommentsFailed": "Falha ao pedir ao agente para resolver os comentários de revisão do PR. Tente novamente.",
        "watchPrFailed": "Não foi possível começar a acompanhar este pull request. Tente novamente.",
        "watchPrNoPr": "Esta tarefa não tem um pull request do GitHub para acompanhar.",
        "watchPrLimitReached": "Você atingiu o limite de monitores ativos. Pare um para acompanhar este pull request.",
        "watchPrNotFound": "Não foi possível encontrar esta tarefa.",
        "watchPrForbidden": "Você não tem acesso para acompanhar este pull request.",
        "planChanged": "O plano mudou. Revise de novo antes de aprovar.",
        "stopRunFailed": "Falha ao interromper a execução. Tente novamente.",
        "endRunFailed": "Não foi possível encerrar a execução. Tente novamente."
      },
      "approval": {
        "confirmLabel": "Confirmar ({{count}})",
        "cancelLabel": "Cancelar"
      },
      "banner": {
        "queued": "Delegado para {{targetName}}",
        "running": "Delegado para {{targetName}}",
        "blocked": "{{targetName}} está aguardando sua resposta",
        "paused": "{{targetName}} está pausado",
        "planReadyTitle": "Plano pronto",
        "reviewPlan": "Revisar plano",
        "done": "O agente terminou",
        "failed": "O agente falhou",
        "openPr": "Abrir PR",
        "discussInAssistant": "Discutir no assistente",
        "answerPlaceholder": "Ou digite uma resposta…",
        "send": "Enviar",
        "approve": "Aprovar",
        "expand": "Expandir",
        "collapse": "Recolher",
        "dismiss": "Dispensar",
        "stepsLoading": "Carregando etapas…",
        "approvalNeeded": "{{targetName}} precisa da sua aprovação",
        "showLog": "Mostrar log",
        "hideLog": "Ocultar log",
        "askAssistantAboutError": "Perguntar ao assistente sobre isso",
        "attemptLabel": "tentativa {{count}}"
      },
      "errorGuidance": {
        "branchExists": {
          "title": "Uma branch remanescente da tentativa anterior está bloqueando uma nova execução.",
          "action": "Tentar novamente — limpa tudo e recomeça."
        },
        "needsRepoAccess": {
          "title": "O agente não conseguiu acessar o repositório.",
          "action": "Verifique as permissões da conexão com o GitHub e depois tente novamente."
        },
        "timeout": {
          "title": "A tarefa ultrapassou o limite de tempo.",
          "action": "Tentar novamente retoma da sessão salva quando possível."
        },
        "maxTurns": {
          "title": "O agente atingiu o limite de etapas.",
          "action": "Toque em Tentar novamente para ele continuar de onde parou."
        },
        "noSessionToResume": {
          "title": "Não há sessão salva para retomar.",
          "action": "Tentar novamente reinicia a tarefa do zero."
        },
        "localAgentUnreachable": {
          "title": "Sua máquina local não está acessível.",
          "action": "Verifique se o app de delegação está em execução e depois tente novamente."
        },
        "permissionPolicyBlocked": {
          "title": "Sua máquina impediu o agente de alterar arquivos",
          "action": "As configurações do Claude Code na máquina pareada recusaram uma permissão que a tarefa precisa, então nada pôde ser escrito. Libere lá e tente de novo — repetir sem mudar nada vai falhar igual."
        },
        "prDescriptionUpdateFailed": {
          "title": "Não consegui atualizar a descrição da PR.",
          "action": "Peça de novo aqui no chat."
        },
        "noChanges": {
          "title": "O agente terminou sem alterar nenhum arquivo.",
          "action": "Explique no chat o que precisa mudar e peça de novo."
        },
        "noStepAttempted": {
          "title": "O agente terminou sem fazer nada nesta tarefa.",
          "action": "Diga o que você quer que ele faça e entregue a tarefa de novo."
        },
        "noReviewComments": {
          "title": "Esta PR não tem comentários de revisão para resolver.",
          "action": "Se quiser outra mudança, peça aqui no chat."
        },
        "connectionNotFound": {
          "title": "A conexão de código usada por esta tarefa foi removida.",
          "action": "Reconecte, ou escolha outra máquina, e tente novamente."
        },
        "localJobNotFound": {
          "title": "Sua máquina não reconhece mais este job.",
          "action": "Verifique o app na bandeja do sistema nessa máquina e tente novamente."
        },
        "deviceOfflineExpired": {
          "title": "Sua máquina ficou offline por 72 horas.",
          "action": "Reconecte e tente novamente."
        },
        "sourceChangedBeforeDispatch": {
          "title": "Uma nova mensagem chegou antes que isso pudesse começar.",
          "action": "Revise o plano atualizado e tente novamente."
        },
        "dispatchUnconfirmed": {
          "title": "Uma versão antiga do app de delegação não confirmou o início disso.",
          "action": "Verifique a máquina e tente novamente."
        },
        "unknown": {
          "title": "Algo deu errado e o agente não conseguiu terminar a tarefa.",
          "action": "Tente de novo. Se o erro se repetir, fale com o suporte."
        }
      },
      "eventKind": {
        "delegated": "Delegado",
        "statusChange": "Status alterado",
        "questionAsked": "Pergunta feita",
        "answered": "Respondido",
        "failed": "Falhou",
        "retried": "Nova tentativa",
        "planReady": "Plano pronto",
        "planRefined": "Revisão do plano solicitada",
        "prUpdateRequested": "Alterações no PR solicitadas",
        "completed": "Concluído"
      },
      "panel": {
        "needsDecision": "Precisa da sua aprovação",
        "requestChangesTitle": "Solicitar alterações",
        "requestChangesPlaceholder": "Descreva o que você quer que o agente ajuste..."
      },
      "modal": {
        "title": "Plano do agente",
        "close": "Fechar",
        "expand": "Expandir",
        "collapse": "Recolher",
        "viewPlan": "Ver plano",
        "statusLabelBlocked": "Bloqueado",
        "statusLabelPlanReady": "Pronto para aprovação",
        "answerQuickReplyYes": "Sim",
        "answerQuickReplyNo": "Não",
        "answerQuickReplySkip": "Pular"
      },
      "activity": {
        "DELEGATING": "Delegando para um subagente…",
        "EDITING": "Editando arquivos…",
        "PLANNING": "Planejando o trabalho…",
        "READING": "Lendo arquivos…",
        "RESEARCHING": "Consultando referências…",
        "RUNNING_COMMANDS": "Executando comandos…",
        "SEARCHING": "Pesquisando no código…",
        "WORKING": "Trabalhando…"
      },
      "conversation": {
        "streamAriaLabel": "Log da conversa com o agente",
        "emptyTitle": "Pronto quando você estiver",
        "emptyBody": "O Claude Code está pareado e parado nesta tarefa. Envie uma mensagem ou inicie a execução — tudo fica dentro desta tarefa.",
        "emptyTitleCloud": "Aguardando o agente",
        "emptyBodyCloud": "Ainda não há nada do agente. As mensagens e propostas dele vão aparecer aqui assim que chegarem.",
        "emptyTitleProcessing": "Começando agora",
        "emptyBodyProcessing": "O agente está iniciando a execução — a atividade vai aparecer aqui em instantes.",
        "emptyChipStartRun": "Iniciar execução",
        "loading": "Carregando conversa",
        "statusIdle": "Ocioso",
        "statusRunning": "Em execução",
        "statusWaiting": "Aguardando sua resposta",
        "statusCompleted": "Concluído",
        "statusFailed": "Falhou",
        "modePlan": "Modo Plano",
        "modeImplementing": "Implementando",
        "modeExecuting": "Executando",
        "tabsNotStarted": "não iniciado",
        "tabsElapsed": "{{elapsed}} decorrido",
        "fullHistory_one": "Histórico ({{count}})",
        "fullHistory_other": "Histórico ({{count}})",
        "fullHistoryAriaLabel": "Ver o histórico completo de execução",
        "elapsedMinutes": "{{count}} min",
        "elapsedHours": "{{count}}h",
        "elapsedDays_one": "{{count}} dia",
        "elapsedDays_other": "{{count}} dias",
        "toolStatusRunning": "executando",
        "toolStatusDone": "concluído",
        "toolStatusFailed": "falhou",
        "activityRunToggleAriaLabel": "Alternar detalhes da atividade",
        "plan": {
          "showFull": "Ver plano completo",
          "hideFull": "Ocultar plano completo"
        },
        "askGroupAriaLabel": "Pergunta do agente",
        "askEyebrow": "Precisa da sua resposta",
        "questionAnswerHint": "Escolha uma opção ou digite sua resposta na caixa abaixo.",
        "answerSendFailed": "Essa resposta não foi enviada. Seu texto foi mantido, então você pode enviar de novo.",
        "askFreeTextHint": "Ou escreva uma resposta mais longa na caixa de mensagem — ela conta como a resposta.",
        "resultTitle": "Tarefa concluída",
        "resolvePrComments": "Resolver comentários de revisão",
        "watchPr": "Acompanhar PR",
        "viewWatcher": "Ver monitor",
        "watchPrCreated": "Acompanhando este pull request. Siga na aba Monitorando.",
        "resultMarkTaskDone": "Marcar tarefa como concluída",
        "resultPrDescriptionUpdateFailed": "O código foi enviado, mas não consegui atualizar a descrição da PR. Peça de novo aqui no chat.",
        "failTitle": "Execução falhou",
        "failRetry": "Tentar novamente",
        "failViewFullLog": "Ver log completo",
        "pausedEvent": "Pausado por você · o agente foi interrompido imediatamente",
        "messagePending": "Enviando…",
        "workingBarPause": "Pausar",
        "workingBarPauseAriaLabel": "Pausar agente",
        "pausedBarLabel": "Pausado",
        "pausedBarResume": "Retomar",
        "pausedBarResumeAriaLabel": "Retomar agente",
        "composerSendAriaLabel": "Enviar mensagem",
        "composerInputAriaLabel": "Mensagem para o agente",
        "placeholderRunning": "Envie uma nota — ela fica guardada até esta execução terminar",
        "placeholderIdle": "Envie uma mensagem para o agente sobre esta tarefa",
        "hintRunning": "Enter envia. A execução continua; sua mensagem chega na próxima etapa.",
        "hintIdle": "Enter envia · Shift+Enter para nova linha · arquivos são compartilhados com o workspace do agente",
        "notOwnDelegationHint": "Só quem iniciou esta delegação pode enviar mensagens ou aprovar aqui.",
        "localActivityStarting": "Começando — é só um instante.",
        "historyLimitNotice": "Esta conversa já tem bastante histórico — as mensagens mais antigas não aparecem mais aqui, mas o trabalho segue normalmente.",
        "newItemsAvailable_one": "{{count}} novidade",
        "newItemsAvailable_other": "{{count}} novidades",
        "destinationQueueMessage": "Envia para o agente",
        "destinationAnswerQuestion": "Responde à pergunta",
        "destinationRevisePlan": "Revisa o plano",
        "destinationRequestPrChanges": "Solicita alterações no PR",
        "destinationRestartTask": "Reinicia a tarefa com sua mensagem",
        "destinationContinueConversation": "Continua a conversa",
        "destinationRetryWithInstructions": "Tenta novamente com suas instruções",
        "destinationResumeAndSend": "Retoma a execução e envia",
        "destinationQueuedForRunningJob": "Na fila — a execução ainda está em andamento",
        "prFeedbackMinLengthHint": "Adicione pelo menos {{count}} caracteres para solicitar alterações",
        "queuedEyebrow": "Retida — ainda não enviada",
        "queuedCheckNow": "Verificar agora",
        "queuedCancel": "Cancelar",
        "queuedCheckNowFailed": "Não foi possível verificar o status da execução. Tente novamente.",
        "approvalEyebrow": "Precisa da sua aprovação",
        "approvalGroupAriaLabel": "Ações propostas",
        "failTechnicalDetails": "Detalhes técnicos",
        "elapsedLessThanMinute": "menos de um minuto",
        "activityRunSteps_one": "{{count}} etapa",
        "activityRunSteps_other": "{{count}} etapas",
        "toolGenericLabel": "Etapa"
      },
      "runView": {
        "statusNeedsApproval_one": "Precisa da sua aprovação · {{count}} mudança",
        "statusNeedsApproval_other": "Precisa da sua aprovação · {{count}} mudanças",
        "expandAriaLabel": "Abrir em tela cheia",
        "collapseAriaLabel": "Voltar ao painel",
        "hintRunningHeld": "Enter envia. Sua nota fica retida e é enviada ao agente quando esta execução terminar.",
        "stopConfirmPrompt": "Cancelar esta execução? Você pode delegar de novo quando quiser.",
        "stopConfirmYes": "Sim, cancelar execução",
        "stopConfirmNo": "Continuar",
        "endRunConfirmPrompt": "Fechar esta execução? A tarefa continua aberta.",
        "endRunConfirmYes": "Fechar execução",
        "endRunConfirmNo": "Manter",
        "planFirstChip": "Primeiro o plano — nenhuma alteração de código sem seu OK",
        "liveLog": {
          "title": "Log em tempo real",
          "copy": "Copiar",
          "copySuccess": "Log copiado para a área de transferência."
        },
        "approvals": {
          "bar": {
            "skipFuture": "Não perguntar de novo nesta tarefa",
            "title_one": "Esta mudança está esperando por você",
            "title_other": "{{count}} mudanças esperando por você",
            "hint_one": "Ela só muda esta tarefa e o seu Brain. Mensagens para pessoas e exclusões continuam pedindo aprovação antes.",
            "hint_other": "Elas só mudam esta tarefa e o seu Brain. Mensagens para pessoas e exclusões continuam pedindo aprovação uma a uma.",
            "approveAll_one": "Aprovar",
            "approveAll_other": "Aprovar todas"
          },
          "result": {
            "title": "Resultado de aprovar todas",
            "applied_one": "{{count}} mudança aplicada",
            "applied_other": "{{count}} mudanças aplicadas",
            "failed_one": "{{count}} não deu certo",
            "failed_other": "{{count}} não deram certo",
            "nothingApplied": "Nada foi aplicado",
            "stepFailed": "O cartão dela abaixo diz o que aconteceu. Tente de novo por lá ou dispense.",
            "notStarted": "Não começou.",
            "leftForIndividual_one": "{{count}} mudança ainda precisa da sua decisão. Ela está no próprio cartão, logo abaixo.",
            "leftForIndividual_other": "{{count}} mudanças ainda precisam da sua decisão. Elas estão nos próprios cartões, logo abaixo.",
            "dismiss": "Dispensar"
          },
          "errors": {
            "approveAll": "Não foi possível aprovar essas mudanças. Tente de novo.",
            "turnOffSkip": "Não foi possível desativar. Tente de novo.",
            "turnOnSkip": "Não foi possível ligar isto. Tente de novo."
          }
        },
        "state": {
          "labelCompact": {
            "needsApproval": "Aprovação"
          },
          "label": {
            "working": "Trabalhando",
            "needsApproval": "Precisa da sua aprovação",
            "needsYou": "Precisa de você",
            "prReady": "PR pronto",
            "prDraft": "PR em rascunho",
            "prMerged": "PR mergeado",
            "prClosed": "PR fechado",
            "prChecksFailing": "Checks falhando",
            "prChangesRequested": "Alterações solicitadas",
            "prComments": "Comentários de revisão",
            "prChecksRunning": "Checks em andamento",
            "prApproved": "PR aprovado",
            "prChecksPassed": "Checks aprovados",
            "done": "Concluída",
            "replied": "Respondeu",
            "failed": "Falhou",
            "waitingReply": "Aguardando resposta",
            "stopped": "Interrompida",
            "ended": "Encerrada"
          },
          "meta": {
            "planReady": "plano pronto",
            "updateReady": "alteração pronta",
            "actionReady": "ação pronta",
            "stoppedOnStep": "parou no passo {{step}}",
            "finishedIn": "concluída em {{elapsed}}",
            "declinedByOwner": "você recusou a ação",
            "endedByUser": "Encerrada por você",
            "replaced": "Substituída por uma execução mais nova"
          }
        },
        "pastRun": {
          "endedExplanation": "Esta execução parou antes de {{agent}} terminar. Nada mais vai acontecer nela.",
          "composerReplacement": "Esta execução terminou. Use + Nova para delegar de novo."
        },
        "topBar": {
          "back": "Voltar para a tarefa",
          "new": "Nova",
          "metaCloud": "Agente na nuvem · iniciado às {{time}}",
          "metaLocal": "Iniciado às {{time}} · {{taskType}}",
          "metaLocalPlanFirst": "Iniciado às {{time}} · {{taskType}} · Primeiro o plano"
        },
        "menu": {
          "ariaLabel": "Opções da execução",
          "worksWithoutAskingOn": "Trabalha sem perguntar: ligado",
          "worksWithoutAskingOff": "Trabalha sem perguntar: desligado",
          "worksWithoutAskingAgent": "Trabalha sem perguntar (definido no agente)",
          "cancelRun": "Cancelar execução",
          "closeRun": "Fechar execução"
        },
        "card": {
          "plan": {
            "fallbackTitle": "Revise o plano",
            "approve": "Aprovar plano",
            "readFull": "Ler plano completo",
            "hideFull": "Ocultar plano completo"
          },
          "action": {
            "approve": "Aprovar",
            "askForChanges": "Pedir ajustes",
            "toolLine": "Ferramenta: {{tool}}",
            "decline": "Recusar",
            "title": {
              "generic": "Aprovar esta ação",
              "SOURCE_REPLY": "Enviar esta resposta",
              "OUTBOUND_MESSAGE": "Enviar esta mensagem",
              "CALENDAR_EVENT": "Alterar sua agenda",
              "DOBOX_INTERNAL": "Aplicar esta alteração na tarefa",
              "KNOWLEDGE_WRITE": "Atualizar seu Brain",
              "FLOW": "Alterar um fluxo",
              "AGENT": "Alterar um agente",
              "MCP_READ": "Usar um app conectado",
              "MCP_WRITE": "Fazer uma alteração em um app conectado",
              "MEMORY": "Salvar isto na memória",
              "CODE_DELEGATION": "Iniciar uma tarefa de código",
              "CAPABILITY": "Conectar o que isto precisa",
              "mcpNeutral": {
                "toolInApp": "Usar {{tool}} em {{app}}",
                "tool": "Usar {{tool}}",
                "generic": "Usar um app conectado"
              }
            }
          },
          "done": {
            "fallback": "{{agent}} concluiu esta execução.",
            "fallbackPr": "{{agent}} concluiu e abriu um PR. Revise o que mudou antes de fazer o merge.",
            "fallbackReplied": "{{agent}} respondeu sem fazer alterações.",
            "fallbackPrSettled": "{{agent}} concluiu e abriu um PR.",
            "more": "Ler mais",
            "less": "Mostrar menos",
            "openPr": "Abrir PR",
            "nextLabel": "Próximos passos com {{agent}}",
            "resolveComments": "Resolver comentários da revisão",
            "resolveCommentsHint": "Lê os comentários do PR e envia as correções",
            "resolveCommentsCount_one": "Resolver {{count}} comentário de revisão",
            "resolveCommentsCount_other": "Resolver {{count}} comentários de revisão",
            "fixChecks": "Corrigir checks com falha",
            "fixChecksHint": "Escreve a instrução no campo de mensagem para você revisar e enviar",
            "fixChecksPrefill": "Os checks do PR estão falhando. Veja quais falharam, corrija a causa e envie a correção para a mesma branch.",
            "signals": {
              "checksRunning": "Checks em andamento",
              "checksFailing_one": "{{count}} check falhou",
              "checksFailing_other": "{{count}} checks falharam",
              "checksPassed": "Checks aprovados",
              "approved": "Aprovado",
              "changesRequested": "Alterações solicitadas",
              "reviewRequired": "Revisão necessária",
              "comments_one": "{{count}} comentário para resolver",
              "comments_other": "{{count}} comentários para resolver"
            },
            "watchHint": "Avisa quando as verificações ou revisões mudarem"
          },
          "failed": {
            "title": "A execução parou",
            "titleStep": "A execução parou em “{{step}}”",
            "effects_one": "Antes de parar, {{count}} ação já foi concluída.",
            "effects_other": "Antes de parar, {{count}} ações já foram concluídas.",
            "retry": "Tentar de novo",
            "technicalDetails": "Detalhes técnicos"
          },
          "declined": {
            "title": "Você recusou a ação",
            "explanation": "Nada foi alterado. Use + Nova para pedir que {{agent}} tente de outro jeito."
          }
        },
        "earlierPending": {
          "heading": "Pendente de uma execução anterior",
          "explanation": "{{agent}} pediu isso antes da execução atual. Recuse para limpar o alerta ou aprove se ainda quiser."
        },
        "openQuestions": {
          "title_one": "{{count}} pergunta em aberto",
          "title_other": "{{count}} perguntas em aberto",
          "subtitle": "O plano já assume uma resposta. As perguntas que você não mexer mantêm essa resposta.",
          "assumes": "Assume:",
          "change": "Mudar",
          "changeAria": "Mudar a resposta da pergunta {{number}}",
          "answerPrefix": "Pergunta {{number}}",
          "answerAria": "Resposta da pergunta {{number}}",
          "answerPlaceholder": "Digite sua resposta",
          "answerPlaceholderAssumes": "Assume: {{assumes}}",
          "send_one": "Enviar resposta",
          "send_other": "Enviar {{count}} respostas",
          "discard": "Descartar"
        },
        "progress": {
          "label": "Progresso",
          "waitingForYou": "Esperando você",
          "stoppedHere": "Parou aqui",
          "showPlan": "Mostrar plano",
          "hidePlan": "Ocultar plano",
          "title": {
            "planWritten": "Leu o código e escreveu um plano",
            "planApproved": "Você aprovou o plano",
            "localAnalysis": "Leu o código e escreveu um plano",
            "localAnalysisActive": "Lendo o código",
            "localImplementation": "Fez a alteração",
            "localImplementationActive": "Fazendo a alteração",
            "localImplementationPr": "Fez a alteração e abriu o PR",
            "notRun": "Os próximos passos não rodaram"
          },
          "decision": {
            "approved": "{{action}} · Aprovada",
            "declined": "{{action}} · Recusada por você",
            "waiting": "{{action}}"
          }
        },
        "composer": {
          "to": "Para:",
          "placeholder": {
            "running": "Envie uma nota — ele a lê entre os passos",
            "plan": "Peça ajustes no plano…",
            "action": "Peça ajustes ou responda “pode seguir”",
            "input": "Digite sua resposta…",
            "done": "Mensagem para {{agent}} sobre esta execução",
            "failed": "Adicione uma nota e tente de novo…"
          },
          "hint": {
            "followUp": "Mensagens de acompanhamento vão para esta execução. Para outro agente, use + Nova.",
            "plan": "Devolve o plano com a sua nota. Para cancelar a execução, use ⋯.",
            "failed": "Enviar repete a execução com a sua nota."
          }
        }
      },
      "activityDone": {
        "DELEGATING": "Delegou para um subagente",
        "EDITING": "Editou arquivos",
        "PLANNING": "Planejou o trabalho",
        "READING": "Leu arquivos",
        "RESEARCHING": "Consultou referências",
        "RUNNING_COMMANDS": "Executou comandos",
        "SEARCHING": "Pesquisou no código",
        "WORKING": "Trabalhou nisso"
      },
      "linkedPullRequests": {
        "title": "Pull requests vinculados",
        "numbered": "Pull request nº {{number}}",
        "unnumbered": "Pull request",
        "open": "Abrir PR",
        "openAriaLabel": "Abrir {{name}} em uma nova aba"
      },
      "runList": {
        "title": "Trabalho do agente nesta tarefa",
        "earlier": "Execuções anteriores",
        "view": "Ver",
        "finished": "terminou às {{time}}",
        "started": "começou às {{time}}",
        "ended": "encerrada às {{time}}",
        "finishedOn": "terminou em {{time}}",
        "startedOn": "começou em {{time}}",
        "endedOn": "encerrada em {{time}}",
        "rowAriaLabel": "{{agent}}, {{state}}. Ver execução",
        "assistant": {
          "name": "Assistente",
          "rowAriaLabel": "{{agent}}, {{state}}. Abrir conversa",
          "state": {
            "working": "Trabalhando",
            "needsApproval": "Precisa da sua aprovação",
            "needsInput": "Precisa da sua resposta",
            "replied": "Respondeu"
          }
        }
      }
    },
    "agentPresence": {
      "card": {
        "line1": {
          "working": "{{agent}} está trabalhando",
          "needsYou": "{{agent}} precisa de você",
          "reviewDraft": "{{agent}} · rascunho pronto para revisar",
          "reviewPr": "{{agent}} · PR pronto para revisar"
        },
        "line2": {
          "waitingForDevice": "Aguardando seu Mac",
          "planReady": "Plano pronto — aprove para começar a programar",
          "paused": "Pausado",
          "failed": "Não conseguiu terminar",
          "question": "{{question}}",
          "reviewSubject": "Re: {{subject}}",
          "reviewRecipient": "Para {{recipient}}",
          "reviewGeneric": "Pronto para revisar",
          "waitingReply": "Aguardando resposta"
        }
      },
      "cta": {
        "watch": "Acompanhar",
        "answer": "Responder",
        "reviewAndSend": "Revisar e enviar",
        "reviewPr": "Revisar PR",
        "ariaLabel": "{{cta}}: {{subject}}",
        "reviewPlan": "Revisar plano"
      },
      "agentKind": {
        "localClaude": "Local Claude",
        "assistant": "Assistente"
      },
      "chip": {
        "openRunViewAriaLabel": "Abrir a execução de {{agent}}: {{state}}",
        "openRunListAriaLabel_one": "Mostrar os agentes desta tarefa: {{agent}}: {{state}}, e mais {{count}} em execução",
        "openRunListAriaLabel_other": "Mostrar os agentes desta tarefa: {{agent}}: {{state}}, e mais {{count}} em execução",
        "statusAriaLabel": "{{agent}}: {{state}}"
      },
      "delegateButton": "Delegar",
      "delegateButtonAriaLabel": "Delegar: {{subject}}"
    },
    "agentBand": {
      "status": {
        "working": {
          "full": "está trabalhando",
          "compact": "Trabalhando"
        },
        "starting": "Iniciando…",
        "needsYou": {
          "full": "precisa de você",
          "compact": "Precisa de você"
        },
        "draftReady": {
          "full": "rascunho pronto",
          "compact": "Rascunho pronto"
        },
        "editApproval": {
          "full": "aguardando sua aprovação",
          "compact": "Precisa da sua aprovação"
        },
        "prReady": {
          "full": "PR pronto",
          "compact": "PR pronto"
        },
        "failed": "Falhou",
        "paused": "Pausado",
        "offline": "Offline",
        "waitingReply": "Aguardando resposta"
      },
      "action": {
        "watch": "Acompanhar",
        "answer": "Responder",
        "reviewAndSend": "Revisar e enviar",
        "review": "Revisar",
        "reviewPr": "Revisar PR",
        "open": "Abrir",
        "reviewPlan": "Revisar plano"
      },
      "aria": {
        "working": "{{agent}} está trabalhando — acompanhar",
        "workingWithElapsed": "{{agent}} está trabalhando, {{elapsed}} — acompanhar",
        "starting": "{{agent}} está iniciando — acompanhar",
        "needsYou": "{{agent}} precisa de você — responder",
        "draftReady": "{{agent}} tem um rascunho pronto — revisar",
        "editApproval": "{{agent}} aguarda sua aprovação — revise",
        "prReady": "{{agent}} abriu um PR — revisar",
        "offline": "{{agent}} está offline — abrir",
        "paused": "{{agent}} está pausado — abrir",
        "failed": "{{agent}} falhou — abrir",
        "waitingReply": "{{agent}} está aguardando uma resposta — abrir",
        "state": "{{agent}}: {{state}} — abrir",
        "withOtherRuns_one": "{{label}}. Mais {{count}} agente está trabalhando nesta tarefa",
        "withOtherRuns_other": "{{label}}. Mais {{count}} agentes estão trabalhando nesta tarefa",
        "planReady": "{{agent}} tem um plano pronto — revisar"
      },
      "elapsedNow": "agora"
    },
    "delegatePopover": {
      "ariaLabel": "Delegar esta tarefa",
      "instructionLabel": "O que o agente deve fazer?",
      "instructionHint": "Opcional · Enter delega",
      "agentListAriaLabel": "Agentes",
      "sectionSuggested": "Sugerido",
      "sectionOthers": "Outros agentes",
      "sectionCloud": "Agentes na nuvem",
      "manageAgents": "Gerenciar",
      "askBeforeActing": "Perguntar antes de agir",
      "planFirst": "Planejar primeiro, eu aprovo",
      "delegate": "Delegar",
      "delegating": "Delegando…",
      "error": "Não foi possível delegar. Tente novamente.",
      "openInAssistant": "Abrir no assistente",
      "toastDelegated": "Delegado para {{agent}}"
    },
    "agentNotifications": {
      "typeLabel": {
        "error": "Agente falhou",
        "decision": "Precisa de decisão",
        "blocked": "Aguardando você",
        "done": "Concluído"
      },
      "defaultTitle": {
        "decision": "O agente tem um plano pronto para você",
        "blocked": "O agente precisa da sua resposta",
        "done": "O agente terminou"
      },
      "action": {
        "openChat": "Abrir conversa",
        "dismissAriaLabel": "Dispensar notificação"
      },
      "bar": {
        "statusLine_one": "{{count}} agente precisa da sua resposta",
        "statusLine_other": "{{count}} agentes precisam da sua resposta",
        "viewAll": "Ver todos",
        "collapse": "Recolher"
      },
      "bell": {
        "ariaLabel_one": "Notificações de agentes, {{count}} item pendente",
        "ariaLabel_other": "Notificações de agentes, {{count}} itens pendentes"
      },
      "browserTitle": "{{agent}} · {{label}}",
      "browserBody": "{{title}}",
      "completion": {
        "generic": "O agente concluiu com sucesso",
        "withSummary": "O agente concluiu com sucesso — {{summary}}"
      }
    },
    "undoToast": {
      "deletedSingle": "\"{{subject}}\" excluída",
      "deletedMultiple": "{{count}} tarefas excluídas",
      "resolvedSingle": "Marcada como concluída: \"{{subject}}\"",
      "resolvedMultiple": "{{count}} tarefas marcadas como concluídas",
      "unresolvedSingle": "Marcada como não concluída: \"{{subject}}\"",
      "unresolvedMultiple": "{{count}} tarefas marcadas como não concluídas",
      "undo": "Desfazer",
      "commitError": "A ação falhou. O item vai reaparecer ao atualizar a página.",
      "leaveTitle": "Sair da página?",
      "leaveDescription": "Você tem ações pendentes. Elas serão executadas imediatamente quando você sair.",
      "leaveConfirm": "Sair",
      "leaveCancel": "Ficar"
    },
    "rejectionDialog": {
      "title": "Conte por que esta tarefa sugerida não foi útil",
      "feedbackPlaceholder": "Conte por que esta tarefa sugerida não foi útil",
      "helpText": "Seu feedback nos ajuda a melhorar as tarefas sugeridas para você e sua equipe. Clique em Enviar para rejeitar esta sugestão e enviar seu feedback opcional",
      "rejectAndDelete": "Enviar",
      "feedbackTooltip": "Esta tarefa sugerida não é útil",
      "successMessage": "Feedback enviado e tarefa sugerida removida",
      "errorMessage": "Falha ao enviar o feedback. Tente novamente."
    },
    "aiAssistant": {
      "title": "Criar tarefas com IA",
      "placeholder": "Descreva as tarefas que você precisa criar...",
      "createButton": "Gerar",
      "createManually": "Criar manualmente",
      "singleTaskNotice": "A IA transformou seu pedido em uma tarefa. Revise e crie.",
      "batchNotice": "Tarefa {{current}} de {{total}} do seu pedido. A próxima abre depois que você criar esta; cancelar descarta as restantes.",
      "error": "Falha ao gerar as tarefas. Tente novamente.",
      "examplePrompts": {
        "reviewReport": "Revisar o relatório do 1º trimestre até sexta",
        "prepareMeeting": "Preparar a daily da equipe de amanhã",
        "followUpEmail": "Fazer follow-up da proposta do cliente da semana passada",
        "weeklyPlanning": "Planejar minhas tarefas da semana"
      }
    },
    "postOnboarding": {
      "title": "Explore automações",
      "subtitle": "Enquanto sincronizamos seus e-mails, vamos explorar algumas automações para turbinar sua caixa de entrada e o Slack.",
      "dismiss": "Talvez depois"
    },
    "postOnboardingAnalyze": {
      "title": "Veja como está a sua caixa de entrada",
      "subtitle": "Analisamos seus últimos 90 dias de e-mail para encontrar padrões que você pode automatizar.",
      "loading": {
        "title": "Analisando sua caixa de entrada…",
        "subtitle": "Procurando padrões repetitivos nos seus e-mails."
      },
      "hero": {
        "minutesSavedPerDay": "{{duration}} economizados por dia",
        "interruptionsPerDay": "{{count}} interrupções a menos por dia",
        "totalEmails": "Com base em {{count}} e-mails dos últimos 90 dias"
      },
      "empty": {
        "title": "Sua caixa de entrada já está em ótima forma",
        "subtitle": "Não encontramos padrões relevantes para automatizar agora. Isso é um bom sinal."
      },
      "error": {
        "title": "Algo deu errado",
        "subtitle": "Não foi possível analisar sua caixa de entrada. Tente novamente.",
        "retry": "Tentar novamente"
      },
      "suggestions": {
        "title": "Fluxos sugeridos",
        "impact": "{{count}} e-mails / semana",
        "timeSaved": "~{{duration}} economizados / semana"
      },
      "cardActions": {
        "labelName": "Nome da etiqueta",
        "labelNamePlaceholder": "ex.: Newsletters",
        "forwardTo": "Encaminhar para",
        "forwardToPlaceholder": "name@company.com",
        "forwardToHintInvalid": "Insira um endereço de e-mail válido",
        "toggleAriaLabel": "Ativar automação"
      },
      "cta": {
        "dismiss": "Dispensar",
        "activate": "Ativar {{count}} fluxo",
        "activate_other": "Ativar {{count}} fluxos"
      },
      "toast": {
        "saveSummary": "{{succeeded}} fluxo criado",
        "saveSummary_other": "{{succeeded}} fluxos criados",
        "saveError": "Falha ao criar os fluxos. Tente novamente.",
        "allInvalid": "Verifique os campos antes de salvar"
      },
      "validation": {
        "missingLabelId": "Defina a etiqueta para \"{{value}}\"",
        "missingForwardTo": "Defina o destino para \"{{value}}\"",
        "invalidForwardTo": "E-mail inválido em \"{{value}}\""
      }
    },
    "doBoxFormModal": {
      "titleEdit": "Editar tarefa",
      "titleCreate": "Criar tarefa",
      "subjectLabel": "Assunto",
      "subjectPlaceholder": "Digite o assunto",
      "descriptionLabel": "Descrição",
      "descriptionPlaceholder": "Digite a descrição",
      "taskGroupLabel": "Lista",
      "taskSubgroupLabel": "Seção",
      "taskSubgroupNone": "Backlog",
      "noTaskText": "Nenhuma tarefa disponível",
      "taskRequired": "A tarefa é obrigatória",
      "taskGroupRequired": "Uma lista é obrigatória",
      "createError": "Falha ao criar a tarefa. Tente novamente.",
      "editError": "Falha ao salvar as alterações. Tente novamente.",
      "moveError": "Alterações salvas, mas não foi possível mover a tarefa para a lista selecionada.",
      "editSuccess": "Alterações salvas",
      "createSuccess": "Tarefa criada",
      "openTask": "Abrir tarefa",
      "openTaskWithSubject": "Abrir: {{subject}}",
      "recurrenceLabel": "Tarefa recorrente",
      "recurrencePlaceholder": "Definir recorrência",
      "recurrenceCreateError": "Tarefa criada, mas não foi possível definir a recorrência. Você pode configurá-la nos detalhes.",
      "recurrenceUpdateError": "Falha ao atualizar a recorrência. Tente novamente.",
      "recurrenceDeleteError": "Falha ao remover a recorrência. Tente novamente.",
      "recurrenceChipClear": "Limpar tarefa recorrente",
      "titleEditRecurrence": "Editar tarefa recorrente",
      "participantsLabel": "Membros",
      "participantsSearchPlaceholder": "Buscar membros...",
      "participantsEmptyState": "Nenhum membro encontrado",
      "collectionsApplyError": "Tarefa salva, mas não foi possível aplicar etiquetas ou participantes. Você pode configurá-los nos detalhes.",
      "priorityLabel": "Prioridade",
      "priorityPlaceholder": "Sem prioridade",
      "createWithAiButton": "Criar com IA"
    },
    "welcomeDialog": {
      "title": "Suas mensagens acionáveis, organizadas automaticamente",
      "subtitle": "Mensagens que exigem uma ação — do Slack, Teams, e-mail e mais — viram automaticamente entradas do DoBox, para que nada passe despercebido."
    },
    "settings": {
      "title": "Configurações do DoBox",
      "rules": {
        "title": "Regras de feedback",
        "description": "Regras geradas a partir do seu feedback. Exclua uma regra para parar de aplicá-la.",
        "empty": "Nenhuma regra ainda. As regras são criadas quando você dá feedback nas sugestões do DoBox.",
        "deleteLabel": "Excluir regra",
        "deleteConfirmTitle": "Excluir esta regra?",
        "deleteConfirmBody": "Esta ação não pode ser desfeita.",
        "deleteError": "Não foi possível excluir a regra. Tente novamente."
      },
      "openRulesPage": "Abrir no Brain",
      "rulesHeading": "Suas regras do DoBox ficam no seu Brain",
      "rulesDescription": "As regras do DoBox ensinam ao assistente o que não transformar em sugestões de tarefas. Abra a página de Regras para revisá-las e editá-las."
    },
    "rules": {
      "title": "Regras do DoBox",
      "description": "As regras do DoBox ensinam ao assistente o que não transformar em sugestões de tarefas.",
      "activeCount_one": "{{count}} regra ativa",
      "activeCount_other": "{{count}} regras ativas",
      "search": {
        "placeholder": "Buscar regras..."
      },
      "openInBrain": "Abrir no Brain →",
      "create": "Nova regra",
      "createPlaceholder": "Instruções da regra...",
      "edit": "Editar",
      "delete": "Excluir",
      "empty": "Nenhuma regra ainda",
      "manageTitle": "Gerenciar regras",
      "saveEdit": "Salvar",
      "cancelEdit": "Cancelar",
      "addRule": "Adicionar regra",
      "addRulePlaceholder": "ex.: Não sugerir tarefas para e-mails de newsletter",
      "add": "Adicionar",
      "done": "Concluído",
      "toggleActiveAriaLabel": "Ativar ou desativar regra",
      "createError": "Não foi possível criar a regra. Tente novamente.",
      "updateError": "Não foi possível atualizar a regra. Tente novamente.",
      "decisionToast": {
        "created": "Regra criada — a IA vai aplicá-la daqui em diante.",
        "replaced": "Regra atualizada — a IA substituiu uma regra semelhante.",
        "merged": "Regra mesclada — a IA combinou esta com uma regra existente.",
        "skipped": "Nenhuma alteração de regra — seu feedback foi registrado, mas não exigiu uma nova regra."
      },
      "pagination": {
        "previous": "Anterior",
        "next": "Próxima",
        "pageInfo": "Página {{current}} de {{total}}"
      },
      "footerNote": "As regras afetam apenas novas sugestões — nada que já está no seu DoBox será movido."
    },
    "boardAgents": {
      "title": "Agentes do quadro",
      "description": "Escolha quais agentes, seus e da sua equipe, aparecem como opções de delegação nos cartões de tarefa do DoBox.",
      "empty": "Nenhum agente do quadro ainda. Os agentes que você adicionar aqui aparecerão no cartão de delegação do DoBox.",
      "addAgent": "Adicionar agente",
      "addAgentTitle": "Escolha um agente",
      "noAvailableAgents": "Não há mais agentes disponíveis para adicionar",
      "removeAriaLabel": "Remover {{name}} dos agentes do quadro",
      "addAgentAriaLabel": "Adicionar {{name}} como agente do quadro",
      "removeError": "Não foi possível remover o agente. Tente novamente.",
      "addError": "Não foi possível adicionar o agente. Tente novamente.",
      "cancelAdd": "Cancelar",
      "deleteAriaLabel": "Excluir {{name}}",
      "deleteConfirmTitle": "Excluir este agente?",
      "deleteConfirmDescription": "{{name}} será excluído em definitivo. As tarefas já delegadas a ele mantêm o histórico. Esta ação não pode ser desfeita.",
      "deleteSuccess": "Agente excluído",
      "deleteError": "Não foi possível excluir o agente. Tente novamente."
    },
    "templates": {
      "title": "Modelos",
      "description": "Modelos reutilizáveis para criar tarefas estruturadas com IA",
      "addTemplate": "Modelo",
      "empty": "Nenhum modelo ainda. Crie um para começar.",
      "count_one": "{{count}} modelo",
      "count_other": "{{count}} modelos",
      "blank": "Em branco",
      "selector": {
        "label": "Comece com um modelo (opcional)"
      },
      "search": {
        "placeholder": "Buscar modelos..."
      },
      "form": {
        "nameLabel": "Nome do modelo",
        "iconLabel": "Ícone e cor",
        "descriptionLabel": "Descrição (modelo)",
        "descriptionPlaceholder": "[Verbo de ação] + [o quê]\n\nPor quê: [uma frase]\n\nSolução:\n[2-4 frases]\n\nConcluído quando:\n- [critério]\n- [critério]",
        "descriptionHelp": "A IA segue esta estrutura ao escrever a descrição de cada tarefa gerada.",
        "save": "Salvar modelo",
        "createTitle": "Novo modelo",
        "editTitle": "Editar modelo",
        "createBadge": "Novo",
        "editBadge": "Editando"
      },
      "delete": {
        "title": "Excluir modelo",
        "confirmTitle": "Excluir modelo",
        "confirmBody": "Tem certeza de que deseja excluir o modelo \"{{name}}\"? Ele não aparecerá mais ao criar tarefas com IA. Esta ação não pode ser desfeita.",
        "confirm": "Excluir modelo",
        "deleteError": "Falha ao excluir o modelo. Tente novamente."
      },
      "pagination": {
        "previous": "Anterior",
        "next": "Próxima",
        "pageInfo": "Página {{current}} de {{total}}"
      },
      "menu": {
        "sectionLabel": "AUTOMAÇÃO",
        "rulesTitle": "Regras",
        "recurringTitle": "Tarefas recorrentes",
        "templatesTitle": "Modelos",
        "rulesSubtitle_one": "{{count}} regra ativa",
        "rulesSubtitle_other": "{{count}} regras ativas",
        "rulesSubtitleNone": "Nenhuma regra ativa",
        "recurringSubtitle_one": "{{count}} tarefa recorrente",
        "recurringSubtitle_other": "{{count}} tarefas recorrentes",
        "recurringSubtitleNone": "Nenhuma tarefa recorrente",
        "templatesSubtitle_one": "{{count}} modelo",
        "templatesSubtitle_other": "{{count}} modelos",
        "templatesSubtitleNone": "Nenhum modelo",
        "agentsTitle": "Agentes",
        "agentsSubtitle_one": "{{count}} agente",
        "agentsSubtitle_other": "{{count}} agentes",
        "agentsSubtitleNone": "Nenhum agente",
        "tooltip": "Automações"
      }
    },
    "bulkActions": {
      "selectedCount": "{{count}} selecionadas",
      "selectedLabel": "selecionadas",
      "selectAllTasks": "Selecionar todas as tarefas",
      "selectAllSuggestions": "Selecionar todas as sugestões",
      "blockedSuggestion": "Sugestões não podem ser selecionadas junto com tarefas. Limpe a seleção para selecionar sugestões.",
      "blockedTask": "Tarefas não podem ser selecionadas junto com sugestões. Limpe a seleção para selecionar tarefas.",
      "clearAll": "Limpar tudo",
      "markDone": "Concluir",
      "markUndone": "Não concluída",
      "move": "Mover",
      "priority": "Prioridade",
      "delete": "Excluir",
      "closeSelection": "Limpar seleção",
      "acceptSuggestion": "Aceitar",
      "rejectSuggestion": "Rejeitar",
      "deleteConfirmTitle": "Excluir {{count}} tarefa(s)?",
      "deleteConfirmBody": "Esta ação não pode ser desfeita. As tarefas selecionadas serão removidas permanentemente.",
      "moveTaskGroupSection": "Listas",
      "moveSubgroupSection": "Seções",
      "noSubgroup": "Backlog",
      "toast": {
        "markedDone": "{{count}} tarefa(s) marcada(s) como concluída(s)",
        "markedUndone": "{{count}} tarefa(s) marcada(s) como não concluída(s)",
        "deleted": "{{count}} tarefa(s) excluída(s)",
        "moved": "{{count}} tarefa(s) movida(s) para {{group}}",
        "moveLoading": "Movendo tarefas...",
        "moveError": "Falha ao mover as tarefas",
        "priority": "Prioridade definida como {{level}}",
        "priorityLoading": "Atualizando prioridade...",
        "priorityError": "Falha ao atualizar a prioridade",
        "acceptingSuggestions": "Aceitando sugestões...",
        "suggestionsAccepted": "{{count}} sugestão(ões) aceita(s)",
        "acceptSuggestionsError": "Falha ao aceitar as sugestões",
        "movedToSubgroup": "{{count}} tarefa(s) movida(s) para {{subgroup}}",
        "movedOutOfSubgroup": "{{count}} tarefa(s) movida(s) para fora da seção"
      }
    },
    "keyboardShortcuts": {
      "tooltip": "Atalhos de teclado",
      "modalTitle": "Atalhos de teclado",
      "navigation": "Navegação",
      "actions": "Ações",
      "selection": "Seleção",
      "moveItems": "Navegar entre itens",
      "firstLast": "Primeiro/último item",
      "openTask": "Abrir modal da tarefa",
      "closeModal": "Fechar modal",
      "openDropdown": "Abrir menu suspenso",
      "closeDropdown": "Fechar menu suspenso",
      "markDone": "Marcar como concluída",
      "acceptSuggestion": "Aceitar sugestão",
      "openLabels": "Abrir etiquetas",
      "openParticipants": "Abrir participantes",
      "openPriority": "Abrir prioridade",
      "delete": "Excluir",
      "moveToList": "Mover para lista",
      "createCard": "Criar novo cartão",
      "openDueDate": "Abrir prazo",
      "openTaskGroups": "Abrir seletor de grupos de tarefas",
      "openCheatsheet": "Abrir este guia de atalhos",
      "toggleSelection": "Alternar seleção",
      "selectAll": "Selecionar tudo",
      "clearSelection": "Limpar seleção",
      "modifierClickSelect": "Alternar seleção",
      "shiftClickSelect": "Selecionar intervalo",
      "popoverSection": "Dentro de popovers",
      "popoverNavigate": "Navegar entre itens",
      "popoverToggle": "Selecionar/alternar item",
      "popoverClose": "Fechar popover"
    },
    "taskGroupAccessLost": {
      "title": "Você não faz mais parte deste grupo de tarefas",
      "description": "Escolha outra lista no seletor acima ou peça a alguém do grupo de tarefas para adicionar você de volta."
    },
    "attachGeneratedImage": {
      "button": "Anexar imagem",
      "modalTitle": "Escolha uma imagem",
      "toast": {
        "loading": "Anexando imagem…",
        "success": "Imagem anexada.",
        "error": "Não foi possível anexar a imagem. {{message}}"
      }
    },
    "subgroups": {
      "toggleOpen": "Expandir ou recolher seção",
      "editTitle": "Editar título da seção",
      "dragHandle": "Arraste para reordenar a seção",
      "delete": "Excluir seção",
      "dropToAdd": "Solte para adicionar a {{name}}",
      "dragTasksHere": "Arraste tarefas para cá",
      "addTaskToSubgroup": "Adicionar tarefa a {{name}}",
      "newSubgroupTitle": "Nova seção",
      "addSubgroup": "Seção",
      "taskCount_one": "{{count}} tarefa",
      "taskCount_other": "{{count}} tarefas",
      "ungroupedEmpty": "Arraste tarefas para cá para removê-las de uma seção",
      "deleteConfirmTitle": "Excluir seção?",
      "deleteConfirmBody": "As tarefas em \"{{name}}\" não serão excluídas — elas serão movidas para fora da seção."
    },
    "board": {
      "viewSwitch": {
        "list": "Lista",
        "board": "Quadro",
        "ariaLabel": "Alternar entre visualização em lista e em quadro"
      },
      "noSubgroup": "Backlog",
      "addColumn": "Coluna",
      "communicationsCount_one": "{{count}} comunicação",
      "communicationsCount": "{{count}} comunicações",
      "newReply": "Nova resposta",
      "openConversation": "Abrir conversa",
      "approvalsColumnTitle": "Aprovações",
      "suggestionsColumnTitle": "Sugestões de tarefas",
      "column": {
        "editTitle": "Editar título da coluna",
        "delete": "Excluir coluna",
        "newColumnTitle": "Nova coluna",
        "deleteConfirmTitle": "Excluir coluna?",
        "deleteConfirmBody": "As tarefas em \"{{name}}\" não serão excluídas — elas serão movidas para fora da coluna."
      },
      "mover": {
        "title": "Mover",
        "hint": "Solte aqui para escolher uma coluna",
        "ariaLabel": "Alvo de arraste — solte aqui para escolher uma coluna"
      },
      "moveSheet": {
        "title": "Mover \"{{name}}\" para",
        "acceptTitle": "Aceitar \"{{name}}\" em",
        "ariaLabel": "Mover tarefa para coluna",
        "closeAriaLabel": "Fechar painel de mover"
      }
    },
    "backlog": {
      "title": "Backlog",
      "empty": "Arraste tarefas para cá para movê-las para o Backlog",
      "createFirstCard": "Crie seu primeiro cartão"
    }
  },
  "aria-labels": {
    "reply": "Responder",
    "replyAll": "Responder a todos",
    "forward": "Encaminhar",
    "unsubscribe": "Cancelar inscrição na lista de e-mails",
    "archive": "Arquivar",
    "openAttachment": "Abrir anexo",
    "clear": "Limpar",
    "toggle": "Alternar",
    "close": "Fechar",
    "viewFile": "Ver arquivo",
    "deleteFile": "Excluir arquivo",
    "previousSlide": "Slide anterior",
    "nextSlide": "Próximo slide",
    "openMessageInNewWindow": "Abrir mensagem em nova janela",
    "toggleRecipientsDropdown": "Alternar lista de destinatários",
    "settings": "Configurações",
    "toggleFontMenu": "Alternar menu de fontes",
    "attach": "Anexar",
    "link": "Link",
    "fontSize": "Tamanho da fonte",
    "fontFamily": "Família da fonte",
    "textColor": "Cor do texto",
    "openSidebar": "Abrir barra lateral",
    "closeSidebar": "Fechar barra lateral",
    "floatingButton": "Botão flutuante",
    "optionsMenu": "Opções",
    "dragDropIndicator": "Indicador de arraste",
    "navigationButton": "Botão de navegação",
    "removeAttachment": "Remover anexo",
    "fileInput": "Campo de arquivo",
    "downloadAttachment": "Baixar anexo",
    "clickToPreview": "Clique para visualizar",
    "deleteInboxEntry": "Excluir entrada: {{subject}}",
    "selectLabel": "Selecionar {{labelDisplayName}}",
    "filterByLabel": "Filtrar pela etiqueta {{labelDisplayName}}",
    "toggleLabel": "Alternar etiqueta {{labelDisplayName}}",
    "collapseLabel": "Recolher {{labelDisplayName}}",
    "expandLabel": "Expandir {{labelDisplayName}}",
    "time": "Horário",
    "dueDateBadge": "Prazo: {{date}}",
    "dueDateBadgeTooltip": {
      "overdue": "Esta tarefa está atrasada.",
      "dueSoon": "Esta tarefa vence em menos de vinte e quatro horas.",
      "normal": "Esta tarefa vence mais tarde.",
      "resolved": "Esta tarefa está concluída."
    },
    "previousPage": "Página anterior",
    "nextPage": "Próxima página",
    "star": "Marcar com estrela",
    "unstar": "Remover estrela",
    "markImportant": "Marcar como importante",
    "unmarkImportant": "Marcar como não importante",
    "linkedToDoBox": "Vinculado a uma tarefa do DoBox"
  },
  "messageEditor": {
    "tooltips": {
      "menuBar": {
        "fontColor": "Cor da fonte e opções de formatação",
        "attach": "Anexar arquivo",
        "link": "Inserir link",
        "fontSize": "Tamanho da fonte",
        "fontFamily": "Fonte",
        "textColor": "Cor do texto",
        "attachFile": "Anexar arquivo",
        "formatting": {
          "bold": "Negrito",
          "italic": "Itálico",
          "strike": "Tachado",
          "highlight": "Destacar",
          "align-left": "Alinhar à esquerda",
          "align-center": "Centralizar",
          "align-right": "Alinhar à direita",
          "align-justify": "Justificar",
          "code": "Bloco de código",
          "bullet-list": "Lista com marcadores",
          "ordered-list": "Lista numerada"
        }
      },
      "recipients": {
        "addRecipients": "Adicionar destinatários {{recipientType}} ({{recipientShortcut}})"
      }
    },
    "linkPopover": {
      "linkText": "Texto do link",
      "linkTextPlaceholder": "Digite o texto do link...",
      "url": "URL",
      "urlPlaceholder": "Digite a URL...",
      "addLink": "Adicionar link",
      "updateLink": "Atualizar link",
      "removeLink": "Remover link"
    },
    "colorPicker": {
      "presetColors": "Cores predefinidas",
      "customColor": "Personalizada",
      "selectColor": "Selecionar cor",
      "customColorPicker": "Seletor de cor personalizada",
      "colors": {
        "black": "Preto",
        "darkGray": "Cinza-escuro",
        "gray": "Cinza",
        "red": "Vermelho",
        "orange": "Laranja",
        "yellow": "Amarelo",
        "green": "Verde",
        "emerald": "Esmeralda",
        "blue": "Azul",
        "indigo": "Índigo",
        "purple": "Roxo",
        "pink": "Rosa"
      }
    }
  },
  "slackChannelPreview": {
    "unreadDivider": "NOVAS"
  },
  "userInfoCard": {
    "contact": "Contato"
  },
  "teamsProcessing": {
    "progressNotification": "Processando conversas do Teams: {{processedChats}} de {{totalChats}} conversas sincronizadas.",
    "completedNotification": "Sincronização do Teams concluída: {{totalChats}} conversas sincronizadas com sucesso.",
    "failedNotification": "Não conseguimos terminar a sincronização das suas conversas do Teams. Processamos {{processedChats}} conversas antes de parar — reconecte o Teams para concluir."
  },
  "s3Attachments": {
    "loadAttachments": "Carregar anexos",
    "moreAttachments": "+{{count}} mais"
  },
  "errors": {
    "attachment": {
      "downloadFailed": "Falha ao baixar o anexo"
    },
    "unexpectedError": {
      "title": "Algo deu errado",
      "description": "Ocorreu um erro inesperado. Tente novamente.",
      "retry": "Tentar novamente"
    },
    "copy": "Falha ao copiar para a área de transferência.",
    "notFound": {
      "title": "Página não encontrada",
      "description": "A página que você procura não existe ou foi movida.",
      "backToDoBox": "Voltar para o DoBox"
    }
  },
  "meetingAssistantPage": {
    "googleSuccessfullyConnected": {
      "title": "Google conectado",
      "message": "Sua conta do Google foi conectada com sucesso."
    },
    "outlookSuccessfullyConnected": {
      "title": "Outlook conectado",
      "message": "Sua conta do Outlook foi conectada com sucesso."
    },
    "integrationSuccessfullyConnected": {
      "title": "Integração conectada",
      "message": "Sua integração foi conectada com sucesso."
    }
  },
  "chromeExtension": {
    "popup": {
      "title": "this+that para Gmail",
      "signInDescription": "Entre para ver seus itens do DoBox no Gmail",
      "signIn": "Entrar",
      "signOut": "Sair",
      "openDoBox": "Abrir DoBox",
      "openDoBoxLabel": "Abrir DoBox (abre em nova aba)",
      "connected": "Conectado",
      "loading": "Carregando...",
      "defaultUserName": "Usuário"
    },
    "doBoxIndicator": {
      "active": "DoBox",
      "resolved": "DoBox (Concluído)",
      "openInDoBox": "Abrir no this+that",
      "viewArrow": "→",
      "noticeBarLabel": "Abrir {{subject}} no this+that"
    },
    "sidebar": {
      "title": "DoBox",
      "appName": "this+that DoBox",
      "sectionActive": "Ativos",
      "sectionSuggestions": "Sugestões",
      "sectionApprovals": "Aprovações",
      "sectionDone": "Concluídos",
      "emptyTitle": "Tudo em dia!",
      "emptyDescription": "Nenhum item ativo no DoBox agora.",
      "loadingText": "Carregando...",
      "errorText": "Falha ao carregar os itens",
      "retryButton": "Tentar novamente",
      "resolveButton": "Concluir",
      "acceptButton": "Aceitar",
      "showDoneLabel": "Mostrar concluídos",
      "unresolveButton": "Marcar como não concluído",
      "emptyDoneTitle": "Nenhum item concluído",
      "emptyDoneDescription": "As tarefas concluídas aparecerão aqui.",
      "createButton": "+",
      "createFormTitle": "Nova tarefa",
      "createFormSubjectLabel": "Assunto",
      "createFormSubjectPlaceholder": "O que precisa ser feito?",
      "createFormDescriptionLabel": "Descrição",
      "createFormDescriptionPlaceholder": "Adicione detalhes...",
      "createFormSubmit": "Criar",
      "createFormCancel": "Cancelar",
      "createFormCreating": "Criando...",
      "createFormError": "Falha ao criar o item. Tente novamente.",
      "createFormSubjectRequired": "O assunto é obrigatório",
      "timeJustNow": "agora mesmo",
      "timeMinutesAgo": "há {{count}}m",
      "timeHoursAgo": "há {{count}}h",
      "timeDaysAgo": "há {{count}}d",
      "toggleDoneLabel": "Alternar exibição de itens concluídos",
      "createButtonLabel": "Criar novo item no DoBox",
      "listSwitcherLabel": "Trocar de lista",
      "entryListLabel": "Entradas do DoBox",
      "approveButton": "Aprovar",
      "rejectButton": "Rejeitar",
      "proposedChangeLabel": "Alteração proposta",
      "evidenceLabel": "Evidências",
      "evidenceCount": "Evidências ({{count}})",
      "evidenceEmpty": "Nenhuma evidência anexada.",
      "evidenceLoading": "Carregando evidências...",
      "evidenceError": "Não foi possível carregar as evidências.",
      "evidenceRetry": "Tentar de novo",
      "relatedItemsLabel": "Itens relacionados",
      "expandLabel": "Mostrar mais",
      "collapseLabel": "Mostrar menos",
      "editButton": "Editar",
      "editSubjectLabel": "Título",
      "editDescriptionLabel": "Descrição",
      "saveAndApproveButton": "Salvar e aprovar",
      "cancelEditButton": "Cancelar",
      "actionError": "Algo deu errado. Tente de novo."
    },
    "agentTab": {
      "controlledBanner": "this+that está usando esta aba"
    }
  },
  "workspaceAddon": {
    "sectionActive": "Ativos",
    "sectionSuggestions": "Sugestões",
    "sectionDone": "Concluídos",
    "buttonResolve": "Concluir",
    "buttonUnresolve": "Marcar como não concluído",
    "buttonAccept": "Aceitar",
    "buttonNewTask": "+ Nova tarefa",
    "buttonCreate": "Criar",
    "buttonCancel": "Cancelar",
    "buttonRetry": "Tentar novamente",
    "buttonOpenInDobox": "Abrir no DoBox",
    "buttonConnect": "Conectar",
    "buttonOpen": "Abrir",
    "buttonRefresh": "Atualizar",
    "emptyDescription": "Nenhum item ativo no DoBox agora.",
    "emptyDoneDescription": "As tarefas concluídas aparecerão aqui.",
    "unauthenticatedTitle": "Conecte sua conta",
    "unauthenticatedDescription": "Entre no this+that para ver seus itens do DoBox.",
    "unauthenticatedAccountRequired": "É necessária uma conta do this+that.",
    "entryResolvedLabel": "Concluído",
    "entrySuggestionLabel": "Sugestão",
    "createFormTitle": "Nova tarefa",
    "labelSubject": "Assunto",
    "labelDescription": "Descrição",
    "hintSubject": "O que precisa ser feito?",
    "hintDescription": "Adicione detalhes...",
    "noSubject": "(sem assunto)",
    "errorUpdateEntry": "Falha ao atualizar a entrada. Tente novamente.",
    "errorAcceptSuggestion": "Falha ao aceitar a sugestão. Tente novamente.",
    "errorLoadHomepage": "Falha ao carregar os itens. Tente novamente.",
    "errorSwitchList": "Falha ao trocar de lista. Tente novamente.",
    "errorSubjectRequired": "O assunto é obrigatório.",
    "errorCreateEntry": "Falha ao criar a entrada. Tente novamente.",
    "errorUpdateFilter": "Falha ao atualizar o filtro. Tente novamente.",
    "errorMissingEntryId": "ID da entrada ausente.",
    "timeJustNow": "agora mesmo",
    "timeMinutesAgo": "há {{count}}m",
    "timeHoursAgo": "há {{count}}h",
    "timeDaysAgo": "há {{count}}d",
    "dropdownDone": "Concluído"
  },
  "pushNotifications": {
    "permissionPromptTitle": "Fique por dentro",
    "permissionPromptDescription": "Ative as notificações para receber alertas em tempo real de novas mensagens e itens da caixa de entrada.",
    "enableButton": "Ativar notificações",
    "dismissButton": "Agora não",
    "newTask": "Nova tarefa no seu DoBox",
    "newMessage": "Nova mensagem",
    "executorAttention": {
      "SEND_FAILED": "Um envio falhou — precisa de você",
      "NEEDS_APPROVAL": "Precisa da sua aprovação",
      "NEEDS_INPUT": "Precisa da sua resposta",
      "NEEDS_CONNECTION": "Precisa de uma conexão",
      "READY_TO_RESOLVE": "Pronto para resolver",
      "SUGGESTED_DECISION": "Tem uma decisão sugerida"
    },
    "executorApprovalExpiring": "Aprovação expira em breve"
  },
  "flows": {
    "pageTitle": "Flows",
    "pageDescription": "Automatize seu trabalho com fluxos personalizados",
    "create": {
      "newFlow": "Novo fluxo",
      "newFlowDescription": "Um gatilho → ação → resultado",
      "newGroup": "Novo grupo",
      "newWorkflow": "Novo workflow",
      "newWorkflowDescription": "Agrupe vários fluxos",
      "createManually": "Criar grupo vazio",
      "menuAriaLabel": "Opções de criação",
      "aiFlow": "Novo fluxo · com IA",
      "aiFlowDescription": "Descreva e nós montamos para você",
      "manualFlow": "Novo fluxo · manualmente",
      "manualFlowDescription": "Comece com um editor vazio",
      "aiGroup": "Novo grupo · com IA",
      "aiGroupDescription": "Agrupe vários fluxos",
      "manualGroup": "Novo grupo · manualmente",
      "manualGroupDescription": "Dê um nome e adicione os fluxos você mesmo",
      "chatManualLink": "Prefere montar você mesmo? Criar manualmente"
    },
    "empty": "Nenhum fluxo ainda. Crie seu primeiro fluxo para começar.",
    "aiGenerate": "Gerar com IA",
    "aiEdit": "Editar com IA",
    "testRun": "Testar",
    "run": "Executar",
    "testRunStarted": "Execução do agente iniciada",
    "flowSaved": "Fluxo salvo com sucesso",
    "testRunError": "Falha ao iniciar a execução de teste",
    "toggleStatusError": "Falha ao atualizar o status do fluxo",
    "history": "Histórico",
    "systemFlows": "Fluxos do sistema",
    "myFlows": "Meus fluxos",
    "myAgents": "Meus agentes",
    "emptyAgents": "Nenhum agente ainda. Crie seu primeiro agente especialista.",
    "showSystemAgents": "Mostrar agentes do sistema",
    "showSystemFlows": "Mostrar fluxos do sistema",
    "createAgent": "Novo agente",
    "agentCard": {
      "modelTier": "Modelo: {{tier}}",
      "maxTurns_one": "{{count}} turno",
      "maxTurns_other": "{{count}} turnos",
      "toolSets_one": "{{count}} conjunto de ferramentas",
      "toolSets_other": "{{count}} conjuntos de ferramentas",
      "editAriaLabel": "Editar agente",
      "deleteAriaLabel": "Excluir agente",
      "duplicateAriaLabel": "Duplicar modelo de agente",
      "duplicateConfirmTitle": "Duplicar modelo",
      "duplicateConfirmDescription": "Criar uma cópia editável de \"{{name}}\"?",
      "duplicateConfirmButton": "Duplicar",
      "system": "Sistema"
    },
    "systemBadge": "Sistema",
    "setupBadge": "Configuração",
    "status": {
      "active": "Ativo",
      "stopped": "Parado",
      "needsAttention": "Configuração pendente"
    },
    "setupRunningBanner": {
      "title": "Configurando seu workspace",
      "description": "Os outros fluxos ficam em espera até essa configuração única terminar."
    },
    "hub": {
      "discover": "Descobrir",
      "ownership": {
        "mine": "Meus flows",
        "team": "Flows do time"
      },
      "filters": {
        "paused": "Pausados"
      },
      "modeBadge": {
        "runsOnItsOwn": "Executa sozinho",
        "agent": "Agente"
      },
      "updatedAt": "Atualizado {{time}}",
      "emptyFiltered": "Nenhum fluxo corresponde a esses filtros.",
      "counts": {
        "running_one": "{{count}} em execução",
        "running_other": "{{count}} em execução",
        "agents_one": "{{count}} agente",
        "agents_other": "{{count}} agentes",
        "needsAttention_one": "{{count}} precisa de atenção",
        "needsAttention_other": "{{count}} precisam de atenção"
      }
    },
    "actions": {
      "run": "Executar",
      "edit": "Editar",
      "view": "Ver",
      "delete": "Excluir",
      "duplicate": "Duplicar",
      "toggleStatus": "Alternar status",
      "activate": "Ativar",
      "deactivate": "Desativar"
    },
    "stepsCount_one": "{{count}} etapa",
    "stepsCount_other": "{{count}} etapas",
    "notifyAssistant": {
      "description": "Publique uma mensagem no assistente quando este fluxo for executado. A mensagem pode incluir variáveis de etapas anteriores.",
      "messageTemplateLabel": "Mensagem",
      "messageTemplatePlaceholder": "ex.: Novo lead recebido: {{step1.email}} — revisão necessária.",
      "conversationModeLabel": "Conversa de destino",
      "modeBackgroundTasks": "Aba compartilhada \"Tarefas em segundo plano\"",
      "modeNewEachRun": "Nova conversa por execução",
      "conversationTitleLabel": "Título da conversa",
      "conversationTitlePlaceholder": "ex.: Alerta de lead — {{step1.name}}"
    },
    "runAssistant": {
      "description": "Execute o assistente com um prompt personalizado. Uma nova conversa é criada a cada execução, e as ferramentas selecionadas são aprovadas automaticamente para a execução do agente.",
      "promptTemplateLabel": "Prompt",
      "promptTemplatePlaceholder": "ex.: Resuma este e-mail e rascunhe uma resposta: {{step1.body}}",
      "conversationTitleLabel": "Título da conversa (opcional)",
      "conversationTitlePlaceholder": "ex.: Resumo do e-mail — {{step1.subject}}",
      "conversationModeLabel": "Modo de conversa",
      "modeNewEachRun": "Nova conversa por execução",
      "modeBackgroundTasks": "Aba compartilhada \"Tarefas em segundo plano\" (em breve)",
      "modeReuseSame": "Reutilizar a mesma conversa",
      "autoApprovedToolsLabel": "Ferramentas aprovadas automaticamente",
      "autoApprovedToolsPlaceholder": "Adicionar uma ferramenta…",
      "removeTool": "Remover ferramenta",
      "nonInteractiveLabel": "Executar sem pedir confirmação",
      "nonInteractiveHelperText": "Para fluxos automatizados: as ações são executadas automaticamente e a execução nunca aguarda um humano. Apenas as ferramentas aprovadas automaticamente abaixo serão executadas; o restante é ignorado. A criação de fluxos ou agentes personalizados nunca pode ser aprovada automaticamente: cada um sempre aguarda a sua confirmação.",
      "closeOnCompleteLabel": "Fechar a conversa quando terminar",
      "closeOnCompleteHelperText": "Quando a execução termina, a conversa é removida da sua lista do assistente (mas fica no histórico). Disponível apenas com uma nova conversa por execução.",
      "tools": {
        "act_on_emails": "Ações de e-mail (arquivar, etiquetar etc.)",
        "send_slack_bot_message": "Enviar mensagem no Slack (bot)",
        "send_notification_email": "Enviar e-mail de notificação",
        "create_dobox": "Criar tarefa",
        "update_dobox": "Atualizar tarefa",
        "resolve_dobox": "Concluir tarefa",
        "accept_dobox_suggestion": "Aceitar sugestão de tarefa",
        "move_dobox": "Mover tarefa para lista",
        "update_dobox_collections": "Atualizar etiquetas / coleções da tarefa",
        "create_dobox_label": "Criar etiqueta de tarefa",
        "add_dobox_comment": "Adicionar comentário na tarefa",
        "delete_dobox": "Excluir tarefa",
        "update_task_group_participants": "Atualizar participantes da lista",
        "create_task_group": "Criar lista de tarefas",
        "act_on_calendar_invites": "Agir em convites de agenda (RSVP)",
        "create_calendar_event": "Criar evento na agenda",
        "create_email_label": "Criar etiqueta de e-mail",
        "run_flow_now": "Executar um fluxo",
        "request_from_teammate": "Solicitar a um colega de equipe",
        "propose_flow": "Propor um fluxo",
        "propose_custom_agent": "Propor um agente personalizado",
        "execute_create_knowledge_space": "Criar espaço de conhecimento",
        "execute_create_knowledge_page": "Criar página de conhecimento",
        "execute_edit_knowledge_page": "Editar página de conhecimento",
        "execute_rename_knowledge_page": "Renomear página de conhecimento",
        "execute_delete_knowledge_page": "Excluir página de conhecimento",
        "facebook_reply_comment": "Responder comentário do Facebook",
        "facebook_publish_post": "Publicar no Facebook",
        "instagram_reply_comment": "Responder a comentário do Instagram",
        "instagram_publish_post": "Publicar post no Instagram",
        "gbp_reply_review": "Responder avaliação do Google Business Profile"
      }
    },
    "askUser": {
      "description": "Pause o fluxo e peça ao usuário para escolher entre uma lista de opções. A opção selecionada fica disponível como variável nas etapas seguintes.",
      "messageTemplate": {
        "label": "Pergunta",
        "placeholder": "ex.: Como devo tratar este e-mail? Contexto: {{step1.subject}}"
      },
      "options": {
        "label": "Opções",
        "optionPlaceholder": "Opção {{number}}",
        "optionAriaLabel": "Opção {{number}}",
        "removeOption": "Remover opção {{number}}",
        "addOption": "Adicionar opção",
        "minHint": "São necessárias pelo menos 2 opções"
      },
      "conversationModeLabel": "Conversa de destino",
      "modeBackgroundTasks": "Aba compartilhada \"Tarefas em segundo plano\"",
      "modeHelpText": "ASK_USER sempre usa a conversa compartilhada de Tarefas em segundo plano.",
      "conversationTitleLabel": "Título da conversa (opcional)",
      "conversationTitlePlaceholder": "ex.: Ação necessária — {{step1.subject}}"
    },
    "approvalGate": {
      "description": "Pause o fluxo e aguarde um usuário aprovar ou rejeitar no DoBox dele. A decisão fica disponível como variável nas etapas seguintes.",
      "titleLabel": "Título do cartão de aprovação (opcional)",
      "titlePlaceholder": "ex.: Aprovar resposta a {{step1.subject}}",
      "summaryPromptLabel": "Prompt do resumo",
      "summaryPromptPlaceholder": "ex.: Resuma o que precisa de aprovação: {{step1.subject}}",
      "taskGroupLabel": "Lista de destino no DoBox",
      "taskGroupPlaceholder": "DoBox padrão do proprietário",
      "taskGroupDescription": "Deixe em branco para criar a aprovação no DoBox padrão do proprietário do fluxo. Escolha uma lista compartilhada para permitir que outras pessoas aprovem."
    },
    "executionHistory": {
      "title": "Histórico de execuções",
      "empty": "Nenhuma execução registrada ainda. As execuções aparecerão aqui depois que o fluxo for acionado.",
      "loadMore": "Carregar mais",
      "refresh": "Atualizar",
      "refreshing": "Atualizando",
      "history": "Histórico",
      "noSubject": "(Sem assunto)",
      "duration": "{{ms}}ms",
      "steps": "Etapas",
      "iterations": "Iterações",
      "iterationLabel": "Iteração {{number}}",
      "output": "Resultado",
      "error": "Erro",
      "triggeredBy": "Acionado por {{triggerKey}}",
      "refusedRecipients_one": "{{count}} destinatário foi removido: apenas endereços digitados no fluxo, caixas de entrada conectadas, colegas de equipe ou contatos da agenda recebem e-mails de fluxos.",
      "refusedRecipients_other": "{{count}} destinatários foram removidos: apenas endereços digitados no fluxo, caixas de entrada conectadas, colegas de equipe ou contatos da agenda recebem e-mails de fluxos.",
      "status": {
        "RUNNING": "Em execução",
        "SUCCESS": "Sucesso",
        "PARTIAL_FAILURE": "Falha parcial",
        "FAILURE": "Falhou",
        "TIMEOUT": "Tempo esgotado",
        "WAITING_FOR_REPLY": "Aguardando resposta",
        "REJECTED": "Rejeitado"
      },
      "stepStatus": {
        "SUCCESS": "Sucesso",
        "FAILURE": "Falhou",
        "SKIPPED": "Ignorada",
        "TIMEOUT": "Tempo esgotado"
      }
    },
    "generator": {
      "upgrade": {
        "title": "Isso parece um objetivo de grupo",
        "reason": "Eu criaria {{count}} fluxos:",
        "createAsGroup": "Criar como grupo",
        "keepAsSingleFlow": "Manter como fluxo único"
      }
    },
    "groups": {
      "examplePrompts": {
        "projectManager": "Crie um gerente de projetos que esclarece tarefas, busca informações e agenda follow-ups diários",
        "salesPipeline": "Organize minha caixa de entrada de vendas: classifique leads, responda automaticamente a perguntas comuns e envie um relatório diário do pipeline"
      },
      "systemEvents": {
        "flowMovedIn": "Fluxo '{{name}}' adicionado ao grupo",
        "flowMovedOut": "Fluxo '{{name}}' removido do grupo",
        "flowCreated": "Fluxo '{{name}}' criado",
        "flowDeleted": "Fluxo '{{name}}' excluído",
        "groupActivated": "Grupo ativado",
        "groupPaused": "Grupo pausado",
        "groupMetadataUpdated": "Detalhes do grupo atualizados"
      },
      "sectionTitle": "{{name}}",
      "ungroupedTitle": "Sem grupo",
      "memberCount_one": "{{count}} fluxo",
      "memberCount_other": "{{count}} fluxos",
      "memberCount": "{{count}} fluxos",
      "collapse": "Recolher",
      "expand": "Expandir",
      "comingSoon": "Em breve",
      "toggleError": "Falha ao atualizar o status do grupo",
      "deleteSuccess": "Grupo excluído",
      "deleteError": "Falha ao excluir o grupo",
      "active": "Ativo",
      "paused": "Pausado",
      "createdFromGroup": "Criado a partir do grupo '{{name}}'",
      "menu": {
        "rename": "Renomear",
        "editObjective": "Editar objetivo",
        "delete": "Excluir grupo",
        "openEditor": "Abrir editor",
        "openMenu": "Ações do grupo",
        "moveToGroup": "Mover para grupo...",
        "moveToGroupError": "Falha ao mover o fluxo",
        "removeFromGroup": "Remover do grupo",
        "removeFromGroupError": "Falha ao remover o fluxo do grupo",
        "newGroup": "+ Novo grupo…",
        "ungrouped": "📂 Sem grupo"
      },
      "delete": {
        "confirmTitle": "Excluir grupo?",
        "keepFlows": "Manter os fluxos do grupo (recomendado)",
        "deleteAll": "Excluir também os {{count}} fluxos do grupo",
        "confirm": "Excluir",
        "cancel": "Cancelar"
      },
      "deleteWithFlows": {
        "title": "Excluir o grupo e seus fluxos?",
        "description": "Isso excluirá permanentemente este grupo e todos os {{count}} fluxo(s) dentro dele. Essa ação não pode ser desfeita."
      },
      "editor": {
        "backToFlows": "← Flows",
        "createGroup": "Criar grupo",
        "addFlow": "Adicionar fluxo",
        "unlinkFlow": "Remover do grupo",
        "editFlow": "Editar fluxo",
        "objectivePlaceholder": "Qual é o objetivo deste grupo?",
        "namePlaceholder": "Nome do grupo",
        "chatPlaceholder": "Descreva o objetivo que você quer alcançar…",
        "toggleSidebar": "Alternar assistente de IA",
        "aiChat": "Chat de IA",
        "patchApplied": "Alterações aplicadas com sucesso",
        "patchDiscarded": "Alterações descartadas",
        "createSuccess": "Grupo criado com sucesso",
        "createError": "Falha ao criar o grupo",
        "deleteGroup": "Excluir grupo",
        "createdFromGroup": "Criado a partir do grupo",
        "rename": "Renomear grupo",
        "editObjective": "Editar objetivo"
      },
      "preview": {
        "title": "Prévia do grupo",
        "stepsCount_one": "{{count}} etapa",
        "stepsCount_other": "{{count}} etapas",
        "createButton": "Criar grupo",
        "emptyState": "Descreva seu objetivo para gerar fluxos"
      },
      "patch": {
        "title": "Alterações sugeridas",
        "adding": "Adicionando",
        "removing": "Removendo",
        "updating": "Atualizando",
        "groupChanges": "Alterações do grupo",
        "apply": "Aplicar alterações",
        "discard": "Descartar",
        "applied": "Fluxos atualizados no grupo",
        "error": "Falha ao aplicar as alterações ao grupo"
      },
      "moveDialog": {
        "title": "Mover para grupo",
        "description": "Selecione um grupo para mover este fluxo",
        "searchPlaceholder": "Buscar grupos...",
        "emptyState": "Nenhum grupo encontrado",
        "cancel": "Cancelar"
      },
      "createModal": {
        "title": "Novo grupo",
        "nameLabel": "Nome",
        "namePlaceholder": "Nome do grupo",
        "objectiveLabel": "Objetivo",
        "objectivePlaceholder": "Qual é o objetivo deste grupo?",
        "submit": "Criar grupo",
        "cancel": "Cancelar",
        "nameRequired": "Digite um nome para o grupo"
      }
    },
    "teamFlows": "Fluxos da equipe",
    "teamAgents": "Agentes da equipe",
    "team": {
      "picker": "Equipe",
      "allTeams": "Todas as equipes",
      "ownerBadgeYou": "Você",
      "unknownMember": "Membro desconhecido",
      "makeTeamFlow": "Transformar em fluxo da equipe",
      "selectTeam": "Selecionar equipe",
      "managedByGroup": "Gerenciado pelo grupo",
      "managedByGroupHint": "A equipe deste fluxo é gerenciada pelo grupo dele. Remova o fluxo do grupo para alterar a equipe.",
      "emptyNoTeam": "Você não é membro de nenhuma equipe.",
      "empty": "Nenhum fluxo da equipe ainda.",
      "ownerLabel": "Proprietário",
      "makeTeamAgent": "Compartilhar este agente com sua equipe",
      "emptyAgents": "Nenhum agente da equipe ainda.",
      "mcpAgentHint": "As conexões MCP são pessoais. Membros da equipe que executarem este agente não terão acesso às suas ferramentas MCP.",
      "mcpAgentRunHint": "Usa as conexões MCP pessoais do proprietário — elas não se aplicam aos seus fluxos.",
      "teamAgentMeta": "Compartilhado por {{owner}}"
    }
  },
  "discover": {
    "title": "Descobrir modelos",
    "backToFlows": "Voltar para Flows",
    "eyebrow": "Modelos de Flow",
    "heroTitle": "Automatize seu trabalho com this+that",
    "heroTitlePrefix": "Automatize seu trabalho com",
    "heroDescription": "Simplifique sua caixa de entrada e gerencie tarefas com Flows impulsionados por IA",
    "generator": {
      "eyebrow": "Gerador de Flows",
      "title": "O que você quer automatizar?",
      "description": "Descreva a automação com suas próprias palavras — o assistente cria um rascunho do flow e vocês o refinam juntos.",
      "inputPlaceholder": "ex.: Resumir nossos canais do Slack em um resumo diário…",
      "submitAriaLabel": "Gerar flow",
      "examples": {
        "slackDigest": "Resumir canais do Slack em um resumo diário",
        "competitorMonitor": "Monitorar sites de concorrentes toda semana",
        "shipDigest": "Documentar o que foi entregue a cada dia",
        "emailToTask": "Transformar e-mails importantes em tarefas no DoBox"
      }
    },
    "searchPlaceholder": "Descreva o que você quer automatizar...",
    "expandedTitle": "Descreva uma tarefa para o this+that",
    "expandedPlaceholder": "Descreva quais tarefas fazer, quais apps usar e quando executá-las",
    "editTitle": "Descreva o que você quer mudar",
    "editPlaceholder": "Descreva o que você quer mudar...",
    "editButton": "Aplicar alterações",
    "tryExamplePrompts": "Experimente prompts de exemplo",
    "examplePrompts": {
      "dailySummary": "Me envie um resumo diário dos e-mails não lidos",
      "labelEmails": "Etiquetar e-mails com itens de ação",
      "slackDigest": "Me atualize sobre as mensagens do Slack",
      "followUp": "Acompanhar e-mails que precisam de follow-up"
    },
    "createButton": "Criar",
    "generateButton": "Gerar flow",
    "generateError": "Falha ao gerar o flow. Tente novamente.",
    "clarification": {
      "title": "Mais alguns detalhes",
      "subtitle": "Ajude a criar o flow perfeito para você",
      "backButton": "Voltar",
      "selectPlaceholder": "Selecione uma opção",
      "textPlaceholder": "Digite sua resposta...",
      "optional": "opcional",
      "reviewConfirmation": {
        "create": "Sim, criar o agente",
        "update": "Sim, atualizar o agente",
        "requestChanges": "Não, quero fazer alterações"
      },
      "knowledgePagePicker": {
        "spaceLabel": "Espaço do Brain",
        "spacePlaceholder": "Selecione um espaço…",
        "pageLabel": "Página",
        "pagePlaceholder": "Selecione uma página…",
        "pageHint": "Opcional — deixe em branco para usar o espaço inteiro."
      }
    },
    "useTemplateSuccess": "Flow criado com sucesso",
    "useTemplateError": "Falha ao criar o flow a partir do modelo",
    "turnOn": "Ativar",
    "preview": "Experimentar",
    "view": "Ver",
    "active": "Ativo",
    "activate": "Ativar",
    "deactivate": "Desativar",
    "paused": "Pausado",
    "pausedNote": "Este workflow já existe, mas está pausado. Reative-o na aba Meus Flows.",
    "openWorkflow": "Abrir workflow",
    "openFlow": "Abrir flow",
    "setUpAgain": "Configurar novamente",
    "setUpAgainConfirmTitle": "Configurar este modelo novamente?",
    "setUpAgainConfirmBodyWorkflow": "Um workflow já foi criado a partir deste modelo. Se continuar, uma cópia separada será criada ao lado dele.",
    "setUpAgainConfirmBodyFlow": "Um flow já foi criado a partir deste modelo. Se continuar, uma cópia separada será criada ao lado dele.",
    "setUpAgainConfirmAction": "Criar uma cópia",
    "allCategories": "Todos",
    "categories": {
      "email_boosters": "Boosters de e-mail",
      "dobox_tasks": "Boosters de DoBox e tarefas",
      "slack_automation": "Boosters de Slack",
      "daily_summaries": "Resumos diários",
      "workflows": "Workflows",
      "agents": "Agentes"
    },
    "flowCount_one": "{{count}} flow",
    "flowCount_other": "{{count}} flows",
    "searchTemplates": "Buscar modelos…",
    "clearSearch": "Limpar busca",
    "noResults": "Nenhum modelo corresponde à sua busca.",
    "templatesLabel": "modelos",
    "flowType": "Flow",
    "useTemplate": "Usar modelo",
    "useWorkflow": "Usar workflow",
    "viewDetails": "Ver detalhes",
    "outcomeLabel": "Resultado",
    "objectiveLabel": "Objetivo",
    "scheduleLabel": "Agendamento",
    "integrationsLabel": "Integrações",
    "featuredWorkflow": "Workflow em destaque",
    "spotlight": {
      "previous": "Workflow em destaque anterior",
      "next": "Próximo workflow em destaque",
      "goToSlide": "Ir para o workflow em destaque {{index}}",
      "carouselLabel": "Workflows em destaque"
    },
    "flowsInWorkflow": "Flows neste workflow",
    "howItWorks": "Como funciona",
    "connectedApps": "Apps conectados",
    "workflows": {
      "company-brain": {
        "title": "Brain da empresa",
        "description": "Construa uma base de conhecimento viva a partir do código, e-mails e, se quiser, canais públicos do Slack — decisões e arquitetura capturadas automaticamente, com atualizações de fontes privadas passando por aprovação no DoBox.",
        "objective": "Dê a toda a equipe acesso instantâneo a decisões, arquitetura e contexto da empresa — capturados automaticamente do código e do e-mail, mais canais públicos do Slack se você escolher, com atualizações de fontes privadas passando por aprovação no DoBox.",
        "outcome": "Um espaço do Brain estruturado e sempre atual: decisões registradas, arquitetura documentada e contexto da empresa em dia — com atualizações de fontes privadas passando por aprovação segura no DoBox.",
        "schedule": "Monitora na cadência que quiser",
        "flows": {
          "0": {
            "name": "Semente inicial do Brain",
            "strip": {
              "seed": "Semear o Brain",
              "analyse": "Análise de IA"
            }
          },
          "1": {
            "name": "Monitor contínuo do Brain",
            "strip": {
              "schedule": "Agendado",
              "monitor": "Monitorar Slack"
            }
          },
          "2": {
            "name": "Propostas por e-mail",
            "strip": {
              "scan": "Varrer e-mails",
              "propose": "Propor atualizações"
            }
          },
          "3": {
            "name": "Aplicar propostas aprovadas",
            "strip": {
              "trigger": "DoBox aprovado",
              "apply": "Aplicar no Brain"
            }
          }
        },
        "landsIn": "Seu espaço no Brain, sempre atualizado automaticamente — mais uma fila no DoBox para o que precisar da sua aprovação antes",
        "needs": "Opcional: canais públicos do Slack para monitorar · Aprovações via DoBox para atualizações de fontes privadas"
      },
      "competitor-intelligence": {
        "title": "Inteligência de concorrentes",
        "description": "Monitore concorrentes, analise notícias e alertas e leve insights semanais para sua equipe automaticamente.",
        "objective": "Fique à frente dos concorrentes sem gastar horas em pesquisa manual. Receba um relatório semanal estruturado no Slack.",
        "outcome": "Um briefing semanal no Slack com notícias de concorrentes, lançamentos de produtos e sinais de mercado — zero esforço manual.",
        "schedule": "Semanal, toda segunda de manhã",
        "integrations": {
          "slack": "Slack"
        },
        "flows": {
          "0": {
            "name": "Semear páginas de concorrentes",
            "strip": {
              "seed": "Semear páginas",
              "research": "Pesquisa de IA"
            }
          },
          "1": {
            "name": "Monitor de concorrentes",
            "strip": {
              "schedule": "Agendado",
              "research": "Pesquisa de IA"
            }
          },
          "2": {
            "name": "Monitor de recursos e preços",
            "strip": {
              "scan": "Varredura web",
              "updates": "Atualizações de IA"
            }
          },
          "3": {
            "name": "Relatório semanal de insights",
            "strip": {
              "report": "Compilar relatório",
              "share": "Publicar no Slack"
            }
          }
        },
        "landsIn": "Um relatório semanal no Slack, além do seu espaço no Brain",
        "needs": "Busca na web (Tavily) · uma lista de sites de concorrentes"
      },
      "ship-log": {
        "title": "Diário de entregas",
        "description": "Documente automaticamente o que foi entregue a cada dia, acompanhe tarefas em aberto e produza um resumo semanal de engenharia.",
        "objective": "Dê a cada membro da equipe um registro claro do que foi entregue, do que está em andamento e do que precisa de atenção — sem escrever manualmente.",
        "outcome": "Um diário de entregas atualizado diariamente e um resumo semanal compartilhado no Slack — mantendo toda a equipe alinhada.",
        "schedule": "Todo dia à noite, resumo na segunda",
        "integrations": {
          "email": "E-mail",
          "slack": "Slack"
        },
        "landsIn": "Seu espaço no Brain, além de um resumo semanal no Slack ou e-mail — mudanças de arquitetura e direção também vão para o Brain da empresa, se ele estiver instalado",
        "needs": "Um repositório do GitHub conectado",
        "flows": {
          "0": {
            "name": "Resumo diário de atividades",
            "strip": {
              "schedule": "Toda noite",
              "summarise": "Resumo de IA"
            }
          },
          "1": {
            "name": "Resumo semanal de engenharia",
            "strip": {
              "digest": "Compilar resumo",
              "share": "Publicar no Slack"
            }
          }
        }
      },
      "daily-briefing": {
        "title": "Briefing diário",
        "description": "Comece cada manhã com um briefing objetivo da sua agenda, e-mails, destaques do Slack e tarefas em aberto — entregue nos canais que você escolher.",
        "objective": "Substitua a sobrecarga da caixa de entrada por um briefing matinal estruturado, para que nada importante passe despercebido.",
        "outcome": "Um briefing matinal diário entregue automaticamente no seu Brain, DoBox, e-mail ou Slack — sempre com contexto.",
        "schedule": "Manhãs de dias úteis",
        "integrations": {
          "email": "E-mail",
          "slack": "Slack"
        },
        "flows": {
          "0": {
            "strip": {
              "0": "Manhãs de dias úteis",
              "1": "Briefing de IA nos seus canais"
            }
          }
        },
        "setupFlows": {
          "briefing": {
            "name": "Briefing diário",
            "strip": {
              "schedule": "Agendado",
              "compose": "Redação de IA"
            }
          }
        },
        "landsIn": "Onde você escolher — Brain, DoBox, Slack ou e-mail",
        "needs": "Pelo menos um canal de entrega"
      },
      "inbox-autopilot": {
        "title": "Piloto automático da caixa de entrada",
        "description": "Classifique todos os e-mails, rascunhe respostas quando necessário, rascunhe follow-ups de reuniões e receba um briefing matinal — tudo sem chat de IA.",
        "objective": "Reduza o trabalho manual na caixa de entrada roteando, etiquetando, rascunhando e resumindo com etapas de flow determinísticas.",
        "outcome": "Uma caixa de entrada estruturada: e-mails classificados e etiquetados ao chegar, respostas rascunhadas automaticamente, follow-ups acompanhados e um resumo diário entregue toda manhã.",
        "schedule": "Tempo real + rotina diária",
        "integrations": {
          "email": "E-mail",
          "calendar": "Agenda"
        },
        "categories": {
          "toRespond": "Responder",
          "fyi": "Informativo",
          "marketing": "Marketing",
          "notification": "Notificação",
          "meetingUpdate": "Atualização de reunião",
          "awaitingReply": "Aguardando resposta"
        },
        "flows": {
          "0": {
            "name": "Triagem inteligente",
            "strip": {
              "trigger": "Novo e-mail",
              "classify": "Classificar e etiquetar",
              "draft": "Rascunhar a resposta"
            }
          },
          "1": {
            "name": "Follow-ups de reuniões",
            "strip": {
              "meetings": "Carregar reuniões",
              "followup": "Rascunhar follow-up"
            }
          },
          "2": {
            "name": "Briefing diário",
            "strip": {
              "load": "Carregar comunicações",
              "briefing": "Resumo matinal"
            },
            "notification": {
              "heading": "Seu resumo diário"
            }
          }
        },
        "landsIn": "Sua caixa de entrada — rotulada, com rascunhos e resumida",
        "needs": "Uma conta de e-mail para monitorar"
      },
      "manage-distractions": {
        "title": "Removedor de distrações",
        "description": "Arquive automaticamente e-mails promocionais, de fóruns e de redes sociais assim que chegam e receba um relatório nos dias úteis do que foi filtrado, para nada passar despercebido.",
        "objective": "Mantenha sua caixa de entrada livre de ruído de baixa prioridade sem perder nada importante, tirando da frente os e-mails dessas categorias e apresentando um resumo diário.",
        "outcome": "Promoções, fóruns e e-mails de redes sociais são etiquetados e arquivados ao chegar. Um relatório nos dias úteis chega ao seu assistente ou à sua caixa de entrada, para você conferir rapidamente o que foi filtrado.",
        "schedule": "Tempo real + relatório em dias úteis",
        "integrations": {
          "email": "E-mail"
        },
        "flows": {
          "0": {
            "name": "Arquivar distrações automaticamente",
            "strip": {
              "trigger": "Chega um e-mail de distração",
              "label": "Etiquetar e arquivar"
            }
          },
          "1": {
            "name": "Relatório diário de distrações",
            "strip": {
              "load": "Carregar distrações arquivadas",
              "report": "Gerar relatório"
            }
          }
        },
        "landsIn": "Arquivados automaticamente, com um relatório na caixa de entrada ou no assistente",
        "needs": "Uma conta de e-mail para monitorar"
      },
      "pr-review-copilot": {
        "title": "Copiloto de Revisão de PR",
        "description": "Uma revisão feita por IA chega em todo pull request assim que ele é aberto, os revisores são avisados na hora e os PRs parados recebem um lembrete antes de serem esquecidos.",
        "objective": "Reduza o tempo que os pull requests ficam esperando feedback, dando a cada PR uma primeira revisão instantânea e mantendo revisores e autores lembrados até que ele seja concluído.",
        "outcome": "Todo PR recebe uma revisão de IA e um aviso no Slack assim que precisa de atenção, além de um lembrete diário para o que estiver parado.",
        "schedule": "Tempo real nos eventos do GitHub, mais checagem de PRs parados",
        "flows": {
          "0": {
            "name": "Revisão de IA ao abrir o PR",
            "strip": {
              "trigger": "PR aberto",
              "review": "Revisão de IA"
            }
          },
          "1": {
            "name": "Aviso de revisão solicitada",
            "strip": {
              "trigger": "Revisão solicitada",
              "notify": "Avisar revisor"
            }
          },
          "2": {
            "name": "Lembrete de PR parado",
            "strip": {
              "schedule": "Manhãs de dias úteis",
              "nudge": "Lembrar PRs parados"
            }
          },
          "3": {
            "name": "Configuração das diretrizes de revisão",
            "strip": {
              "inspect": "Inspecionar repositório",
              "write": "Escrever diretrizes"
            }
          }
        },
        "landsIn": "Slack ou e-mail para as revisões, além de uma página de Diretrizes de Revisão de Código no seu Brain, mantida atualizada a partir do seu repositório",
        "needs": "O GitHub App instalado no repositório (é ele que entrega os eventos), mais uma conexão MCP do GitHub para ler o diff, e Slack ou e-mail para as notificações de revisão"
      },
      "dependency-security": {
        "title": "Monitor de Vulnerabilidades de Dependências",
        "description": "Monitore os alertas de segurança do Dependabot, escale imediatamente vulnerabilidades críticas e de alta severidade, resuma semanalmente a exposição restante e acompanhe itens que ultrapassarem o SLA de remediação.",
        "objective": "Garantir que todo alerta de segurança do Dependabot seja visto e acompanhado — vulnerabilidades críticas e de alta severidade escaladas assim que aparecem, um panorama completo da exposição restante toda semana, e nada fica aberto além do SLA sem um lembrete.",
        "outcome": "Vulnerabilidades de alto risco são escaladas imediatamente, todo alerta aberto permanece visível até ser resolvido, e problemas de segurança atrasados recebem acompanhamento automático.",
        "schedule": "Monitoramento contínuo do Dependabot na cadência escolhida, resumo toda segunda, verificação diária de atraso",
        "flows": {
          "0": {
            "name": "Triagem e ciclo de vida dos alertas",
            "strip": {
              "trigger": "Monitorar alertas do Dependabot",
              "triage": "Triar, notificar e acompanhar o ciclo de vida"
            }
          },
          "1": {
            "name": "Resumo semanal de vulnerabilidades",
            "strip": {
              "scan": "Buscar todos os alertas abertos",
              "digest": "Postar resumo no Slack"
            }
          },
          "2": {
            "name": "Escalonamento de vulnerabilidades atrasadas",
            "strip": {
              "schedule": "Diário",
              "reminder": "Escalar alertas atrasados"
            }
          }
        },
        "landsIn": "Uma DoBox para cada alerta qualificado, além de alertas, resumos semanais e escalonamentos no Slack ou e-mail",
        "needs": "Alertas do Dependabot habilitados no repositório, uma conta GitHub conectada, além de Slack ou e-mail para alertas e resumos"
      },
      "bug-intake": {
        "title": "Entrada de Bugs",
        "description": "Todo relato de bug vira um ticket DoBox triado com checklist de reprodução, issues do GitHub são espelhadas automaticamente, e correções mescladas fecham o ticket sozinhas.",
        "objective": "Transformar relatos de bugs espalhados em uma única fila rastreada — classificada por severidade, com passos de reprodução registrados e fechada automaticamente quando a correção é lançada.",
        "outcome": "Páginas de relato de bug e issues do GitHub viram tickets DoBox com checklist de reprodução, e pull requests mesclados fecham o ticket correspondente sem que ninguém precise mexer.",
        "schedule": "Tempo real em páginas de bug, issues do GitHub e PRs mesclados",
        "flows": {
          "0": {
            "name": "Triagem de página de bug",
            "strip": {
              "trigger": "Página de bug criada",
              "triage": "Classificar e criar ticket"
            }
          },
          "1": {
            "name": "Espelho de issue do GitHub",
            "strip": {
              "trigger": "Issue do GitHub aberta",
              "mirror": "Espelhar como DoBox"
            }
          },
          "2": {
            "name": "PR mesclado fecha ticket",
            "strip": {
              "trigger": "PR mesclado",
              "close": "Fechar ticket correspondente"
            }
          }
        },
        "landsIn": "Um espaço Bug Reports no Brain, além de um ticket DoBox por bug",
        "needs": "Um time, Slack ou e-mail para notificações e, opcionalmente, o GitHub App instalado no repositório (é ele que entrega os eventos)"
      },
      "incident-response": {
        "title": "Resposta a Incidentes",
        "description": "Alertas das suas ferramentas de monitoramento e mensagens no seu canal de incidentes viram tickets DoBox rastreados, e um post-mortem é rascunhado automaticamente assim que um ticket de incidente é resolvido.",
        "objective": "Manter todo sinal de incidente em um só lugar enquanto ele acontece, e transformar o ticket resolvido em um post-mortem sem que ninguém precise escrevê-lo do zero.",
        "outcome": "Alertas e mensagens do canal de incidentes se acumulam em um ticket DoBox rastreado, e resolver um ticket genuinamente ligado a um incidente rascunha uma página de post-mortem e avisa o time.",
        "schedule": "Tempo real em alertas, mensagens de incidentes e resoluções",
        "flows": {
          "0": {
            "name": "Triagem de alertas",
            "strip": {
              "trigger": "E-mail de alerta chega",
              "triage": "Rastrear em uma DoBox"
            }
          },
          "1": {
            "name": "Captura do canal de incidentes",
            "strip": {
              "trigger": "Mensagem no canal de incidentes",
              "capture": "Rastrear em uma DoBox"
            }
          },
          "2": {
            "name": "Rascunho de post-mortem",
            "strip": {
              "trigger": "DoBox resolvida",
              "draft": "Rascunhar post-mortem"
            }
          }
        },
        "landsIn": "Um espaço Incidents no Brain, tickets DoBox e avisos no Slack ou e-mail",
        "needs": "Domínios dos remetentes de alerta, além de Slack ou e-mail para os avisos; um canal do Slack de incidentes é opcional"
      },
      "team-rituals": {
        "title": "Rituais do Time",
        "description": "Um standup assíncrono é postado todo dia útil, um documento de conquistas celebra os pull requests da semana, e um pacote de retro mensal compara o mês com o anterior.",
        "objective": "Manter os rituais leves do time rodando sozinhos — standups, conquistas semanais e retros mensais — sem que ninguém precise lembrar de escrevê-los.",
        "outcome": "Um standup no formato ontem/hoje/bloqueios chega no Slack todo dia útil, um documento semanal celebra o que foi entregue, e uma página de retro mensal compara o progresso mês a mês.",
        "schedule": "Standups em dias úteis, documento de conquistas às sextas, retro no primeiro dia do mês",
        "flows": {
          "0": {
            "name": "Standup assíncrono",
            "strip": {
              "schedule": "Manhãs de dias úteis",
              "standup": "Postar standup"
            }
          },
          "1": {
            "name": "Documento de conquistas de sexta",
            "strip": {
              "schedule": "Sextas às 16h",
              "brag": "Celebrar a semana"
            }
          },
          "2": {
            "name": "Pacote de retro mensal",
            "strip": {
              "schedule": "Dia 1 do mês",
              "retro": "Compilar retro"
            }
          }
        },
        "landsIn": "Um espaço Team Rituals no Brain, além de atualizações no Slack ou e-mail",
        "needs": "Um repositório GitHub conectado, além de Slack ou e-mail para as atualizações dos rituais"
      },
      "engineering-knowledge": {
        "title": "Docs & Conhecimento",
        "description": "Perguntas feitas no canal de dev-help são respondidas direto do Brain, novos documentos de decisão são anunciados no Slack, e issues do GitHub marcadas needs-spec viram automaticamente um rascunho de especificação.",
        "objective": "Manter o conhecimento de engenharia respondido, anunciado e rascunhado sem que ninguém precise correr atrás — perguntas de dev-help recebem respostas com fonte, novos docs são divulgados, e issues needs-spec ganham um ponto de partida.",
        "outcome": "Perguntas de dev-help recebem uma resposta do Brain ou viram um rascunho de FAQ rastreado, todo novo documento no Engineering Docs gera um resumo de 3 linhas no Slack, e issues needs-spec viram uma página de especificação rascunhada.",
        "schedule": "Tempo real em perguntas, novos documentos e issues needs-spec",
        "flows": {
          "0": {
            "name": "Bot de FAQ do dev-help",
            "strip": {
              "trigger": "Pergunta no dev-help",
              "answer": "Buscar no Brain, responder ou rascunhar"
            }
          },
          "1": {
            "name": "Anunciador de ADR",
            "strip": {
              "trigger": "Novo documento publicado",
              "announce": "Resumir e notificar"
            }
          },
          "2": {
            "name": "Issue needs-spec",
            "strip": {
              "trigger": "Issue marcada needs-spec",
              "draft": "Rascunhar página de spec"
            }
          }
        },
        "landsIn": "Um espaço Engineering Docs no Brain, além de avisos no Slack ou e-mail",
        "needs": "Slack ou e-mail para notificações e um time; um canal dev-help no Slack é opcional, e o flow de needs-spec precisa do GitHub App instalado no repositório (é ele que entrega os eventos)"
      },
      "release-notes": {
        "title": "Notas de Lançamento",
        "description": "Todo release publicado tem seu changelog reescrito em linguagem voltada ao cliente e colocado na fila para revisão de um colega antes de ir para o Slack, e-mail e o Brain.",
        "objective": "Transformar um changelog bruto do GitHub em notas de lançamento prontas para o cliente automaticamente, com uma revisão humana antes de qualquer coisa chegar aos clientes.",
        "outcome": "Uma página de notas de lançamento rascunhada e um ticket de revisão aparecem no momento em que um release é publicado; quando um colega aprova, as notas são postadas no Slack, a página do release é finalizada, e interessados recebem por e-mail se configurado.",
        "schedule": "Tempo real em releases do GitHub e aprovações de revisão",
        "flows": {
          "0": {
            "name": "Rascunhar notas de lançamento para revisão",
            "strip": {
              "trigger": "Release publicado",
              "draft": "Rascunhar e pedir revisão"
            }
          },
          "1": {
            "name": "Publicar após aprovação",
            "strip": {
              "trigger": "Revisão aprovada",
              "publish": "Postar no Slack e e-mail"
            }
          }
        },
        "landsIn": "Um espaço Releases no Brain, um aviso no Slack ou e-mail e, opcionalmente, um e-mail para interessados",
        "needs": "Um padrão de tag, o GitHub App instalado no repositório (é ele que entrega os eventos), Slack ou e-mail para os avisos de release, e um time"
      },
      "inbound-response-desk": {
        "title": "Central de Inbound",
        "description": "Organiza tudo que cai na caixa de marketing e coloca os leads que importam na frente de vendas enquanto ainda estão quentes.",
        "objective": "Toda mensagem que chega no endereço de marketing é classificada, roteada e respondida dentro da janela que ainda converte — demo em minutos, imprensa em horas, pitch de fornecedor nunca.",
        "outcome": "Todo pedido de demo chega no canal de vendas em minutos, e pitch de fornecedor para de disputar sua atenção com inbound de verdade.",
        "schedule": "A cada e-mail recebido, com recap semanal",
        "landsIn": "Slack para lead quente, seu e-mail como etiquetas e rascunhos, DoBox para os follow-ups",
        "needs": "Gmail ou Outlook · Slack · DoBox · Brain",
        "categories": {
          "demo": "Pedido de demo",
          "press": "Imprensa",
          "partnership": "Parceria",
          "vendor": "Pitch de fornecedor",
          "community": "Comunidade"
        },
        "flows": {
          "0": {
            "name": "Organizar a caixa de marketing",
            "strip": {
              "trigger": "A cada e-mail",
              "classify": "Classificar e etiquetar",
              "handoff": "Encaminhar leads quentes",
              "draft": "Rascunhar a resposta"
            }
          },
          "1": {
            "name": "Recap semanal de inbound",
            "strip": {
              "load": "Carregar a semana",
              "recap": "Escrever o recap"
            }
          }
        }
      },
      "content-operations": {
        "title": "Operação de Conteúdo",
        "description": "Mantém sua estratégia de conteúdo, seus briefs e seus derivados em um só lugar, para o trabalho pré-escrita nunca começar de uma página em branco.",
        "objective": "Tirar do braço as duas metades caras da produção de conteúdo — a pesquisa que antecede a escrita e a redistribuição que vem depois da publicação — mantendo as duas ancoradas na mesma estratégia escrita.",
        "outcome": "Seus redatores recebem um brief pronto em vez de um tema, e todo asset publicado volta como um pacote de derivados prontos por canal.",
        "schedule": "Briefs semanais, repurposing na publicação, auditoria mensal",
        "landsIn": "Seu Brain como estratégia, briefs e derivados, com a fila no Slack",
        "needs": "Brain · Slack · conexão de busca na web (Tavily) · Gmail ou Outlook. A etiqueta precisa ser aplicada na chegada — crie um filtro no seu provedor de e-mail, porque uma etiqueta posto à mão depois não dispara o flow.",
        "flows": {
          "0": {
            "name": "Semear a estratégia de conteúdo",
            "strip": {
              "seed": "Semear o espaço",
              "research": "Pesquisar clusters"
            }
          },
          "1": {
            "name": "Montar os briefs da semana",
            "strip": {
              "research": "Pesquisar a SERP",
              "briefs": "Escrever os briefs"
            }
          },
          "2": {
            "name": "Repurposar o que publicamos",
            "strip": {
              "trigger": "Na etiqueta Published",
              "repurpose": "Gerar derivados"
            }
          },
          "3": {
            "name": "Auditoria mensal de lacunas",
            "strip": {
              "audit": "Auditar cobertura",
              "share": "Postar no Slack"
            }
          }
        }
      },
      "approval-chaser": {
        "title": "Cobrador de Aprovação",
        "description": "Cobra cada aprovador de uma tarefa até o aval sair, e informa exatamente quem está travando.",
        "objective": "Parar de ser o sistema de lembrete. Cada aprovador é perguntado diretamente, cada resposta é registrada, e quem está travando é nomeado em vez de adivinhado.",
        "outcome": "Você para de ser o sistema de lembrete — o status de cada aprovador fica visível sem você perguntar para ninguém.",
        "schedule": "Quando uma tarefa do DoBox é criada",
        "landsIn": "Slack como as perguntas, DoBox como o status corrente",
        "needs": "Slack · DoBox",
        "flows": {
          "0": {
            "name": "Cobrar os aprovadores",
            "strip": {
              "ask": "Perguntar a cada um",
              "track": "Acompanhar respostas"
            }
          }
        }
      },
      "account-pulse": {
        "title": "Pulso das Contas",
        "description": "Mantém uma página viva por conta no seu Brain, avisa quando uma conta fica em silêncio e escreve o brief do QBR para você.",
        "objective": "Substituir a planilha de \"última interação\" e o garimpo pré-QBR por um estado por conta que se atualiza sozinho a partir de e-mail, Slack e calendário.",
        "outcome": "Você entra em toda call de cliente com um brief de uma página que não levou três horas para montar.",
        "schedule": "Varredura diária de risco, recap semanal, briefs sob demanda",
        "landsIn": "Seu Brain como uma página por conta, com alertas no Slack e tarefas no DoBox",
        "needs": "Gmail ou Outlook · Slack · Calendário · Brain · DoBox",
        "flows": {
          "0": {
            "name": "Semear as páginas de conta",
            "strip": {
              "seed": "Criar as páginas",
              "accounts": "Preencher do histórico"
            }
          },
          "1": {
            "name": "Recap semanal das contas",
            "strip": {
              "schedule": "Toda segunda",
              "update": "Atualizar as páginas"
            }
          },
          "2": {
            "name": "Varredura diária de risco",
            "strip": {
              "sweep": "Checar silêncio",
              "task": "Abrir o outreach"
            }
          },
          "3": {
            "name": "Brief de QBR",
            "strip": {
              "gather": "Reunir o período",
              "brief": "Escrever o brief"
            }
          }
        }
      },
      "customer-onboarding-cockpit": {
        "title": "Cockpit de Onboarding de Cliente",
        "description": "Transforma cada cliente novo em um plano de onboarding rastreado, com o contexto da venda já escrito e as etapas travadas cobradas por você.",
        "objective": "Fechar a lacuna entre contrato assinado e primeiro valor entregue — o ponto em que o kickoff escorrega uma ou duas semanas e uma tarefa bloqueada custa outra quinzena.",
        "outcome": "O kickoff acontece com o contexto já na mão, e nada fica travado duas semanas sem alguém perceber.",
        "schedule": "Na etiqueta New Customer, varrido diariamente, reportado na sexta",
        "landsIn": "Uma página de kickoff no seu Brain, o plano no DoBox, cobranças no Slack e e-mail",
        "needs": "Gmail ou Outlook · Slack · Brain · DoBox. A etiqueta precisa ser aplicada na chegada — crie um filtro no seu provedor de e-mail, porque uma etiqueta posto à mão depois não dispara o flow.",
        "flows": {
          "0": {
            "name": "Pacote de kickoff",
            "strip": {
              "trigger": "No New Customer",
              "plan": "Montar o plano"
            }
          },
          "1": {
            "name": "Varredura de etapas travadas",
            "strip": {
              "sweep": "Achar o travado",
              "chase": "Cobrar o dono"
            }
          },
          "2": {
            "name": "Relatório de time-to-value",
            "strip": {
              "report": "Compilar o estado",
              "share": "Postar no Slack"
            }
          }
        }
      },
      "month-end-close": {
        "title": "Coordenador de Fechamento Mensal",
        "description": "Roda o checklist de fechamento de ponta a ponta — cobra os donos por accruals e explicação de variação, e posta o status diário do fechamento no Slack.",
        "objective": "Transformar a planilha de fechamento em um processo que roda sozinho durante a janela, com cobrança ativa dos donos e um único ponto de status.",
        "outcome": "Você para de ser o motor de lembrete: o checklist se cobra sozinho e você vê o que está travado antes de travar você.",
        "schedule": "Accruals no cut-off, standup diário, variação no D+3",
        "landsIn": "Slack para as perguntas e o standup, Brain para o log, DoBox para as tarefas",
        "needs": "Slack · Brain · DoBox",
        "flows": {
          "0": {
            "name": "Semear o checklist de fechamento",
            "strip": {
              "read": "Ler o checklist",
              "tasks": "Criar as tarefas"
            }
          },
          "1": {
            "name": "Pedido de cut-off e accruals",
            "strip": {
              "ask": "Perguntar aos donos",
              "log": "Escrever o log"
            }
          },
          "2": {
            "name": "Standup diário do fechamento",
            "strip": {
              "schedule": "Toda manhã",
              "standup": "Postar o status"
            }
          },
          "3": {
            "name": "Cobrança do comentário de variação",
            "strip": {
              "ask": "Perguntar o porquê",
              "consolidate": "Consolidar por linha"
            }
          }
        }
      },
      "contract-renewal-radar": {
        "title": "Radar de Renovação de Contratos",
        "description": "Monta um registro de todo contrato de fornecedor a partir da sua caixa de e-mail e avisa antes de cada janela de cancelamento fechar.",
        "objective": "O e-mail já contém a verdade sobre os contratos — order form, fatura anual, aviso de renovação. Extrair essa verdade para um registro vivo e disparar o alarme dentro da janela de aviso, não depois da fatura.",
        "outcome": "Nenhum contrato renova automaticamente porque ninguém viu a janela de aviso.",
        "schedule": "Alarme diário, revisão trimestral de compromisso",
        "landsIn": "Um registro de contratos no seu Brain, alertas no Slack, decisões no DoBox",
        "needs": "Gmail ou Outlook · Slack · Brain · DoBox. A etiqueta precisa ser aplicada na chegada — crie um filtro no seu provedor de e-mail, porque uma etiqueta posto à mão depois não dispara o flow.",
        "flows": {
          "0": {
            "name": "Semear o registro de contratos",
            "strip": {
              "seed": "Montar o registro",
              "scan": "Varrer 12 meses"
            }
          },
          "1": {
            "name": "Captador de e-mail de renovação",
            "strip": {
              "trigger": "Na etiqueta Contracts",
              "update": "Atualizar o fornecedor"
            }
          },
          "2": {
            "name": "Alarme da janela de aviso",
            "strip": {
              "alarm": "Checar os prazos",
              "task": "Pedir a decisão"
            }
          },
          "3": {
            "name": "Revisão trimestral de compromisso",
            "strip": {
              "review": "Somar o trimestre",
              "share": "Postar no Slack"
            }
          }
        }
      },
      "ops-pulse": {
        "title": "Pulso de Operações",
        "description": "Pergunta a mesma coisa a cada dono de projeto no Slack, espera as respostas e publica um relatório semanal de operações estruturado.",
        "objective": "Substituir o ciclo manual de DM individual, planilha de controle e copy-paste em doc por um ciclo automático de coleta, consolidação e publicação — com o registro de projetos vivendo no Brain como fonte única.",
        "outcome": "Seu relatório semanal se escreve sozinho a partir de respostas reais, e você para de passar a quarta à tarde em quinze DMs separadas.",
        "schedule": "Coleta no meio da semana, relatório no dia seguinte",
        "landsIn": "Slack como o relatório, seu Brain como o registro e o histórico semanal",
        "needs": "Slack · Brain · DoBox",
        "flows": {
          "0": {
            "name": "Semear o registro de projetos",
            "strip": {
              "seed": "Criar o registro",
              "register": "Uma linha por projeto"
            }
          },
          "1": {
            "name": "Coletar status dos donos",
            "strip": {
              "ask": "Perguntar a cada dono",
              "record": "Registrar respostas"
            }
          },
          "2": {
            "name": "Montar e publicar o pulso",
            "strip": {
              "assemble": "Montar o relatório",
              "publish": "Postar no Slack"
            }
          },
          "3": {
            "name": "Abrir um DoBox por bloqueio",
            "strip": {
              "blockers": "Achar os bloqueios",
              "task": "Abrir a tarefa"
            }
          }
        }
      },
      "okr-check-in": {
        "title": "Check-in de OKR",
        "description": "Pergunta a cada dono de KR o número atual e o motivo por trás dele, e depois publica o que está no ritmo e o que não está.",
        "objective": "Parar de deixar o OKR morrer na semana 9 porque ninguém olhou na semana 6. A cada ciclo os números são coletados de quem é dono deles e medidos contra o ritmo necessário para bater a meta.",
        "outcome": "Todo key result tem um número atual com data, e ficar atrás aparece enquanto ainda dá tempo de agir.",
        "schedule": "A cada duas semanas, ou mensal",
        "landsIn": "Seu Brain como o registro e cada check-in datado, com a versão curta no Slack",
        "needs": "Slack · Brain",
        "flows": {
          "0": {
            "name": "Semear o registro de OKR",
            "strip": {
              "seed": "Criar o registro",
              "objectives": "Objetivos e KRs"
            }
          },
          "1": {
            "name": "Coletar os números atuais",
            "strip": {
              "ask": "Perguntar a cada dono",
              "record": "Registrar os números"
            }
          },
          "2": {
            "name": "Publicar o check-in",
            "strip": {
              "compute": "Medir o ritmo",
              "publish": "Postar no Slack"
            }
          }
        }
      },
      "onboarding-runway": {
        "title": "Pista de Onboarding",
        "description": "Transforma a data de início de cada contratado em uma pista de 30 dias pronta, entre calendário, tarefas e Slack.",
        "objective": "Transformar o checklist de onboarding — que hoje vive num template copiado à mão — em flows que disparam sozinhos a partir de uma data de início registrada uma única vez.",
        "outcome": "Todo novo contratado tem o mesmo primeiro mês bem conduzido, sem você remontar o checklist do zero.",
        "schedule": "Verificado diariamente contra cada data de início",
        "landsIn": "DoBox e seu calendário, com uma página por contratado no Brain e as boas-vindas no Slack",
        "needs": "Google ou Outlook Calendar · Slack · Brain · DoBox. Não existe gatilho de data — uma varredura diária lê as datas de início no Brain.",
        "flows": {
          "0": {
            "name": "Intake do novo contratado",
            "strip": {
              "intake": "Coletar os dados",
              "tasks": "Abrir as tarefas D-7"
            }
          },
          "1": {
            "name": "Montador da agenda da semana 1",
            "strip": {
              "schedule": "Achar quem começa",
              "weekone": "Agendar a semana 1"
            }
          },
          "2": {
            "name": "Boas-vindas do dia 1",
            "strip": {
              "announce": "Apresentar a pessoa",
              "welcome": "Enviar as boas-vindas"
            }
          },
          "3": {
            "name": "Cobrança dos check-ins de marco",
            "strip": {
              "checkin": "Abrir o check-in",
              "ask": "Perguntar como está indo"
            }
          }
        }
      },
      "hiring-loop": {
        "title": "Ciclo de Contratação",
        "description": "Mantém toda vaga aberta andando: tria as candidaturas, cobra o feedback de entrevista e monta o pacote de debrief.",
        "objective": "Fechar as três lacunas que travam o funil: candidatura que fica sem leitura, entrevista que não vira scorecard, e comitê que começa sem os dados na mesa.",
        "outcome": "Você entra no comitê de contratação com todos os scorecards já coletados, resumidos e contrastados.",
        "schedule": "A cada candidatura, cobrado diariamente, debrief no dia do comitê",
        "landsIn": "Seu Brain como páginas de candidato e debrief, DoBox para decisões, Slack para a cobrança",
        "needs": "Gmail ou Outlook · Calendário · Slack · Brain · DoBox. A etiqueta precisa ser aplicada na chegada — crie um filtro no seu provedor de e-mail, porque uma etiqueta posto à mão depois não dispara o flow.",
        "flows": {
          "0": {
            "name": "Intake de candidatura",
            "strip": {
              "trigger": "Na etiqueta Candidates",
              "screen": "Escrever a nota"
            }
          },
          "1": {
            "name": "Cobrança de feedback de entrevista",
            "strip": {
              "interviews": "Ler as entrevistas do dia",
              "chase": "Cobrar o scorecard"
            }
          },
          "2": {
            "name": "Pacote de debrief",
            "strip": {
              "assemble": "Reunir os scorecards",
              "contrast": "Expor a divergência"
            }
          },
          "3": {
            "name": "Alerta de candidato em silêncio",
            "strip": {
              "silence": "Achar o silêncio",
              "draft": "Rascunhar o update"
            }
          }
        }
      },
      "legal-request-desk": {
        "title": "Central de Demandas Jurídicas",
        "description": "Transforma pedidos jurídicos espalhados por Slack e e-mail em uma fila única, com o que falta coletado antes de alguém abrir um documento.",
        "objective": "Substituir o intake por DM sem pedir ao negócio que aprenda uma ferramenta nova. O pedido continua sendo feito onde já é feito — o que muda é que ele passa a ser completo, registrado e visível.",
        "outcome": "Todo pedido jurídico chega completo, cai em uma fila só, e você sabe toda manhã de quem é a bola.",
        "schedule": "No e-mail de intake e a cada pedido no canal, standup toda manhã",
        "landsIn": "DoBox como a fila, um canal privado do jurídico para o standup, a thread original para o que falta",
        "needs": "Gmail ou Outlook · Slack · Brain · DoBox. A etiqueta precisa ser aplicada na chegada — crie um filtro no seu provedor de e-mail, porque uma etiqueta posto à mão depois não dispara o flow.",
        "flows": {
          "0": {
            "name": "Intake por e-mail",
            "strip": {
              "trigger": "No Legal/Intake",
              "matter": "Abrir a matéria"
            }
          },
          "1": {
            "name": "Intake pelo Slack",
            "strip": {
              "sweep": "Na mensagem do canal",
              "matter": "Abrir a matéria"
            }
          },
          "2": {
            "name": "Standup da fila",
            "strip": {
              "load": "Carregar a fila",
              "standup": "Postar o standup"
            }
          },
          "3": {
            "name": "Já respondido antes",
            "strip": {
              "search": "Buscar no playbook",
              "answer": "Responder ou escalar"
            }
          }
        }
      },
      "payment-change-guard": {
        "title": "Guarda de Mudança de Pagamento",
        "description": "Coloca em quarentena todo e-mail que pede troca de dados bancários, roda as checagens de fraude e segura a mudança atrás de uma aprovação humana.",
        "objective": "Fraude de boleto funciona por causa de uma thread de e-mail que ninguém verificou por fora. Isso transforma a verificação em um passo que o pagamento não consegue pular, em vez de um hábito que dura até a semana em que alguém está ocupado.",
        "outcome": "Nenhuma troca de dados bancários é executada só com um e-mail, e a checagem pulada fica visível.",
        "schedule": "A cada pedido de troca de pagamento",
        "landsIn": "Uma etiqueta de quarentena na mensagem, um alerta no canal do financeiro e uma tarefa de aprovação com os passos da ligação",
        "needs": "Gmail ou Outlook · Slack · DoBox",
        "flows": {
          "0": {
            "name": "Colocar em quarentena e verificar uma mudança de pagamento",
            "strip": {
              "detect": "Identificar o pedido",
              "verify": "Rodar as checagens",
              "hold": "Segurar para um humano"
            }
          }
        }
      },
      "support-triage-desk": {
        "title": "Central de Triagem do Suporte",
        "description": "Etiqueta, enfileira e rascunha uma primeira resposta para cada mensagem que chega na caixa compartilhada de suporte, para que um humano abra uma fila já trabalhada em vez de uma pilha.",
        "objective": "A caixa compartilhada é onde a dívida de suporte se acumula invisível. Isso torna o estado de cada mensagem explícito no momento em que ela chega, e não quando alguém finalmente rola até ela.",
        "outcome": "Toda mensagem de suporte chega etiquetada, enfileirada e — quando é simples — já rascunhada.",
        "schedule": "A cada mensagem na caixa de suporte",
        "landsIn": "Etiquetas na mensagem, uma tarefa no DoBox por pedido, um rascunho de resposta na thread",
        "needs": "Gmail ou Outlook · DoBox",
        "categories": {
          "urgent": "Urgente",
          "question": "Dúvida",
          "bug": "Bug"
        },
        "flows": {
          "0": {
            "name": "Triar uma mensagem de suporte",
            "strip": {
              "triage": "Etiquetar e classificar",
              "queue": "Enfileirar e rascunhar"
            }
          }
        }
      },
      "privacy-request-log": {
        "title": "Registro de Pedidos de Privacidade",
        "description": "Registra todo pedido de titular de dados no dia em que chega, com o prazo legal já calculado, e rascunha um aviso de recebimento neutro para o jurídico revisar.",
        "objective": "Um pedido de privacidade descoberto no dia vinte e nove já é um incidente em formação. O prazo precisa existir como data rastreada desde o dia um, não como algo que alguém lembra de calcular.",
        "outcome": "Nenhum pedido de titular é descoberto tarde, e nenhum dado do solicitante é copiado para lugar novo.",
        "schedule": "A cada mensagem na caixa de privacidade",
        "landsIn": "Uma tarefa no DoBox com o tipo e o prazo, um rascunho de aviso para revisão",
        "needs": "Gmail ou Outlook · DoBox",
        "flows": {
          "0": {
            "name": "Registrar um pedido de titular",
            "strip": {
              "clock": "Calcular o prazo",
              "log": "Registrar o pedido"
            }
          }
        }
      },
      "ops-intake-queue": {
        "title": "Fila de Entrada de Operações",
        "description": "Transforma cada pedido real postado no canal de operações em uma tarefa rastreada com tipo, responsável e janela de resposta — e avisa o solicitante o que esperar.",
        "objective": "Pedidos de operações chegam como mensagem e morrem como mensagem. Isso mantém o pedido onde as pessoas já pedem e adiciona o rastreamento que faltava.",
        "outcome": "Todo pedido de operações fica rastreado com uma janela de resposta, e o solicitante sabe que foi recebido.",
        "schedule": "A cada mensagem no canal de operações",
        "landsIn": "Uma tarefa no DoBox por pedido, uma confirmação no mesmo canal do Slack",
        "needs": "Slack · DoBox",
        "flows": {
          "0": {
            "name": "Rotear um pedido de operações",
            "strip": {
              "read": "Avaliar a mensagem",
              "route": "Classificar e rastrear"
            }
          }
        }
      },
      "people-policy-line": {
        "title": "Linha de Políticas de RH",
        "description": "Responde dúvidas de política no Slack a partir do que está escrito no espaço de People Ops, citando a regra e linkando a página.",
        "objective": "As mesmas seis perguntas chegam ao RH todo mês. Respondê-las a partir da política escrita — com o link — é mais rápido e é a única versão que se mantém consistente.",
        "outcome": "Dúvidas rotineiras de política são respondidas a partir da fonte escrita, e o que o Brain não cobre chega a um humano em vez de ser improvisado.",
        "schedule": "A cada pergunta no canal de RH",
        "landsIn": "Uma resposta no mesmo canal do Slack, com a página de origem linkada",
        "needs": "Slack · Brain",
        "flows": {
          "0": {
            "name": "Responder uma dúvida de política",
            "strip": {
              "search": "Buscar no Brain",
              "answer": "Responder com a fonte"
            }
          }
        }
      },
      "marketing-performance-read": {
        "title": "Leitura de Performance de Marketing",
        "description": "Transforma os números que seu time já registra em uma leitura semanal escrita — o que mudou, a razão provável e a decisão que isso implica — separada por audiência.",
        "objective": "Um dashboard mostra o que mudou mas nunca diz o que fazer a respeito. A leitura escrita é a parte sobre a qual se age, e é a parte que ninguém tem tempo de escrever.",
        "outcome": "A liderança recebe a manchete e a decisão; o dono do canal recebe o detalhe. Nenhum dos dois é montado à mão.",
        "schedule": "Semanalmente nas manhãs de segunda",
        "landsIn": "Uma leitura curta no canal da liderança, a completa no canal de marketing",
        "needs": "Brain · Slack",
        "flows": {
          "0": {
            "name": "Escrever a leitura semanal",
            "strip": {
              "read": "Ler os números",
              "deliver": "Entregar por audiência"
            }
          }
        }
      }
    },
    "setup": {
      "next": "Avançar",
      "confirm": "Configurar",
      "settingUp": "Configurando…",
      "review": {
        "resources": "Recursos a criar",
        "flows": "Flows a ativar",
        "brainSpace": "Espaço do Brain",
        "brainPage": "Página do Brain",
        "emailLabel": "Etiqueta do Gmail: {{name}}",
        "agentTemplate": "Agente: {{name}}"
      },
      "fields": {
        "chips": {
          "add": "Adicionar",
          "placeholder": "Digite e pressione Enter"
        },
        "slackChannel": {
          "loading": "Carregando canais…",
          "placeholder": "Selecione um canal",
          "error": "Não foi possível carregar os canais do Slack",
          "workspace": "Workspace",
          "workspacePlaceholder": "Selecione um workspace",
          "noWorkspace": "Nenhum workspace do Slack conectado. Conecte o Slack nas configurações de integrações.",
          "noBotChannels": "Nenhum canal em que o bot seja membro. Convide o bot para um canal no Slack (/invite @bot) e reabra esta tela.",
          "searchPlaceholder": "Buscar canais",
          "selectedCount": "{{count}} selecionados",
          "noMatches": "Nenhum canal corresponde à sua busca"
        },
        "team": {
          "label": "Atribuir à equipe",
          "personalNote": "Nenhuma equipe encontrada. O workflow será criado no seu espaço de trabalho pessoal.",
          "personalOption": "Pessoal (sem equipe)",
          "loading": "Carregando equipes…"
        },
        "mcpConnection": {
          "connected": "Conectado",
          "notConnected": "Não conectado. Conecte o {{service}} nas configurações de integrações e clique em Verificar novamente.",
          "connect": "Ir para Integrações",
          "recheck": "Verificar novamente",
          "hint": "Este workflow precisa do servidor MCP do {{service}} conectado para funcionar.",
          "loading": "Verificando conexão…",
          "services": {
            "github": "GitHub",
            "tavily": "Tavily (busca na web)"
          }
        },
        "digestDelivery": {
          "slackLabel": "Canal do Slack (opcional)",
          "emailLabel": "Endereço de e-mail (opcional)",
          "emailPlaceholder": "ex.: team@example.com",
          "hint": "Pelo menos um método de entrega é obrigatório — Slack, e-mail ou ambos."
        },
        "deliveryChannels": {
          "label": "Onde entregar o briefing",
          "loading": "Carregando integrações…",
          "channels": {
            "assistantPage": {
              "label": "Página do Brain",
              "description": "Salve o briefing no seu Brain todos os dias"
            },
            "dobox": {
              "label": "DoBox",
              "description": "Crie uma entrada no DoBox para o briefing"
            },
            "email": {
              "label": "E-mail",
              "description": "Enviado para sua caixa de entrada automaticamente pelo assistente do this+that.",
              "selectLabel": "Enviar para"
            },
            "slack": {
              "label": "Slack",
              "description": "O bot do assistente envia o briefing para você como mensagem direta no Slack.",
              "workspaceSelectLabel": "Workspace"
            }
          }
        },
        "emailAccount": {
          "placeholder": "Selecione uma conta",
          "noAccounts": "Nenhuma conta de e-mail conectada. Conecte uma conta de e-mail nas configurações de integrações."
        },
        "githubRepository": {
          "add": "Adicionar",
          "placeholder": "Adicionar outro, ex. owner/repo",
          "allHint": "Deixe vazio para observar todos os repositórios.",
          "noRepositories": "Nenhum repositório sincronizado ainda. Conecte o GitHub ou digite o nome completo owner/repo abaixo.",
          "invalid": "Use o nome completo do repositório, como acme/backend.",
          "remove": "Remover {{repository}}"
        }
      },
      "inbox-autopilot": {
        "params": {
          "emailAccount": {
            "label": "Conta de e-mail",
            "description": "Qual conta de e-mail os flows devem monitorar?"
          }
        }
      },
      "competitor-intelligence": {
        "params": {
          "team": {
            "label": "Equipe"
          },
          "tavily": {
            "label": "Busca na web (Tavily)"
          },
          "companyName": {
            "label": "Nome da empresa",
            "placeholder": "ex.: Acme"
          },
          "website": {
            "label": "Site da empresa",
            "placeholder": "ex.: https://acme.com"
          },
          "description": {
            "label": "O que o seu app faz? (principais recursos)",
            "placeholder": "Breve descrição do seu produto e dos principais recursos"
          },
          "competitors": {
            "label": "Concorrentes a monitorar"
          },
          "slackChannel": {
            "label": "Canal do Slack para o relatório semanal"
          },
          "cadence": {
            "label": "Frequência do relatório",
            "options": {
              "weekly-monday": "Semanal, às segundas",
              "daily": "Diário (seg–sex)"
            }
          }
        }
      },
      "company-brain": {
        "params": {
          "team": {
            "label": "Equipe"
          },
          "companyName": {
            "label": "Nome da empresa",
            "placeholder": "ex.: Acme Corp"
          },
          "githubRepo": {
            "label": "Repositório GitHub (opcional)",
            "placeholder": "ex.: owner/repo"
          },
          "description": {
            "label": "O que a empresa faz? (opcional)",
            "placeholder": "Breve descrição da empresa, do produto e da equipe — preenche a página Company & Market junto com o que aparecer no Slack e no e-mail"
          },
          "sourceChannels": {
            "label": "Canais públicos do Slack a monitorar (opcional)"
          },
          "cadence": {
            "label": "Frequência de monitoramento",
            "options": {
              "hourly": "A cada hora",
              "every-4h": "A cada 4 horas",
              "daily": "Diário (8h)"
            }
          }
        }
      },
      "ship-log": {
        "params": {
          "team": {
            "label": "Atribuir à equipe"
          },
          "github": {
            "label": "Conexão GitHub"
          },
          "githubRepo": {
            "label": "Repositório GitHub",
            "placeholder": "ex.: owner/repo"
          },
          "digest": {
            "label": "Entrega do resumo semanal"
          }
        }
      },
      "daily-briefing": {
        "params": {
          "briefingTime": {
            "label": "Horário de entrega",
            "options": {
              "07": "7h (dias úteis)",
              "08": "8h (dias úteis)",
              "09": "9h (dias úteis)"
            }
          },
          "delivery": {
            "label": "Canais de entrega"
          }
        }
      },
      "manage-distractions": {
        "params": {
          "emailAccount": {
            "label": "Conta de e-mail"
          },
          "categories": {
            "label": "Arquivar automaticamente estas abas",
            "options": {
              "promotions": "Promoções",
              "forums": "Fóruns",
              "social": "Social",
              "updates": "Atualizações",
              "personal": "Principal"
            }
          },
          "reportTime": {
            "label": "Horário do relatório",
            "options": {
              "morning": "8h (dias úteis)",
              "noon": "12h (dias úteis)",
              "evening": "18h (dias úteis)"
            }
          },
          "deliveryMode": {
            "label": "Entrega do relatório",
            "options": {
              "assistant": "Conversa do assistente",
              "email": "E-mail (obs.: o relatório pode cair na aba Promoções do seu Gmail)",
              "both": "Assistente e e-mail"
            }
          }
        }
      },
      "pr-review-copilot": {
        "params": {
          "team": {
            "label": "Atribuir à equipe"
          },
          "github": {
            "label": "Conexão GitHub"
          },
          "githubRepo": {
            "label": "Repositórios do GitHub"
          },
          "destination": {
            "label": "Entrega das notificações"
          }
        }
      },
      "dependency-security": {
        "params": {
          "team": {
            "label": "Atribuir à equipe"
          },
          "github": {
            "label": "Conexão GitHub"
          },
          "githubRepos": {
            "label": "Repositórios GitHub (owner/repo)"
          },
          "destination": {
            "label": "Entrega das notificações"
          },
          "severityThreshold": {
            "label": "Notificar imediatamente para",
            "options": {
              "critical-only": "Apenas crítica",
              "critical-high": "Crítica + alta",
              "critical-high-medium": "Crítica + alta + média"
            }
          },
          "pollCadence": {
            "label": "Frequência de verificação",
            "options": {
              "hourly": "A cada hora",
              "every-4h": "A cada 4 horas",
              "daily": "Diário"
            }
          },
          "slaPreset": {
            "label": "SLA de remediação",
            "options": {
              "standard": "Padrão (24h / 3d / 14d / 30d)",
              "aggressive": "Agressivo (12h / 1d / 7d / 14d)",
              "relaxed": "Relaxado (3d / 7d / 30d / 60d)"
            }
          }
        }
      },
      "bug-intake": {
        "params": {
          "team": {
            "label": "Atribuir à equipe"
          },
          "github": {
            "label": "Conexão GitHub (opcional)"
          },
          "githubRepo": {
            "label": "Repositórios do GitHub"
          },
          "destination": {
            "label": "Entrega das notificações"
          }
        }
      },
      "incident-response": {
        "params": {
          "alertSenders": {
            "label": "Domínios dos remetentes de alerta"
          },
          "incidentsSource": {
            "label": "Canal do Slack de incidentes (opcional)"
          },
          "destination": {
            "label": "Entrega das notificações"
          },
          "team": {
            "label": "Atribuir à equipe"
          }
        }
      },
      "team-rituals": {
        "params": {
          "team": {
            "label": "Atribuir à equipe"
          },
          "github": {
            "label": "Conexão GitHub"
          },
          "githubRepo": {
            "label": "Repositórios do GitHub"
          },
          "destination": {
            "label": "Entrega das notificações"
          },
          "standupTime": {
            "label": "Horário do standup",
            "options": {
              "10": "10h00",
              "08": "8h00",
              "09": "9h00"
            }
          }
        }
      },
      "engineering-knowledge": {
        "params": {
          "team": {
            "label": "Atribuir à equipe"
          },
          "devHelp": {
            "label": "Canal do Slack de dev-help (opcional)"
          },
          "destination": {
            "label": "Entrega das notificações"
          }
        }
      },
      "release-notes": {
        "params": {
          "tagPattern": {
            "label": "Padrão de tag do release",
            "placeholder": "ex.: prod-*"
          },
          "destination": {
            "label": "Entrega das notificações"
          },
          "stakeholderEmail": {
            "label": "E-mail de interessados (opcional)",
            "placeholder": "ex.: customers@empresa.com"
          },
          "team": {
            "label": "Atribuir à equipe"
          }
        }
      },
      "inbound-response-desk": {
        "params": {
          "team": {
            "label": "Atribuir ao time"
          },
          "emailAccount": {
            "label": "Caixa de marketing"
          },
          "companyPitch": {
            "label": "O que a sua empresa vende",
            "placeholder": "ex.: Acme — software de agendamento para clínicas odontológicas"
          },
          "salesChannel": {
            "label": "Onde o lead quente é postado"
          },
          "noiseSignals": {
            "label": "Domínios e termos que são sempre ruído"
          },
          "autoArchiveNoise": {
            "label": "Arquivar o ruído em vez de só etiquetar"
          },
          "recapCadence": {
            "label": "Cadência do recap",
            "options": {
              "weekly-monday": "Semanal, segunda de manhã",
              "daily": "Todo dia útil"
            }
          }
        }
      },
      "content-operations": {
        "params": {
          "team": {
            "label": "Atribuir ao time"
          },
          "searchConnection": {
            "label": "Conexão de busca web"
          },
          "emailAccount": {
            "label": "Caixa que recebe a etiqueta Published"
          },
          "companyContext": {
            "label": "Empresa, site e para quem você vende",
            "placeholder": "ex.: Acme — acme.com — líderes de operações em clínicas de 50 a 500 pessoas"
          },
          "topicClusters": {
            "label": "Clusters de tema iniciais"
          },
          "briefsPerWeek": {
            "label": "Briefs por semana",
            "options": {
              "2": "2 briefs",
              "3": "3 briefs",
              "5": "5 briefs"
            }
          },
          "derivativeChannels": {
            "label": "Derivados a produzir",
            "options": {
              "linkedin": "Post de LinkedIn",
              "newsletter": "Newsletter",
              "social": "Social short-form",
              "one-pager": "One-pager de vendas",
              "thread": "Thread"
            }
          },
          "contentChannel": {
            "label": "Onde a fila é postada"
          },
          "briefCadence": {
            "label": "Cadência dos briefs",
            "options": {
              "weekly-monday": "Semanal, segunda de manhã",
              "daily": "Todo dia útil"
            }
          }
        }
      },
      "approval-chaser": {
        "params": {
          "approvers": {
            "label": "Aprovadores"
          },
          "approvalChannel": {
            "label": "Onde os aprovadores são perguntados"
          },
          "reminderHours": {
            "label": "Quanto esperar antes de escalar",
            "options": {
              "4": "4 horas",
              "24": "24 horas",
              "48": "48 horas"
            }
          }
        }
      },
      "account-pulse": {
        "params": {
          "team": {
            "label": "Atribuir ao time"
          },
          "emailAccount": {
            "label": "Conta de e-mail varrida"
          },
          "accounts": {
            "label": "Contas a acompanhar (nome — domínio)"
          },
          "accountChannels": {
            "label": "Canais de Slack dos clientes"
          },
          "silenceThresholdDays": {
            "label": "Dias de silêncio até o alerta",
            "options": {
              "30": "30 dias",
              "45": "45 dias",
              "60": "60 dias",
              "90": "90 dias"
            }
          },
          "renewalNoticeDays": {
            "label": "Avisar com esta antecedência da renovação",
            "options": {
              "30": "30 dias",
              "60": "60 dias",
              "90": "90 dias"
            }
          },
          "alertChannel": {
            "label": "Onde alertas e recaps são postados"
          }
        }
      },
      "customer-onboarding-cockpit": {
        "params": {
          "team": {
            "label": "Atribuir ao time"
          },
          "emailAccount": {
            "label": "Caixa que recebe a etiqueta New Customer"
          },
          "milestones": {
            "label": "Marcos do onboarding"
          },
          "stallDays": {
            "label": "Dias sem movimento até cobrar",
            "options": {
              "3": "3 dias",
              "5": "5 dias",
              "7": "7 dias"
            }
          },
          "internalChannel": {
            "label": "Onde os nudges e o relatório são postados"
          }
        }
      },
      "month-end-close": {
        "params": {
          "team": {
            "label": "Atribuir ao time"
          },
          "slackChannel": {
            "label": "Canal do fechamento"
          },
          "closeOwners": {
            "label": "Donos das tarefas de fechamento"
          },
          "budgetOwners": {
            "label": "Donos de centro de custo"
          },
          "targetCloseDay": {
            "label": "Dia-alvo de fechamento",
            "options": {
              "3": "Fechar até D+3",
              "5": "Fechar até D+5",
              "10": "Fechar até D+10"
            }
          }
        }
      },
      "contract-renewal-radar": {
        "params": {
          "team": {
            "label": "Atribuir ao time"
          },
          "emailAccount": {
            "label": "Caixa que recebe e-mail contratual"
          },
          "slackChannel": {
            "label": "Onde os alertas são postados"
          },
          "seedVendors": {
            "label": "Fornecedores conhecidos para semear o registro"
          },
          "alertThresholds": {
            "label": "Avisar com esta antecedência do prazo de aviso",
            "options": {
              "14": "14 dias",
              "30": "30 dias",
              "60": "60 dias",
              "90": "90 dias"
            }
          },
          "defaultOwner": {
            "label": "Dono padrão quando o contrato não tem um",
            "placeholder": "ex.: Head de Finanças"
          }
        }
      },
      "ops-pulse": {
        "params": {
          "team": {
            "label": "Atribuir ao time"
          },
          "reportChannel": {
            "label": "Onde o pulso é publicado"
          },
          "projects": {
            "label": "Projetos acompanhados"
          },
          "owners": {
            "label": "Slack IDs dos donos, na mesma ordem dos projetos"
          },
          "collectionDay": {
            "label": "Dia da coleta (o relatório sai no dia seguinte)",
            "options": {
              "monday": "Segunda",
              "tuesday": "Terça",
              "wednesday": "Quarta"
            }
          },
          "chaseNonResponders": {
            "label": "Reperguntar uma vez após quatro horas de silêncio"
          }
        }
      },
      "okr-check-in": {
        "params": {
          "team": {
            "label": "Atribuir ao time"
          },
          "reportChannel": {
            "label": "Onde o check-in é publicado"
          },
          "objectives": {
            "label": "Objetivos deste trimestre"
          },
          "krOwners": {
            "label": "Slack IDs dos donos de key result"
          },
          "checkInCadence": {
            "label": "Cadência do check-in",
            "options": {
              "biweekly": "A cada duas semanas",
              "monthly": "Mensal"
            }
          }
        }
      },
      "onboarding-runway": {
        "params": {
          "team": {
            "label": "Atribuir ao time"
          },
          "announcementChannel": {
            "label": "Onde os novos contratados são apresentados"
          },
          "itOwner": {
            "label": "Quem é dono dos acessos",
            "placeholder": "ex.: Sam do TI"
          },
          "preStartChecklist": {
            "label": "Checklist de antes do dia 1"
          },
          "weekOneSessions": {
            "label": "Sessões da semana 1 a agendar",
            "options": {
              "welcome-1-1": "Um-a-um de boas-vindas",
              "buddy": "Sessão com o buddy",
              "product-tour": "Tour de produto",
              "team-intro": "Apresentação ao time"
            }
          },
          "checkInMilestones": {
            "label": "Marcos de check-in",
            "options": {
              "30": "30 dias",
              "60": "60 dias",
              "90": "90 dias"
            }
          }
        }
      },
      "hiring-loop": {
        "params": {
          "team": {
            "label": "Atribuir ao time"
          },
          "emailAccount": {
            "label": "Caixa que recebe as candidaturas"
          },
          "hiringChannel": {
            "label": "Onde o debrief é anunciado"
          },
          "openRoles": {
            "label": "Vagas abertas"
          },
          "feedbackSlaHours": {
            "label": "Horas até um scorecard ser considerado atrasado",
            "options": {
              "12": "12 horas",
              "24": "24 horas",
              "48": "48 horas"
            }
          },
          "silenceThresholdDays": {
            "label": "Dias de silêncio do candidato até o alerta",
            "options": {
              "5": "5 dias",
              "7": "7 dias",
              "14": "14 dias"
            }
          }
        }
      },
      "legal-request-desk": {
        "params": {
          "team": {
            "label": "Atribuir ao time"
          },
          "intakeInbox": {
            "label": "Caixa que recebe os pedidos jurídicos"
          },
          "requestsChannel": {
            "label": "Canal onde o negócio pede"
          },
          "legalPrivateChannel": {
            "label": "Canal privado do jurídico (standup e escalações)"
          },
          "requestTypes": {
            "label": "Tipos de pedido"
          },
          "ndaSla": {
            "label": "Prazo de resposta para NDA",
            "options": {
              "1": "1 dia útil",
              "2": "2 dias úteis",
              "3": "3 dias úteis",
              "5": "5 dias úteis"
            }
          },
          "autoAskMissingFields": {
            "label": "Pedir automaticamente os campos que faltam"
          },
          "escalationTopics": {
            "label": "Temas que vão direto ao advogado e nunca para a fila",
            "options": {
              "litigation": "Litígio",
              "investigation": "Investigação interna",
              "regulator": "Regulador",
              "termination": "Desligamento",
              "ma": "Aquisição"
            }
          }
        }
      },
      "payment-change-guard": {
        "params": {
          "team": {
            "label": "Atribuir ao time"
          },
          "emailAccount": {
            "label": "Caixa que recebe e-mails de fornecedores"
          },
          "financeChannel": {
            "label": "Canal do financeiro para alertas"
          }
        }
      },
      "support-triage-desk": {
        "params": {
          "team": {
            "label": "Atribuir ao time"
          },
          "emailAccount": {
            "label": "Caixa compartilhada de suporte"
          }
        }
      },
      "privacy-request-log": {
        "params": {
          "team": {
            "label": "Atribuir ao time"
          },
          "privacyInbox": {
            "label": "Caixa que recebe pedidos de privacidade"
          },
          "responseBufferDays": {
            "label": "Folga antes do prazo legal",
            "options": {
              "3": "3 dias",
              "5": "5 dias",
              "10": "10 dias"
            }
          }
        }
      },
      "ops-intake-queue": {
        "params": {
          "team": {
            "label": "Atribuir ao time"
          },
          "intakeChannel": {
            "label": "Canal onde chegam pedidos de operações"
          }
        }
      },
      "people-policy-line": {
        "params": {
          "team": {
            "label": "Atribuir ao time"
          },
          "questionsChannel": {
            "label": "Canal onde perguntam para o RH"
          }
        }
      },
      "marketing-performance-read": {
        "params": {
          "team": {
            "label": "Atribuir ao time"
          },
          "leadershipChannel": {
            "label": "Canal da liderança (manchete)"
          },
          "teamChannel": {
            "label": "Canal de marketing (leitura completa)"
          }
        }
      }
    },
    "templates": {
      "triageEmails": {
        "title": "Triagem de e-mails",
        "description": "Classifique e priorize automaticamente os e-mails recebidos por categoria e urgência"
      },
      "smartReplies": {
        "title": "Respostas inteligentes",
        "description": "Rascunhe sugestões de resposta com IA para seus e-mails mais importantes",
        "prompt": "Crie um fluxo acionado quando eu receber um novo e-mail.\n\nEtapa 1: Determine se o e-mail exige resposta.\nProssiga apenas se TODAS as condições abaixo forem atendidas:\n- O e-mail foi escrito por um humano (não automatizado, não vindo de endereços no-reply, não gerado por sistema).\n- O e-mail claramente espera ou se beneficia de uma resposta (ex.: contém uma pergunta, uma solicitação, uma decisão pendente ou exige confirmação).\n- A conversa ainda não foi concluída (ex.: sem \"obrigado\", \"entendido\", \"anotado\" ou sinais de encerramento sem pendências).\n\nNÃO gere um rascunho se:\n- O e-mail for uma notificação, marketing, newsletter, recibo ou alerta de plataforma.\n- O remetente for um sistema automatizado ou um bot.\n- A mensagem for apenas informativa e não exigir ação.\n- A conversa já estiver resolvida ou não precisar de resposta.\n\nEtapa 2: Se uma resposta for necessária:\n- Carregue meus e-mails enviados recentes para aprender meu tom, estilo e forma de escrever.\n- Reproduza meu estilo natural de escrita (conciso, amigável e direto).\n- Responda no mesmo idioma do e-mail original.\n\nEtapa 3: Gere a resposta:\n- Escreva uma resposta completa, limpa e bem formatada.\n- Não inclua explicações, comentários ou metadados.\n- O resultado deve estar pronto para envio como está.\n\nEtapa 4: Crie um rascunho de resposta na conta de e-mail em que o e-mail chegou, para revisão.",
        "outcome": "Todo e-mail que merece resposta já tem um rascunho esperando por você.",
        "landsIn": "Sua caixa de entrada, como rascunho",
        "needs": "Uma conta do Gmail conectada"
      },
      "smartDoboxPipeline": {
        "title": "Pipeline inteligente do DoBox",
        "description": "Valide automaticamente, verifique entradas existentes e gere tarefas a partir das suas comunicações"
      },
      "dailyUnreadSummary": {
        "title": "Resumo diário de não lidos",
        "description": "Receba um resumo dos e-mails não lidos toda manhã",
        "prompt": "Crie um fluxo agendado que rode toda manhã às 8h e me envie um resumo de todos os e-mails não lidos das últimas 24 horas. O resumo deve ser enviado como um e-mail de notificação com os principais destaques, agrupados por urgência.",
        "outcome": "Toda manhã, seus e-mails não lidos já chegam resumidos para você.",
        "landsIn": "Sua caixa de entrada, como um e-mail matinal",
        "needs": "Uma conta do Gmail conectada"
      },
      "vipEmailAlerts": {
        "title": "Alertas de e-mails VIP",
        "description": "Seja notificado no Slack quando chegar um e-mail de alguém importante para você.",
        "prompt": "Monitore minha caixa de entrada em busca de e-mails de remetentes e domínios específicos que considero VIPs. Quando um deles chegar, envie imediatamente uma mensagem no Slack em um canal privado com o remetente, o assunto, uma prévia e um link para abrir o e-mail. Comece me perguntando quais e-mails e domínios monitorar.",
        "outcome": "No momento em que alguém importante te manda um e-mail, você recebe um aviso no Slack.",
        "landsIn": "Slack, como mensagem direta",
        "needs": "Gmail · Slack"
      },
      "autoLabelActionItems": {
        "title": "Etiquetar itens de ação automaticamente",
        "description": "Etiquete automaticamente e-mails que exigem ação",
        "prompt": "Crie um fluxo que etiquete automaticamente e-mails contendo itens de ação. Quando chegar um e-mail que exija alguma ação minha, adicione a etiqueta 'Ação necessária' a ele.",
        "outcome": "E-mails que exigem uma ação já chegam rotulados antes de você abrir a caixa de entrada.",
        "landsIn": "Sua caixa de entrada, como um rótulo",
        "needs": "Uma conta do Gmail conectada"
      },
      "draftReply": {
        "title": "Rascunhar resposta",
        "description": "Rascunhe automaticamente respostas para e-mails que precisam de retorno, no seu estilo de escrita",
        "prompt": "Crie um fluxo acionado apenas por e-mails da categoria Principal (CATEGORY_PERSONAL). Quando um e-mail da categoria Principal chegar, determine se ele exige resposta — ignore notificações automáticas, remetentes no-reply, conversas já concluídas e mensagens com a etiqueta SENT. Se uma resposta for necessária, carregue meus últimos 5 e-mails enviados para entender meu estilo de escrita, tom e idioma. Depois, rascunhe uma resposta que corresponda a como escrevo naturalmente, mantendo o mesmo idioma do e-mail original. Salve o rascunho na minha conta de e-mail, pronto para eu revisar e enviar.",
        "outcome": "Suas respostas já saem rascunhadas, no seu tom, esperando uma leitura rápida.",
        "landsIn": "Sua caixa de entrada, como rascunho",
        "needs": "Uma conta do Gmail conectada"
      },
      "meetingActionItems": {
        "title": "Itens de ação de reuniões",
        "description": "Extraia tarefas de e-mails de resumo de reunião",
        "prompt": "Quando chegar um e-mail do Gemini, Granola, Fireflies, Otter, Fathom ou de qualquer outro assistente de notas de reunião, analise o corpo do e-mail em busca de itens de ação. Para cada item de ação detectado, crie uma entrada no DoBox com a ação como título, um link de referência para o e-mail de origem e — se houver um prazo mencionado — defina o prazo de acordo. Agrupe as entradas criadas para que o usuário veja que todas vieram da mesma reunião.",
        "outcome": "Cada item de ação das notas da reunião vira uma tarefa automaticamente.",
        "landsIn": "DoBox, como tarefas",
        "needs": "Uma conta do Gmail conectada"
      },
      "followUpTracker": {
        "title": "Rastreador de follow-ups",
        "description": "Acompanhe e-mails que precisam de follow-up",
        "prompt": "Todo dia útil às 9h, verifique todos os e-mails que enviei nos últimos 7 dias e que não receberam resposta. Para cada um, crie uma entrada no DoBox com o título 'Fazer follow-up com <destinatário>', com o assunto original como contexto e um lembrete com prazo para hoje. Ignore e-mails marcados como informativos ou newsletters.",
        "outcome": "E-mails que ainda não tiveram resposta viram um lembrete de follow-up sozinhos.",
        "landsIn": "DoBox, como lembrete",
        "needs": "Uma conta do Gmail conectada"
      },
      "channelDigest": {
        "title": "Resumo de canais",
        "description": "Resumo diário dos canais importantes do Slack",
        "prompt": "Crie um fluxo que me envie um resumo diário das mensagens importantes do Slack dos meus canais. Resuma as principais discussões e destaque tudo o que precisar da minha atenção.",
        "outcome": "Seus canais do Slack já chegam resumidos antes de você conferir.",
        "landsIn": "Slack, como mensagem direta",
        "needs": "Um workspace do Slack conectado"
      },
      "slackToDobox": {
        "title": "Slack para DoBox",
        "description": "Converta mensagens importantes do Slack em itens do DoBox"
      },
      "morningBriefing": {
        "title": "Briefing matinal",
        "description": "Acorde com um resumo de 30 segundos de todas as mensagens do Slack e e-mails que chegaram durante a noite.",
        "prompt": "Todo dia útil às 8h, verifique todos os canais do Slack que sigo e minha caixa de entrada principal em busca de mensagens recebidas desde a noite anterior. Agrupe por urgência e me envie um briefing com as 3 coisas mais importantes que preciso saber e as ações necessárias.",
        "outcome": "Acorde já sabendo o punhado de coisas que realmente precisam da sua atenção hoje.",
        "landsIn": "Sua caixa de entrada, como um briefing",
        "needs": "Gmail · Slack"
      },
      "endOfDayReport": {
        "title": "Relatório de fim de dia",
        "description": "Um resumo dos e-mails e reuniões do seu dia, enviado para a sua caixa toda noite.",
        "prompt": "Toda semana, de segunda a sexta às 18h, reúna os e-mails que recebi e enviei hoje e as reuniões de hoje na minha agenda. Agrupe pelo que ainda depende de mim e me envie um resumo por e-mail com as contagens, as threads esperando minha resposta, e o que eu assumi em reunião.",
        "outcome": "Toda noite você recebe um apanhado do que entrou, do que você enviou e do que ainda depende de você.",
        "landsIn": "Sua caixa de entrada, como um e-mail no fim do dia",
        "needs": "Uma conta do Gmail conectada"
      }
    },
    "agentType": "Agente",
    "useAgent": "Usar agente",
    "openAgent": "Abrir agente",
    "agents": {
      "toolsLabel": "Ferramentas utilizadas",
      "leadResearcher": {
        "title": "Pesquisador de Leads",
        "description": "Pesquisa uma empresa ou pessoa na web e nos contatos do CRM e devolve um briefing estruturado.",
        "outcome": "Pergunte sobre qualquer empresa ou contato e receba um briefing pronto para usar.",
        "landsIn": "A conversa, como um briefing estruturado",
        "needs": "Conexão de busca na web (Tavily) · seus contatos do CRM"
      },
      "emailTriageAssistant": {
        "title": "Assistente de Triagem de E-mails",
        "description": "Analisa sua caixa de entrada recente, sinaliza o que precisa de resposta ou ação e cria tarefas no DoBox para itens acionáveis.",
        "outcome": "Rode e sua caixa de entrada é triada, com tarefas já esperando no DoBox.",
        "landsIn": "DoBox, como tarefas — mais um resumo na conversa",
        "needs": "Uma conta do Gmail conectada"
      },
      "dailySlackDigest": {
        "title": "Resumo Diário do Slack",
        "description": "Resume as conversas importantes do Slack do dia anterior, as decisões tomadas e as perguntas em aberto em um resumo conciso.",
        "outcome": "Fique por dentro do Slack de ontem em um resumo curto, sem precisar rolar tudo.",
        "landsIn": "A conversa, ou uma mensagem direta no Slack",
        "needs": "Um workspace do Slack conectado"
      },
      "followUpWriter": {
        "title": "Redator de Follow-up",
        "description": "Redige e-mails de follow-up educados e contextualizados para conversas que pararam de responder.",
        "outcome": "Um follow-up educado e direto ao ponto é rascunhado para toda conversa que esfriou.",
        "landsIn": "Sua caixa de entrada, como rascunhos",
        "needs": "Uma conta do Gmail conectada"
      },
      "knowledgeCurator": {
        "title": "Curador de Conhecimento",
        "description": "Transforma anotações e conversas soltas em páginas organizadas no Brain e mantém o espaço de conhecimento arrumado.",
        "outcome": "Notas bagunçadas entram, uma página organizada no Brain sai.",
        "landsIn": "Brain, como páginas organizadas",
        "needs": "Notas ou uma conversa para organizar"
      },
      "meetingPrepAssistant": {
        "title": "Assistente de Preparação de Reuniões",
        "description": "Reúne o contexto dos participantes a partir do CRM e de e-mails anteriores antes de cada reunião e gera uma nota de preparação de uma página.",
        "outcome": "Entre em cada reunião com uma página de briefing sobre quem você vai encontrar.",
        "landsIn": "A conversa, como uma nota de preparação de uma página",
        "needs": "Agenda · Gmail · seus contatos do CRM"
      },
      "performanceReporter": {
        "title": "Relator de Performance",
        "description": "Transforma os números de marketing que você já tem em uma leitura escrita curta, e entrega cada versão na profundidade certa para cada público.",
        "outcome": "Um conjunto de números vira a manchete da liderança, o detalhe do time e o update do cliente, sem reescrever o mesmo e-mail três vezes.",
        "landsIn": "Slack e e-mail, com o texto salvo no seu Brain",
        "needs": "Slack · Gmail ou Outlook · Brain"
      },
      "battlecardKeeper": {
        "title": "Guardião de Battlecards",
        "description": "Responde as perguntas de concorrência do time de vendas a partir dos seus battlecards, e atualiza a página com o que precisou pesquisar.",
        "outcome": "Vendas recebe o posicionamento acordado no canal em que perguntou, e o battlecard para de envelhecer entre trimestres.",
        "landsIn": "Slack, com a página de battlecard atualizada no seu Brain",
        "needs": "Slack · Brain · conexão de busca web (Tavily)"
      },
      "experimentLogger": {
        "title": "Registro de Experimentos",
        "description": "Captura o resultado de cada teste de marketing em um log estruturado, para ninguém repetir um teste que já foi respondido.",
        "outcome": "\"A gente já testou isso?\" passa a ter resposta com data e número, em vez de um dar de ombros.",
        "landsIn": "Seu Brain, como um log trimestral de experimentos",
        "needs": "Brain · Slack"
      },
      "supportInboxTriage": {
        "title": "Triagem da Caixa de Suporte",
        "description": "Faz a triagem da caixa compartilhada de suporte: classifica cada mensagem, aplica etiqueta, rascunha as respostas fáceis e abre tarefa para o que precisa de gente.",
        "outcome": "Você começa o dia com uma fila organizada em vez de uma pilha indistinta de não lidos.",
        "landsIn": "Seu e-mail, como etiquetas e rascunhos, mais uma fila no DoBox",
        "needs": "Gmail ou Outlook · DoBox"
      },
      "supportReplyComposer": {
        "title": "Redator de Respostas de Suporte",
        "description": "Escreve respostas de suporte fundamentadas nas respostas documentadas do seu Brain, cita as páginas que usou e avisa quando falta documentação.",
        "outcome": "A mesma pergunta recebe a mesma boa resposta sempre, e você descobre quais artigos ainda faltam escrever.",
        "landsIn": "Seu e-mail, como rascunho de resposta com as fontes",
        "needs": "Gmail ou Outlook · Brain"
      },
      "escalationPackager": {
        "title": "Empacotador de Escalações",
        "description": "Transforma uma thread bagunçada de cliente em um relatório de bug pronto para engenharia, com passos de reprodução, ambiente e evidências — e abre a issue.",
        "outcome": "Engenharia pega a sua escalação sem devolver pedindo mais detalhe.",
        "landsIn": "Seu rastreador de engenharia quando houver uma conexão MCP de issue tracker, com o link publicado de volta no Slack",
        "needs": "Gmail ou Outlook · Slack · Brain · conexão GitHub"
      },
      "voiceOfCustomerAnalyst": {
        "title": "Analista de Voz do Cliente",
        "description": "Lê um mês de e-mail de suporte e de Slack com clientes e reporta os três ou quatro temas que produto precisa mesmo ouvir.",
        "outcome": "Produto recebe temas com evidência e contagem de contas, não os seus três casos mais barulhentos.",
        "landsIn": "Seu Brain como página datada, mais uma versão curta no Slack",
        "needs": "Gmail ou Outlook · Slack · Brain"
      },
      "invoiceApprovalChaser": {
        "title": "Cobrador de Aprovação de NF",
        "description": "Encontra notas de fornecedor paradas na sua caixa, transforma cada uma em tarefa rastreada e cobra o aprovador até o lote de pagamento ficar pronto.",
        "outcome": "Você entra no lote semanal de pagamento sabendo exatamente o que está aprovado e quem está segurando o resto.",
        "landsIn": "DoBox, uma tarefa por nota, com a cobrança feita no Slack",
        "needs": "Gmail ou Outlook · Slack · DoBox"
      },
      "paymentChangeVerifier": {
        "title": "Verificador de Troca de Pagamento",
        "description": "Pega qualquer e-mail pedindo troca de dados bancários ou de pagamento, coloca em quarentena e te entrega um checklist de verificação fora da thread.",
        "outcome": "Uma troca de dados bancários de fornecedor nunca é executada com base só na palavra de uma thread de e-mail.",
        "landsIn": "Um alerta no Slack, uma etiqueta de quarentena e um checklist no DoBox",
        "needs": "Gmail ou Outlook · Slack · DoBox · Brain · seus contatos do CRM"
      },
      "vendorDocumentChaser": {
        "title": "Cobrador de Documentos de Fornecedor",
        "description": "Pede os documentos cadastrais e fiscais que todo fornecedor novo deve, acompanha quem respondeu e recobra quem não respondeu.",
        "outcome": "Fornecedor novo fica documentado antes do primeiro pagamento, e o fim de ano não vira correria.",
        "landsIn": "Seu registro de fornecedores no Brain, com os pedidos por e-mail",
        "needs": "Gmail ou Outlook · Brain"
      },
      "boardPackWriter": {
        "title": "Redator do Pacote do Board",
        "description": "Coleta o update mensal de cada área, redige a narrativa em torno dos números que você fornece e monta o pacote do board.",
        "outcome": "O pacote do board fica pronto antes da reunião, não na véspera dela.",
        "landsIn": "Seu Brain, como um pacote datado pronto para revisão",
        "needs": "Slack · Gmail ou Outlook · Brain · Calendário"
      },
      "actionItemCloser": {
        "title": "Fechador de Action Items",
        "description": "Transforma cada compromisso de reunião em tarefa com dono e prazo, e traz de volta à tona os que não andaram.",
        "outcome": "Nada decidido em reunião desaparece em silêncio — todo compromisso tem nome, data e follow-up.",
        "landsIn": "DoBox, uma tarefa por compromisso, com snapshot semanal no Slack",
        "needs": "Google ou Outlook Calendar · Slack · DoBox"
      },
      "opsIntakeRouter": {
        "title": "Roteador de Pedidos de Ops",
        "description": "Transforma pedidos de operações espalhados por Slack e e-mail em uma fila priorizada, confirma para cada solicitante e sinaliza o que está atrasado.",
        "outcome": "Todo pedido tem ticket, dono e prazo de resposta — e você finalmente consegue dizer quantos entraram na semana.",
        "landsIn": "DoBox como a fila, com as confirmações enviadas no Slack",
        "needs": "Slack · Gmail ou Outlook · DoBox"
      },
      "runbookKeeper": {
        "title": "Guardião de Runbooks",
        "description": "Responde \"como a gente faz X?\" a partir do Brain, e escreve o runbook que faltava sempre que a resposta teve que vir de uma pessoa.",
        "outcome": "Toda pergunta de processo que você responde uma vez vira página que qualquer um acha, e runbook velho é sinalizado.",
        "landsIn": "Seu Brain, como páginas de runbook sob um pai comum",
        "needs": "Brain · Slack ou Gmail"
      },
      "peoplePolicyAssistant": {
        "title": "Assistente de Políticas de RH",
        "description": "Responde dúvidas de política interna a partir do handbook no seu Brain, com a página de origem anexada.",
        "outcome": "As mesmas vinte perguntas param de cair na sua DM, e todo mundo recebe a mesma resposta.",
        "landsIn": "No mesmo canal em que a pergunta chegou",
        "needs": "Brain · Slack · Gmail ou Outlook"
      },
      "candidateScreener": {
        "title": "Triador de Candidatos",
        "description": "Lê as candidaturas que chegam e escreve uma nota de triagem baseada em evidência, medida contra os requisitos escritos da vaga.",
        "outcome": "Toda candidatura recebe uma primeira leitura consistente, e o seu tempo vai para a shortlist em vez da pilha.",
        "landsIn": "DoBox, como nota de triagem e tarefa de decisão",
        "needs": "Gmail ou Outlook · Brain · DoBox"
      },
      "reviewEvidenceCollector": {
        "title": "Coletor de Evidências de Avaliação",
        "description": "Reúne seis meses do que a pessoa de fato fez — entregas, decisões, feedback — em um dossiê datado antes do ciclo de avaliação.",
        "outcome": "Gestores escrevem a avaliação a partir de um período documentado, não das últimas três semanas que lembram.",
        "landsIn": "Uma página privada no Brain — nunca um canal",
        "needs": "Slack · Gmail ou Outlook · Brain · DoBox"
      },
      "offboardingCoordinator": {
        "title": "Coordenador de Desligamento",
        "description": "Monta o plano completo de saída a partir de um nome e um último dia — repasse, ativos, entrevista de saída, pedidos de acesso.",
        "outcome": "Nada sobre uma saída é descoberto uma semana depois de a pessoa já ter ido.",
        "landsIn": "DoBox e Calendário, com uma página de handover no seu Brain",
        "needs": "Google ou Outlook Calendar · Slack · Brain · DoBox"
      },
      "legalIntakeTriager": {
        "title": "Triador de Demandas Jurídicas",
        "description": "Transforma cada \"pergunta rápida\" em uma demanda jurídica completa e rastreada antes de chegar na sua mesa.",
        "outcome": "Você para de perguntar quem é a contraparte pela terceira vez.",
        "landsIn": "DoBox, com o que falta sendo pedido na thread original",
        "needs": "Slack · Gmail ou Outlook · DoBox"
      },
      "contractDeadlineWatcher": {
        "title": "Vigia de Prazos Contratuais",
        "description": "Lê os contratos assinados conforme chegam, registra as datas que importam e avisa antes de a janela de aviso fechar.",
        "outcome": "Você descobre uma renovação automática sessenta dias antes, não sessenta dias depois.",
        "landsIn": "Um registro de contratos no seu Brain, mais DoBox e seu calendário",
        "needs": "Gmail ou Outlook · Slack · Brain · DoBox · Calendário"
      },
      "legalPlaybookAnswerer": {
        "title": "Respondedor do Playbook Jurídico",
        "description": "Responde dúvidas jurídicas rotineiras com a posição que o seu time já aprovou, e escala as que ainda não têm posição.",
        "outcome": "A mesma pergunta para de chegar até você pela quinta vez no mês.",
        "landsIn": "A thread original no Slack, ou uma mensagem privada quando escala",
        "needs": "Brain · Slack"
      },
      "privacyRequestClerk": {
        "title": "Atendente de Pedidos de Privacidade",
        "description": "Registra todo pedido de titular de dados no dia em que chega e mantém o prazo legal à vista.",
        "outcome": "Você nunca descobre um pedido de titular no dia vinte e nove.",
        "landsIn": "DoBox, só metadados, com um rascunho de acuse no seu e-mail",
        "needs": "Gmail ou Outlook · DoBox · Slack"
      }
    },
    "meta": {
      "landsInLabel": "Chega em",
      "needsLabel": "Precisa de",
      "setupMinutes": "Configuração ~{{count}} min",
      "setupInstant": "Configuração em um clique"
    },
    "integrationApps": {
      "email": "E-mail",
      "slack": "Slack",
      "calendar": "Agenda",
      "dobox": "DoBox",
      "brain": "Brain",
      "web": "Busca na web",
      "github": "GitHub"
    },
    "areas": {
      "engineering": "Engenharia",
      "hr_people": "RH & Pessoas",
      "sales": "Vendas",
      "marketing": "Marketing",
      "support_cs": "Suporte & CS",
      "finance": "Financeiro",
      "operations": "Operações",
      "legal": "Jurídico",
      "founder_leadership": "Fundador & Liderança",
      "everyone": "Todos"
    },
    "filters": {
      "allAreas": "Todas",
      "areasGroupLabel": "Filtrar por área",
      "runsWithLabel": "Funciona com",
      "runsWithGroupLabel": "Filtrar por app conectado"
    },
    "shelves": {
      "popularAll": "Populares",
      "popularForArea": "Populares com times de {{area}}",
      "biggerJobsAll": "Tarefas maiores",
      "biggerJobsForArea": "Tarefas maiores para {{area}}",
      "biggerJobsSubtitle": "Várias etapas, um resultado, instalado como um só",
      "seeAll": "Ver todos os {{count}}"
    }
  },
  "flowEditor": {
    "pageTitle": "Editor de fluxos",
    "untitledFlow": "Fluxo sem título",
    "starterRequired": "Selecione um iniciador (gatilho) antes de salvar o fluxo.",
    "systemFlowReadOnly": "Este é um fluxo do sistema. Você pode ativá-lo ou desativá-lo, mas não pode editar a configuração.",
    "systemSlackChannelsOnlyEditable": "Este é um fluxo do sistema. Você pode editar apenas a seleção de canais.",
    "systemEmailContactsOnlyEditable": "Este é um fluxo do sistema. Você pode alterar apenas se ele processa somente e-mails dos seus contatos.",
    "setupOnlyReadOnly": "Este fluxo rodou uma vez durante a configuração e não pode ser editado nem executado novamente. Você ainda pode ver o histórico de execuções.",
    "unsavedChanges": {
      "title": "Alterações não salvas",
      "description": "Você tem alterações não salvas. Deseja salvar antes de sair?",
      "save": "Salvar",
      "leave": "Sair"
    },
    "chooseStarter": "Escolha um iniciador",
    "addStep": "Adicionar etapa",
    "starter": {
      "title": "Escolha um iniciador",
      "description": "Selecione o que aciona este fluxo",
      "schedule": "Em um agendamento",
      "email": "Quando eu receber um e-mail",
      "tagApplied": "Quando uma tag for aplicada",
      "slackMessage": "Quando eu receber uma mensagem no Slack",
      "slack_message": "Quando eu receber uma mensagem no Slack",
      "slack": "Quando eu receber uma mensagem no Slack",
      "instagram": "Quando eu receber uma mensagem no Instagram",
      "instagram_content": "Quando alguém comentar na minha publicação do Instagram",
      "googleChat": "Quando eu receber uma mensagem no Google Chat",
      "google_chat": "Quando eu receber uma mensagem no Google Chat",
      "dobox": "Quando ocorrer um evento no DoBox",
      "manual": "Executar manualmente",
      "knowledge_page": "Quando uma nova página for criada",
      "github": "Quando ocorrer um evento no GitHub",
      "people": "Quando uma pessoa for criada",
      "google_business": "Quando eu receber uma avaliação no Google Business Profile",
      "facebook": "Quando alguém comentar na minha publicação do Facebook",
      "facebook_messenger": "Quando eu receber uma mensagem no Facebook",
      "lockedTooltip": "Apenas administradores ou proprietários da equipe podem criar este gatilho. Peça a um administrador para habilitá-lo.",
      "whatsapp": "Quando eu receber uma mensagem no WhatsApp",
      "teams": "Quando eu receber uma mensagem no Microsoft Teams"
    },
    "instagramTrigger": {
      "title": "Gatilho do Instagram",
      "description": "Executa quando uma nova mensagem direta do Instagram chega na conta selecionada.",
      "accountLabel": "Conta do Instagram",
      "accountPlaceholder": "Selecione uma conta do Instagram",
      "noAccountsTitle": "Conecte uma conta do Instagram",
      "noAccountsMessage": "Sua equipe ainda não tem uma conta do Instagram conectada.",
      "noAccountsCta": "Ir para Integrações",
      "changeStarter": "Alterar gatilho",
      "insufficientRoleError": "Apenas administradores ou proprietários do workspace podem criar gatilhos do Instagram.",
      "accountNotFoundError": "A conta do Instagram selecionada não está mais conectada a esta equipe.",
      "accountRequiredError": "Selecione uma conta do Instagram antes de salvar.",
      "executionType": "Tipo de execução",
      "immediate": "Imediata",
      "debounce": "Debounce",
      "debounceMinutes": "Atraso do debounce (minutos)",
      "onlyStoryReplies": "Apenas respostas a stories",
      "onlyStoryRepliesDescription": "Disparar este flow apenas para mensagens diretas que sejam respostas a um story do Instagram. As demais mensagens diretas são ignoradas."
    },
    "instagramContentTrigger": {
      "title": "Gatilho de comentário em post do Instagram",
      "description": "Executa quando alguém comenta em uma publicação da conta do Instagram selecionada.",
      "accountLabel": "Conta do Instagram",
      "accountPlaceholder": "Selecione uma conta do Instagram",
      "noAccountsTitle": "Conecte uma conta do Instagram",
      "noAccountsMessage": "Sua equipe ainda não tem uma conta do Instagram conectada.",
      "noAccountsCta": "Ir para Integrações",
      "postLabel": "Publicação (opcional)",
      "postPlaceholder": "ex.: 17895695668004550",
      "postHelperText": "Não foi possível carregar suas publicações recentes. Informe o ID da publicação do Instagram manualmente. Deixe em branco para acionar em comentários de qualquer publicação desta conta.",
      "anyPostOption": "Qualquer publicação",
      "postLoadingHelperText": "Carregando suas publicações recentes…",
      "postSelectHelperText": "Escolha uma publicação específica para restringir este gatilho a ela, ou mantenha Qualquer publicação selecionada para acionar em comentários de qualquer publicação desta conta.",
      "changeStarter": "Alterar gatilho"
    },
    "doboxTrigger": {
      "title": "Gatilho do DoBox",
      "description": "Configure quando este fluxo deve ser acionado com base na atividade do DoBox",
      "triggerType": "Tipo de evento",
      "doboxCreated": "DoBox criado",
      "commentAdded": "Comentário adicionado",
      "participantAdded": "Membro adicionado",
      "labelAdded": "Etiqueta adicionada",
      "labelRemoved": "Etiqueta removida",
      "taskGroupChanged": "Lista alterada",
      "taskGroupScope": "Aplicar às listas",
      "taskGroupScopeAll": "Todas as listas",
      "taskGroupScopeSelected": "Listas selecionadas",
      "selectTaskGroups": "Selecionar listas",
      "selectTaskGroupsPlaceholder": "Escolha uma ou mais listas",
      "selectLabels": "Selecionar etiquetas",
      "selectLabelsPlaceholder": "Escolha uma ou mais etiquetas",
      "changeStarter": "Alterar iniciador",
      "doboxResolved": "DoBox concluído",
      "doboxApproved": "DoBox aprovado",
      "doboxRejected": "DoBox rejeitado",
      "doboxReopened": "DoBox reaberto"
    },
    "githubTrigger": {
      "title": "Gatilho do GitHub",
      "description": "Executa quando um evento de pull request, issue, revisão ou release acontece na instalação do GitHub selecionada.",
      "loading": "Carregando instalações do GitHub…",
      "loadError": "Não foi possível carregar suas instalações do GitHub. Feche e abra o gatilho novamente para tentar de novo.",
      "installationsLabel": "Instalações do GitHub",
      "installationsHint": "Escolha as instalações a observar e, se quiser, restrinja cada uma a repositórios específicos. Deixe todas desmarcadas para observar todas as instalações.",
      "installationLabel": "Instalação do GitHub",
      "installationPlaceholder": "Selecione uma instalação do GitHub",
      "eventsLabel": "Eventos",
      "actionsLabel": "Ações",
      "anyEventHint": "Deixe vazio para corresponder a qualquer evento",
      "anyActionHint": "Deixe vazio para corresponder a qualquer ação",
      "eventsSubtitle": "Ative um evento e escolha quais das ações dele disparam o fluxo.",
      "off": "Desativado",
      "anyAction": "Qualquer ação",
      "actionsForThisEvent": "Ações deste evento",
      "removeTag": "Remover {{value}}",
      "repositories": {
        "label": "Repositórios",
        "placeholder": "owner/repo",
        "hint": "Deixe vazio para observar todos os repositórios desta instalação, inclusive os criados depois."
      },
      "refPatterns": {
        "release": {
          "label": "Tags de release",
          "placeholder": "prod-all-*",
          "hint": "Digite uma tag e pressione Enter ou vírgula. Use * como curinga. Deixe vazio para corresponder a qualquer tag."
        },
        "push": {
          "label": "Branches",
          "placeholder": "main",
          "hint": "Digite uma branch e pressione Enter ou vírgula. Use * como curinga. Deixe vazio para observar apenas a branch padrão."
        }
      },
      "changeStarter": "Alterar gatilho",
      "noAccountsTitle": "Conecte uma instalação do GitHub",
      "noAccountsMessage": "Sua equipe ainda não tem uma instalação do GitHub conectada.",
      "noAccountsCta": "Ir para Integrações",
      "events": {
        "pullRequest": "Pull request",
        "pullRequestReview": "Revisão de pull request",
        "issues": "Issue",
        "issueComment": "Comentário em issue",
        "release": "Release",
        "push": "Push"
      },
      "actions": {
        "opened": "Aberto",
        "reopened": "Reaberto",
        "closed": "Fechado",
        "merged": "Mesclado",
        "assigned": "Atribuído",
        "reviewRequested": "Revisão solicitada",
        "submitted": "Enviado",
        "created": "Criado",
        "deleted": "Excluído",
        "published": "Publicado",
        "pushed": "Push realizado"
      }
    },
    "gbpTrigger": {
      "title": "Gatilho do Google Business Profile",
      "description": "Executa quando uma avaliação é publicada ou atualizada em um local conectado do Google Business Profile.",
      "triggerType": "Tipo de gatilho",
      "newReview": "Nova avaliação",
      "updatedReview": "Avaliação atualizada",
      "changeStarter": "Alterar gatilho",
      "noAccountsTitle": "Conecte o Google Business Profile",
      "noAccountsMessage": "Sua conta ainda não tem um Google Business Profile conectado.",
      "noAccountsCta": "Ir para Integrações"
    },
    "facebookTrigger": {
      "title": "Gatilho de comentário em post de página do Facebook",
      "description": "Executa quando alguém comenta em uma publicação de uma página do Facebook conectada.",
      "pageLabel": "Página do Facebook",
      "pagePlaceholder": "Selecione uma página do Facebook",
      "noPagesTitle": "Conecte uma página do Facebook",
      "noPagesMessage": "Sua equipe ainda não tem uma página do Facebook conectada.",
      "noPagesCta": "Ir para Integrações",
      "changeStarter": "Alterar gatilho",
      "pageRequiredError": "Selecione uma página do Facebook antes de salvar."
    },
    "facebookMessengerTrigger": {
      "title": "Gatilho do Facebook",
      "description": "Executa quando uma nova mensagem direta do Facebook chega na página selecionada.",
      "pageLabel": "Página do Facebook",
      "pagePlaceholder": "Selecione uma página do Facebook",
      "noPagesTitle": "Conecte uma página do Facebook",
      "noPagesMessage": "Sua equipe ainda não tem uma página do Facebook conectada.",
      "noPagesCta": "Ir para Integrações",
      "changeStarter": "Alterar gatilho",
      "pageRequiredError": "Selecione uma página do Facebook antes de salvar.",
      "executionType": "Tipo de execução",
      "immediate": "Imediata",
      "debounce": "Debounce",
      "debounceMinutes": "Atraso do debounce (minutos)"
    },
    "slackTrigger": {
      "title": "Gatilho do Slack",
      "description": "Configure quando este fluxo deve ser acionado com base nas mensagens recebidas no Slack",
      "triggerType": "Tipo de gatilho",
      "allMessages": "Todas as mensagens do Slack",
      "channelMatch": "Correspondência de canal",
      "authorMatch": "Correspondência de autor",
      "workspace": "Workspace",
      "workspacePlaceholder": "Selecione um workspace",
      "channel": "Canal",
      "channelPlaceholder": "Selecione um canal",
      "author": "Autor",
      "authorPlaceholder": "Selecione uma pessoa",
      "loadingOptions": "Carregando opções...",
      "executionType": "Tipo de execução",
      "immediate": "Imediata",
      "debounce": "Debounce",
      "channels": "Canais",
      "channelsAllHelp": "Deixe vazio para observar todos os canais",
      "changeStarter": "Alterar iniciador",
      "workspacesScopeLabel": "Workspaces e canais",
      "allWorkspacesHelp": "Observando todos os workspaces e todos os canais. Selecione workspaces abaixo para restringir.",
      "allChannelsHelp": "Todos os canais deste workspace. Escolha canais para restringir.",
      "includeWorkspace": "Incluir este workspace"
    },
    "googleChatTrigger": {
      "title": "Gatilho do Google Chat",
      "description": "Configure quando este fluxo deve ser acionado com base nas mensagens recebidas no Google Chat",
      "triggerType": "Tipo de gatilho",
      "allMessages": "Todas as mensagens do Google Chat",
      "spaceMatch": "Correspondência de espaço",
      "authorMatch": "Correspondência de autor",
      "account": "Conta do Google",
      "accountPlaceholder": "Selecione uma conta do Google",
      "space": "Espaço",
      "spaceForAuthor": "Espaço",
      "spacePlaceholder": "Selecione um espaço",
      "spaceForAuthorPlaceholder": "Selecione um espaço",
      "author": "Autor",
      "authorPlaceholder": "Selecione uma pessoa",
      "loadingAccounts": "Carregando contas...",
      "loadingOptions": "Carregando opções...",
      "executionType": "Tipo de execução",
      "immediate": "Imediata",
      "debounce": "Debounce",
      "connectTitle": "Conecte sua conta do Google",
      "connectDescription": "Automatize ações com base em mensagens do Google Chat — processe atualizações, alertas e resumos dos seus espaços como parte do fluxo.",
      "connectButton": "Conectar Google",
      "changeStarter": "Alterar iniciador"
    },
    "teamsTrigger": {
      "title": "Gatilho do Microsoft Teams",
      "description": "Configure quando este fluxo deve ser disparado por novas mensagens de chat do Microsoft Teams. Mensagens enviadas por você não o disparam.",
      "account": "Conta do Microsoft",
      "allAccounts": "Todas as contas",
      "chatsSectionLabel": "Chats",
      "limitToChats": "Limitar a chats específicos",
      "chats": "Chats",
      "chatsPlaceholder": "Selecione os chats",
      "chatsSearchPlaceholder": "Buscar chats",
      "chatsEmptyMessage": "Nenhum chat encontrado",
      "chatsSelectionRequired": "Selecione ao menos um chat",
      "chatsSelectionRequiredError": "Selecione ao menos um chat no gatilho do Microsoft Teams antes de salvar.",
      "untitledChat": "Chat sem título",
      "executionType": "Tipo de execução",
      "immediate": "Imediata",
      "debounce": "Debounce",
      "debounceMinutes": "Atraso do debounce (minutos)",
      "noAccountsTitle": "Conecte o Microsoft Teams",
      "noAccountsMessage": "Você ainda não tem uma conta do Microsoft Teams conectada. Vá para Integrações para conectar uma.",
      "noAccountsCta": "Ir para Integrações",
      "changeStarter": "Alterar iniciador"
    },
    "emailTrigger": {
      "title": "Gatilho de e-mail",
      "description": "Configure quando este fluxo deve ser acionado com base nos e-mails recebidos",
      "triggerType": "Tipo de gatilho",
      "primaryInbox": "Caixa de entrada principal",
      "allEmails": "Todos os e-mails",
      "labelMatch": "Correspondência de etiqueta",
      "labelMatchPlaceholder": "ex.: Importante, Newsletter...",
      "categoryMatch": "Correspondência de categoria",
      "emailMatch": "Correspondência de e-mail do remetente",
      "emailMatchPlaceholder": "ex.: john@example.com",
      "domainMatch": "Correspondência de domínio do remetente",
      "domainMatchPlaceholder": "ex.: example.com",
      "sentEmails": "E-mails enviados",
      "changeStarter": "Alterar iniciador",
      "emailAccountScope": "Aplicar às contas de e-mail",
      "allAccounts": "Todas as contas de e-mail",
      "selectedAccounts": "Contas de e-mail selecionadas",
      "contactFilter": {
        "toggleLabel": "Apenas dos meus contatos"
      },
      "directToFilter": {
        "toggleLabel": "Apenas quando eu for destinatário direto"
      }
    },
    "knowledgePageTrigger": {
      "starterLabel": "Quando uma nova página for criada",
      "title": "Nova página de conhecimento",
      "description": "Execute este fluxo sempre que uma nova página for criada em um espaço de conhecimento.",
      "spaceLabel": "Espaço",
      "spacePlaceholder": "Selecione um espaço…",
      "spaceTeamBadge": "equipe",
      "parentPageLabel": "Página pai (opcional)",
      "parentPagePlaceholder": "Qualquer página do espaço",
      "parentPageHelp": "Deixe em branco para corresponder a qualquer página do espaço. Quando definido, corresponde a qualquer página em qualquer nível abaixo desta (filhas, netas etc.).",
      "missingSpaceError": "Escolha um espaço para continuar.",
      "changeStarter": "Alterar gatilho (página de conhecimento)"
    },
    "contentFilter": {
      "title": "Filtro de conteúdo",
      "description": "Acione apenas quando o conteúdo da mensagem corresponder a uma condição.",
      "typeLabel": "Tipo de filtro",
      "typeKeyword": "Palavra-chave (contém)",
      "typeRegex": "Regex (correspondência de padrão)",
      "fieldLabel": "Buscar em",
      "fieldAny": "Qualquer campo",
      "fieldSubject": "Assunto",
      "fieldMessage": "Corpo da mensagem",
      "fieldAuthor": "Nome do autor",
      "fieldAuthorEmail": "E-mail do autor",
      "keywordLabel": "Palavra-chave",
      "keywordPlaceholder": "ex.: github, urgente, /review-pr",
      "regexLabel": "Padrão regex",
      "regexPlaceholder": "ex.: ^URGENTE:|review-pr\\s+#\\d+",
      "regexInvalid": "Este regex é inválido ou potencialmente inseguro. Simplifique o padrão (evite grupos aninhados como (a+)+ ).",
      "regexDocs": "Guia rápido de regex",
      "testLabel": "Teste seu regex",
      "testPlaceholder": "Cole uma mensagem de exemplo para testar...",
      "testMatch": "Corresponde!",
      "testNoMatch": "Sem correspondência",
      "logicLabel": "Modo do filtro",
      "logicInclude": "Incluir — aciona apenas quando o conteúdo corresponde",
      "logicExclude": "Excluir — ignora quando o conteúdo corresponde",
      "descriptionExclude": "Deixe de acionar quando o conteúdo da mensagem corresponder a uma condição."
    },
    "schedule": {
      "title": "Em um agendamento",
      "description": "Comece em uma data e hora definidas. Execute uma única vez ou repita em um agendamento.",
      "presetMondayMorning": "Segunda-feira às 8h",
      "presetWeekdays": "Dias úteis às 8h",
      "presetIn10Min": "Em 10 minutos",
      "startTooSoonError": "Para um agendamento único, escolha um início pelo menos {{minutes}} minutos no futuro.",
      "startDateAndTime": "Data e hora de início",
      "date": "Data",
      "time": "Hora",
      "repeat": "Repetir",
      "doesNotRepeat": "Não se repete",
      "everyHour": "A cada hora",
      "daily": "Diariamente",
      "weekly": "Semanalmente",
      "monthly": "Mensalmente",
      "customDays": "Dias personalizados",
      "selectDays": "Executar nestes dias",
      "dayMon": "Seg",
      "dayTue": "Ter",
      "dayWed": "Qua",
      "dayThu": "Qui",
      "dayFri": "Sex",
      "daySat": "Sáb",
      "daySun": "Dom",
      "repeatHelperText": "Para repetições diárias ou menos frequentes, as execuções começam em até 3 minutos do horário definido",
      "ends": "Termina",
      "ends1Week": "1 semana",
      "ends1Month": "1 mês",
      "ends3Months": "3 meses",
      "ends6Months": "6 meses",
      "endsNever": "Nunca",
      "changeStarter": "Alterar iniciador"
    },
    "steps": {
      "title": "Adicionar uma etapa",
      "description": "Escolha uma ação para adicionar ao seu fluxo",
      "AI_ASK": "Perguntar à IA",
      "DECIDE": "Decidir",
      "SUMMARIZE": "Resumir",
      "CHECK_IF": "Verificar se",
      "FORWARD": "Encaminhar",
      "ARCHIVE": "Arquivar",
      "NOTIFY_EMAIL": "Notificar por e-mail",
      "DRAFT_EMAIL": "Criar rascunho de e-mail",
      "DRAFT_REPLY": "Criar rascunho de resposta",
      "ADD_LABEL": "Adicionar etiqueta",
      "ADD_LABELS": "Adicionar etiquetas",
      "REMOVE_LABEL": "Remover etiqueta",
      "REMOVE_LABELS": "Remover etiquetas",
      "DELETE": "Excluir",
      "MARK_READ": "Marcar como lido",
      "MARK_AS_UNREAD": "Marcar como não lido",
      "MARK_UNREAD": "Marcar como não lido",
      "CHANGE_CATEGORY": "Alterar categoria",
      "NOTIFY_BY_EMAIL": "Notificar por e-mail",
      "SEND_NOTIFICATION_EMAIL": "Enviar e-mail de notificação",
      "SEND_EMAIL": "Enviar e-mail",
      "SEND_SLACK_MESSAGE": "Enviar mensagem no Slack",
      "SEND_USER_SLACK_MESSAGE": "Enviar mensagem no Slack como você",
      "SEND_BOT_SLACK_MESSAGE": "Enviar mensagem no Slack como bot",
      "GENERATE_DOBOX": "Gerar DoBox",
      "CREATE_DOBOX": "Criar DoBox",
      "LOAD_DOBOX": "Carregar DoBox",
      "LOAD_COMMUNICATIONS": "Carregar comunicações",
      "RESOLVE_DOBOX": "Concluir DoBox",
      "ACCEPT_DOBOX_SUGGESTION": "Aceitar sugestão do DoBox",
      "ADD_DOBOX_COMMENT": "Adicionar comentário no DoBox",
      "UPDATE_DOBOX_PARTICIPANTS": "Atualizar participantes do DoBox",
      "UPDATE_DOBOX_LABELS": "Atualizar etiquetas do DoBox",
      "VALIDATE_DOBOX_RULES": "Validar regras do DoBox",
      "CLASSIFY_ACTIONABILITY": "Classificar acionabilidade",
      "RAG_SEARCH": "Busca RAG",
      "APPEND_TO_DOBOX": "Adicionar ao DoBox",
      "CHECK_AND_APPEND_DOBOX": "Verificar e adicionar",
      "PROCESS_DOBOX": "Processar DoBox",
      "SEND_INSTAGRAM_MESSAGE": "Enviar mensagem no Instagram",
      "REPLY_INSTAGRAM_COMMENT": "Responder a comentário do Instagram",
      "PUBLISH_INSTAGRAM_POST": "Publicar post no Instagram",
      "FOR_EACH": "Para cada",
      "MCP_TOOL_CALL": "Ferramenta MCP",
      "CALENDAR_RSVP": "Responder a convite de reunião",
      "CALENDAR_CREATE_EVENT": "Criar evento na agenda",
      "CALENDAR_DELETE_EVENT": "Excluir evento da agenda",
      "CALENDAR_RESCHEDULE_EVENT": "Reagendar evento",
      "CALENDAR_ADD_ATTENDEES": "Adicionar participantes",
      "CALENDAR_REMOVE_ATTENDEES": "Remover participantes",
      "calendarRsvpDescription": "Responda a um convite de evento da agenda (aceitar, recusar ou talvez). Funciona com agendas do Gmail e do Outlook.",
      "calendarCreateEventDescription": "Crie um novo evento na agenda com título, horário, participantes e local. Funciona com agendas do Gmail e do Outlook.",
      "calendarDeleteEventDescription": "Exclua ou cancele um evento da agenda. Opcionalmente notifica os participantes sobre o cancelamento.",
      "calendarRescheduleEventDescription": "Altere o horário de início e término de um evento existente da agenda.",
      "calendarAddAttendeesDescription": "Adicione novos participantes a um evento existente da agenda.",
      "calendarRemoveAttendeesDescription": "Remova participantes de um evento existente da agenda.",
      "calendarResponseStatus": "Status da resposta",
      "calendarResponseStatusPlaceholder": "Selecione um status de resposta",
      "calendarRsvpAccepted": "Aceito",
      "calendarRsvpDeclined": "Recusado",
      "calendarRsvpTentative": "Talvez",
      "calendarSummary": "Título do evento",
      "calendarSummaryPlaceholder": "ex.: Reunião diária da equipe",
      "calendarStartDateTime": "Data/hora de início (ISO 8601)",
      "calendarStartDateTimePlaceholder": "ex.: 2026-04-01T09:00:00",
      "calendarEndDateTime": "Data/hora de término (ISO 8601)",
      "calendarEndDateTimePlaceholder": "ex.: 2026-04-01T09:30:00",
      "calendarTimeZone": "Fuso horário",
      "calendarTimeZonePlaceholder": "ex.: America/Sao_Paulo",
      "calendarDescription": "Descrição",
      "calendarDescriptionPlaceholder": "Descrição do evento...",
      "calendarLocation": "Local",
      "calendarLocationPlaceholder": "ex.: Sala de reunião A",
      "calendarAttendees": "Participantes (e-mails separados por vírgula)",
      "calendarAttendeesPlaceholder": "ex.: alice@example.com, bob@example.com",
      "calendarSendCancellation": "Enviar cancelamento",
      "calendarSendCancellationPlaceholder": "Notificar os participantes sobre o cancelamento",
      "AGENT_TASK": "Tarefa de agente",
      "NOTIFY_ASSISTANT": "Notificar assistente",
      "ASK_USER": "Perguntar ao usuário",
      "APPROVAL_GATE": "Ponto de aprovação",
      "RUN_ASSISTANT": "Executar assistente",
      "LOAD_MEETINGS": "Carregar reuniões",
      "LOAD_TEAM_MEMBERS": "Carregar membros da equipe",
      "CHECK_TEAM_CALENDAR": "Consultar agenda da equipe",
      "LOAD_KNOWLEDGE_PAGE": "Carregar página de conhecimento",
      "SEARCH_PEOPLE": "Buscar pessoas",
      "UPDATE_PERSON_NOTES": "Atualizar notas da pessoa",
      "LOAD_TEAM_PEOPLE": "Carregar pessoas da equipe",
      "searchPeopleDescription": "Busque seus contatos por nome, e-mail ou cargo. Combine os resultados com uma etapa Para cada para agir sobre cada correspondência.",
      "searchPeopleHelpTitle": "Pelo menos um campo é obrigatório",
      "searchPeopleHelpText": "Preencha nome, e-mail ou cargo (ou qualquer combinação) para refinar a busca. Não é permitido deixar os três vazios.",
      "searchPeopleNameLabel": "Nome",
      "searchPeopleNamePlaceholder": "ex.: Jane Doe ou {{step.step-0.output}}",
      "searchPeopleEmailLabel": "E-mail",
      "searchPeopleEmailPlaceholder": "ex.: jane@example.com",
      "searchPeopleJobTitleLabel": "Cargo",
      "searchPeopleJobTitlePlaceholder": "ex.: Gerente de produto",
      "searchPeopleMissingCriteriaError": "Preencha pelo menos um dos campos nome, e-mail ou cargo na etapa Buscar pessoas antes de salvar.",
      "updatePersonNotesDescription": "Adicione conteúdo às notas do perfil de uma pessoa ou substitua as notas existentes.",
      "updatePersonNotesPersonIdLabel": "ID da pessoa",
      "updatePersonNotesPersonIdPlaceholder": "ex.: {{person.id}}",
      "updatePersonNotesTemplateLabel": "Notas",
      "updatePersonNotesTemplatePlaceholder": "ex.: Follow-up agendado para {{step.step-0.output}}",
      "updatePersonNotesModeLabel": "Modo de escrita",
      "updatePersonNotesModePlaceholder": "Selecione um modo de escrita",
      "updatePersonNotesModeAppend": "Adicionar ao final (padrão)",
      "updatePersonNotesModeReplace": "Substituir",
      "updatePersonNotesMissingNotesError": "Preencha o modelo de notas na etapa Atualizar notas da pessoa antes de salvar.",
      "GBP_REPLY_REVIEW": "Responder avaliação",
      "gbpReplyReviewDescription": "Publique uma resposta (ou atualize a resposta existente) em uma avaliação do Google Business Profile.",
      "gbpReplyTextLabel": "Texto da resposta",
      "gbpReplyTextPlaceholder": "ex.: Obrigado pela avaliação, {{starter.gbp.authorName}}!",
      "gbpReplyTextMissingError": "Preencha o texto da resposta na etapa Responder avaliação antes de salvar.",
      "gbpReviewNameLabel": "Avaliação (opcional)",
      "gbpReviewNamePlaceholder": "ex.: {{starter.gbp.reviewName}}",
      "gbpReviewNameHelpTitle": "Por padrão, usa a avaliação do gatilho",
      "gbpReviewNameHelpText": "Deixe vazio para responder à avaliação que disparou este fluxo. Defina apenas para responder a uma avaliação diferente.",
      "PUBLISH_FACEBOOK_POST": "Publicar no Facebook",
      "facebookKindLabel": "Tipo de publicação",
      "facebookKindPlaceholder": "Selecione um tipo de publicação",
      "facebookKindText": "Publicação de texto",
      "facebookKindLink": "Publicação de link",
      "facebookKindPhoto": "Publicação de foto",
      "facebookMessageLabel": "Mensagem",
      "facebookMessagePlaceholder": "Digite sua mensagem...",
      "facebookLinkLabel": "Link",
      "facebookLinkPlaceholder": "ex.: https://exemplo.com/artigo",
      "facebookImageUrlLabel": "URL da imagem",
      "facebookImageUrlPlaceholder": "ex.: https://exemplo.com/foto.jpg",
      "facebookScheduledAtLabel": "Agendar para (opcional)",
      "facebookScheduledAtPlaceholder": "ex.: 2026-04-01T09:00:00-03:00",
      "facebookPageIdLabel": "Página do Facebook (opcional)",
      "facebookPageIdPlaceholder": "Selecione uma página do Facebook",
      "facebookPublishPostDescription": "Publique uma postagem de texto, link ou foto em uma página do Facebook conectada. Uma publicação agendada é enfileirada no Facebook — ela ainda não está no ar até o horário agendado.",
      "facebookScheduledAtHelpTitle": "Uma publicação agendada ainda não está no ar",
      "facebookScheduledAtHelpText": "Ao definir Agendar para, o Facebook enfileira a publicação em vez de publicá-la imediatamente. A etapa é concluída com sucesso e retorna scheduled: true, mas a publicação só aparecerá na página no horário agendado.",
      "REPLY_FACEBOOK_COMMENT": "Responder comentário do Facebook",
      "facebookCommentIdLabel": "ID do comentário (opcional)",
      "facebookCommentIdPlaceholder": "ex.: {{starter.facebook.commentId}}",
      "facebookAsPrivateReplyLabel": "Resposta privada",
      "facebookAsPrivateReplyPlaceholder": "Enviar como mensagem privada em vez de uma resposta pública. Permitido apenas uma vez por comentário e somente dentro de 7 dias após a publicação do comentário — não pode ser desfeito.",
      "facebookReplyCommentDescription": "Responda a um comentário em uma publicação de uma página do Facebook conectada, de forma pública ou como mensagem privada.",
      "facebookPrivateReplyHelpTitle": "Respostas privadas são limitadas",
      "facebookPrivateReplyHelpText": "Uma resposta privada só é permitida uma vez por comentário, e somente dentro de 7 dias após a publicação do comentário. Não pode ser desfeita, e uma segunda tentativa falhará.",
      "LOAD_FACEBOOK_POSTS": "Carregar publicações do Facebook",
      "LOAD_FACEBOOK_COMMENTS": "Carregar comentários do Facebook",
      "facebookLimitLabel": "Limite",
      "facebookLimitPlaceholder": "ex.: 20",
      "facebookPostIdLabel": "ID da publicação (opcional)",
      "facebookPostIdPlaceholder": "ex.: {{starter.facebook.postId}}",
      "loadFacebookPostsDescription": "Carregue publicações recentes de uma página do Facebook conectada para usar nas etapas seguintes.",
      "loadFacebookCommentsDescription": "Carregue comentários de uma publicação de uma página do Facebook para usar nas etapas seguintes. Por padrão, usa a publicação do comentário que disparou o gatilho.",
      "facebookReplyMessageMissingError": "Preencha o texto da resposta na etapa Responder comentário do Facebook antes de salvar.",
      "SEND_FACEBOOK_MESSAGE": "Enviar mensagem no Facebook",
      "mcpToolCallDescription": "Chame uma ferramenta externa por meio de uma conexão de servidor MCP. Configure a conexão, selecione a ferramenta e informe os argumentos.",
      "agentTaskDescription": "Configure um agente de IA que decide de forma autônoma quais ferramentas usar para cumprir um objetivo.",
      "agentTaskGoalLabel": "Objetivo",
      "agentTaskGoalPlaceholder": "Descreva o que o agente deve realizar. Aceita {{variables}}.",
      "agentTaskSystemPromptLabel": "Prompt de sistema (papel / persona)",
      "agentTaskSystemPromptPlaceholder": "Opcional. Defina quem é o agente — seu papel, tom e persona. É adicionado antes das regras de execução internas, para você não precisar incluir isso no objetivo.",
      "agentTaskToolSetsLabel": "Conjuntos de ferramentas",
      "agentTaskMaxTurnsLabel": "Máximo de turnos",
      "agentTaskModelTierLabel": "Modelo",
      "agentTaskModelStandard": "Padrão (Sonnet)",
      "agentTaskModelFast": "Rápido (Haiku)",
      "agentTaskToolSet_EMAIL_ACTIONS": "Ações de e-mail (enviar, rascunhar, arquivar, etiquetas)",
      "agentTaskToolSet_COMMUNICATIONS": "Carregar comunicações (ler e-mails, mensagens do Slack)",
      "agentTaskToolSet_NOTIFICATIONS": "Notificações (mensagens do Slack e e-mails do sistema)",
      "agentTaskToolSet_DOBOX": "DoBox (tarefas, entradas)",
      "agentTaskToolSet_MCP": "Aplicativos conectados",
      "agentTaskToolSet_CONVERSATIONAL": "Conversacional (fazer perguntas, aguardar respostas)",
      "agentTaskToolSet_MEMORY": "Memória (lembrar, salvar, histórico)",
      "agentTaskToolSet_KNOWLEDGE": "Brain somente leitura (buscar e ler páginas)",
      "agentTaskToolSet_KNOWLEDGE_WRITE": "Brain leitura/escrita (buscar, ler, criar e editar páginas)",
      "agentTaskToolSet_CALENDAR": "Agenda (eventos, reuniões, convites)",
      "agentTaskToolSet_LOAD_MEETINGS": "Reuniões (consultas somente leitura na agenda)",
      "agentTaskToolSet_PEOPLE": "Pessoas (buscar, ver, criar e editar contatos)",
      "agentTaskToolSet_WHATSAPP": "WhatsApp (números, ler mensagens, enviar)",
      "agentTaskToolSet_FACEBOOK": "Página do Facebook somente leitura (listar publicações e comentários)",
      "agentTaskMcpSelectConnections": "Escolha quais aplicativos conectados ele pode usar:",
      "agentTaskMcpAllConnections": "Todas as conexões habilitadas (desmarque para restringir)",
      "agentTaskMcpNoConnections": "Nenhum aplicativo conectado encontrado. Adicione um em Integrações primeiro.",
      "agentTaskConversationalSettings": "Configurações de conversa",
      "agentTaskWaitStrategy": "Estratégia de resposta",
      "agentTaskWaitStrategyAll": "Aguardar todas as respostas",
      "agentTaskWaitStrategyAny": "Retomar na primeira resposta",
      "agentTaskWaitTimeout": "Tempo limite de resposta",
      "agentTaskWaitTimeout15": "15 minutos",
      "agentTaskWaitTimeout30": "30 minutos",
      "agentTaskWaitTimeout60": "1 hora",
      "agentTaskWaitTimeout120": "2 horas",
      "agentTaskWaitTimeout480": "8 horas",
      "agentTaskWaitTimeout1440": "24 horas",
      "agentTaskSubAgentsLabel": "Subagentes",
      "agentTaskCreateSubAgent": "+ Criar agente",
      "agentTaskModeInline": "Configurar aqui",
      "agentTaskModeSavedAgent": "Usar um agente salvo",
      "agentTaskNoSavedAgents": "Nenhum agente salvo ainda. Crie um agente na aba Agentes primeiro.",
      "agentTaskSavedGoalLabel": "Objetivo (opcional)",
      "agentTaskSavedGoalPlaceholder": "Deixe vazio para executar o agente com as instruções salvas. Aceita {{variables}}.",
      "agentTaskTurns": "turnos",
      "agentTaskToolSetsShort": "conjuntos de ferramentas",
      "agentToolSetAsksFirstTag": "Pergunta antes",
      "agentTemplateModalTitleCreate": "Criar subagente",
      "agentTemplateModalTitleEdit": "Editar agente",
      "agentTemplateSavingTitle": "Salvando subagente",
      "agentTemplateSavingDescription": "Aguarde enquanto salvamos suas alterações.",
      "agentTemplateNameLabel": "Nome",
      "agentTemplateNamePlaceholder": "ex.: Analista de e-mails",
      "agentTemplateDescriptionLabel": "Descrição",
      "agentTemplateDescriptionPlaceholder": "O que este agente faz, quando usá-lo...",
      "agentTemplateSystemPromptLabel": "Instruções",
      "agentTemplateSystemPromptPlaceholder": "Você é um especialista que...",
      "agentTemplateToolSetsLabel": "Ferramentas disponíveis",
      "agentTemplateModelTierLabel": "Modelo",
      "agentTemplateMaxTurnsLabel": "Máximo de turnos",
      "agentTemplateMaxTurnsHint": "Um turno é uma etapa do trabalho do agente: ler, pensar ou usar uma ferramenta. Com poucos, ele para antes de terminar.",
      "agentTemplateIconLabel": "Ícone (emoji)",
      "agentTemplateIconPlaceholder": "ex.: 📧",
      "agentTemplateSave": "Salvar",
      "agentTemplateCancel": "Cancelar",
      "agentTemplateSavedSuccess": "Agente salvo com sucesso",
      "agentTemplateWizard": {
        "title": "Criar um agente",
        "subtitle": "Etapa {{step}} de {{total}}",
        "advancedSubtitle": "Configurações avançadas",
        "actions": {
          "build": "Gerar",
          "continue": "Continuar",
          "create": "Criar agente"
        },
        "describe": {
          "title": "O que seu agente deve fazer?",
          "helper": "Descreva o trabalho em linguagem simples. Vamos rascunhar as instruções, escolher as ferramentas e definir um modelo. Em seguida, você revisa e edita tudo.",
          "prompt": "ex.: Resuma minhas reuniões da agenda todos os dias e me envie um resumo",
          "examples": "Precisa de um ponto de partida?"
        },
        "examples": {
          "calendar": "Resumir minhas reuniões da agenda",
          "email": "Revisar e categorizar e-mails de clientes",
          "landingPage": "Criar landing pages alinhadas à marca"
        },
        "review": {
          "helper": "Aqui está o que criamos — ajuste o que quiser",
          "descriptionHint": "exibida quando alguém escolhe um agente",
          "systemPromptHint": "o que o agente sempre segue"
        },
        "configure": {
          "helper": "Pré-selecionamos o que este trabalho precisa. Ajuste se quiser, ou apenas continue.",
          "tools": "O que ele pode usar",
          "selectedCount": "{{count}} selecionadas",
          "share": "Compartilhar com sua equipe",
          "shareHint": "Os aplicativos conectados permanecem pessoais.",
          "sharing": "Compartilhamento",
          "models": {
            "fast": "Ideal para trabalhos rápidos e simples",
            "standard": "Melhor equilíbrio entre qualidade e velocidade"
          }
        },
        "edit": {
          "intro": "Editando este agente — as alterações são aplicadas quando você salva",
          "save": "Salvar alterações"
        },
        "creating": {
          "title": "Criando seu agente...",
          "description": "Configurando tudo a partir da sua descrição."
        },
        "buildSteps": {
          "goal": "Entendendo o objetivo",
          "instructions": "Escrevendo as instruções",
          "tools": "Selecionando as ferramentas certas",
          "model": "Escolhendo modelo e limites",
          "finish": "Finalizando"
        },
        "preview": {
          "personal": "Privado",
          "emptyDescription": "Nenhuma descrição fornecida",
          "model": "Modelo",
          "turns": "turnos",
          "maxTurns": "{{count}} turnos",
          "sharing": "Compartilhamento"
        },
        "progress": {
          "describe": "Descrever",
          "review": "Revisar",
          "configure": "Configurar"
        },
        "success": {
          "title": "{{name}} está pronto",
          "description": "Salvo nos seus agentes. Você pode executá-lo agora ou conectá-lo a um fluxo.",
          "createAnother": "Criar outro",
          "done": "Concluído"
        },
        "tools": {
          "EMAIL_ACTIONS": "enviar, rascunhar, arquivar, etiquetas",
          "COMMUNICATIONS": "ler e-mails, mensagens do Slack",
          "NOTIFICATIONS": "mensagens do Slack e e-mails do sistema",
          "DOBOX": "tarefas, entradas",
          "MCP": "conectar serviços externos",
          "MEMORY": "lembrar, salvar, histórico",
          "KNOWLEDGE": "buscar e ler páginas",
          "CALENDAR": "eventos, reuniões, convites"
        },
        "discard": {
          "title": "Descartar este agente?",
          "description": "Suas alterações serão perdidas.",
          "cancel": "Continuar editando",
          "confirm": "Descartar"
        },
        "validation": {
          "nameRequired": "Informe um nome para o agente.",
          "systemPromptRequired": "Informe as instruções do agente.",
          "invalidTeam": "Selecione uma equipe da qual você faz parte."
        },
        "errors": {
          "createFailed": "Não foi possível criar o agente. Tente novamente.",
          "saveFailed": "Não foi possível salvar o agente. Tente novamente.",
          "generateFailed": "Não foi possível gerar seu agente. Tente novamente.",
          "approvalModeForbidden": "Só quem criou este agente pode mudar como ele pede aprovação. Nada foi salvo.",
          "outboundRejected": "Não foi possível salvar onde este agente pode enviar. Confira se cada workspace do Slack está conectado para o \"Enviar como\" que você escolheu."
        }
      },
      "mcpSelectConnection": "Conexão MCP",
      "mcpConnectionPlaceholder": "Selecione uma conexão...",
      "mcpLoadingConnections": "Carregando conexões...",
      "mcpNoConnections": "Nenhuma conexão MCP configurada. Adicione uma em Configurações.",
      "mcpSelectTool": "Ferramenta",
      "mcpToolPlaceholder": "Selecione uma ferramenta...",
      "mcpNoTools": "Nenhuma ferramenta disponível. Tente sincronizar a conexão.",
      "mcpArguments": "Argumentos",
      "configTitle": "Configurar etapa",
      "stepNameLabel": "Nome da etapa (para variáveis)",
      "stepNamePlaceholder": "ex.: loadMessages",
      "prompt": "Prompt",
      "promptPlaceholder": "Digite seu prompt...",
      "aiAskDescription": "Peça à IA para criar texto para qualquer finalidade, de resumos a respostas, e use-o em etapas posteriores. Forneça contexto das etapas anteriores com variáveis.",
      "aiAskPromptPlaceholder": "ex.: Analise o e-mail fornecido e extraia todos os itens de ação necessários...",
      "summarizeInstructions": "Instruções adicionais",
      "summarizePlaceholder": "A IA vai resumir os destaques da conversa. Você também pode descrever o que sempre incluir, o tamanho ou o estilo.",
      "decideDescription": "Peça à IA para informar se suas condições são verdadeiras ou falsas",
      "decidePromptLabel": "Digite um prompt",
      "decidePromptPlaceholder": "ex.: Este e-mail é urgente?",
      "decideHelpTitle": "Como funciona o Decidir",
      "decideHelpText": "Depois do Decidir, use uma etapa Verificar se para definir quais ações executar com base no resultado. Por exemplo, marcar um e-mail com estrela apenas se ele for urgente. Se a IA não tiver informações suficientes para decidir, o padrão é falso.",
      "required": "Obrigatório",
      "senderEmailAddress": "De",
      "senderEmailAddressPlaceholder": "Selecione o e-mail do remetente...",
      "recipient": "Destinatário",
      "recipientPlaceholder": "Digite o destinatário...",
      "recipients": "Destinatários",
      "addRecipient": "Adicionar destinatário",
      "removeRecipient": "Remover destinatário {{position}}",
      "recipientAt": "Destinatário {{position}}",
      "subject": "Assunto",
      "subjectPlaceholder": "Digite o assunto...",
      "body": "Corpo",
      "bodyPlaceholder": "Digite o corpo...",
      "duration": "Duração",
      "durationPlaceholder": "ex.: 1 hora",
      "condition": "Condição",
      "conditionPlaceholder": "Digite a condição do filtro...",
      "channel": "Canal",
      "labels": "Etiquetas",
      "labelsPlaceholder": "ex.: importante, follow-up...",
      "channelPlaceholder": "Selecione um canal...",
      "message": "Mensagem",
      "messagePlaceholder": "Digite a mensagem...",
      "workspace": "Workspace",
      "workspacePlaceholder": "Selecione um workspace...",
      "slackConnectTitle": "Conecte seu workspace do Slack",
      "slackConnectDescription": "Automatize mensagens para sua equipe — envie atualizações, alertas e resumos diretamente para canais do Slack ou colegas como parte do seu fluxo.",
      "slackConnectButton": "Conectar Slack",
      "sendSlackMessageDescription": "Envie uma mensagem para um canal do Slack ou mensagem direta usando seu workspace conectado.",
      "sendAs": "Enviar como",
      "sendAsUser": "Em meu nome",
      "sendAsBot": "Bot",
      "destination": "Enviar para",
      "destinationPlaceholder": "Selecione um canal ou pessoa...",
      "destinationChannels": "Canais",
      "destinationDirectMessages": "Mensagens diretas",
      "useVariable": "Usar variável",
      "useDropdown": "Usar lista",
      "workspaceVariablePlaceholder": "ex.: {{starter.slack.workspaceId}}",
      "destinationVariablePlaceholder": "ex.: {{starter.slack.channelId}}",
      "loadingDestinations": "Carregando canais e contatos...",
      "generateDoBoxDescription": "A IA vai criar uma tarefa no DoBox com base no seu prompt e no contexto do e-mail.",
      "validateDoBoxRulesDescription": "Valida a comunicação contra as regras de feedback do usuário antes de gerar itens do DoBox",
      "classifyActionabilityDescription": "Classifica se uma comunicação é acionável (ACTIONABLE / NOT_ACTIONABLE)",
      "validateDoBoxRulesInputModeLabel": "Entrada da validação",
      "validateDoBoxRulesInputModeCommunication": "Comunicação atual",
      "validateDoBoxRulesInputModeCommunicationHelper": "Valida o e-mail ou a mensagem recebida que disparou o agente.",
      "validateDoBoxRulesInputModeCommunicationsBatch": "Lote da etapa anterior",
      "validateDoBoxRulesInputModeCommunicationsBatchHelper": "Valida um lote agregado de mensagens carregado por uma etapa anterior.",
      "validateDoBoxRulesCommunicationsInputLabel": "Variável de comunicações",
      "validateDoBoxRulesCommunicationsInputPlaceholder": "{{step.step-0.output}}",
      "validateDoBoxRulesCommunicationsInputHelper": "Referencie a saída da etapa que carregou o lote de comunicações.",
      "generateDoBoxPromptPlaceholder": "ex.: Crie uma tarefa com os itens de ação deste e-mail...",
      "taskGroup": "Grupo de tarefas",
      "taskGroupPlaceholder": "Grupo de tarefas padrão",
      "taskGroupDescription": "Selecione em qual grupo de tarefas criar as entradas. Deixe vazio para usar o seu padrão.",
      "taskGroupVariablePlaceholder": "ex.: {{variable.taskGroupId}}",
      "loadingTaskGroups": "Carregando grupos de tarefas...",
      "ragSearchDescription": "Pesquise suas comunicações usando busca semântica para recuperar contexto relevante para etapas posteriores.",
      "ragSearchQueryLabel": "Consulta de busca",
      "ragSearchQueryPlaceholder": "ex.: {{email.subject}} {{email.senderName}} — encontra conversas e contexto relacionados",
      "loadDoBoxDescription": "Carregue entradas do DoBox para usar como contexto em etapas posteriores.",
      "loadDoBoxTaskGroups": "Grupos de tarefas a carregar (obrigatório)",
      "loadDoBoxTaskGroupsEmpty": "Nenhum grupo de tarefas ainda — crie um no DoBox primeiro.",
      "loadDoBoxStatus": "Filtro de status",
      "loadDoBoxStatusOpen": "Em aberto",
      "loadDoBoxStatusResolved": "Concluídas",
      "loadDoBoxStatusSuggestion": "Sugestão",
      "loadDoBoxStatusAll": "Todas",
      "loadDoBoxDaysBack": "Dias retroativos",
      "loadDoBoxDaysBackPlaceholder": "ex.: 30",
      "loadDoBoxSortLabel": "Ordenar por última atualização",
      "loadDoBoxSortDesc": "Atualizadas mais recentemente primeiro",
      "loadDoBoxSortAsc": "Atualizadas há mais tempo primeiro",
      "loadDoBoxLimitLabel": "Limite",
      "loadDoBoxLimitPlaceholder": "ex.: 20",
      "loadDoBoxLimitHelp": "Até {{max}} entradas. Limita quantas um loop posterior pode processar.",
      "appendToDoBoxDescription": "Adiciona comunicações a uma entrada existente do DoBox",
      "appendToDoBoxEntryIdLabel": "ID da entrada do DoBox",
      "appendToDoBoxEntryIdPlaceholder": "ex.: {{step.step-0.matchedEntryId}}",
      "appendToDoBoxCommunicationIdsLabel": "IDs de comunicação",
      "appendToDoBoxCommunicationIdsPlaceholder": "ex.: {{email.messageId}} ou IDs separados por vírgula",
      "checkAndAppendDoBoxDescription": "Verifica se as comunicações correspondem a entradas existentes do DoBox e as adiciona automaticamente",
      "checkAndAppendCommunicationsSourceLabel": "Origem das comunicações",
      "checkAndAppendCommunicationsSourcePlaceholder": "ex.: {{step.step-1.output}}",
      "checkAndAppendIncludeResolvedLabel": "Incluir entradas concluídas",
      "checkAndAppendDaysBackLabel": "Dias retroativos de entradas concluídas",
      "checkAndAppendDaysBackPlaceholder": "ex.: 7",
      "processDoBoxDescription": "Analisa as mensagens carregadas da conversa, cria novas entradas no DoBox para itens de ação e adiciona mensagens relacionadas a entradas existentes.",
      "loadingGoogleChatDestinations": "Carregando espaços e membros...",
      "sendGoogleChatMessage": "Enviar mensagem no Google Chat",
      "SEND_GOOGLE_CHAT_MESSAGE": "Enviar mensagem no Google Chat",
      "SEND_USER_GOOGLE_CHAT_MESSAGE": "Enviar mensagem no Google Chat",
      "sendTeamsMessage": "Enviar mensagem no Microsoft Teams",
      "SEND_TEAMS_MESSAGE": "Enviar mensagem no Microsoft Teams",
      "teamsConnectTitle": "Conecte sua conta do Microsoft Teams",
      "teamsConnectDescription": "Automatize mensagens para sua equipe — envie atualizações, alertas e resumos diretamente para chats do Microsoft Teams como parte do seu fluxo.",
      "teamsConnectButton": "Conectar Microsoft Teams",
      "sendTeamsMessageDescription": "Envie uma mensagem para um chat do Microsoft Teams usando sua conta Microsoft conectada.",
      "teamsAccount": "Conta Microsoft",
      "teamsAccountPlaceholder": "Selecione uma conta Microsoft",
      "teamsChat": "Chat",
      "teamsChatPlaceholder": "Selecione um chat",
      "teamsChatVariablePlaceholder": "ex.: {{starter.teams.chatId}}",
      "loadingTeamsChats": "Carregando chats...",
      "googleChatConnectTitle": "Conecte sua conta Google",
      "googleChatConnectDescription": "Automatize mensagens para sua equipe — envie atualizações, alertas e resumos diretamente para espaços do Google Chat ou mensagens diretas como parte do seu fluxo.",
      "googleChatConnectButton": "Conectar Google",
      "sendGoogleChatMessageDescription": "Envie uma mensagem para um espaço do Google Chat ou mensagem direta usando sua conta Google conectada.",
      "googleChatAccount": "Conta Google",
      "googleChatAccountPlaceholder": "Selecione uma conta Google",
      "googleChatAccountVariablePlaceholder": "ex.: {{starter.googleChat.emailAddress}}",
      "googleChatSpace": "Espaço",
      "googleChatSpacePlaceholder": "Selecione um espaço ou mensagem direta",
      "googleChatSpaceVariablePlaceholder": "ex.: {{starter.googleChat.spaceName}}",
      "googleChatDestinationSpaces": "Espaços",
      "googleChatDestinationDMs": "Mensagens diretas",
      "googleChatThreadName": "Nome da thread (opcional)",
      "googleChatThreadNamePlaceholder": "ex.: {{starter.googleChat.threadName}}",
      "sendInstagramMessageDescription": "Envie uma mensagem para uma conversa do Instagram usando sua conta conectada.",
      "sendInstagramAccount": "Conta do Instagram",
      "sendInstagramAccountPlaceholder": "Selecione uma conta do Instagram...",
      "sendInstagramConversation": "Conversa",
      "sendInstagramConversationPlaceholder": "Selecione uma conversa...",
      "sendInstagramConversationVariablePlaceholder": "ex.: {{starter.instagram.conversationId}}",
      "sendInstagramMessageLabel": "Mensagem",
      "sendInstagramMessagePlaceholder": "Digite sua mensagem...",
      "processInstagramDoBoxSourceLabel": "Origem das comunicações",
      "sendFacebookMessageDescription": "Envie uma mensagem para uma conversa em uma página do Facebook conectada.",
      "sendFacebookPage": "Página do Facebook",
      "sendFacebookPagePlaceholder": "Selecione uma página do Facebook",
      "sendFacebookPagePlaceholderDefault": "Por padrão, usa a página do gatilho",
      "sendFacebookConversation": "Conversa",
      "sendFacebookRecipient": "Destinatário",
      "sendFacebookRecipientPlaceholder": "Selecione um destinatário...",
      "sendFacebookRecipientPlaceholderDefault": "Por padrão, usa quem disparou o gatilho",
      "sendFacebookRecipientVariablePlaceholder": "ex.: {{starter.facebookMessenger.authorId}}",
      "sendFacebookRecipientDefaultHint": "Deixe em branco para responder a quem disparou este flow, naquela página.",
      "sendFacebookMessageLabel": "Mensagem",
      "sendFacebookMessagePlaceholder": "Digite sua mensagem...",
      "replyInstagramCommentDescription": "Responda a um comentário do Instagram na sua conta conectada, de forma pública ou como mensagem direta privada.",
      "replyInstagramCommentId": "Comentário",
      "replyInstagramCommentIdPlaceholder": "{{starter.instagramContent.commentId}} ou um ID de comentário",
      "replyInstagramAsPrivateReply": "Enviar como resposta privada",
      "replyInstagramAsPrivateReplyDescription": "Envia uma mensagem direta para quem comentou, em vez de uma resposta pública. O Instagram permite apenas uma resposta privada por comentário, em até 7 dias após a publicação.",
      "publishInstagramPostDescription": "Publique um novo post na sua conta do Instagram conectada.",
      "publishInstagramPostApprovalWarning": "Esta etapa precisa ser precedida por uma etapa de Aprovação (Approval Gate) no flow. As publicações do Instagram são feitas imediatamente e não podem ser desfeitas.",
      "publishInstagramUnavailableTitle": "A publicação no Instagram está temporariamente indisponível",
      "publishInstagramUnavailableMessage": "Esta etapa não pode ser executada agora porque a publicação de posts no Instagram está desativada. Remova-a para continuar ou volte a verificar mais tarde.",
      "publishInstagramKind": "Tipo de publicação",
      "publishInstagramKindImage": "Imagem",
      "publishInstagramKindReels": "Reels",
      "publishInstagramKindStory": "Story",
      "publishInstagramKindCarousel": "Carrossel",
      "publishInstagramImageUrl": "URL da imagem",
      "publishInstagramImageUrlPlaceholder": "https://... ou uma variável",
      "publishInstagramGeneratedImageId": "ID da imagem gerada",
      "publishInstagramGeneratedImageIdPlaceholder": "ID da imagem ou uma variável",
      "publishInstagramGeneratedImageIdHint": "Use o imageId de uma imagem da sua biblioteca de imagens (enviada pelo Assistente, do Google Drive, ou um screenshot) em vez da URL da imagem — esta etapa fica atrás de uma etapa de Aprovação obrigatória, que pode pausar o flow por horas ou dias, muito além da validade de 1 hora da URL.",
      "publishInstagramVideoUrl": "URL do vídeo",
      "publishInstagramVideoUrlPlaceholder": "https://... ou uma variável",
      "publishInstagramCoverUrl": "URL da imagem de capa",
      "publishInstagramCoverUrlPlaceholder": "https://... ou uma variável",
      "publishInstagramStoryHint": "Informe a URL de uma imagem, um ID de imagem gerada ou a URL de um vídeo para o story.",
      "publishInstagramShareToFeed": "Compartilhar também no feed",
      "publishInstagramShareToFeedDescription": "Publicar este Reels também na grade principal do feed, além da aba Reels.",
      "publishInstagramCaption": "Legenda",
      "publishInstagramCaptionPlaceholder": "Escreva uma legenda...",
      "publishInstagramCarouselImages": "Imagens do carrossel",
      "publishInstagramCarouselHint": "Adicione entre 2 e 10 imagens.",
      "publishInstagramCarouselGeneratedImageIdPlaceholder": "ID da imagem ou uma variável",
      "publishInstagramCarouselGeneratedImageIdHint": "Cada imagem também pode vir do imageId de uma imagem da sua biblioteca de imagens (enviada pelo Assistente, do Google Drive, ou um screenshot), em vez de uma URL — use isso quando esta etapa vier depois da etapa de Aprovação obrigatória, já que ela pode pausar o flow além da validade de 1 hora da URL.",
      "publishInstagramAddCarouselImage": "Adicionar imagem",
      "publishInstagramRemoveCarouselImage": "Remover imagem",
      "updateDoBoxDescription": "Atualize uma entrada existente do DoBox: adicione etiquetas, participantes, prazo, comentários ou marque como concluída.",
      "updateDoBoxEntryIdLabel": "ID da entrada do DoBox",
      "updateDoBoxEntryIdPlaceholder": "ex.: {{step.step-0.matchedEntryId}}",
      "updateDoBoxActionsTitle": "Ações",
      "updateDoBoxLabelsLabel": "Adicionar etiquetas",
      "updateDoBoxLabelsPlaceholder": "IDs de etiquetas (separados por vírgula ou variável)",
      "updateDoBoxParticipantsLabel": "Adicionar participantes",
      "updateDoBoxParticipantsPlaceholder": "IDs de usuários (separados por vírgula ou variável)",
      "updateDoBoxParticipantsSearchPlaceholder": "Buscar por nome ou e-mail...",
      "updateDoBoxParticipantsEmpty": "Nenhum membro da equipe encontrado",
      "updateDoBoxDueDateLabel": "Prazo",
      "updateDoBoxDueDatePlaceholder": "Selecione data e hora",
      "updateDoBoxCommentLabel": "Adicionar comentário",
      "updateDoBoxCommentPlaceholder": "ex.: Adicionado automaticamente pelo fluxo",
      "updateDoBoxResolveLabel": "Marcar como concluída",
      "createDoBoxDescriptionLabel": "Descrição",
      "createDoBoxDescriptionPlaceholder": "Digite a descrição (opcional)...",
      "removeDoBoxParticipantsLabel": "Remover participantes",
      "removeDoBoxParticipantsPlaceholder": "IDs de usuários (separados por vírgula ou variável)",
      "removeDoBoxLabelsLabel": "Remover etiquetas",
      "removeDoBoxLabelsPlaceholder": "IDs de etiquetas (separados por vírgula ou variável)",
      "forEachDescription": "Itere sobre cada item de uma lista e execute as etapas abaixo para cada um. Use variáveis de uma etapa Perguntar à IA anterior que retorne um array.",
      "forEachSourceLabel": "Array de origem",
      "forEachSourcePlaceholder": "ex.: {{step.step-0.output.ids}}",
      "forEachSourceEmpty": "Selecione uma variável de uma etapa anterior",
      "forEachAvailableVars": "Variáveis disponíveis dentro do loop:",
      "forEachVarItem": "O item atual em cada iteração",
      "forEachVarIndex": "A posição atual (0, 1, 2...)",
      "forEachVarTotal": "Número total de itens",
      "forEachMaxIterationsLabel": "Máximo de iterações",
      "forEachMaxIterationsPlaceholder": "ex.: 20",
      "forEachMaxIterationsHelp": "Limita quantos itens o loop processa (máx. {{max}}). Reduza para limitar custo e tempo.",
      "forEachMaxIterationsCappedBySource": "Limitado a {{max}} pelo limite de carregamento da etapa de origem.",
      "outputSchemaToggle": "Avançado: saída estruturada",
      "outputSchemaDescription": "Por padrão, a IA retorna texto livre. Habilite para obter uma resposta estruturada (JSON) — útil quando você precisa de dados específicos, como uma lista de IDs, categorias ou valores para usar em etapas posteriores.",
      "outputSchemaLabel": "Formato de saída (JSON)",
      "outputSchemaPlaceholder": "Cole seu formato de saída aqui...",
      "outputSchemaExampleTitle": "Exemplo:",
      "outputSchemaInvalidJson": "JSON inválido — a saída estruturada será ignorada e nenhum campo ficará disponível na etapa Verificar se.",
      "outputSchemaNoProperties": "Adicione um objeto \"properties\" no nível raiz — sem ele, nenhum campo é detectado.",
      "outputSchemaFieldsDetected": "Campos detectados: {{fields}}",
      "variableRequiredWarning": "Insira pelo menos uma variável para dar contexto à IA. Use o botão Variáveis acima para adicionar uma.",
      "variableRequired": "O campo de prompt é obrigatório",
      "notifyEmailDescription": "Envie uma notificação por e-mail com conteúdo personalizado.",
      "sendMode": "Modo de envio",
      "sendModePersonal": "Enviar em meu nome",
      "sendModeNotification": "E-mail de notificação",
      "heading": "Título",
      "headingPlaceholder": "Digite o título do e-mail...",
      "notifyContent": "Conteúdo",
      "notifyContentPlaceholder": "Digite o conteúdo do e-mail (aceita markdown e {{variables}})...",
      "SEND_WHATSAPP_MESSAGE": "Enviar mensagem no WhatsApp",
      "whatsappPhoneNumberId": "Número do WhatsApp",
      "whatsappPhoneNumberIdPlaceholder": "ex.: {{starter.whatsapp.phoneNumberId}}",
      "whatsappTo": "Destinatário",
      "whatsappToPlaceholder": "ex.: {{starter.whatsapp.counterpartId}}",
      "whatsappSendKind": "Tipo de mensagem",
      "whatsappSendKindPlaceholder": "Selecione um tipo de mensagem",
      "whatsappSendKindText": "Texto livre (dentro da janela de 24h)",
      "whatsappSendKindTemplate": "Modelo aprovado (a qualquer momento)",
      "whatsappMessage": "Mensagem",
      "whatsappMessagePlaceholder": "Digite sua mensagem...",
      "whatsappTemplateName": "Nome do modelo",
      "whatsappTemplateNamePlaceholder": "Nome do modelo aprovado no WhatsApp Manager",
      "whatsappTemplateLanguageCode": "Idioma do modelo",
      "whatsappTemplateLanguageCodePlaceholder": "ex.: pt_BR",
      "LOAD_CHAT_COMMUNICATIONS": "Carregar mensagens de conversa",
      "loadChatCommunicationsDescription": "Carregue mensagens de uma plataforma de chat para processar nas etapas seguintes. Escolha a plataforma abaixo e use variáveis para definir dinamicamente os identificadores a partir do gatilho.",
      "loadChatPlatformLabel": "Plataforma",
      "loadChatPlatformSlack": "Slack",
      "loadChatPlatformTeams": "Microsoft Teams",
      "loadChatPlatformGoogleChat": "Google Chat",
      "loadChatPlatformInstagram": "Instagram",
      "loadChatPlatformWhatsapp": "WhatsApp",
      "loadChatPlatformMessenger": "Facebook Messenger",
      "loadChatWorkspaceLabel": "Workspace",
      "loadChatWorkspacePlaceholder": "ex.: {{starter.slack.workspaceId}}",
      "loadChatChannelLabel": "Canal",
      "loadChatChannelPlaceholder": "ex.: {{starter.slack.channelId}}",
      "loadChatTeamsChatLabel": "Chat",
      "loadChatTeamsChatPlaceholder": "ex.: {{starter.teams.chatId}}",
      "loadChatGoogleAccountLabel": "Conta Google",
      "loadChatGoogleAccountPlaceholder": "ex.: {{starter.googleChat.emailAddress}}",
      "loadChatGoogleSpaceLabel": "Espaço",
      "loadChatGoogleSpacePlaceholder": "ex.: {{starter.googleChat.spaceName}}",
      "loadChatInstagramAccountLabel": "Conta do Instagram",
      "loadChatInstagramAccountPlaceholder": "ex.: {{starter.instagram.accountId}}",
      "loadChatInstagramConversationLabel": "Conversa",
      "loadChatInstagramConversationPlaceholder": "ex.: {{starter.instagram.conversationId}}",
      "loadChatMessengerPageLabel": "Página do Facebook",
      "loadChatMessengerPagePlaceholder": "ex.: {{starter.facebookMessenger.pageId}}",
      "loadChatMessengerConversationLabel": "Conversa",
      "loadChatMessengerConversationPlaceholder": "ex.: {{starter.facebookMessenger.conversationId}}",
      "loadChatTimeRange": "Intervalo de tempo",
      "loadChatTimeRangeSinceLastExecution": "Desde a última execução",
      "loadChatTimeRange30m": "Últimos 30 minutos",
      "loadChatTimeRange1h": "Última hora",
      "loadChatTimeRange2h": "Últimas 2 horas",
      "loadChatTimeRange3h": "Últimas 3 horas",
      "loadChatTimeRange6h": "Últimas 6 horas",
      "loadChatTimeRange12h": "Últimas 12 horas",
      "loadChatTimeRange24h": "Últimas 24 horas",
      "loadChatLimit": "Limite de mensagens",
      "loadChatContextMessageCount": "Mensagens de contexto",
      "loadChatContextNone": "Nenhuma",
      "loadChatAdvancedSettings": "Configurações avançadas",
      "CREATE_PERSON_EVENT": "Log Timeline Event",
      "createPersonEventDescription": "Log a timeline event on a person's contact record — a dated fact, distinct from a durable note.",
      "createPersonEventDescriptionTemplateLabel": "Description (optional)",
      "createPersonEventDescriptionTemplatePlaceholder": "e.g. Discussed pricing for {{step.step-0.output}}",
      "createPersonEventHelpText": "Fill in Person ID or Person Email, not both. Use Person ID when you already have it (e.g. from a starter or a previous step); use Person Email to look the person up by email instead.",
      "createPersonEventHelpTitle": "Exactly one of Person ID or Person Email is required",
      "createPersonEventPersonEmailLabel": "Person Email",
      "createPersonEventPersonEmailPlaceholder": "e.g. jane@example.com",
      "createPersonEventPersonIdLabel": "Person ID",
      "createPersonEventPersonIdPlaceholder": "e.g. {{person.id}}",
      "createPersonEventTitleTemplateLabel": "Title",
      "createPersonEventTitleTemplatePlaceholder": "e.g. Called about renewal",
      "agentTaskToolSet_INSTAGRAM": "Instagram (listar publicações e comentários, ver insights, responder comentários, DMs — publicar é uma etapa separada)",
      "agentTaskToolSet_TEAMS": "Microsoft Teams (listar chats, enviar mensagens)",
      "agentTaskToolSet_ARTIFACT": "Artefatos (criar e exportar documentos)"
    },
    "categories": {
      "ai_skills": "Habilidades de IA",
      "tools": "Ferramentas",
      "communications": "Comunicações",
      "gmail": "Gmail",
      "google_chat": "Google Chat",
      "slack": "Slack",
      "instagram": "Instagram",
      "dobox": "DoBox",
      "external": "Ferramentas externas (MCP)",
      "calendar": "Agenda",
      "teams": "Equipes",
      "knowledge": "Conhecimento",
      "people": "Pessoas",
      "google_business": "Google Business Profile",
      "whatsapp": "WhatsApp",
      "facebook": "Facebook",
      "microsoft_teams": "Microsoft Teams"
    },
    "labelPicker": {
      "systemLabels": "Etiquetas do sistema",
      "yourLabels": "Suas etiquetas",
      "empty": "Nenhuma etiqueta encontrada. Crie etiquetas no Gmail primeiro.",
      "unread": "Não lidos",
      "important": "Importante",
      "starred": "Com estrela",
      "sent": "Enviados",
      "inbox": "Caixa de entrada",
      "draft": "Rascunho"
    },
    "categoryPicker": {
      "title": "Categorias do Gmail",
      "primary": "Principal",
      "updates": "Atualizações",
      "social": "Social",
      "promotions": "Promoções",
      "forums": "Fóruns"
    },
    "variables": {
      "insert": "Variáveis",
      "removeVariable": "Remover variável",
      "triggerTitle": "Quando eu recebo um e-mail",
      "stepsTitle": "Etapas anteriores",
      "knowledgePageTitle": "Título da página de conhecimento",
      "knowledgePagePath": "Caminho da página de conhecimento",
      "knowledgePageContent": "Conteúdo da página de conhecimento (markdown)",
      "knowledgePageId": "ID da página de conhecimento",
      "knowledgeSpaceId": "ID do espaço de conhecimento",
      "knowledgePageVersion": "Versão da página de conhecimento",
      "knowledgeParentPageId": "ID da página pai de conhecimento",
      "knowledgeOwnerType": "Tipo de proprietário do espaço de conhecimento",
      "knowledgeOwnerId": "ID do proprietário do espaço de conhecimento",
      "emailSubject": "Assunto do e-mail",
      "emailBody": "Corpo do e-mail",
      "emailDateTime": "Data e hora do e-mail",
      "emailTo": "Endereços de e-mail em 'Para'",
      "emailCc": "Endereços de e-mail em 'Cc'",
      "senderDisplayName": "Nome de exibição do remetente",
      "senderEmail": "E-mail do remetente",
      "emailAttachments": "Anexos do e-mail (texto)",
      "slackMessage": "Mensagem do Slack",
      "slackChannel": "Canal do Slack",
      "slackChannelId": "ID do canal do Slack",
      "slackWorkspaceId": "ID do workspace do Slack",
      "slackAuthor": "Autor no Slack",
      "slackAuthorId": "ID do autor no Slack",
      "slackDateTime": "Data e hora do Slack",
      "slackAttachments": "Anexos do Slack",
      "googleChatMessage": "Mensagem do Google Chat",
      "googleChatSpaceName": "Nome do espaço do Google Chat",
      "googleChatSpaceId": "ID do espaço do Google Chat",
      "googleChatSpaceType": "Tipo do espaço do Google Chat",
      "googleChatEmailAddress": "Conta do Google Chat",
      "googleChatAuthor": "Autor no Google Chat",
      "googleChatAuthorId": "ID do autor no Google Chat",
      "googleChatAuthorEmail": "E-mail do autor no Google Chat",
      "googleChatThreadName": "Nome da thread do Google Chat",
      "googleChatDateTime": "Data e hora do Google Chat",
      "outputSendGoogleChatMessageResult": "Resultado do envio",
      "teamsMessage": "Mensagem do Microsoft Teams",
      "teamsChatId": "ID do chat do Microsoft Teams",
      "teamsChatName": "Nome do chat do Microsoft Teams",
      "teamsChatType": "Tipo do chat do Microsoft Teams",
      "teamsAuthorName": "Nome do autor no Microsoft Teams",
      "teamsAuthorEmail": "E-mail do autor no Microsoft Teams",
      "teamsMessageUrl": "URL da mensagem do Microsoft Teams",
      "teamsTenantId": "ID do tenant do Microsoft Teams",
      "teamsHomeAccountId": "Conta do Microsoft Teams",
      "teamsMessageId": "ID da mensagem do Microsoft Teams",
      "teamsReceivedAt": "Data e hora do Microsoft Teams",
      "instagramMessage": "Mensagem do Instagram",
      "instagramSenderName": "Nome do remetente no Instagram",
      "instagramAuthorId": "ID do remetente no Instagram",
      "instagramConversationId": "ID da conversa do Instagram",
      "instagramAccountId": "ID da conta do Instagram",
      "instagramAccountUsername": "Nome de usuário da conta do Instagram",
      "instagramDateTime": "Data e hora do Instagram",
      "instagramStoryId": "ID do story do Instagram",
      "instagramStoryUrl": "URL do story do Instagram",
      "instagramContentPostId": "ID do post do Instagram",
      "instagramContentCommentId": "ID do comentário do Instagram",
      "instagramContentParentCommentId": "ID do comentário pai do Instagram",
      "instagramContentCommentText": "Texto do comentário do Instagram",
      "instagramContentAuthorUsername": "Nome de usuário de quem comentou",
      "githubEvent": "Evento do GitHub",
      "githubAction": "Ação do GitHub",
      "githubRepository": "Repositório do GitHub",
      "githubRef": "Branch ou tag do GitHub",
      "githubUrl": "URL do GitHub",
      "githubAuthor": "Autor no GitHub",
      "githubBody": "Corpo do GitHub",
      "gbpReviewName": "Nome do recurso da avaliação",
      "gbpReviewId": "ID da avaliação",
      "gbpRating": "Nota da avaliação",
      "gbpAuthorName": "Nome do avaliador",
      "gbpReviewText": "Texto da avaliação",
      "gbpLocationName": "Nome do recurso do local",
      "gbpIsUpdate": "É avaliação atualizada",
      "gbpExistingReply": "Texto da resposta existente",
      "gbpCreatedAt": "Data e hora da avaliação",
      "facebookCommentId": "ID do comentário no Facebook",
      "facebookCommentText": "Texto do comentário no Facebook",
      "facebookPostId": "ID da publicação no Facebook",
      "facebookPageId": "ID da página do Facebook",
      "facebookPageName": "Nome da página do Facebook",
      "facebookAuthorName": "Nome do comentarista no Facebook",
      "facebookAuthorId": "ID do comentarista no Facebook",
      "facebookParentCommentId": "ID do comentário pai no Facebook",
      "facebookDateTime": "Data e hora do comentário no Facebook",
      "facebookMessengerMessage": "Mensagem do Facebook",
      "facebookMessengerSenderName": "Nome de quem enviou no Facebook",
      "facebookMessengerAuthorId": "ID de quem enviou no Facebook",
      "facebookMessengerConversationId": "ID da conversa no Facebook",
      "facebookMessengerPageId": "ID da página no Facebook",
      "facebookMessengerPageName": "Nome da página no Facebook",
      "facebookMessengerDateTime": "Data e hora do Facebook",
      "outputSummary": "Resumo",
      "outputResponse": "Resposta da IA",
      "outputDecision": "Decisão",
      "outputDoBoxId": "ID do DoBox",
      "outputDoBoxEntries": "Entradas do DoBox",
      "outputCommunications": "Comunicações",
      "outputChatCommunications": "Comunicações de Chat",
      "outputValidationResult": "Resultado da validação (PROCEED/BLOCK)",
      "outputActionabilityResult": "Veredito de acionabilidade (ACTIONABLE / NOT_ACTIONABLE)",
      "outputRagContext": "Contexto RAG",
      "outputAppendedEntryId": "ID da entrada adicionada",
      "outputCheckAndAppendResult": "Resultado da correspondência (MATCHED/NO_MATCH)",
      "outputProcessDoBoxResult": "Entradas do DoBox criadas e adicionadas",
      "outputMcpToolCallResult": "Resultado da ferramenta MCP",
      "outputCalendarRsvpResult": "Resultado do RSVP",
      "outputCalendarCreatedEvent": "ID do evento criado",
      "outputCalendarDeleteResult": "Resultado da exclusão",
      "outputCalendarRescheduleResult": "Resultado do reagendamento",
      "outputCalendarAddAttendeesResult": "Resultado da adição de participantes",
      "outputCalendarRemoveAttendeesResult": "Resultado da remoção de participantes",
      "outputAgentTaskResult": "Saída do agente",
      "outputMeetings": "Reuniões",
      "outputPeopleSearchResults": "Pessoas correspondentes",
      "outputTeamPeople": "Pessoas da equipe",
      "outputUpdatePersonNotesResult": "Resultado da atualização de notas",
      "forEachItem": "Item atual",
      "forEachIndex": "Índice atual",
      "forEachTotal": "Total de itens",
      "calendarTitle": "Agenda",
      "calendarEventId": "ID do evento da agenda",
      "calendarSummary": "Título do evento da agenda",
      "calendarResponseStatus": "Status de RSVP da agenda",
      "calendarOrganizer": "E-mail do organizador",
      "calendarOrganizerName": "Nome do organizador",
      "calendarStartTime": "Horário de início do evento",
      "calendarEndTime": "Horário de término do evento",
      "calendarTimeZone": "Fuso horário do evento",
      "doboxInboxEntryId": "ID da entrada do DoBox",
      "doboxSubject": "Assunto do DoBox",
      "doboxDescription": "Descrição do DoBox",
      "doboxTaskGroupName": "Nome da lista do DoBox",
      "doboxTaskLabelNames": "Nomes das etiquetas do DoBox",
      "doboxDueAt": "Prazo do DoBox",
      "doboxAddedParticipantNames": "Nomes dos membros adicionados",
      "doboxAddedLabelNames": "Nomes das etiquetas adicionadas",
      "doboxRemovedLabelNames": "Nomes das etiquetas removidas",
      "doboxNewTaskGroupName": "Nome da nova lista",
      "doboxCommentId": "ID do comentário",
      "doboxCommentMessage": "Mensagem do comentário",
      "doboxCommentAuthor": "Autor do comentário",
      "outputKnowledgePageContent": "Conteúdo da página de conhecimento",
      "emailMessageId": "ID da mensagem de e-mail",
      "personId": "ID da pessoa",
      "personDisplayName": "Nome de exibição da pessoa",
      "personEmails": "E-mails da pessoa",
      "personPhones": "Telefones da pessoa",
      "personJobTitle": "Cargo da pessoa",
      "personNotes": "Notas da pessoa",
      "personOrigin": "Origem da pessoa",
      "personTeamId": "ID da equipe da pessoa",
      "whatsappMessage": "Mensagem do WhatsApp",
      "whatsappSenderName": "Nome do remetente no WhatsApp",
      "whatsappSenderUsername": "Nome de usuário do remetente no WhatsApp",
      "whatsappCounterpartId": "ID do contato no WhatsApp",
      "whatsappPhoneNumberId": "ID do número do WhatsApp",
      "whatsappDisplayPhoneNumber": "Número de exibição do WhatsApp",
      "whatsappDateTime": "Data da mensagem do WhatsApp",
      "outputCreatePersonEventResult": "Create person event result",
      "scheduleFiredAt": "Data e hora do disparo",
      "scheduleFireDateLocal": "Data do disparo (local)",
      "scheduleFireTimeLocal": "Hora do disparo (local)",
      "manualTriggeredAt": "Disparado em",
      "manualTriggeredByUserId": "Disparado por (ID do usuário)",
      "emailRecipients": "Todos os destinatários"
    },
    "step": {
      "stepLabel": "Etapa {{number}}",
      "outputAgentTaskResult": "Saída do agente",
      "doboxInboxEntryId": "ID da entrada do DoBox",
      "doboxSubject": "Assunto do DoBox",
      "doboxDescription": "Descrição do DoBox",
      "doboxTaskGroupName": "Nome da lista do DoBox",
      "doboxTaskLabelNames": "Nomes das etiquetas do DoBox",
      "doboxDueAt": "Prazo do DoBox",
      "doboxAddedParticipantNames": "Nomes dos membros adicionados",
      "doboxAddedLabelNames": "Nomes das etiquetas adicionadas",
      "doboxRemovedLabelNames": "Nomes das etiquetas removidas",
      "doboxNewTaskGroupName": "Nome da nova lista",
      "doboxCommentId": "ID do comentário",
      "doboxCommentMessage": "Mensagem do comentário",
      "doboxCommentAuthor": "Autor do comentário"
    },
    "checkIf": {
      "description": "Execute as próximas etapas apenas se condições específicas forem atendidas.",
      "if": "Se",
      "also": "Também",
      "and": "E",
      "or": "OU",
      "selectVariable": "Selecione uma variável...",
      "valuePlaceholder": "Digite um valor...",
      "addCondition": "Adicionar condição",
      "removeCondition": "Remover condição",
      "operatorLabel": "Operador",
      "starterPrefix": "Gatilho",
      "stepPrefix": "Etapa",
      "stepLabel": "Etapa {{number}}",
      "substepLabel": "Etapa {{number}}",
      "addSubstep": "Adicionar subetapa",
      "noSubsteps": "Nenhuma subetapa ainda. Adicione uma abaixo.",
      "operators": {
        "contains": "contém",
        "not_contains": "não contém",
        "equals": "é igual a",
        "not_equals": "é diferente de",
        "starts_with": "começa com",
        "ends_with": "termina com",
        "is_empty": "está vazio",
        "is_not_empty": "não está vazio",
        "is_true": "é verdadeiro",
        "is_false": "é falso"
      }
    },
    "forEach": {
      "stepLabel": "Etapa {{number}}",
      "substepLabel": "Etapa {{number}}",
      "addSubstep": "Adicionar etapa ao loop",
      "noSubsteps": "Nenhuma etapa ainda. Adicione uma para executar para cada item."
    },
    "loadCommunications": {
      "description": "Carregue comunicações de uma plataforma específica dentro de um intervalo de tempo. Use filtros para refinar os resultados.",
      "platform": "Plataforma",
      "platformGmail": "Gmail",
      "platformOutlook": "Outlook",
      "platformSlack": "Slack",
      "platformTeams": "Teams",
      "timeInterval": "Intervalo de tempo",
      "intervalLastHours": "Últimas X horas",
      "intervalToday": "Hoje",
      "intervalThisWeek": "Esta semana",
      "intervalThisMonth": "Este mês",
      "hours": "Número de horas",
      "hoursPlaceholder": "ex.: 24",
      "filterBy": "Filtrar por",
      "filterPlaceholder": "Selecione um filtro...",
      "gmailFilterAll": "Todos os e-mails",
      "gmailFilterByLabel": "Por etiqueta",
      "gmailFilterByAuthorEmail": "Por e-mail do remetente",
      "gmailFilterByCategory": "Por categoria",
      "gmailFilterByArchived": "E-mails arquivados",
      "slackFilterAll": "Todas as mensagens",
      "slackFilterByChannel": "Por canal",
      "slackFilterByPerson": "Por pessoa",
      "authorEmail": "E-mail do remetente",
      "authorEmailPlaceholder": "ex.: john@example.com",
      "category": "Categoria",
      "categoryPlaceholder": "Selecione uma categoria...",
      "channel": "Nome do canal",
      "channelPlaceholder": "ex.: #general",
      "person": "Pessoa",
      "personPlaceholder": "ex.: @john"
    },
    "loadMeetings": {
      "description": "Carregue reuniões da sua agenda dentro de um intervalo de tempo.",
      "platform": "Provedor de agenda",
      "platformGmail": "Google Calendar",
      "platformOutlook": "Outlook Calendar",
      "timeInterval": "Intervalo de tempo",
      "intervalLastHours": "Últimas X horas",
      "intervalToday": "Hoje",
      "intervalThisWeek": "Esta semana",
      "hours": "Número de horas",
      "hoursPlaceholder": "ex.: 24",
      "calendarAccount": "Conta da agenda",
      "calendarAccountPlaceholder": "Selecione uma conta",
      "calendar": "Agenda",
      "calendarPlaceholder": "Selecione uma agenda"
    },
    "loadTeamMembers": {
      "description": "Carrega os membros da sua equipe. Combine com uma etapa Para cada para agir sobre cada membro individualmente — use {{forEach.item.userId}}, {{forEach.item.email}} ou {{forEach.item.name}} nas etapas seguintes.",
      "teamIdLabel": "ID da equipe (opcional)",
      "teamIdPlaceholder": "Deixe em branco para carregar todas as equipes",
      "teamIdHelperText": "Deixe em branco para carregar os membros de todas as suas equipes, ou informe o ID de uma equipe específica para restringir a uma só."
    },
    "loadTeamPeople": {
      "description": "Carrega pessoas (contatos) compartilhadas com uma equipe. Combine com uma etapa Para cada para agir sobre cada pessoa individualmente.",
      "teamIdLabel": "ID da equipe",
      "teamIdPlaceholder": "ex.: {{step.step-0.output.teamId}}",
      "teamIdHelperText": "A equipe cujas pessoas compartilhadas devem ser carregadas.",
      "queryLabel": "Consulta de busca (opcional)",
      "queryPlaceholder": "Deixe em branco para carregar todas as pessoas compartilhadas com a equipe",
      "queryHelperText": "Quando definida, apenas as pessoas que correspondem a esta busca são retornadas, em vez da lista completa."
    },
    "checkTeamCalendar": {
      "description": "Consulte as agendas dos colegas de equipe. Com proteção de privacidade: apenas disponibilidade (livre/ocupado) e eventos públicos.",
      "modeLabel": "Modo",
      "modeAvailability": "Disponibilidade (encontrar horários livres em comum)",
      "modeEvents": "Eventos públicos (listar itens da agenda)",
      "membersLabel": "Membros",
      "membersPlaceholder": "ex.: {{step.step-0.output.members}}",
      "membersHelperText": "Aceita uma referência de variável para uma lista de membros, um único {{forEach.item.userId}} ou uma lista de userIds/e-mails separados por vírgula.",
      "rangeLabel": "Atalho de intervalo de tempo (opcional)",
      "rangePlaceholder": "Selecione um intervalo…",
      "rangeHelperText": "Ignorado quando Hora mínima e Hora máxima estão definidas.",
      "rangeToday": "Hoje",
      "rangeThisWeek": "Esta semana",
      "rangeNext7Days": "Próximos 7 dias",
      "timeMinLabel": "Hora mínima (opcional)",
      "timeMinPlaceholder": "ex.: 2024-01-01T00:00:00+00:00",
      "timeMaxLabel": "Hora máxima (opcional)",
      "timeMaxPlaceholder": "ex.: 2024-01-07T23:59:59+00:00",
      "timeRangeHelperText": "ISO 8601 com offset UTC. Quando as duas estão definidas, o atalho de intervalo acima é ignorado.",
      "durationMinutesLabel": "Duração de cada horário (minutos)",
      "durationMinutesPlaceholder": "Padrão: 30",
      "maxSlotsLabel": "Máximo de horários a retornar",
      "maxSlotsPlaceholder": "Padrão: 5 (máx. 10)",
      "maxSlotsHelperText": "Número máximo de horários disponíveis a retornar (1–10).",
      "includeSelfLabel": "Incluir sua própria agenda",
      "includeSelfYes": "Sim (incluir minha agenda)",
      "includeSelfNo": "Não (apenas colegas de equipe)",
      "subjectContainsLabel": "Assunto contém (opcional)",
      "subjectContainsPlaceholder": "Filtrar eventos por palavra-chave no assunto"
    },
    "loadKnowledgePage": {
      "spaceLabel": "Espaço",
      "spacePlaceholder": "Selecione um espaço…",
      "spaceTeamBadge": "equipe",
      "pageLabel": "Página",
      "pagePlaceholder": "Selecione uma página…",
      "pageHelp": "Selecione a página específica a carregar do espaço escolhido."
    },
    "actions": {
      "save": "Salvar",
      "run": "Executar",
      "saveBeforeRun": "Salve o fluxo antes de executá-lo",
      "testRun": "Execução de teste",
      "turnOn": "Ativar"
    },
    "manualTrigger": {
      "title": "Gatilho manual",
      "description": "Este agente é executado manualmente, sob demanda. Salve o fluxo e clique em Executar para rodá-lo.",
      "changeStarter": "Alterar gatilho"
    },
    "peopleTrigger": {
      "title": "Nova pessoa criada",
      "description": "Execute este fluxo sempre que uma nova pessoa for adicionada aos seus contatos, seja criada manualmente, importada ou sincronizada de uma integração.",
      "scopeLabel": "Contatos que iniciam este fluxo",
      "personalScope": "Meus contatos",
      "personalScopeHelp": "Dispara quando um novo contato é adicionado aos seus contatos pessoais.",
      "teamsLabel": "Equipes",
      "teamsHelp": "Dispara quando um novo contato é adicionado aos contatos compartilhados de uma equipe marcada.",
      "teamUnavailable": "(não faz mais parte)",
      "lockedScopeMarker": "(bloqueado)",
      "lockedScopeReason": "Este é o único escopo selecionado — sem nenhum selecionado, este gatilho nunca dispararia. Marque outro escopo para desbloquear este.",
      "teamNameUnknown": "Equipe desconhecida",
      "teamsLoadError": "Não foi possível carregar suas equipes.",
      "neverFiresError": "Selecione pelo menos um escopo para este gatilho — sem nenhum selecionado, ele nunca dispararia.",
      "teamMembershipError": "Você não faz mais parte de uma das equipes marcadas — desmarque-a antes de salvar.",
      "changeStarter": "Alterar gatilho"
    },
    "editorMode": {
      "label": "Modo do editor",
      "builder": "Construtor",
      "aiChat": "Chat com IA"
    },
    "aiChat": {
      "placeholder": "Descreva o que você quer que seu agente faça...",
      "send": "Enviar",
      "welcomeMessage": "Oi! Descreva o agente que você quer criar e eu monto para você.",
      "flowApplied": "Fluxo atualizado! Mude para o Construtor para ver os detalhes ou continue conversando para refinar.",
      "generating": "Gerando seu fluxo...",
      "building": "Montando seu fluxo...",
      "emptyState": "Experimente um destes prompts para começar",
      "generationTimeout": "A geração expirou. Tente novamente."
    },
    "whatsappTrigger": {
      "title": "Gatilho do WhatsApp",
      "description": "Executa quando uma nova mensagem do WhatsApp chega no número comercial selecionado. Mensagens enviadas por você não o disparam.",
      "numberLabel": "Número do WhatsApp",
      "numberPlaceholder": "Selecione um número do WhatsApp",
      "noAccountsTitle": "Conecte um número do WhatsApp",
      "noAccountsMessage": "Você ainda não tem um número do WhatsApp Business conectado. Vá para Integrações para conectar um.",
      "noAccountsCta": "Ir para Integrações",
      "changeStarter": "Alterar gatilho",
      "executionType": "Tipo de execução",
      "immediate": "Imediata",
      "debounce": "Debounce",
      "debounceMinutes": "Atraso do debounce (minutos)"
    }
  },
  "flowPlan": {
    "panel": {
      "untitled": "Nova automação",
      "statusDraft": "Rascunho",
      "statusReady": "Pronta",
      "statusActive": "Ativa"
    },
    "plan": {
      "triggerPrefix": "Gatilho: {{trigger}}"
    }
  },
  "flowCostEstimate": {
    "title": "Custo estimado",
    "perRun_one": "{{credits}} crédito por execução",
    "perRun_other": "{{credits}} créditos por execução",
    "perRun_belowOne": "Menos de 1 crédito por execução",
    "perMonth_one": "{{credits}} crédito por mês",
    "perMonth_other": "{{credits}} créditos por mês",
    "perMonth_belowOne": "Menos de 1 crédito por mês",
    "upToPerMonth_one": "Até {{credits}} crédito por mês",
    "upToPerMonth_other": "Até {{credits}} créditos por mês",
    "upToPerMonth_belowOne": "Menos de 1 crédito por mês",
    "unknownExecutions": "Ainda não há dados suficientes para estimar quantas vezes esse fluxo vai rodar por mês.",
    "partialPricingNote": "Algumas etapas deste fluxo ainda não têm preço calculado — os totais acima são um mínimo.",
    "freeSteps_one": "{{count}} etapa é gratuita",
    "freeSteps_other": "{{count}} etapas são gratuitas",
    "pricedSteps_one": "{{count}} etapa precificada com uso real",
    "pricedSteps_other": "{{count}} etapas precificadas com uso real",
    "unpricedSteps_one": "{{count}} etapa ainda sem preço",
    "unpricedSteps_other": "{{count}} etapas ainda sem preço",
    "actualMonthToDate_one": "Gasto até agora neste mês: {{credits}} crédito",
    "actualMonthToDate_other": "Gasto até agora neste mês: {{credits}} créditos",
    "actualMonthToDate_belowOne": "Gasto até agora neste mês: menos de 1 crédito",
    "error": "Não foi possível carregar a estimativa de custo.",
    "runsPerMonth": {
      "label": "Execuções por mês",
      "placeholder": "Ex.: 100",
      "reset": "Usar valor sugerido",
      "source": {
        "schedule": "Exato — vem da própria agenda deste fluxo.",
        "debounced": "Estimado a partir de mensagens agrupadas, uma execução a cada {{minutes}} minutos.",
        "communication": "Estimado como uma execução por mensagem recebida.",
        "similarFlows": "Número de referência baseado em outros fluxos seus com gatilho parecido — a estimativa menos confiável.",
        "unknown": "Ainda não há dados suficientes para sugerir um número. Digite quantas vezes você espera que esse fluxo rode por mês."
      }
    }
  },
  "automationChat": {
    "header": {
      "back": "Voltar para os fluxos",
      "title": "Criar uma automação",
      "subtitle": "Diga o que você quer automatizar, com suas palavras",
      "viewSteps": "Ver etapas"
    },
    "mobileView": {
      "chat": "Chat",
      "workspace": "Plano"
    },
    "composer": {
      "placeholder": "Descreva o que você quer automatizar...",
      "send": "Enviar"
    },
    "attachments": {
      "attachButtonLabel": "Anexar arquivos",
      "removeLabel": "Remover {{name}}",
      "tooManyFiles": "Você pode anexar até {{max}} arquivos.",
      "tooLarge": "Os arquivos anexados são grandes demais. Mantenha o conteúdo combinado abaixo de 80.000 caracteres.",
      "unsupportedType": "\"{{name}}\" não é um tipo de arquivo aceito. Use .txt, .md, .csv, .json, .log, .yml ou .yaml.",
      "readFailed": "Não foi possível ler \"{{name}}\". Tente novamente."
    },
    "chat": {
      "greeting": "Oi — me diga o que você gostaria de automatizar, com suas palavras. Vou fazer algumas perguntas rápidas, configurar tudo, e você pode executar aqui mesmo.",
      "generating": "Trabalhando nisso...",
      "clarificationNeeded": "Preciso de um pouco mais de detalhes antes de montar isso.",
      "upgradeSuggested": "Isso parece precisar de algumas automações conectadas trabalhando juntas como um workflow. Posso montar assim, ou manter como um único fluxo, se você preferir.",
      "answersSubmitted": "Aqui estão minhas respostas.",
      "flowCreatedSchedule": "Criei \"{{name}}\" — {{schedule}} Executar agora também roda uma vez imediatamente.",
      "flowCreatedManual": "Criei \"{{name}}\" como uma automação manual — ela só roda quando você pressiona Executar agora.",
      "flowCreatedEvent": "Criei \"{{name}}\" — dispara {{trigger}}. Executar agora faz uma única execução de teste sem um evento real; ative para que rode automaticamente sempre que isso acontecer.",
      "runFinishedSuccess": "Execução concluída com sucesso.",
      "runFinishedFailure": "Execução concluída com erros.",
      "runFinishedSuccessWithSummary": "Execução concluída com sucesso — {{summary}}",
      "runFinishedFailureWithSummary": "Execução concluída com erros — {{summary}}",
      "flowUpdated": "Pronto — atualizei \"{{name}}\". O painel à direita mostra o novo plano. Você pode continuar ajustando por aqui, executar ou abrir no editor.",
      "groupCreated": "Criei \"{{name}}\" como um workflow de {{count}} automações conectadas. Cada uma roda de forma independente com seu próprio gatilho — expanda um fluxo à direita para ver o plano ou executá-lo separadamente.",
      "groupUpdated": "Pronto — atualizei o workflow \"{{name}}\". O painel à direita mostra o novo plano.",
      "validationWarnings": "Alguns pontos que valem uma conferida: {{issues}}"
    },
    "chips": {
      "runNow": "Executar agora",
      "activate": "Ativar automação",
      "openInEditor": "Abrir no editor",
      "continueAsSingleFlow": "Continuar como fluxo único",
      "createAsWorkflow": "Criar como workflow ({{count}} automações)",
      "example1": "Fazer a triagem da minha caixa de entrada — arquivar o ruído e criar tarefas no DoBox para o que importa",
      "example2": "Me enviar um resumo diário dos não lidos",
      "example3": "Arquivar newsletters automaticamente"
    },
    "panel": {
      "emptyState": "Uma visão em linguagem simples da sua automação. Ela vai se preenchendo conforme conversamos.",
      "checklistTitle": "Checklist de configuração",
      "untitled": "Nova automação",
      "untitledGroup": "Novo workflow",
      "subtitle": "Uma visão em linguagem simples da sua automação. Ela vai se preenchendo conforme conversamos.",
      "groupSubtitle": "Uma visão em linguagem simples das automações do seu workflow. Ela vai se preenchendo conforme conversamos.",
      "statusDraft": "Rascunho",
      "statusReady": "Pronta",
      "statusActive": "Ativa",
      "updating": "Atualizando…"
    },
    "checklist": {
      "summary": "Configuração · {{answered}} respondidas",
      "expandAria": "Expandir checklist de configuração",
      "collapseAria": "Recolher checklist de configuração"
    },
    "plan": {
      "unknownTrigger": "quando disparada",
      "triggerPrefix": "Gatilho: {{trigger}}",
      "checkIfBullet": "Verificar se {{variable}} {{operator}} {{value}}",
      "checkIfBulletNoValue": "Verificar se {{variable}} {{operator}}",
      "checkIfBulletWithMore": "{{condition}} (+{{count}} mais)",
      "forEachBullet": "Repetir para cada item em {{source}}",
      "forEachBulletGeneric": "Repetir para cada item"
    },
    "proposedAgents": {
      "title": "Novos agentes que este fluxo vai criar",
      "description": "Estes subagentes especialistas serão criados e conectados às etapas acima.",
      "teamBadge": "Equipe"
    },
    "runControls": {
      "runNow": "Executar agora",
      "activate": "Ativar",
      "openInEditor": "Abrir no editor",
      "noteSchedule": "Depois de ativada, roda automaticamente {{schedule}}. Executar agora roda uma vez imediatamente.",
      "noteEvent": "Executar agora faz uma única execução de teste sem um e-mail ou mensagem reais. Ative para que rode automaticamente sempre que um evento correspondente chegar.",
      "noteManual": "Este fluxo só roda quando você pressiona Executar agora.",
      "scheduleUnknown": "no agendamento definido"
    },
    "group": {
      "runNow": "Executar agora",
      "activate": "Ativar workflow",
      "openWorkflow": "Abrir workflow"
    },
    "runLog": {
      "title": "Registro de execução",
      "workingLabel": "Trabalhando...",
      "viewFullHistory": "Ver histórico completo",
      "metrics": {
        "stepsRun": "Etapas executadas",
        "succeeded": "Bem-sucedidas",
        "failed": "Com falha",
        "durationSeconds": "Duração (s)"
      },
      "conditionMet": "condição atendida",
      "conditionNotMet": "condição não atendida",
      "actionsRan": "As ações dentro desta condição foram executadas."
    },
    "errors": {
      "generationFailed": "Algo deu errado ao montar sua automação. Tente novamente.",
      "generationTimeout": "Isso está demorando mais que o esperado. Tente novamente.",
      "createFailed": "Montei a automação, mas não consegui salvá-la. Tente novamente.",
      "activateFailed": "Não foi possível ativar a automação. Tente novamente.",
      "updateFailed": "Não consegui aplicar essa alteração. Tente novamente."
    },
    "progress": {
      "working": "Trabalhando nisso...",
      "checkingAccounts": "Verificando suas contas conectadas...",
      "checkingExistingFlows": "Procurando fluxos existentes parecidos...",
      "checkingEmailLabels": "Verificando suas etiquetas de e-mail...",
      "creatingEmailLabel": "Criando uma etiqueta de e-mail...",
      "checkingTaskGroups": "Verificando seus grupos de tarefas...",
      "checkingSlack": "Verificando seu workspace do Slack...",
      "checkingConnections": "Verificando suas ferramentas conectadas...",
      "checkingAgents": "Verificando seus agentes...",
      "preparingQuestions": "Preparando algumas perguntas para você...",
      "preparingReview": "Preparando uma revisão do plano...",
      "assembling": "Montando sua automação..."
    },
    "activity": {
      "sectionTitle": "Atividade",
      "started": "Começou a montar sua automação",
      "questionsAsked": "Fez {{count}} pergunta(s)",
      "answersSubmitted": "Respostas enviadas",
      "planAssembled": "Plano montado",
      "flowCreated": "Criou \"{{name}}\"",
      "groupCreated": "Criou o workflow \"{{name}}\"",
      "flowUpdated": "Atualizou \"{{name}}\"",
      "groupUpdated": "Atualizou o workflow \"{{name}}\"",
      "runStarted": "Iniciou uma execução",
      "testRunWithSample": "Execução de teste com: {{sample}}",
      "runFinishedSuccess": "Execução concluída com sucesso",
      "runFinishedFailure": "Execução concluída com erros",
      "activated": "Ativou a automação",
      "error": "Algo deu errado"
    },
    "samplePicker": {
      "title": "Testar com um evento real",
      "subtitle": "Escolha um evento correspondente recente e a execução vai usá-lo exatamente como se ele tivesse acabado de chegar.",
      "loading": "Procurando eventos correspondentes...",
      "empty": "Nenhum evento recente corresponde a este gatilho — confira os filtros do gatilho ou execute sem amostra.",
      "runWithSelected": "Executar com o selecionado",
      "runWithoutSample": "Executar sem amostra",
      "simulateWithAi": "Simular com IA",
      "cancel": "Cancelar"
    },
    "scenarioSim": {
      "title": "Simular com IA",
      "subtitle": "Gere 3 eventos de gatilho escritos por IA — um caminho feliz, um caso extremo e um que não deve disparar — depois edite e execute cada um para ver o veredito.",
      "loading": "Gerando cenários...",
      "cancel": "Cancelar",
      "runScenario": "Executar este cenário",
      "errors": {
        "generateFailed": "Não foi possível gerar os cenários. Tente novamente.",
        "runFailed": "Não foi possível executar este cenário. Tente novamente."
      },
      "kind": {
        "HAPPY_PATH": "Caminho feliz",
        "EDGE_CASE": "Caso extremo",
        "NON_TRIGGERING": "Não deve disparar"
      },
      "fields": {
        "senderName": "Nome do remetente",
        "senderEmail": "E-mail do remetente",
        "subject": "Assunto",
        "body": "Corpo",
        "authorName": "Nome do autor",
        "message": "Mensagem",
        "description": "Descrição",
        "commentMessage": "Comentário",
        "commentAuthor": "Autor do comentário"
      },
      "slackContext": {
        "location": "#{{channel}} · {{workspace}}",
        "locationNoChannel": "{{workspace}}"
      },
      "doboxContext": {
        "taskGroupOnly": "{{taskGroup}}",
        "taskGroupWithLabels": "{{taskGroup}} · {{labels}}",
        "addedParticipants": "Adicionados: {{names}}",
        "addedLabels": "Etiquetas adicionadas: {{names}}",
        "removedLabels": "Etiquetas removidas: {{names}}",
        "movedTo": "Movido para {{taskGroup}}"
      },
      "verdict": {
        "correctlyFiltered": "Filtrado corretamente — este fluxo não teria disparado.",
        "filterTooBroad": "Disparou, mas não deveria — o filtro do fluxo pode estar amplo demais.",
        "triggeredAsExpected": "Disparou como esperado.",
        "didNotTrigger": "Não dispararia — confira os filtros do fluxo."
      }
    },
    "restore": {
      "loading": "Carregando sua conversa…",
      "failed": "Não consegui restaurar a conversa anterior, mas você pode continuar — é só me dizer o que gostaria de mudar.",
      "resumedGreeting": "Bem-vindo de volta — carreguei \"{{name}}\". O que você gostaria de mudar?",
      "resumedActivity": "Conversa retomada"
    }
  },
  "evalAnnotations": {
    "configPageTitle": "Configuração do Eval",
    "annotationsPageTitle": "Anotações do Eval",
    "sourceAccounts": "Contas de origem",
    "sourceAccountsHint": "mensagens amostradas destes usuários",
    "dailySampleSize": "Amostra diária",
    "dailySampleHint": "mensagens amostradas por dia",
    "positiveNegativeRatio": "Proporção positivo / negativo",
    "ratioHint": "{{positivePct}}% das amostras devem conter tarefas · {{negativePct}}% sem",
    "notificationRecipients": "Destinatários de notificações",
    "messageRecipients": "Destinatários",
    "notifications": "Notificações",
    "notificationsHintOn": "Destinatários são avisados quando novas anotações ficam prontas.",
    "notificationsHintOff": "Notificações desligadas. Destinatários não serão avisados.",
    "sampling": "Amostragem",
    "discard": "Descartar",
    "saveConfig": "Salvar configuração",
    "updated": "Atualizado em {{date}}",
    "unsavedChanges": "Alterações não salvas",
    "allChangesSaved": "Tudo salvo",
    "errorLoadingConfig": "Falha ao carregar a configuração",
    "configSaved": "Configuração salva com sucesso",
    "configSaveError": "Falha ao salvar a configuração",
    "userAdded": "Usuário adicionado",
    "userRemoved": "Usuário removido",
    "addUser": "Adicionar",
    "addUserPlaceholder": "Adicionar por e-mail",
    "userNotFound": "Usuário não encontrado",
    "removeUser": "Remover",
    "unknownUser": "Usuário desconhecido",
    "noUsersAdded": "Nenhum usuário adicionado ainda",
    "filterByStatus": "Filtrar por status",
    "allStatuses": "Todos",
    "pending": "Pendente",
    "completed": "Concluída",
    "skipped": "Ignorada",
    "noAnnotations": "Nenhuma anotação encontrada",
    "noAnnotationsDescription": "Configure as contas de origem e execute o pipeline de amostragem para criar anotações",
    "annotationId": "ID",
    "llmTaskCount_one": "{{count}} tarefa do LLM",
    "llmTaskCount_other": "{{count}} tarefas do LLM",
    "humanTaskCount_one": "{{count}} humana",
    "humanTaskCount_other": "{{count}} humanas",
    "compareHint": "Clique numa linha para comparar tarefas do LLM com a anotação humana",
    "compareHintMobile": "Toque numa linha para comparar tarefas do LLM com a anotação humana",
    "selectAnnotation": "Selecione uma anotação",
    "loadMore": "Carregar mais",
    "loading": "Carregando...",
    "noSubject": "Sem assunto",
    "tasks": "Tarefas",
    "addTask": "Adicionar tarefa",
    "submitAndNext": "Enviar e avançar",
    "skipAndNext": "Ignorar e avançar",
    "backToList": "Voltar para as anotações",
    "taskTitle": "Título",
    "taskDescription": "Descrição",
    "taskPriority": "Prioridade",
    "taskDueDate": "Prazo",
    "taskParticipants": "Membros",
    "taskNumber": "Tarefa {{number}}",
    "removeTask": "Remover tarefa",
    "noTasksYet": "Nenhuma tarefa adicionada ainda. Clique em 'Adicionar tarefa' para começar a anotar.",
    "titleRequired": "Todas as tarefas devem ter um título",
    "annotationSubmitted": "Anotação enviada com sucesso",
    "annotationSkipped": "Anotação ignorada",
    "allAnnotationsComplete": "Todas as anotações pendentes foram concluídas!",
    "submitError": "Falha ao enviar a anotação",
    "deleteError": "Falha ao excluir a anotação",
    "deleteAnnotation": "Excluir e avançar",
    "annotationDeleted": "Anotação excluída",
    "annotationNotFound": "Anotação não encontrada",
    "errorLoadingAnnotation": "Falha ao carregar a anotação",
    "threadMessages": "Mensagens da conversa",
    "toRecipients": "Para:",
    "ccRecipients": "CC:",
    "bccRecipients": "CCO:",
    "directMessage": "Mensagem direta",
    "messageDetailsToggle": "Detalhes",
    "noParticipantsAvailable": "Nenhum membro disponível para esta mensagem",
    "llmExtracted": "LLM extraiu",
    "humanAnnotation": "Anotação humana",
    "noTasks": "Nenhuma tarefa extraída",
    "awaitingAnnotation": "Aguardando anotação",
    "skippedByAnnotator": "Pulada pelo anotador",
    "wrongPerspectiveShort": "perspectiva errada",
    "priorityMicro": "P{{priority}}",
    "annotate": "Anotar",
    "skip": "Pular",
    "unsavedEditTitle": "Você tem alterações não salvas",
    "unsavedEditBody": "Mudar para outra anotação vai descartar suas edições.",
    "keepEditing": "Continuar editando",
    "discardChanges": "Descartar alterações",
    "priorityLevels": {
      "1": "1 - Mais alta",
      "2": "2 - Alta",
      "3": "3 - Média",
      "4": "4 - Baixa",
      "5": "5 - Mais baixa"
    },
    "taskWrongPerspective": "Perspectiva errada",
    "taskWrongPerspectiveHint": "Marque se o extrator escolheu o ator errado (ex.: responsável = destinatário em vez do remetente).",
    "guidelines": {
      "toggle": "Diretrizes de anotação",
      "policyLine": "Política em uma linha: anote cada mensagem com base no que essa mensagem, sozinha, pede ao usuário. Não carregue contexto de mensagens anteriores da conversa.",
      "bullet1": "Cada mensagem é rotulada de forma independente. A conversa fica visível para compreensão humana, mas apenas a mensagem em anotação determina os rótulos.",
      "bullet2": "Uma mensagem que pede que o usuário faça algo é uma tarefa (\"Por favor, compre leite\").",
      "bullet3": "Uma mensagem que é uma afirmação, um reconhecimento ou a própria resposta enviada pelo usuário não é uma tarefa (\"Vou ao mercado\", \"Comprei o leite\", \"obrigado!\"). Elas não recebem anotação de tarefa mesmo que a mensagem anterior na conversa tenha recebido.",
      "bullet4": "As tarefas são da perspectiva do usuário. Se a mensagem pede que o remetente faça algo, isso não é uma tarefa para o usuário.",
      "bullet5Bold": "Perspectiva errada:",
      "bullet5Body": "marque a caixa de perspectiva errada em uma tarefa quando o extrator inventou uma tarefa por interpretar mal de quem é a responsabilidade.",
      "rationale": "Por que anotamos assim: em produção, as tarefas são extraídas uma mensagem por vez, sem contexto da conversa no prompt. Anotar com base no estado da conversa puniria o modelo por inferências para as quais ele não tem insumo."
    },
    "removeUserAriaLabel": "Remover {{email}}",
    "annotationIdAriaLabel": "ID: {{id}}",
    "senderToRecipient": "→ {{recipient}}",
    "channelLabel": "Canal:",
    "channelName": "#{{channel}}"
  },
  "evalLanding": {
    "pageTitle": "Eval",
    "pageDescription": "Ferramentas e configuração de avaliação de LLM",
    "annotationsCardTitle": "Anotações",
    "annotationsCardDescription": "Revise mensagens amostradas e compare tarefas do LLM com o julgamento humano",
    "annotationsCardAriaLabel": "Ir para Anotações do Eval",
    "configCardTitle": "Configuração",
    "configCardDescription": "Contas de origem, destinatários e parâmetros de amostragem",
    "configCardAriaLabel": "Ir para Configuração do Eval",
    "dashboardCardTitle": "Painel",
    "dashboardCardDescription": "Execuções do pipeline, precisão / recall / F1 e acurácia por campo",
    "dashboardCardAriaLabel": "Ir para o Painel do Eval",
    "footnote": "O pipeline amostra mensagens das contas de origem diariamente, extrai tarefas com o LLM e compara com as anotações humanas. Precisão, recall e F1 vêm dessa comparação.",
    "meta": {
      "pending_one": "{{count}} pendente",
      "pending_other": "{{count}} pendentes",
      "sampling": "{{size}} / dia · {{ratio}}% positivo",
      "f1": "F1 {{value}}"
    }
  },
  "evalNav": {
    "ariaLabel": "Seções do Eval",
    "home": "Visão geral",
    "annotations": "Anotações",
    "config": "Configuração",
    "dashboard": "Painel",
    "meta": {
      "tools_one": "{{count}} ferramenta",
      "tools_other": "{{count}} ferramentas",
      "annotations": "{{pending}} · {{notifications}}",
      "notificationsOn": "notificações ativas",
      "notificationsOff": "notificações desligadas",
      "config": "config \"{{configId}}\"",
      "dashboard": "{{from}} – {{to}}"
    }
  },
  "evalDashboard": {
    "pageTitle": "Painel do Eval",
    "averagePrecision": "Precisão média",
    "averageRecall": "Recall médio",
    "averageF1Score": "F1 médio",
    "totalPipelineRuns": "Total de execuções",
    "runningCount_one": "{{count}} em execução",
    "runningCount_other": "{{count}} em execução",
    "rangeCaption": "{{start}} – {{end}}",
    "runHistoryTitle": "Histórico de execuções do pipeline",
    "newestFirst": "mais recentes primeiro",
    "noRuns": "Nenhuma execução do pipeline encontrada",
    "noRunsDescription": "Dispare uma execução do pipeline para começar a avaliar o desempenho do LLM",
    "statusRunning": "Em execução",
    "statusCompleted": "Concluída",
    "statusFailed": "Com falha",
    "samplesProgress": "{{completed}} / {{total}}",
    "runFooterCompleted": "P {{precision}} · R {{recall}} · F1 {{f1}} · {{duration}}",
    "runFooterRunning": "Iniciada {{date}}",
    "confusionTitle": "Confusão",
    "confusionTruePositives": "Verdadeiros positivos",
    "confusionTruePositivesSub": "LLM e humano concordam",
    "confusionFalsePositives": "Falsos positivos",
    "confusionFalsePositivesSub": "LLM inventou tarefa",
    "confusionFalseNegatives": "Falsos negativos",
    "confusionFalseNegativesSub": "LLM deixou passar",
    "noConfusionData": "Nenhum dado de confusão disponível",
    "fieldAccuracyTitle": "Acurácia por campo",
    "exactVsSemantic": "match exato vs semântico",
    "fieldTitle": "Título",
    "fieldDescription": "Descrição",
    "noFieldAccuracy": "Nenhum dado de acurácia por campo disponível",
    "annotationStatsTitle": "Estatísticas de anotações",
    "annotationsTotalCount_one": "{{count}} no total",
    "annotationsTotalCount_other": "{{count}} no total",
    "noAnnotationStats": "Nenhum dado de anotação disponível",
    "pendingAnnotations": "Pendentes",
    "completedAnnotations": "Concluídas",
    "skippedAnnotations": "Ignoradas",
    "triggerRunButton": "Disparar execução do pipeline",
    "triggerConfirmTitle": "Disparar execução do pipeline",
    "triggerConfirmMessage": "Tem certeza de que deseja disparar uma nova execução do pipeline? Isso vai processar todas as anotações pendentes.",
    "triggerConfirm": "Disparar",
    "triggerSuccess": "Execução do pipeline disparada com sucesso",
    "triggerError": "Falha ao disparar a execução do pipeline",
    "runInProgress": "Uma execução do pipeline está em andamento",
    "loadMore": "Carregar mais",
    "errorLoadingRuns": "Falha ao carregar as execuções do pipeline",
    "errorLoadingMetrics": "Falha ao carregar as métricas do painel",
    "durationSeconds": "{{seconds}}s",
    "durationMinutes": "{{minutes}}m {{seconds}}s",
    "performanceChartTitle": "Desempenho ao longo do tempo",
    "precision": "Precisão",
    "recall": "Recall",
    "f1Score": "F1",
    "noChartData": "Nenhuma execução concluída com métricas para exibir",
    "latestRunLabel": "Última execução",
    "runFromDate": "Execução de {{date}}",
    "selectRunAriaLabel": "Selecionar execução de {{date}}",
    "fieldAccuracyValue": "{{exact}}% exato · {{semantic}}% semântico"
  },
  "mcpConnections": {
    "pageTitle": "Conexões MCP",
    "pageDescription": "Conecte servidores MCP externos para usar as ferramentas deles nos seus fluxos.",
    "addButton": "Adicionar conexão",
    "addTitle": "Adicionar conexão MCP",
    "addSubtitle": "Conecte-se a um servidor MCP externo para descobrir e usar as ferramentas dele.",
    "editTitle": "Editar conexão MCP",
    "editSubtitle": "Atualize as configurações da conexão e gerencie as ferramentas habilitadas.",
    "nameLabel": "Nome da conexão",
    "namePlaceholder": "ex.: GitHub, Notion, API personalizada...",
    "serverUrlLabel": "URL do servidor",
    "serverUrlPlaceholder": "ex.: https://api.example.com/mcp/",
    "authTypeLabel": "Autenticação",
    "credentialsLabel": "Credenciais",
    "credentialsPlaceholder": "Insira a chave de API ou o token...",
    "credentialsUpdatePlaceholder": "Deixe em branco para manter as credenciais atuais",
    "authType": {
      "NONE": "Nenhuma",
      "API_KEY": "Chave de API",
      "BEARER_TOKEN": "Bearer Token",
      "OAUTH2": "OAuth 2.0"
    },
    "status": {
      "CONNECTED": "Conectado",
      "DISCONNECTED": "Não conectado",
      "ERROR": "Erro de conexão",
      "notConnected": "Não conectado"
    },
    "connect": "Conectar",
    "searchOnGoogle": "Buscar no Google",
    "toolCount": "{{discovered}} ferramentas descobertas ({{enabled}} habilitadas)",
    "lastSynced": "Última sincronização: {{time}}",
    "sync": "Sincronizar",
    "addAndSync": "Adicionar e sincronizar",
    "syncSuccess": "Conexão sincronizada com sucesso. Ferramentas descobertas!",
    "syncingInBackground": "Conexão criada! Descobrindo ferramentas...",
    "syncError": "Falha ao sincronizar a conexão. Verifique a URL do servidor e as credenciais.",
    "createAndSyncSuccess": "Conexão criada e ferramentas descobertas!",
    "createSuccessSyncFailed": "Conexão criada, mas a sincronização falhou. Tente sincronizar manualmente.",
    "createError": "Falha ao criar a conexão.",
    "officialUrlMismatch": "Esta URL não é válida para {{name}}. Use a URL padrão do servidor ou adicione como conexão personalizada.",
    "updateSuccess": "Conexão atualizada com sucesso.",
    "updateError": "Falha ao atualizar a conexão.",
    "deleteSuccess": "Conexão excluída.",
    "deleteError": "Falha ao excluir a conexão.",
    "deleteConfirmTitle": "Excluir conexão MCP",
    "deleteConfirmDescription": "Tem certeza de que deseja excluir \"{{name}}\"? Isso vai removê-la de todos os fluxos que a usam.",
    "emptyTitle": "Nenhuma conexão MCP ainda",
    "emptyDescription": "Conecte servidores MCP externos como GitHub, Notion ou qualquer servidor de ferramentas personalizado para usar os recursos deles nos seus fluxos.",
    "enabledToolsTitle": "Ferramentas habilitadas",
    "enabledToolsDescription": "Selecione quais ferramentas devem estar disponíveis nos seus fluxos.",
    "officialMcps": {
      "github": "Conecte sua conta do <bold>GitHub</bold> para ler repositórios, gerenciar issues e criar pull requests a partir dos seus fluxos.",
      "notion": "Conecte sua conta do <bold>Notion</bold> para ler e escrever páginas, bancos de dados e comentários no seu workspace.",
      "dropbox": "Conecte sua conta do <bold>Dropbox</bold> para navegar, enviar e gerenciar arquivos e pastas a partir dos seus fluxos.",
      "box": "Conecte sua conta do <bold>Box</bold> para acessar, compartilhar e gerenciar arquivos e pastas armazenados no seu workspace.",
      "figma": "Conecte sua conta do <bold>Figma</bold> para ler arquivos de design, inspecionar componentes e extrair assets dos seus projetos.",
      "hubspot": "Conecte sua conta do <bold>HubSpot</bold> para gerenciar contatos, empresas e negócios a partir dos seus fluxos.",
      "atlassianRovo": "Conecte sua conta da <bold>Atlassian</bold> para pesquisar no Confluence e no Jira usando as ferramentas com IA do Rovo.",
      "monday": "Conecte sua conta do <bold>Monday</bold> para ler e atualizar quadros, itens e colunas a partir dos seus fluxos.",
      "asana": "Conecte sua conta do <bold>Asana</bold> para criar e gerenciar tarefas, projetos e subtarefas a partir dos seus fluxos.",
      "clickup": "Conecte sua conta do <bold>ClickUp</bold> para criar e gerenciar tarefas, espaços e listas a partir dos seus fluxos.",
      "trello": "Conecte sua conta do <bold>Trello</bold> para ler e atualizar quadros, listas e cartões a partir dos seus fluxos.",
      "motion": "Conecte sua conta do <bold>Motion</bold> para ler e gerenciar tarefas, projetos e sua agenda a partir dos seus fluxos.",
      "tavily": "Conecte sua conta do <bold>Tavily</bold> para permitir que seus fluxos pesquisem na web, leiam artigos e extraiam conteúdo de qualquer site.",
      "windsor": "Conecte sua conta do <bold>Windsor.ai</bold> para consultar análises de marketing, CRM e e-commerce a partir dos seus fluxos. Cole sua chave de API do Windsor quando solicitado — ela é armazenada com segurança e nunca aparece na URL.",
      "granola": "Conecte sua conta do <bold>Granola</bold> para permitir que seu assistente pesquise notas e transcrições de reuniões.",
      "metaAds": "Conecte sua conta do <bold>Meta Ads</bold> para gerenciar campanhas, revisar insights e criar públicos a partir dos seus fluxos.",
      "canva": "Conecte sua conta do <bold>Canva</bold> para criar, editar e exportar designs e criativos para suas campanhas de anúncios a partir dos seus fluxos.",
      "shortcut": "Conecte sua conta do <bold>Shortcut</bold> para buscar, criar e atualizar stories, epics e docs a partir dos seus fluxos.",
      "salesforce": "Conecte o servidor MCP hospedado da sua org do <bold>Salesforce</bold> para consultar registros e executar fluxos e ações Apex. O endpoint é específico da sua org — cole a URL das configurações do Salesforce.",
      "linear": "Conecte sua conta do <bold>Linear</bold> para encontrar, criar e atualizar issues, projetos e comentários a partir dos seus fluxos.",
      "sourcegraph": "Conecte sua conta do <bold>Sourcegraph</bold> para pesquisar código, navegar por referências e executar o Deep Search nos seus repositórios.",
      "glean": "Conecte sua conta do <bold>Glean</bold> para pesquisar conhecimento da empresa, documentos e conversas a partir dos seus fluxos.",
      "snowflake": "Conecte sua conta do <bold>Snowflake</bold> para consultar tabelas e executar as ferramentas de IA do Cortex a partir dos seus fluxos."
    },
    "oauthStartError": "Falha ao iniciar o fluxo de autorização. Tente novamente.",
    "oauthCompleteError": "Falha ao concluir a autorização. Tente novamente.",
    "oauthSuccess": "Conexão autorizada com sucesso!",
    "oauthModalExplanation": "Você será redirecionado para autorizar a conexão. Volte aqui depois de aprovar o acesso.",
    "oauthAuthorize": "Autorizar",
    "oauthConnecting": "Conectando…",
    "oauthConnectingDescription": "Concluindo sua autorização. Aguarde.",
    "oauthErrorTitle": "Falha na autorização",
    "oauthCallbackMissingParams": "Parâmetros de autorização ausentes. Tente conectar novamente.",
    "oauthBackToIntegrations": "Voltar para Integrações",
    "oauthClientCredentialsLabel": "Credenciais do app OAuth",
    "oauthClientIdLabel": "Client ID",
    "oauthClientIdPlaceholder": "Insira seu Client ID",
    "oauthClientSecretLabel": "Client Secret",
    "oauthClientSecretPlaceholder": "Insira seu Client Secret",
    "oauthRedirectUrlLabel": "URL de redirecionamento (registre no seu app OAuth)",
    "oauthClientModal": {
      "title": "Credenciais do app OAuth necessárias",
      "description": "Este servidor exige que você crie seu próprio app OAuth. Registre a URL de redirecionamento abaixo no seu app OAuth e depois insira as credenciais.",
      "redirectUrlLabel": "URL de redirecionamento (registre esta URL no seu app OAuth)",
      "copyRedirectUrl": "Copiar",
      "clientIdLabel": "Client ID",
      "clientIdPlaceholder": "Insira seu Client ID",
      "clientSecretLabel": "Client Secret",
      "clientSecretPlaceholder": "Insira seu Client Secret",
      "authorizeButton": "Autorizar",
      "genericError": "Falha ao iniciar o fluxo OAuth. Verifique suas credenciais e tente novamente."
    }
  },
  "localDevices": {
    "pairButton": "Parear dispositivo local",
    "section": {
      "title": "Claude e Codex locais",
      "description": "Pareie sua máquina para que o assistente possa delegar tarefas de código ao seu Claude Code ou Codex CLI local.",
      "emptyHint": "Nenhum dispositivo pareado ainda",
      "pairButton": "Parear dispositivo local",
      "downloadButton": "Baixar para Mac",
      "downloadHint": "macOS Apple Silicon",
      "requirementsPrefix": "Requer ",
      "requirementsClaudeCodeLinkText": "Claude Code",
      "requirementsOr": " ou ",
      "requirementsCodexLinkText": "Codex",
      "requirementsSuffix": " instalado e com login feito no seu Mac.",
      "usageNote": "O app da barra de menus mostra seu uso do Codex — a porcentagem usada e quando ela reinicia.",
      "requirementsTools": "Também requer: GitHub CLI (gh) e cloudflared."
    },
    "modal": {
      "title": "Parear dispositivo local",
      "description": "Insira o código de pareamento exibido no seu script local para conectar este dispositivo.",
      "codePlaceholder": "XXXX-XXXX",
      "codeLabel": "Código de pareamento",
      "submitButton": "Parear dispositivo",
      "cancelButton": "Cancelar",
      "successTitle": "Dispositivo pareado!",
      "successMessage": "{{deviceName}} está pareado. Mantenha o script local em execução — a conexão MCP vai aparecer automaticamente em alguns segundos.",
      "doneButton": "Concluído"
    },
    "list": {
      "title": "Dispositivos locais pareados",
      "lastSeen": "Visto por último {{time}}",
      "neverSeen": "Nunca visto",
      "revokeButton": "Revogar",
      "confirmRevoke": "Confirmar?",
      "cancelRevoke": "Cancelar"
    },
    "status": {
      "connected": "Conectado",
      "disconnected": "Desconectado",
      "error": "Conectado, ferramentas indisponíveis"
    },
    "errors": {
      "invalidCode": "Código de pareamento inválido. Verifique o código exibido no seu script local.",
      "expiredCode": "Este código de pareamento expirou. Gere um novo no seu script local.",
      "usedCode": "Este código de pareamento já foi usado.",
      "unknown": "Algo deu errado. Tente novamente.",
      "revokeFailed": "Falha ao revogar o dispositivo."
    }
  },
  "adminHome": {
    "title": "Painel de administração",
    "statsDescription": "Veja métricas do sistema, análises de uso e integridade dos dados",
    "statsAriaLabel": "Ir para Estatísticas",
    "evalDescription": "Gerencie anotações de avaliação, execute pipelines e revise as métricas do painel",
    "evalAriaLabel": "Ir para Avaliação",
    "funnelDescription": "Acompanhe cadastros e ativação em cada etapa do funil de crescimento",
    "funnelAriaLabel": "Ir para Funil",
    "noFeaturesAvailable": "Nenhum recurso disponível para o seu papel ainda. Fale com um administrador se achar que isso é um engano.",
    "churnDescription": "Por que as pessoas encerraram a conta, e o que tinham construído quando o fizeram",
    "churnAriaLabel": "Ir para Cancelamentos",
    "requiresRole": "Requer {{role}}",
    "roles": {
      "admin": "Admin",
      "marketing": "Marketing",
      "billing": "Billing"
    },
    "teamsDescription": "Encontre um time, veja plano, membros, carteiras e créditos, ou adicione créditos",
    "teamsAriaLabel": "Ir para Times"
  },
  "adminNav": {
    "appName": "this+that Admin",
    "tag": "Admin",
    "home": "Início",
    "stats": "Estatísticas",
    "eval": "Avaliação",
    "signOut": "Sair",
    "funnel": "Funil",
    "churn": "Cancelamentos",
    "teams": "Times"
  },
  "assistant": {
    "errors": {
      "submitFailed": "Não foi possível enviar sua mensagem. Tente novamente.",
      "imageFileTypeNotPermitted": "Este tipo de imagem não é compatível.",
      "imageFileNameInvalid": "O nome deste arquivo de imagem não é válido.",
      "imageUploadInfected": "Esta imagem foi bloqueada por motivos de segurança.",
      "imageUploadInvalidType": "O conteúdo da imagem não corresponde ao tipo do arquivo.",
      "imageUploadScanPending": "Esta imagem ainda está sendo verificada. Tente novamente em alguns segundos.",
      "tooManyImages": "Você pode anexar no máximo 5 imagens por mensagem."
    },
    "emptyState": {
      "greetingMorning": "Bom dia, {{name}}",
      "greetingAfternoon": "Boa tarde, {{name}}",
      "subtitle": "Tenho acesso ao seu e-mail, agenda, Slack e Instagram. Dei uma olhada no seu dia — aqui está o que se destaca e algumas coisas que você pode me pedir para começar.",
      "whatISeeNow": "O que estou vendo agora",
      "updatedAt": "Atualizado {{time}}",
      "suggestedForYou": "Sugestões para você agora",
      "orTrySomethingLike": "Ou tente algo como",
      "connected": "Conectado:",
      "addSource": "+ adicionar fonte",
      "greetingNight": "Boa noite, {{name}}"
    },
    "empty": {
      "greeting": "Oi {{name}}, como posso ajudar hoje?",
      "greetingNoName": "Como posso ajudar hoje?",
      "subtitle": "Pergunte sobre sua agenda, suas comunicações ou qualquer coisa em que você trabalhou recentemente.",
      "sphereAriaLabel": "Esfera do assistente, ociosa",
      "prompts": {
        "0": "O que tenho na agenda hoje?",
        "1": "E-mails recentes desta semana",
        "2": "Rascunhe uma resposta para o e-mail mais recente",
        "3": "O que discutimos ontem?"
      }
    },
    "delegatedSendReceipt": {
      "actions": {
        "calendarEventCreated": "Convite enviado",
        "slackReply": "Resposta enviada"
      },
      "undo": "Desfazer",
      "undoing": "Desfazendo…",
      "undone": "Desfeito",
      "undoFailed": "Não foi possível desfazer. Tente novamente.",
      "markDone": "Marcar como feito"
    },
    "loading": {
      "sphereAriaLabel": "Carregando conversa"
    },
    "typing": "O agente está trabalhando",
    "briefing": {
      "unreadEmails": "E-mails não lidos",
      "needReplyToday": "Precisam de resposta hoje",
      "meetingsToday": "Reuniões hoje",
      "meetingsRemaining": "Reuniões restantes",
      "slackMentions": "Menções no Slack"
    },
    "input": {
      "placeholder": "Pergunte, peça, escreva…"
    },
    "attachments": {
      "dropHere": "Solte as imagens aqui",
      "attachLabel": "Anexar uma imagem",
      "openImage": "Abrir imagem",
      "userUploadCaption": "Imagem que você anexou",
      "errors": {
        "tooMany": "Você pode anexar no máximo {{max}} imagens por mensagem."
      }
    },
    "banner": {
      "draftsPending": "{{count}} rascunhos aguardando sua aprovação",
      "draftsPendingSub": "— nenhuma mensagem é enviada sem o seu clique",
      "viewPending": "Ver pendentes",
      "workingInParallel": "Trabalhando em paralelo",
      "workingInParallelSub": "— você pode continuar usando o chat normalmente",
      "pauseAll": "Pausar tudo",
      "allSent": "Tudo enviado com sucesso",
      "allSentSub": "— {{count}} e-mails entregues agora mesmo",
      "viewSent": "Ver enviados"
    },
    "draft": {
      "proposedReply": "Resposta proposta",
      "notSent": "Não enviado",
      "sentJustNow": "Enviado · agora mesmo",
      "edit": "Editar",
      "refineTone": "Refinar tom",
      "discard": "Descartar",
      "send": "Enviar",
      "sending": "Enviando…",
      "to": "Para",
      "cc": "Cc",
      "from": "De",
      "addCc": "+ Cc",
      "addCcPlaceholder": "e-mail ou nome",
      "removeCc": "Remover Cc",
      "clickToEdit": "Clique para editar",
      "tonePlaceholder": "Ou descreva um tom… ex.: 'entusiasmado, mas profissional'",
      "close": "Fechar",
      "editedByYou": "Editado por você",
      "editorPlaceholder": "Editar rascunho… (com suporte a texto formatado)",
      "tonePrefix": "Tom: {{tone}}",
      "taskCreatedInToDo": "Tarefa criada na sua lista de tarefas:",
      "attachmentsLabel": "{{count}} anexos",
      "actions": {
        "discard": "Descartar",
        "saveDraft": "Salvar rascunho",
        "saveAndSend": "Salvar e enviar",
        "openInGmail": "Abrir no Gmail",
        "viewInGmail": "Ver no Gmail",
        "retry": "Tentar novamente"
      },
      "status": {
        "draftSaved": "Rascunho salvo no Gmail",
        "sent": "Enviado"
      },
      "errors": {
        "noGmail": "Conecte sua conta do Gmail para salvar ou enviar rascunhos.",
        "scopeMissing": "Reconecte sua conta do Gmail para conceder a permissão de rascunho.",
        "generic": "Não foi possível acessar o Gmail. Tente novamente."
      },
      "confirmSend": {
        "title": "Enviar este e-mail?",
        "cancel": "Cancelar",
        "confirm": "Enviar agora",
        "toLabel": "Para",
        "ccLabel": "Cc",
        "subjectLabel": "Assunto",
        "fromLabel": "De"
      }
    },
    "batch": {
      "approveAndSendAll": "Aprovar e enviar todos os {{count}} de uma vez",
      "reviewedThem": "Já revisou? Você pode enviar em lote.",
      "sendCount": "Enviar {{count}} rascunhos",
      "sendingCount": "Enviando {{count}}…"
    },
    "calendar": {
      "day": "Dia",
      "week": "Semana",
      "free": "Bloco livre",
      "title": "Agenda de hoje",
      "meta": "{{count}} eventos",
      "noAccount": "Conecte uma conta Google para ver sua agenda.",
      "unavailable": "Não consegui exibir os resultados da agenda.",
      "openButton": "Abrir",
      "openButtonAriaLabel": "Abrir detalhes da reunião {{title}}"
    },
    "calendarInvite": {
      "unavailable": "Não foi possível exibir os detalhes da reunião.",
      "joinTeams": "Entrar no Microsoft Teams",
      "joinMeet": "Entrar no Google Meet",
      "joinZoom": "Entrar no Zoom",
      "joinWhereby": "Entrar no Whereby",
      "joinCalendly": "Entrar na reunião",
      "cancel": "Cancelar",
      "reschedule": "Reagendar"
    },
    "communications": {
      "title": "Comunicações recentes",
      "meta": "{{count}} itens",
      "metaTruncated": "{{count}}+ itens",
      "unavailable": "Não consegui exibir os resultados das mensagens.",
      "empty": "Nenhuma comunicação corresponde.",
      "yesterday": "Ontem",
      "unread": "Não lida",
      "category": {
        "primary": "Principal",
        "updates": "Atualizações",
        "promotions": "Promoções",
        "forums": "Fóruns",
        "social": "Social"
      }
    },
    "timeline": {
      "viewModeLabel": "Modo de visualização",
      "viewModeDay": "Dia",
      "viewModeWeek": "Semana",
      "allDayGroup": "Dia inteiro",
      "today": "Hoje"
    },
    "changes": {
      "applyingInParallel": "Aplicando {{count}} alterações em paralelo"
    },
    "tracker": {
      "taskN": "Tarefa {{n}} · {{label}}",
      "ready": "Pronto",
      "statusReady": "Pronto",
      "statusWorking": "Trabalhando",
      "working": "Trabalhando",
      "checkPattern": {
        "toolUsed": "Usou {{toolName}}",
        "toolFailed": "{{toolName}} falhou"
      }
    },
    "agentTimeline": {
      "working": "Trabalhando…",
      "expand": "Mostrar etapas",
      "ariaPanel": "Status de processamento do agente",
      "ariaLabel": "Linha do tempo do agente",
      "empty": "Nenhuma etapa ainda",
      "expandDetails": "Expandir detalhes da etapa",
      "collapseDetails": "Recolher detalhes da etapa",
      "completedHeader": "Concluído em {{time}} · {{steps}}",
      "completedHeaderNoTime": "Concluído · {{steps}}",
      "expandSteps": "Expandir etapas",
      "collapseSteps": "Recolher etapas",
      "stepsCount_one": "{{count}} etapa",
      "stepsCount_other": "{{count}} etapas",
      "stop": "Parar",
      "stopping": "Parando…",
      "stopError": "Não foi possível parar o agente",
      "tools": {
        "communicationsList": "Buscando comunicações…",
        "communicationGet": "Abrindo mensagem…",
        "communicationReport": "Gerando relatório de comunicações…",
        "calendarListEvents": "Lendo a agenda…",
        "calendarEventDetail": "Lendo detalhes do evento…",
        "listCalendarAccounts": "Listando contas de agenda…",
        "actOnCalendarInvites": "Processando convite da agenda…",
        "createCalendarEvent": "Criando evento na agenda…",
        "draftCompose": "Redigindo e-mail…",
        "actOnEmails": "Processando e-mails…",
        "createEmailLabel": "Criando etiqueta de e-mail…",
        "listEmailLabels": "Listando etiquetas de e-mail…",
        "proposeActions": "Preparando ações…",
        "proposeFlow": "Preparando fluxo…",
        "proposeCustomAgent": "Preparando agente…",
        "proposeSlackReply": "Redigindo resposta no Slack…",
        "sendDoboxSourceReply": "Respondendo no Slack…",
        "listSlackChannels": "Listando canais do Slack…",
        "findSlackUsers": "Procurando usuários do Slack…",
        "openSlackDm": "Abrindo DM no Slack…",
        "semanticSearch": "Buscando conteúdo relevante…",
        "slackMessageContext": "Carregando contexto da conversa…",
        "listDoboxes": "Consultando tarefas…",
        "getDoboxDetail": "Lendo detalhes da tarefa…",
        "listDoboxTaskGroups": "Listando grupos de tarefas…",
        "listTasksInList": "Lendo as tarefas desta lista…",
        "createDobox": "Criando tarefa…",
        "updateDobox": "Atualizando tarefa…",
        "deleteDobox": "Excluindo tarefa…",
        "resolveDobox": "Concluindo tarefa…",
        "moveDobox": "Movendo tarefa…",
        "addDoboxComment": "Adicionando comentário à tarefa…",
        "acceptDoboxSuggestion": "Aceitando sugestão…",
        "createDoboxLabel": "Criando etiqueta de tarefa…",
        "updateDoboxCollections": "Atualizando coleções de tarefas…",
        "createTaskGroup": "Criando grupo de tarefas…",
        "updateTaskGroupParticipants": "Atualizando participantes…",
        "listTeamMembers": "Consultando membros da equipe…",
        "findUserByEmail": "Resolvendo contato…",
        "resolvePerson": "Buscando uma pessoa…",
        "showIntegrationCard": "Exibindo integração…",
        "produceReport": "Produzindo relatório…",
        "delegateParallel": "Delegando tarefas…",
        "listFlows": "Listando fluxos…",
        "getFlow": "Lendo fluxo…",
        "runFlowNow": "Executando fluxo…",
        "listCustomAgents": "Listando agentes…",
        "echo": "Echo…",
        "mcpTool": "Chamando ferramenta externa…",
        "unknown": "Executando…",
        "listTeamsChats": "Listando chats do Teams…",
        "listTeamsChannels": "Listando canais do Teams…",
        "teamsChatContext": "Carregando contexto da conversa do Teams…",
        "proposeTeamsReply": "Redigindo resposta do Teams…"
      }
    },
    "scene": {
      "allSentAnythingElse": "Tudo enviado. Mais alguma coisa?"
    },
    "run": {
      "error": "Algo deu errado: {{message}}"
    },
    "locked": {
      "tooltip": "Aguarde o agente terminar."
    },
    "queue": {
      "waiting": "Aguardando envio",
      "protocolConfirmed": "Aprovação na fila",
      "protocolCancelled": "Cancelamento na fila",
      "protocolPicker": "Escolha na fila"
    },
    "error": {
      "concurrentRun": "Outra solicitação ainda está sendo processada. Aguarde."
    },
    "commands": {
      "clear": {
        "description": "Limpar a conversa e redefinir o contexto",
        "confirmationBody": "Isso vai iniciar uma nova conversa. As mensagens anteriores ficam arquivadas para auditoria, mas o agente vai perder todo o contexto.",
        "confirmButton": "Limpar conversa"
      },
      "modal": {
        "title": "/{{command}}"
      },
      "menu": {
        "label": "Comandos disponíveis",
        "empty": "Nenhum comando ou agente correspondente",
        "emptyHint": "Apague até o / para ver a lista completa.",
        "shortcuts": {
          "navigate": "Navegar",
          "run": "Executar",
          "complete": "Completar",
          "close": "Fechar"
        }
      },
      "errors": {
        "cannotClearDuringRun": "Aguarde o agente terminar antes de limpar.",
        "unknownCommand": "Nenhum comando correspondente. Pressione Esc para dispensar.",
        "commandFailed": "Não foi possível executar o comando. Tente novamente."
      },
      "agentRun": {
        "defaultPrompt": "Execute seu objetivo agora."
      },
      "actions": {
        "manageBoardAgents": {
          "title": "Adicionar agente ao grupo de tarefas",
          "description": "Fica disponível para todas as tarefas do grupo"
        }
      }
    },
    "mention": {
      "pickerLabel": "Selecione um contato",
      "empty": "Nenhum contato correspondente",
      "source": {
        "slack": "Slack",
        "teams": "Teams",
        "thisThat": "t+t",
        "outlook": "Outlook",
        "gmail": "Gmail",
        "googleChat": "Google Chat",
        "google": "Google"
      }
    },
    "overnight": {
      "eyebrow": "Durante a noite · {{from}} → {{to}}",
      "title": "Sua noite foi tranquila — {{count}} item para revisar",
      "titlePlural": "Sua noite foi tranquila — {{count}} itens para revisar",
      "periodSummary": "{{from}} → {{to}} · {{duration}}",
      "statsLabels": {
        "mentions": "menções",
        "dms": "DMs",
        "threadsActive": "threads ativas",
        "emails": "e-mails",
        "invites": "convites"
      },
      "needsReplyTitle": "Precisa da sua atenção",
      "fyiTitle": "Vale uma olhada",
      "noiseTitle": "Filtrado como ruído",
      "noiseSummary": "{{count}} notificações",
      "replyAction": "Responder",
      "delegateAction": "Delegar",
      "openFullAction": "Abrir completo",
      "replyingState": "Enviando…",
      "sendingState": "Enviando…",
      "sentState": "Respondido",
      "delegatedState": "Agente cuidando disso",
      "urgentPill": "Urgente",
      "mentionPill": "@você",
      "threadCount": "{{count}} resposta na thread",
      "threadCountPlural": "{{count}} respostas na thread",
      "noiseExpand": "Mostrar",
      "noiseCollapse": "Ocultar",
      "sectionAriaLabel": "Seção {{title}}",
      "sourceSlackFallback": "Slack",
      "sourceEmailFallback": "E-mail"
    },
    "communicationReport": {
      "header": {
        "eyebrow": "Relatório de comunicações · {{from}} → {{to}}",
        "title": "{{count}} itens para revisar neste período"
      },
      "stats": {
        "mentions": "{{count}} menções",
        "dms": "{{count}} DMs",
        "threads": "{{count}} threads",
        "emails": "{{count}} e-mails",
        "invites": "{{count}} convites"
      },
      "sections": {
        "needsReply": "Precisa da sua resposta",
        "fyi": "FYI · ler depois"
      },
      "noise": {
        "toggle": "Ruído filtrado"
      },
      "actions": {
        "reply": "Responder",
        "delegate": "Delegar",
        "openFull": "Abrir completo",
        "replyTooltip": "Responder",
        "delegateTooltip": "Delegar ao agente",
        "archive": "Arquivar",
        "delete": "Excluir",
        "archived": "Arquivado",
        "deleted": "Excluído",
        "undo": "Desfazer",
        "archiveError": "Não foi possível arquivar o e-mail",
        "deleteError": "Não foi possível excluir o e-mail",
        "archiving": "Arquivando…",
        "deleting": "Excluindo…"
      },
      "pills": {
        "urgent": "URGENTE",
        "mention": "@você"
      },
      "threadCount": "{{count}} resposta na thread",
      "threadCountPlural": "{{count}} respostas na thread",
      "sourceSlackFallback": "Slack",
      "sourceEmailFallback": "E-mail",
      "unavailable": "Não foi possível carregar o relatório de comunicações."
    },
    "inputContext": {
      "delegateLabel": "Delegando: {{label}}",
      "replyLabel": "Respondendo a {{label}}",
      "brainPageLabel": "Brain: {{label}}",
      "doboxLabel": "DoBox: {{label}}",
      "clear": "Limpar contexto"
    },
    "selectedAgentChip": {
      "clearAriaLabel": "Remover agente selecionado"
    },
    "slackReply": {
      "channelLabel": "Canal",
      "workspaceLabel": "Workspace",
      "repliedAsThread": "Na thread",
      "repliedAsChannel": "Também em {{channel}}",
      "repliedAsDm": "Como DM",
      "sendReply": "Enviar para o Slack",
      "sending": "Enviando…",
      "threadHeader": "Thread",
      "yourReply": "Sua resposta",
      "notSent": "Não enviada",
      "sent": "Enviada · agora mesmo",
      "edit": "Editar",
      "refineTone": "Refinar tom",
      "customTonePlaceholder": "Ou descreva um tom…",
      "discard": "Descartar",
      "editReply": "Editar resposta",
      "cancel": "Cancelar",
      "close": "Fechar",
      "replyAsLabel": "Responder",
      "replyAs": {
        "thread": "Na thread",
        "channel": "Também no canal",
        "dm": "Como DM"
      },
      "editedByYou": "Editada por você",
      "tonePrefix": "Tom: {{tone}}",
      "editorPlaceholder": "Responder na thread… (com suporte a markdown)",
      "send": "Enviar",
      "placeholder": "Edite sua resposta…",
      "unavailable": "Não foi possível exibir a resposta do Slack.",
      "dmFallbackHeader": "Mensagem direta"
    },
    "emailCard": {
      "openFull": "Abrir completo"
    },
    "emailFullView": {
      "close": "Fechar",
      "archive": "Arquivar",
      "delegate": "Delegar ao agente",
      "openInInbox": "Abrir na Caixa de entrada",
      "reply": "Responder",
      "forward": "Encaminhar",
      "cancel": "Cancelar",
      "viewModeModal": "Modal",
      "viewModeSidePanel": "Painel lateral",
      "viewModeAriaLabel": "Modo de visualização",
      "replyTo": "Responder a",
      "forwardTo": "Encaminhar para",
      "composeReplyPlaceholder": "Escreva sua resposta para {{name}}…",
      "composeForwardRecipientPlaceholder": "destinatario@…",
      "composeForwardNotePlaceholder": "Adicione uma observação (opcional)…",
      "starred": "Com estrela",
      "draftWithAgent": "Rascunhar com o agente",
      "loading": "Carregando e-mail…"
    },
    "invite": {
      "respondYes": "Sim",
      "respondMaybe": "Talvez",
      "respondNo": "Não",
      "proposeNewTime": "Novo horário",
      "attendeesAcceptedCount": "{{count}} sim",
      "attendeesPendingCount": "{{count}} aguardando",
      "attendeesMaybeCount": "{{count}} talvez",
      "attendeesDeclinedCount": "{{count}} não",
      "conflictWarning": "Conflito na sua agenda",
      "conflictDetail": "{{time}} — {{title}}",
      "viaVideo": "Chamada de vídeo",
      "atLocation": "Local",
      "durationLabel": "{{duration}}",
      "guestsLabel": "{{count}} convidados",
      "statusAwaitingReply": "Aguardando sua resposta",
      "statusAccepted": "Aceito",
      "statusGoing": "Confirmado",
      "statusMaybe": "Talvez",
      "statusDeclined": "Recusado",
      "googleCalendarSource": "Google Calendar",
      "invitationFrom": "Convite de {{name}}",
      "showMore": "+ {{count}} mais",
      "attendeeYou": "você",
      "attendeeOrganizer": "organizador",
      "addPeopleButton": "Adicionar pessoas",
      "addPeoplePlaceholder": "email1@example.com, email2@example.com",
      "addPeopleSubmit": "Convidar",
      "addPeopleCancel": "Cancelar",
      "addPeopleInvalidEmail": "Insira pelo menos um e-mail válido."
    },
    "accountPicker": {
      "title": "Escolher conta",
      "subtitle": "Escolha qual conta usar",
      "unavailable": "Não foi possível exibir suas contas.",
      "selectedPrompt": "Usar {{email}}."
    },
    "actionProposal": {
      "title": "Ações para confirmar",
      "selectAll": "Selecionar tudo",
      "clear": "Limpar",
      "cancel": "Cancelar",
      "confirm": "Confirmar",
      "confirmSingle": "Confirmar",
      "consumedConfirmed": "{{count}} ação(ões) confirmada(s)",
      "consumedCancelled": "Cancelado",
      "consumedAutoExecuted": "{{count}} ação(ões) executada(s) automaticamente",
      "consumedAutoExecutedWithErrors": "{{count}} ação(ões) executada(s) (algumas falharam)",
      "consumedSuperseded": "Substituída por uma proposta mais recente",
      "unavailable": "Não foi possível exibir a proposta de ações.",
      "alwaysConfirm": "Sempre para isso",
      "effect": {
        "tools": {
          "send_slack_bot_message": "Enviar mensagem no Slack",
          "send_notification_email": "Enviar e-mail",
          "gbp_reply_review": "Responder avaliação do Google Meu Negócio",
          "facebook_reply_comment": "Responder comentário no Facebook",
          "facebook_publish_post": "Publicar post no Facebook",
          "instagram_reply_comment": "Responder comentário no Instagram",
          "instagram_publish_post": "Publicar post no Instagram",
          "create_calendar_event": "Criar evento no calendário",
          "act_on_calendar_invites": "Responder convites do calendário",
          "send_dobox_source_reply": "Responder na conversa do Slack da tarefa"
        },
        "fields": {
          "to": "Para: {{value}}",
          "target": "Destino: {{value}}",
          "subject": "Assunto: {{value}}",
          "preview": "{{value}}",
          "moreRecipients": "+{{count}} mais",
          "attachments": "Anexos ({{count}})",
          "workspace": "Workspace: {{value}}"
        }
      }
    },
    "emailLabelPicker": {
      "title": "Escolher etiqueta",
      "subtitle": "Escolha qual etiqueta usar",
      "unavailable": "Não foi possível exibir as etiquetas.",
      "selectedPrompt": "Usar a etiqueta '{{name}}' (id: {{id}})."
    },
    "slackScopePicker": {
      "title": "Filtrar escopo do Slack",
      "subtitle": "Escolha quais mensagens mostrar",
      "allChip": "Todos os canais e DMs",
      "dmChip": "Somente DMs",
      "moreChip": "+{{count}} mais",
      "unavailable": "Não foi possível exibir os canais do Slack.",
      "workspaceChip": "Tudo em {{workspace}}"
    },
    "dobox": {
      "list": {
        "title": "Tarefas",
        "empty": "Nenhum DoBox corresponde aos seus filtros.",
        "meta": "{{count}} itens",
        "metaTruncated": "{{count}} itens (há mais — refine os filtros)",
        "labelCount": "{{count}} etiqueta",
        "selectItem": "Selecionar {{subject}}"
      },
      "detail": {
        "unavailable": "Não foi possível exibir os detalhes do DoBox.",
        "attached": "{{count}} anexados",
        "comments": "{{count}} comentários"
      },
      "priority": {
        "urgent": "Urgente",
        "high": "Alta",
        "medium": "Média",
        "low": "Baixa",
        "none": "Nenhuma"
      },
      "suggestion": "Sugestão",
      "resolved": "Concluída",
      "editPriority": "Editar prioridade",
      "editDueDate": "Editar prazo",
      "setDueDate": "Definir prazo",
      "clearDueDate": "Limpar",
      "addLabel": "Adicionar etiqueta",
      "removeLabel": "Remover etiqueta",
      "saving": "Salvando…",
      "dueDateSavePicker": {
        "save": "Salvar",
        "cancel": "Cancelar"
      },
      "actions": {
        "markDone": "Concluir",
        "accept": "Aceitar",
        "dismiss": "Dispensar",
        "move": "Mover para...",
        "cancel": "Cancelar",
        "reopen": "Reabrir",
        "markingDone": "Concluindo...",
        "accepting": "Aceitando...",
        "moving": "Movendo..."
      },
      "batch": {
        "markDone": "Concluir {{count}}",
        "moveTo": "Mover {{count}} para...",
        "cancel": "Cancelar",
        "selected": "{{count}} selecionadas"
      },
      "filter": {
        "status": {
          "open": "Abertas",
          "resolved": "Resolvidas",
          "suggestions": "Sugestões",
          "all": "Todas"
        },
        "priority": {
          "urgent": "Urgente",
          "high": "Alta",
          "medium": "Média",
          "low": "Baixa"
        },
        "due": {
          "overdue": "Atrasadas",
          "today": "Hoje",
          "thisWeek": "Esta semana"
        }
      },
      "editSubject": "Editar assunto",
      "editDescription": "Editar descrição",
      "descriptionPlaceholder": "Adicionar descrição…",
      "addPerson": "Adicionar pessoa",
      "removePerson": "Remover pessoa",
      "searchPersonPlaceholder": "E-mail ou nome…",
      "searchPersonHint": "Digite para buscar por e-mail ou nome…",
      "noPersonMatches": "Nenhum resultado",
      "userNotFound": "Usuário não encontrado no sistema. Peça para a pessoa criar uma conta primeiro.",
      "comments": {
        "title": "Comentários",
        "empty": "Nenhum comentário ainda.",
        "viewAll": "Ver todos ({{count}})",
        "placeholder": "Adicionar um comentário…",
        "send": "Enviar"
      },
      "openFull": "Abrir completo",
      "openFullAria": "Abrir visualização completa do DoBox",
      "fullView": {
        "close": "Fechar",
        "closeAria": "Fechar visualização completa do DoBox",
        "loading": "Carregando…",
        "error": "Não foi possível carregar os detalhes do DoBox."
      },
      "delegatedTicket": "Ticket delegado",
      "viaTicketPrefix": "via ticket",
      "viaTicketFallbackLabel": "ticket",
      "openTicketAriaLabel": "Abrir \"{{subject}}\" no DoBox"
    },
    "taskGroupPicker": {
      "title": "Escolher grupo de tarefas",
      "unavailable": "Não foi possível exibir os grupos de tarefas."
    },
    "report": {
      "metadataLabel": "Detalhes"
    },
    "teamMembers": {
      "title": "Membros da equipe",
      "countSingular": "{{count}} membro",
      "countPlural": "{{count}} membros",
      "empty": "Nenhum membro na equipe",
      "truncated": "e mais"
    },
    "slackConversations": {
      "title": "Conversas do Slack",
      "channelPrefix": "#{{name}}",
      "dmPrefix": "@{{name}}",
      "fallbackChannel": "{{id}}…",
      "loadError": "Não foi possível carregar a thread completa; mostrando mensagens recentes.",
      "showingLast": "Mostrando as últimas {{count}} mensagens",
      "replyPlaceholder": "Responder a {{name}}…",
      "send": "Enviar",
      "sending": "Enviando…",
      "replyFailed": "Não foi possível enviar — tente novamente",
      "you": "Você",
      "shortcutHint": "{{shortcut}} para enviar",
      "missingWorkspace": "Não é possível enviar: faltam informações do workspace.",
      "replyInThread": "Responder na thread",
      "inThread": "na thread",
      "draft": "Rascunhar com IA",
      "drafting": "Rascunhando…",
      "draftFailed": "Não foi possível rascunhar uma resposta",
      "replyHelpText": "Digite sua resposta ou descreva o que dizer e clique em ✨ para rascunhos com IA",
      "dismissDrafts": "Dispensar rascunhos",
      "variant": {
        "short": "Curta",
        "friendly": "Amigável",
        "formal": "Formal"
      }
    },
    "integrationCard": {
      "title": {
        "google": "Google",
        "microsoft": "Outlook",
        "outlookMail": "Outlook Mail",
        "outlookCalendar": "Outlook Calendar",
        "teams": "Microsoft Teams",
        "slack": "Slack",
        "mcp": "Integrações MCP",
        "tavily": "Acesso à web via Tavily",
        "windsor": "Análises do Windsor.ai"
      },
      "description": {
        "google": "Conecte seu Gmail e Google Calendar",
        "microsoft": "Conecte seu email e calendário do Outlook",
        "outlookMail": "Conecte sua caixa de e-mail do Outlook",
        "outlookCalendar": "Conecte sua agenda do Outlook",
        "teams": "Conecte seus chats e canais do Microsoft Teams",
        "slack": "Conecte seu workspace do Slack",
        "mcp": "Conecte ferramentas e fontes de dados externas",
        "windsor": "Conecte dados de marketing, CRM e e-commerce"
      },
      "tavily": {
        "description": "Conecte o Tavily para permitir que o assistente pesquise na web, leia artigos e monitore sites.",
        "step1": "Crie uma conta no Tavily",
        "step2": "Gere uma URL de MCP remoto no painel",
        "step3": "Cole a URL nas suas integrações MCP",
        "openTavilyCta": "Abrir Tavily",
        "openMcpSettingsCta": "Abrir configurações de MCP",
        "manageCta": "Gerenciar",
        "connectedAt": "Conectado"
      },
      "windsor": {
        "description": "Conecte o Windsor.ai para consultar análises de marketing, CRM e e-commerce a partir do assistente.",
        "step1": "Abra o Windsor.ai",
        "step2": "Crie ou copie sua chave de API do Windsor",
        "step3": "Adicione o Windsor.ai nas configurações de MCP com autenticação Bearer Token",
        "openWindsorCta": "Abrir Windsor.ai",
        "openMcpSettingsCta": "Abrir configurações de MCP",
        "manageCta": "Gerenciar",
        "connectedAt": "Conectado"
      },
      "status": {
        "connected": "Conectado",
        "notConnected": "Não conectado",
        "justConnected": "Recém-conectado"
      },
      "actions": {
        "connect": "Conectar",
        "addAccount": "Adicionar conta",
        "manageSettings": "Gerenciar nas Configurações",
        "addMcp": "Adicionar MCP",
        "manageMcp": "Gerenciar MCPs"
      },
      "accounts": "Conectado: {{accounts}}",
      "mcpConnectionsOverflow": "+{{count}} mais"
    },
    "mcpResultCard": {
      "header": "MCP: {{tool}}",
      "errorBadge": "Erro",
      "expand": "Mostrar detalhes",
      "collapse": "Ocultar detalhes",
      "copy": "Copiar resultado",
      "copied": "Copiado!",
      "truncated": "... (truncado, copie para ver tudo)",
      "tool": "Ferramenta: {{name}}"
    },
    "flowPreview": {
      "title": "Fluxo proposto",
      "draft": "Rascunho",
      "confirmed": "Criado",
      "cancelled": "Cancelado",
      "actions": {
        "cancel": "Cancelar",
        "openInEditor": "Abrir no editor",
        "create": "Criar fluxo"
      },
      "fields": {
        "name": "Nome",
        "trigger": "Gatilho",
        "steps": "Etapas",
        "branchSteps": "Etapas dentro deste ramo",
        "team": "Equipe"
      },
      "values": {
        "personal": "Pessoal (sem equipe)"
      }
    },
    "agentTemplatePreview": {
      "title": "Agente personalizado proposto",
      "actions": {
        "cancel": "Cancelar",
        "openInEditor": "Abrir no editor",
        "create": "Criar agente"
      },
      "fields": {
        "name": "Nome",
        "description": "Descrição",
        "systemPrompt": "Prompt de sistema",
        "toolSets": "Conjuntos de ferramentas",
        "mcpConnections": "Conexões MCP",
        "modelTier": "Nível do modelo",
        "maxTurns": "Máximo de turnos",
        "icon": "Ícone",
        "team": "Equipe"
      },
      "values": {
        "personal": "Pessoal (sem equipe)",
        "default": "Padrão",
        "noMcpConnections": "Nenhuma",
        "noToolSets": "Nenhum",
        "noIcon": "Nenhum"
      }
    },
    "dock": {
      "backgroundTasks": "Tarefas em segundo plano"
    },
    "flowReportCard": {
      "label": "Relatório do fluxo",
      "openFlow": "Abrir fluxo"
    },
    "askUserCard": {
      "label": "Decisão de fluxo necessária",
      "answered": "Respondido: {{value}}",
      "chooseOption": "Escolha uma opção",
      "error": "Falha ao enviar sua resposta. Tente novamente.",
      "expired": "Esta solicitação já foi tratada ou não está mais ativa.",
      "expiredToast": "Esta solicitação já foi tratada ou não está mais ativa."
    },
    "teamRequestComposer": {
      "label": "Solicitação de {{fromUserName}}",
      "requestLabel": "O que estão pedindo",
      "replyPlaceholder": "Escreva sua resposta…",
      "attachmentsLabel": "Anexar páginas do Brain",
      "attachSearchPlaceholder": "Busque no seu Brain…",
      "send": "Compartilhar",
      "decline": "Recusar",
      "sentState": "Resposta enviada para {{fromUserName}}",
      "declinedState": "Recusado — nenhuma resposta enviada para {{fromUserName}}",
      "expiredToast": "Esta solicitação já foi tratada ou expirou.",
      "expired": "Esta solicitação já foi tratada ou expirou.",
      "sendError": "Falha ao enviar sua resposta. Tente novamente.",
      "noResults": "Nenhuma página do Brain encontrada",
      "removeAttachment": "Remover {{title}}"
    },
    "teamRequestReply": {
      "label": "Resposta de {{fromUserName}}",
      "originalRequest": "Solicitação original",
      "attachmentsLabel": "Anexos",
      "attachmentKindBrainPage": "Página do Brain",
      "attachmentKindDobox": "DoBox",
      "attachmentKindEmail": "E-mail"
    },
    "meetingPoll": {
      "from": "De {{name}}",
      "duration": "{{minutes}} min",
      "bookSlot": "Reservar este horário",
      "decline": "Nenhum desses funciona",
      "confirmed": "Reservado — {{slot}}",
      "declined": "Recusado — nenhum horário selecionado",
      "expired": "Esta enquete expirou",
      "errors": {
        "bookFailed": "Não foi possível reservar este horário. Tente novamente.",
        "declineFailed": "Não foi possível recusar. Tente novamente."
      },
      "timesIn": "Horários em {{tz}}"
    },
    "meetingPollSent": {
      "waiting": "Aguardando uma resposta",
      "waitingRecipient": "Aguardando {{name}} responder",
      "confirmed": "Horário confirmado",
      "declined": "Recusado pelo destinatário",
      "slotsCount": "{{count}} horário(s) proposto(s)",
      "timesIn": "Horários em {{tz}}"
    },
    "artifact": {
      "loading": "Carregando pré-visualização…",
      "error": "Não foi possível carregar a pré-visualização. Tente atualizar.",
      "download": "Baixar",
      "exportPdf": "Baixar PDF",
      "exportingPdf": "Preparando PDF…",
      "expand": "Expandir",
      "close": "Fechar",
      "versionPrefix": "v{{version}}",
      "previewTitle": "Pré-visualização: {{title}}",
      "status": {
        "draft": "Rascunho",
        "published": "Publicado"
      },
      "type": {
        "page": "Página",
        "landing": "Landing page",
        "presentation": "Apresentação",
        "microsite": "Microsite"
      },
      "publish": "Publicar",
      "publishing": "Publicando…",
      "unpublish": "Despublicar",
      "publicUrlLabel": "URL pública",
      "copyLink": "Copiar link",
      "copied": "Copiado!",
      "open": "Abrir em nova aba",
      "errors": {
        "downloadFailed": "Não foi possível baixar o arquivo. Tente novamente.",
        "publishFailed": "Não foi possível publicar o artefato. Tente novamente.",
        "copyFailed": "Não foi possível copiar o link. Tente novamente.",
        "exportPdfFailed": "Não foi possível gerar o PDF. Tente novamente."
      }
    },
    "delegatedTask": {
      "headerFallback": "Tarefa de código delegada",
      "status": {
        "queued": "Na fila…",
        "running": "Processando…",
        "done": "Concluída",
        "failed": "Falhou",
        "unreachable": "Inacessível",
        "unknown": "Status desconhecido",
        "paused": "Pausada",
        "canceled": "Cancelada"
      },
      "prButton": "Ver pull request",
      "errorFallback": "A tarefa falhou, mas nenhum detalhe do erro foi retornado.",
      "unreachableHint": "Sua máquina local pode estar offline ou inacessível."
    },
    "generatedImageCard": {
      "error": "Não foi possível carregar a imagem. Tente novamente.",
      "altFallback": "Imagem",
      "openLightbox": "Ver imagem em tela cheia"
    },
    "imageLightbox": {
      "close": "Fechar",
      "closeAria": "Fechar visualizador de imagem",
      "download": "Baixar",
      "delete": "Excluir",
      "backdropAria": "Fechar visualizador de imagem",
      "altFallback": "Imagem"
    },
    "statusDock": {
      "new": "Nova",
      "newAriaLabel": "Iniciar uma nova conversa",
      "history": "Histórico",
      "historyAriaLabel": "Ver histórico ({{count}} conversas)",
      "navAriaLabel": "Dock de status das conversas",
      "you": "VOCÊ",
      "pillAriaLabel": "{{title}} — {{state}}",
      "pillNeedsActionAriaLabel": "{{title}} — precisa da sua ação",
      "closePillAriaLabel": "Fechar conversa {{title}}",
      "historyTitle": "Histórico",
      "historyReopenAction": "Reabrir",
      "historyReopenAriaLabel": "Reabrir conversa {{title}}",
      "historyEmpty": "Nenhuma conversa arquivada",
      "historyDeleteAction": "Excluir",
      "historyDeleteAriaLabel": "Excluir conversa {{title}}",
      "historyDeleteConfirm": "Excluir permanentemente?",
      "historyDeleteConfirmYes": "Excluir",
      "historyDeleteConfirmNo": "Cancelar",
      "historyDeleting": "Excluindo…",
      "closingPill": "Fechando…",
      "closeConfirmTitle": "Fechar esta conversa?",
      "closeConfirmBody": "Esta conversa será movida para o histórico. Você pode reabri-la depois pelo menu Histórico.",
      "closeConfirmAction": "Fechar conversa",
      "contextMenu": {
        "close": "Fechar",
        "stop": "Parar",
        "rename": "Renomear"
      },
      "pickerAriaLabel": "Mostrar mais {{count}} conversas",
      "pickerButtonLabel": "+{{count}}",
      "pickerListAriaLabel": "Outras conversas ativas",
      "compactPickerAriaLabel": "Trocar de conversa, atualmente {{title}}",
      "openConversationsLabel": "Conversas abertas",
      "historyClearAll": "Limpar tudo",
      "historyClearAllConfirm": "Excluir tudo permanentemente?",
      "historyClearAllConfirmYes": "Excluir tudo",
      "historyClearAllConfirmCancel": "Cancelar"
    },
    "activity": {
      "searchedCommunications": "Comunicações pesquisadas",
      "results": "{{count}} resultados"
    },
    "pageCard": {
      "ariaLabel": "Abrir página do Brain: {{title}}",
      "openLabel": "Abrir página"
    },
    "teamsReply": {
      "notSent": "Não enviada",
      "sent": "Enviada · agora mesmo",
      "sendReply": "Enviar para o Teams",
      "sending": "Enviando…",
      "edit": "Editar",
      "editReply": "Editar resposta",
      "cancel": "Cancelar",
      "close": "Fechar",
      "editedByYou": "Editada por você",
      "editorPlaceholder": "Responder no chat… (com suporte a markdown)",
      "discard": "Descartar",
      "unavailable": "Não foi possível exibir a resposta do Teams.",
      "accountLabel": "Enviar de",
      "accountPlaceholder": "Escolha uma conta",
      "chooseAccountHint": "Mais de uma conta Microsoft tem o Teams habilitado — escolha de qual conta enviar.",
      "sendFailed": "Não foi possível enviar a resposta do Teams."
    },
    "delegateComposer": {
      "targetChip": {
        "to": "Para:",
        "assistant": "Assistente",
        "localClaude": "Local Claude — Mac",
        "ariaLabel": "Escolher para quem esta mensagem vai"
      },
      "planFirst": {
        "label": "Planejar antes, eu aprovo",
        "settingsAriaLabel": "Configurações de runtime e modelo"
      },
      "activeRun": {
        "notice": "Já existe uma execução ativa nesta tarefa, então ela ainda não pode ser delegada de novo. Encerre-a para delegar a este ou a outro agente.",
        "endRun": "Encerrar execução atual"
      },
      "delegateButtonLabel": "Delegar"
    }
  },
  "funnel": {
    "pageTitle": "Funil",
    "pageDescription": "Acompanhe cadastros e ativação em cada etapa do funil.",
    "explainer": {
      "toggle": "Notas",
      "section1": {
        "title": "Como 'Visualizações da página de marketing' e 'Visualizações da página de cadastro' são contadas?",
        "body": "Cada uma é a contagem de usuários únicos (métrica totalUsers do GA4) das páginas relevantes dentro da janela selecionada. Os visitantes das páginas de marketing cobrem o www; os visitantes de cadastro cobrem /signup. Visitantes recorrentes contam uma vez por dia. Uma ressalva: agregamos por dia e somamos ao longo do período, então um usuário que visitou em vários dias diferentes é contado por dia, não por pessoa. Trate os números principais como estimativas a poucos pontos percentuais dos únicos reais, não como contagens exatas — bom para acompanhar tendências de marketing e comparar campanhas, mas não preciso o suficiente para relatórios rigorosos de visitantes únicos."
      },
      "section2": {
        "title": "Por que as etapas podem não formar subconjuntos estritos?",
        "body": "As etapas são ordenadas pelo afunilamento da intenção de marketing — visitantes de marketing, depois visitantes de cadastro, depois cadastros, depois ativação, depois retenção —, mas pequenas violações de 'cada etapa cabe dentro da anterior' são esperadas. Um visitante que vai direto para /signup a partir de um link de e-mail pula a etapa da página de marketing. Um usuário que visitou /signup logo antes da janela e se cadastrou dentro dela vai aparecer nos cadastros sem uma linha correspondente de visita ao cadastro. Desvios grandes podem indicar um bug; desvios pequenos são o formato normal do tráfego real."
      },
      "section3": {
        "title": "Como a retenção e os marcos são calculados?",
        "body": "Todos os números abaixo de 'Cadastros' são restritos à coorte que se cadastrou dentro do intervalo de datas selecionado. 'Conectou a 1ª conta' significa 'desses cadastros, quantos depois conectaram uma conta' — não é 'contas conectadas neste intervalo'. A retenção (1d/7d/30d) só conta membros da coorte cuja data de cadastro tem pelo menos essa quantidade de dias, então usuários recém-cadastrados não puxam a taxa de retenção para baixo."
      },
      "section4": {
        "title": "O que significa '(total da campanha)' em campanhas de e-mail?",
        "body": "Enviados, Entregues, Aberturas e Cliques (total da campanha) vêm diretamente do HubSpot e cobrem toda a vida útil daquele e-mail — eles não respeitam o intervalo de datas. 'Visitas no período', logo abaixo, são os visitantes únicos trazidos pela campanha dentro da janela selecionada. Comparar os dois é como você descobre se uma campanha está trazendo pessoas novas ou reengajando as que já existem."
      },
      "section5": {
        "title": "Quais dados não são capturados?",
        "body": "Os dados de visitantes únicos de www.thisandthat.chat só são capturados a partir de {{coverageStart}}. Intervalos de datas anteriores a essa data vão subnotificar os visitantes desse hostname. A página /signup é rastreada desde fevereiro de 2025 e não é afetada."
      },
      "section6": {
        "title": "Por que os dados de 13–15 de abril de 2026 não são confiáveis?",
        "body": "O rastreamento estava sendo reconfigurado durante essa janela (correções de CSP, integração do CookieYes, lançamento do GCM v2), então o volume de pageviews e a atribuição de utm de 2026-04-13 a 2026-04-15 estão incompletos ou ausentes. Trate qualquer dado anterior a 2026-04-16 como parcial. O funil é confiável a partir de 2026-04-16."
      }
    },
    "tabs": {
      "ariaLabel": "Abas do funil",
      "funnel": "Funil",
      "trends": "Tendências"
    },
    "stages": {
      "title": "Etapas"
    },
    "funnel": {
      "noData": "Nenhum dado de funil disponível para os filtros selecionados."
    },
    "filters": {
      "from": "De",
      "to": "Até",
      "startDate": "Data inicial",
      "endDate": "Data final",
      "utmSource": "Origem UTM",
      "allSources": "Todas as origens",
      "showHidden": "Mostrar ocultas",
      "refresh": "Atualizar",
      "hideSource": "Ocultar origem",
      "unhideSource": "Mostrar origem",
      "hiddenSuffix": "(oculta)",
      "groupCampaigns": "Campanhas",
      "groupPages": "Páginas",
      "noDataInRangeSuffix": "(sem dados no período)",
      "dateRangeTooLarge": "O intervalo de datas não pode exceder 90 dias. Reduza sua seleção."
    },
    "toolbar": {
      "moreActions": "Mais ações"
    },
    "dateRange": {
      "yesterday": "Ontem",
      "last7Days": "Últimos 7 dias",
      "last30Days": "Últimos 30 dias",
      "last90Days": "Últimos 90 dias",
      "thisWeek": "Esta semana",
      "lastWeek": "Semana passada",
      "customRange": "Intervalo personalizado...",
      "apply": "Aplicar",
      "cancel": "Cancelar",
      "customLabel": "Personalizado"
    },
    "chart": {
      "fromPrev": "da etapa anterior",
      "overall": "geral",
      "noData": "Nenhum dado de funil disponível para os filtros selecionados.",
      "ariaLabel": "Gráfico de conversão do funil",
      "tooltipCount": "{{value}} {{label}}",
      "stepHeader": "Etapa",
      "overallHeader": "Geral"
    },
    "steps": {
      "uniquePageViews": "Visualizações da página de marketing",
      "uniqueSignupPageViews": "Visualizações da página de cadastro",
      "viewsCaveat": "Soma de visitantes únicos por dia e por caminho do GA4. Um usuário que vê 3 páginas em um dia conta como 3. Não é uma contagem real de pessoas únicas.",
      "signups": "Cadastros",
      "connected": "Conectou conta",
      "dobox": "Usou o DoBox",
      "retained1d": "Retido 1 dia",
      "retained7d": "Retido 7 dias",
      "retained30d": "Retido 30 dias"
    },
    "errors": {
      "hideSourceFailed": "Falha ao ocultar a origem.",
      "unhideSourceFailed": "Falha ao mostrar a origem.",
      "refreshFailed": "Falha ao atualizar os dados.",
      "exportFailed": "Falha ao exportar os usuários do funil."
    },
    "export": {
      "button": "Exportar CSV",
      "exporting": "Exportando…"
    },
    "trends": {
      "title": "Tendências semanais",
      "weekStarting": "semana iniciando em",
      "legend": "verde alta · vermelho queda vs. semana anterior · * semana parcial",
      "weekOf": "Semana de {{date}}",
      "partialWeek": "Semana parcial",
      "noData": "Nenhum dado de tendência disponível para os filtros selecionados.",
      "step": "Etapa",
      "count": "Contagem",
      "rate": "Taxa",
      "showWeeks": "Ver semanas",
      "hideWeeks": "Ocultar semanas"
    },
    "common": {
      "hide": "Ocultar origem",
      "unhide": "Mostrar origem",
      "refresh": "Atualizar",
      "hiddenBadge": "oculta"
    },
    "emailStats": {
      "ariaLabel": "Estatísticas de campanhas de e-mail",
      "heading": "Desempenho de e-mail",
      "openRate": "Taxa de abertura",
      "clickThroughRate": "Taxa de cliques",
      "bounces": "Devoluções (bounces)",
      "unsubscribes": "Descadastros",
      "spamReports": "Denúncias de spam"
    },
    "emailHeader": {
      "sentPrefix": "Enviado"
    },
    "emailNotice": {
      "noData": "Ainda não há dados do HubSpot para esta campanha. Mostrando o funil padrão. Os dados vão aparecer após a próxima ingestão diária."
    },
    "intent": {
      "title": "Conversão por segmento de intenção",
      "firstTouch": "Atribuição first-touch",
      "excludeManual": "Excluir outreach manual",
      "summary": "Alta intenção {{high}}% · Pago {{paid}}% · Social {{social}}% · E-mail {{email}}% · Direto {{direct}}% · Orgânico {{organic}}% · Baixa intenção {{low}}%",
      "remainderNote": "O que faltar para 100% é tráfego de first-touch não atribuído.",
      "coverageNote": "A cobertura de first-touch começou em {{coverageStart}}. As visualizações de página dependem de consentimento: leia tendências e comparações, não níveis absolutos.",
      "loadError": "Falha ao carregar os segmentos de intenção.",
      "empty": "Nenhum dado para este período.",
      "columns": {
        "segment": "Segmento",
        "intent": "Intenção",
        "visitors": "Visitantes",
        "signups": "Cadastros",
        "connected": "Conectados",
        "conversion": "Conversão"
      },
      "tag": {
        "high": "alta",
        "low": "baixa"
      },
      "segments": {
        "product": "Produto (avaliando)",
        "comparison": "Comparação (concorrentes)",
        "ai-referral": "Indicação de assistente de IA",
        "paid": "Anúncios pagos (Google / Meta)",
        "social": "Social (posts orgânicos)",
        "email": "E-mail (nossa lista)",
        "direct": "Direto (sem referência)",
        "organic-search": "Busca orgânica",
        "referral": "Referência (outros sites)",
        "informational": "Informacional (estatísticas)",
        "editorial": "Editorial (conteúdo autoral)",
        "other": "Outro (não reconhecido)",
        "unknown-first-touch": "First-touch desconhecido"
      }
    },
    "utm": {
      "title": "Cadastros por origem UTM",
      "showingAll": "mostrando todas",
      "zeroHidden": "{{count}} origens com 0 cadastros ocultas",
      "empty": "Nenhuma origem UTM para este período."
    },
    "users": {
      "adminOnly": "somente admin · e-mails",
      "sortedBy": "ordenado por {{column}}"
    }
  },
  "admin": {
    "dataTable": {
      "sortBy": "Ordenar por",
      "sortMenuAriaLabel": "Ordenar por uma coluna oculta"
    },
    "pageInfo": {
      "ariaLabel": "Informações da página"
    },
    "funnel": {
      "users": {
        "tableTitle": "Cadastros por usuário",
        "empty": "Nenhum cadastro nesta janela.",
        "column": {
          "userId": "ID do usuário",
          "id": "ID",
          "email": "E-mail",
          "name": "Nome",
          "signupDate": "Cadastro",
          "utmSource": "Origem UTM",
          "manualSource": "Manual",
          "deepestStep": "Etapa",
          "lastActive": "Atividade",
          "firstTouchUtmSource": "First touch"
        },
        "loading": "Carregando cadastros…",
        "manualSource": {
          "inputLabel": "Origem manual",
          "saveError": "Não foi possível salvar a origem manual. Tente novamente."
        }
      }
    }
  },
  "featureDemo": {
    "inboxSorting": {
      "title": "Caixa de entrada",
      "allCaughtUp": "Tudo em dia ✓",
      "tags": {
        "toRespond": "Responder",
        "meetingUpdate": "Atualização de reunião",
        "fyi": "FYI",
        "toReview": "Revisar",
        "promotion": "Promoção",
        "summary": "Resumo"
      },
      "summaryEmail": {
        "label": "Resumo do fim do dia",
        "sender": "Assistente this+that",
        "subject": "4 promoções arquivadas hoje",
        "preview": "Hoje arquivei 4 e-mails promocionais para você: Amazon · Booking.com · Spotify · Nike — toque para revisar",
        "time": "18:00"
      },
      "emails": [
        {
          "sender": "Nadia Osei",
          "subject": "Revisão do orçamento do Q4",
          "preview": "Olá, pessoal, queria retomar a discussão de ontem sobre a alocação do Q4...",
          "time": "14:34",
          "tagKey": "toRespond",
          "tagColor": "orange",
          "avatarColor": "pink",
          "isPromo": false
        },
        {
          "sender": "Amazon",
          "subject": "🎉 Oferta relâmpago: 50% de desconto só hoje!",
          "preview": "Não perca — a maior promoção da temporada termina hoje à meia-noite...",
          "time": "14:12",
          "tagKey": "promotion",
          "tagColor": "rose",
          "avatarColor": "amber",
          "isPromo": true
        },
        {
          "sender": "John Martinez",
          "subject": "Reunião amanhã às 14h",
          "preview": "Só confirmando nossa conversa amanhã à tarde para discutir o cronograma do projeto...",
          "time": "13:15",
          "tagKey": "meetingUpdate",
          "tagColor": "violet",
          "avatarColor": "violet",
          "isPromo": false
        },
        {
          "sender": "Booking.com",
          "subject": "✈️ Viagens dos sonhos a partir de US$ 299",
          "preview": "Escapadas de fim de semana que você vai amar. Reserve até domingo e economize na sua próxima viagem...",
          "time": "12:48",
          "tagKey": "promotion",
          "tagColor": "rose",
          "avatarColor": "teal",
          "isPromo": true
        },
        {
          "sender": "Equipe Jurídica",
          "subject": "Contrato aguardando revisão",
          "preview": "Por favor, revise o contrato em anexo e envie seu feedback até o fim da semana...",
          "time": "11:42",
          "tagKey": "fyi",
          "tagColor": "yellow",
          "avatarColor": "emerald",
          "isPromo": false
        },
        {
          "sender": "Spotify",
          "subject": "🎵 Seu Descobertas da Semana chegou",
          "preview": "Músicas novas escolhidas para você — 30 faixas para explorar esta semana...",
          "time": "11:20",
          "tagKey": "promotion",
          "tagColor": "rose",
          "avatarColor": "lime",
          "isPromo": true
        },
        {
          "sender": "Anna Williams",
          "subject": "Documentos de kickoff do projeto",
          "preview": "Em anexo estão os documentos de kickoff da nova iniciativa. Revise e compartilhe...",
          "time": "10:55",
          "tagKey": "toReview",
          "tagColor": "blue",
          "avatarColor": "sky",
          "isPromo": false
        },
        {
          "sender": "Nike",
          "subject": "👟 Nova coleção acaba de chegar",
          "preview": "Seja o primeiro a comprar os modelos de edição limitada — membros têm acesso antecipado...",
          "time": "10:30",
          "tagKey": "promotion",
          "tagColor": "rose",
          "avatarColor": "red",
          "isPromo": true
        }
      ]
    },
    "slackChannels": {
      "windowTitle": "Slack",
      "workspaceName": "Acme Workspace",
      "sectionChannels": "Canais",
      "sectionDirectMessages": "Mensagens diretas",
      "analyzingBadge": "✨ IA analisando 127 mensagens...",
      "activeChannelMembers": "42 membros",
      "channels": [
        {
          "id": "general",
          "name": "general",
          "unreadCount": 12,
          "isActive": true
        },
        {
          "id": "product",
          "name": "product",
          "unreadCount": 8,
          "isActive": false
        },
        {
          "id": "engineering",
          "name": "engineering",
          "unreadCount": 5,
          "isActive": false
        },
        {
          "id": "design",
          "name": "design",
          "unreadCount": 0,
          "isActive": false
        },
        {
          "id": "random",
          "name": "random",
          "unreadCount": 15,
          "isActive": false
        },
        {
          "id": "announcements",
          "name": "announcements",
          "unreadCount": 2,
          "isActive": false
        }
      ],
      "directMessages": [
        {
          "id": "alice",
          "name": "Alice Johnson",
          "initial": "A",
          "avatarColor": "pink",
          "unreadCount": 3,
          "presence": "online"
        },
        {
          "id": "bob",
          "name": "Bob Martinez",
          "initial": "B",
          "avatarColor": "sky",
          "unreadCount": 0,
          "presence": "online"
        },
        {
          "id": "carol",
          "name": "Carol Chen",
          "initial": "C",
          "avatarColor": "emerald",
          "unreadCount": 1,
          "presence": "away"
        },
        {
          "id": "david",
          "name": "David Park",
          "initial": "D",
          "avatarColor": "violet",
          "unreadCount": 0,
          "presence": "offline"
        }
      ],
      "messages": [
        {
          "id": "m1",
          "author": "Nadia Osei",
          "initial": "S",
          "avatarColor": "pink",
          "time": "10:42",
          "text": "Pessoal, o lançamento está travado na revisão de design — podemos conversar hoje à tarde?"
        },
        {
          "id": "m2",
          "author": "Mike Lopez",
          "initial": "M",
          "avatarColor": "amber",
          "time": "10:45",
          "text": "Estou livre depois das 15h. Quer que eu envie um convite de agenda?"
        },
        {
          "id": "m3",
          "author": "Priya Patel",
          "initial": "P",
          "avatarColor": "violet",
          "time": "10:51",
          "text": "Ah, e o novo texto de onboarding está pronto para revisão no Figma 🎨"
        },
        {
          "id": "m4",
          "author": "Tom Wright",
          "initial": "T",
          "avatarColor": "teal",
          "time": "10:58",
          "text": "Aviso rápido — deploy em produção hoje às 16h, evitem fazer merge na main."
        }
      ],
      "digest": {
        "label": "Resumo diário",
        "title": "Veja o que você perdeu hoje",
        "bullets": [
          {
            "id": "b1",
            "channel": "#general",
            "msgCount": 12,
            "summary": "Lançamento travado na revisão de design — Sarah e Mike combinando uma conversa às 15h"
          },
          {
            "id": "b2",
            "channel": "#product",
            "msgCount": 8,
            "summary": "Roadmap do Q2 finalizado, aguardando aprovação da engenharia até sexta"
          },
          {
            "id": "b3",
            "channel": "@alice",
            "msgCount": 3,
            "summary": "Perguntou sobre o link do painel de analytics — aguardando sua resposta"
          },
          {
            "id": "b4",
            "channel": "#random",
            "msgCount": 15,
            "summary": "Café informal na sexta + fotos do cachorro do escritório 🐶"
          }
        ]
      },
      "allCaughtUp": "Tudo em dia ✓"
    },
    "dailyUnreadSummary": {
      "windowTitle": "Caixa de entrada",
      "schedule": {
        "title": "Todos os dias às 8h",
        "subtitle": "Fluxo agendado",
        "statusWaiting": "Próxima execução",
        "statusRunning": "⚡ Executando",
        "statusSent": "✓ Enviado"
      },
      "urgencyLabels": {
        "urgent": "Urgente",
        "important": "Importante",
        "fyi": "FYI"
      },
      "emails": [
        {
          "id": "e1",
          "sender": "Nadia Osei",
          "subject": "Orçamento do Q4 — preciso da aprovação",
          "preview": "Oi, antes da reunião do conselho amanhã preciso da sua aprovação final nos números do Q4...",
          "time": "02:34",
          "avatarColor": "pink"
        },
        {
          "id": "e2",
          "sender": "Equipe Jurídica",
          "subject": "Prazo de revisão do contrato é sexta",
          "preview": "Por favor, revise o NDA em anexo e devolva suas anotações até o fim do dia de sexta...",
          "time": "23:58",
          "avatarColor": "emerald"
        },
        {
          "id": "e3",
          "sender": "John Martinez",
          "subject": "Re: conversa amanhã às 14h",
          "preview": "Confirmado — vou levar as projeções mais recentes. Até lá...",
          "time": "23:42",
          "avatarColor": "violet"
        },
        {
          "id": "e4",
          "sender": "Anna Williams",
          "subject": "Documentos de kickoff do projeto prontos",
          "preview": "Em anexo a apresentação de kickoff + cronograma. Me avise se algo precisar de ajuste...",
          "time": "22:18",
          "avatarColor": "sky"
        },
        {
          "id": "e5",
          "sender": "Mike Lopez",
          "subject": "Travado no handoff de design",
          "preview": "Oi, estou esperando os arquivos finais do Figma para destravar o trabalho da engenharia...",
          "time": "21:47",
          "avatarColor": "amber"
        },
        {
          "id": "e6",
          "sender": "Tom Wright",
          "subject": "Resumo semanal da newsletter",
          "preview": "Veja o que aconteceu na empresa esta semana — novidades de produto, conquistas...",
          "time": "20:12",
          "avatarColor": "teal"
        },
        {
          "id": "e7",
          "sender": "Priya Patel",
          "subject": "Fotos do offsite da equipe 📸",
          "preview": "Subindo as fotos do offsite da semana passada no drive compartilhado — aproveitem!...",
          "time": "19:30",
          "avatarColor": "lime"
        }
      ],
      "summary": {
        "label": "Briefing diário",
        "sender": "Assistente this+that",
        "senderGlyph": "✨",
        "subject": "Seu briefing das 8h — 7 não lidos",
        "sections": [
          {
            "urgency": "urgent",
            "count": 2,
            "bullets": [
              {
                "id": "u1",
                "text": "Nadia Osei — orçamento do Q4 precisa de aprovação antes da reunião do conselho"
              },
              {
                "id": "u2",
                "text": "Jurídico — prazo de revisão do contrato: sexta, fim do dia"
              }
            ]
          },
          {
            "urgency": "important",
            "count": 3,
            "bullets": [
              {
                "id": "i1",
                "text": "John — confirmou a conversa amanhã às 14h"
              },
              {
                "id": "i2",
                "text": "Anna — documentos de kickoff do projeto prontos para revisão"
              },
              {
                "id": "i3",
                "text": "Mike — travado no handoff de design"
              }
            ]
          },
          {
            "urgency": "fyi",
            "count": 2,
            "bullets": [
              {
                "id": "f1",
                "text": "Tom — resumo semanal da newsletter"
              },
              {
                "id": "f2",
                "text": "Priya — fotos do offsite da equipe 📸"
              }
            ]
          }
        ]
      },
      "sentConfirmation": "Enviado para sua caixa de entrada ✓",
      "footer": "Tudo pronto — até amanhã às 8h"
    },
    "morningBriefing": {
      "windowTitle": "Briefing matinal",
      "badge": "BRIEFING MATINAL",
      "sender": "Assistente this+that",
      "subject": "Seu briefing matinal · 8 mensagens enquanto você dormia",
      "preview": "2 threads urgentes no Slack · 5 e-mails FYI · 1 ação necessária — toque para ler",
      "nightLabel": "Enquanto você dormia",
      "processingLabel": "IA lendo as mensagens da madrugada...",
      "slackMessages": [
        {
          "id": "s1",
          "sender": "Nadia Osei",
          "preview": "O deploy está travado — alguém pode revisar o check que falhou?",
          "time": "02:14"
        },
        {
          "id": "s2",
          "sender": "Mike Lopez",
          "preview": "O documento do roadmap está pronto para revisão assíncrona antes da conversa de sexta",
          "time": "01:47"
        },
        {
          "id": "s3",
          "sender": "Priya Patel",
          "preview": "Os novos frames do Figma estão no ar — marcando todo mundo para aprovação",
          "time": "00:58"
        }
      ],
      "emailMessages": [
        {
          "id": "e1",
          "sender": "Equipe Jurídica",
          "subject": "Prazo do contrato é sexta",
          "preview": "Por favor, devolva suas anotações no NDA até o fim do dia de sexta...",
          "time": "23:52"
        },
        {
          "id": "e2",
          "sender": "Anna Williams",
          "subject": "Documentos de kickoff do projeto",
          "preview": "Em anexo estão a apresentação de kickoff atualizada e o cronograma para revisão...",
          "time": "23:04"
        },
        {
          "id": "e3",
          "sender": "Tom Wright",
          "subject": "Resumo semanal da newsletter",
          "preview": "Veja o que aconteceu na empresa esta semana — conquistas, novidades...",
          "time": "21:30"
        }
      ]
    },
    "endOfDayReport": {
      "windowTitle": "Caixa de entrada · this+that",
      "badge": "RELATÓRIO DO FIM DO DIA",
      "sender": "Assistente this+that",
      "subject": "Veja o que você fez hoje · 89 itens resolvidos",
      "preview": "47 arquivados · 12 respostas enviadas · 4 rascunhos · 4 reuniões — toque para revisar",
      "duskLabel": "Hoje, até agora…",
      "processingLabel": "Encerrando o seu dia…",
      "handledMessages": [
        {
          "id": "m1",
          "sender": "Respondeu 12 threads no Slack",
          "preview": "12 threads respondidas",
          "time": "17:58"
        },
        {
          "id": "m2",
          "sender": "Rascunho de resposta enviado para 4 e-mails",
          "preview": "4 rascunhos enviados",
          "time": "16:31"
        },
        {
          "id": "m3",
          "sender": "Participou de 4 calls, 2 arquivadas",
          "preview": "4 reuniões",
          "time": "15:15"
        }
      ],
      "completedActions": [
        {
          "id": "a1",
          "label": "47 e-mails promocionais arquivados",
          "category": "E-mail",
          "detail": "47 e-mails arquivados",
          "time": "18:01"
        },
        {
          "id": "a2",
          "label": "23 e-mails FYI etiquetados automaticamente",
          "category": "E-mail",
          "detail": "23 etiquetas aplicadas",
          "time": "17:44"
        },
        {
          "id": "a3",
          "label": "89 itens da caixa de entrada processados",
          "category": "Caixa de entrada",
          "detail": "89 itens resolvidos",
          "time": "18:00"
        }
      ]
    },
    "meetingActionItems": {
      "windowTitle": "Caixa de entrada · this+that",
      "geminiSender": "Gemini",
      "geminiSubject": "Notas da reunião · Planejamento do Q4",
      "geminiPreview": "Resumo, principais decisões e itens de ação da call de hoje…",
      "geminiTime": "09:12",
      "inboxBackdropRows": [
        {
          "id": "r1",
          "sender": "Nadia Osei",
          "subject": "Re: aprovação do orçamento do Q4",
          "preview": "Confirmado, te envio esses números até o fim da semana...",
          "time": "08:47"
        },
        {
          "id": "r2",
          "sender": "Equipe Jurídica",
          "subject": "Revisão do NDA pronta",
          "preview": "A versão atualizada está em anexo — revise antes de sexta...",
          "time": "08:30"
        },
        {
          "id": "r3",
          "sender": "Anna Williams",
          "subject": "Documentos de kickoff atualizados",
          "preview": "Incorporei todo o feedback da sessão de revisão de ontem...",
          "time": "08:15"
        }
      ],
      "detailHeader": {
        "timestamp": "09:12"
      },
      "meetingNoteLines": [
        {
          "id": "n1",
          "text": "Discutimos as prioridades e o faseamento do roadmap do Q4",
          "isAction": false
        },
        {
          "id": "n2",
          "text": "Fazer follow-up com a Sarah sobre a aprovação do orçamento até sexta",
          "isAction": true
        },
        {
          "id": "n3",
          "text": "Principais riscos: atrasos de fornecedores, vagas em aberto",
          "isAction": false
        },
        {
          "id": "n4",
          "text": "Agendar revisão de design com a engenharia na próxima semana",
          "isAction": true
        },
        {
          "id": "n5",
          "text": "Decisão: lançar a v2 em novembro, congelamento de features em 18/out",
          "isAction": false
        },
        {
          "id": "n6",
          "text": "Enviar rascunho da proposta para o jurídico até quinta, fim do dia",
          "isAction": true
        }
      ],
      "extractedTasks": [
        {
          "id": "t1",
          "title": "Fazer follow-up com a Sarah sobre a aprovação do orçamento",
          "context": "De: Notas da reunião · Planejamento do Q4",
          "dueLabel": "Sexta",
          "priority": "high",
          "dueStatus": "soon"
        },
        {
          "id": "t2",
          "title": "Agendar revisão de design com a engenharia",
          "context": "De: Notas da reunião · Planejamento do Q4",
          "dueLabel": "Próxima semana",
          "priority": "medium",
          "dueStatus": "normal"
        },
        {
          "id": "t3",
          "title": "Enviar rascunho da proposta para o jurídico",
          "context": "De: Notas da reunião · Planejamento do Q4",
          "dueLabel": "Qui, fim do dia",
          "priority": "urgent",
          "dueStatus": "soon"
        }
      ],
      "doBoxPaneTitle": "DoBox · agora mesmo",
      "processingLabel": "Extraindo itens de ação…",
      "priority": {
        "urgent": "Urgente",
        "high": "Alta",
        "medium": "Média",
        "low": "Baixa"
      }
    },
    "followUpTracker": {
      "windowTitle": "this+that",
      "folderLabel": "Enviados",
      "processingLabel": "Verificando respostas…",
      "statusReplied": "Respondido",
      "statusNoReply": "Sem resposta",
      "doBoxPaneTitle": "DoBox · Follow-ups",
      "sentEmails": [
        {
          "id": "e1",
          "recipient": "Nadia Osei",
          "recipientAvatarLetter": "S",
          "subject": "Números do orçamento do Q4 — revisão final",
          "sentLabel": "há 2 dias",
          "needsFollowUp": false
        },
        {
          "id": "e2",
          "recipient": "Equipe Jurídica",
          "recipientAvatarLetter": "L",
          "subject": "Revisão do contrato — por favor, revisar",
          "sentLabel": "há 6 dias",
          "needsFollowUp": true
        },
        {
          "id": "e3",
          "recipient": "John Martinez",
          "recipientAvatarLetter": "J",
          "subject": "Rascunho da proposta para a iniciativa do Q1",
          "sentLabel": "há 8 dias",
          "needsFollowUp": true
        },
        {
          "id": "e4",
          "recipient": "Anna Williams",
          "recipientAvatarLetter": "A",
          "subject": "Feedback do documento de kickoff",
          "sentLabel": "ontem",
          "needsFollowUp": false
        },
        {
          "id": "e5",
          "recipient": "Mike Lopez",
          "recipientAvatarLetter": "M",
          "subject": "Handoff de design — próximos passos",
          "sentLabel": "há 14 dias",
          "needsFollowUp": true
        }
      ],
      "extractedTasks": [
        {
          "id": "t1",
          "title": "Fazer follow-up com a Equipe Jurídica",
          "context": "Revisão do contrato — por favor, revisar · enviado há 6 dias",
          "dueLabel": "Hoje",
          "priority": "urgent",
          "dueStatus": "soon"
        },
        {
          "id": "t2",
          "title": "Fazer follow-up com John Martinez",
          "context": "Rascunho da proposta para a iniciativa do Q1 · enviado há 8 dias",
          "dueLabel": "Amanhã",
          "priority": "high",
          "dueStatus": "soon"
        },
        {
          "id": "t3",
          "title": "Fazer follow-up com Mike Lopez",
          "context": "Handoff de design — próximos passos · enviado há 14 dias",
          "dueLabel": "Esta semana",
          "priority": "medium",
          "dueStatus": "normal"
        }
      ],
      "priority": {
        "urgent": "Urgente",
        "high": "Alta",
        "medium": "Média",
        "low": "Baixa"
      }
    },
    "vipEmailAlerts": {
      "windowTitle": "this+that",
      "vipPanelTitle": "Lista VIP",
      "vipPanelSubtitle": "E-mails e domínios que vamos monitorar",
      "addVipLabel": "+ Adicionar VIP",
      "typeLabelEmail": "e-mail",
      "typeLabelDomain": "domínio",
      "processingLabel": "Contato VIP detectado — alertando no Slack…",
      "slackChannelLabel": "vip-alerts",
      "slackBotName": "Assistente this+that",
      "slackBotBadge": "APP",
      "slackTimestamp": "agora mesmo",
      "vipList": [
        {
          "id": "v1",
          "value": "ceo@acme.com",
          "avatarLetter": "C",
          "type": "email"
        },
        {
          "id": "v2",
          "value": "@importantclient.com",
          "avatarLetter": "I",
          "type": "domain"
        },
        {
          "id": "v3",
          "value": "investor@capital.vc",
          "avatarLetter": "V",
          "type": "email"
        },
        {
          "id": "v4",
          "value": "@legal.firm.com",
          "avatarLetter": "L",
          "type": "domain"
        }
      ],
      "inboxBackdropRows": [
        {
          "id": "r1",
          "sender": "Nadia Osei",
          "subject": "Re: aprovação do orçamento do Q4",
          "preview": "Confirmado, te envio esses números até o fim da semana...",
          "time": "08:47"
        },
        {
          "id": "r2",
          "sender": "Equipe Jurídica",
          "subject": "Revisão do NDA pronta",
          "preview": "A versão atualizada está em anexo — revise antes de sexta...",
          "time": "08:30"
        },
        {
          "id": "r3",
          "sender": "Anna Williams",
          "subject": "Documentos de kickoff atualizados",
          "preview": "Incorporei todo o feedback da sessão de revisão de ontem...",
          "time": "08:15"
        }
      ],
      "vipMatchEmail": {
        "sender": "CEO · Acme Corp",
        "subject": "Apresentação do conselho do Q4 — revisão necessária",
        "preview": "Olá, pessoal, em anexo está o rascunho para a reunião do conselho de quinta…",
        "time": "agora mesmo",
        "vipBadge": "VIP"
      },
      "slackMessageLines": [
        {
          "id": "l1",
          "text": "🔔 E-mail VIP do CEO",
          "style": "bold-header"
        },
        {
          "id": "l2",
          "text": "Assunto: Apresentação do conselho do Q4 — revisão necessária",
          "style": "field"
        },
        {
          "id": "l3",
          "text": "Olá, pessoal, em anexo está o rascunho para a reunião do conselho de quinta…",
          "style": "preview"
        },
        {
          "id": "l4",
          "text": "",
          "style": "buttons"
        }
      ],
      "slackButtons": [
        {
          "id": "open",
          "label": "Abrir no Gmail"
        },
        {
          "id": "seen",
          "label": "Marcar como visto"
        }
      ]
    },
    "aiDrafting": {
      "windowTitle": "Caixa de entrada",
      "newEmail": {
        "sender": "Nadia Osei",
        "subject": "Pergunta rápida — timing do orçamento do Q4",
        "preview": "Oi! Você tem 15 min nesta semana para falarmos dos números do Q4? Quero garantir que estamos alinhados antes do conselho...",
        "time": "Agora mesmo",
        "tagKey": "toRespond"
      },
      "compose": {
        "header": "Responder a Nadia Osei",
        "aiBadge": "✨ Rascunho de IA",
        "to": "Para:",
        "toValue": "sarah@company.com",
        "subject": "Assunto:",
        "subjectValue": "Re: Pergunta rápida — timing do orçamento do Q4",
        "draftLabel": "Rascunho — não enviado",
        "draftFooter": "💾 Rascunho salvo na sua caixa de entrada · revise antes de enviar"
      },
      "replyBody": "Oi, Sarah! 👋\n\nClaro, vamos conversar sim. Estou livre quinta à tarde ou sexta de manhã — qual funciona melhor para você?\n\nVou levar os números mais recentes para irmos direto ao ponto.\n\nAté já,\nB",
      "backgroundEmails": [
        {
          "sender": "Nadia Osei",
          "subject": "Revisão do orçamento do Q4",
          "preview": "Olá, pessoal, queria retomar a discussão de ontem sobre a alocação do Q4...",
          "time": "14:34",
          "tagKey": "toRespond",
          "tagColor": "orange",
          "avatarColor": "pink",
          "isPromo": false
        },
        {
          "sender": "John Martinez",
          "subject": "Reunião amanhã às 14h",
          "preview": "Só confirmando nossa conversa amanhã à tarde para discutir o cronograma do projeto...",
          "time": "13:15",
          "tagKey": "meetingUpdate",
          "tagColor": "violet",
          "avatarColor": "violet",
          "isPromo": false
        },
        {
          "sender": "Equipe Jurídica",
          "subject": "Contrato aguardando revisão",
          "preview": "Por favor, revise o contrato em anexo e envie seu feedback até o fim da semana...",
          "time": "11:42",
          "tagKey": "fyi",
          "tagColor": "yellow",
          "avatarColor": "emerald",
          "isPromo": false
        },
        {
          "sender": "Anna Williams",
          "subject": "Documentos de kickoff do projeto",
          "preview": "Em anexo estão os documentos de kickoff da nova iniciativa. Revise e compartilhe...",
          "time": "10:55",
          "tagKey": "toReview",
          "tagColor": "blue",
          "avatarColor": "sky",
          "isPromo": false
        }
      ]
    },
    "autoLabeling": {
      "windowTitle": "Caixa de entrada",
      "badges": {
        "unorganized": "6 e-mails · sem organização",
        "classifying": "✨ IA classificando...",
        "classified": "✓ Classificado",
        "stats": "3 importantes · 3 distrações"
      },
      "footerTagline": "Foco no que importa ✓",
      "labels": {
        "important": "Importante",
        "distraction": "Distração"
      },
      "emails": [
        {
          "sender": "Nadia Osei",
          "subject": "Revisão do orçamento do Q4",
          "preview": "Olá, pessoal, queria retomar a discussão de ontem sobre a alocação do Q4...",
          "time": "14:34",
          "avatarColor": "pink",
          "classification": "important"
        },
        {
          "sender": "Amazon",
          "subject": "📦 Seu pedido foi enviado",
          "preview": "Acompanhe seu pacote — entrega prevista para quinta entre 10h e 14h...",
          "time": "14:12",
          "avatarColor": "amber",
          "classification": "distraction"
        },
        {
          "sender": "John Martinez",
          "subject": "Reunião amanhã às 14h",
          "preview": "Só confirmando nossa conversa amanhã à tarde para discutir o cronograma do projeto...",
          "time": "13:15",
          "avatarColor": "violet",
          "classification": "important"
        },
        {
          "sender": "LinkedIn",
          "subject": "👀 5 pessoas viram seu perfil",
          "preview": "Destaque-se nas buscas — veja quem andou visitando seu perfil do LinkedIn esta semana...",
          "time": "12:48",
          "avatarColor": "sky",
          "classification": "distraction"
        },
        {
          "sender": "Equipe Jurídica",
          "subject": "Contrato aguardando revisão",
          "preview": "Por favor, revise o contrato em anexo e envie seu feedback até o fim da semana...",
          "time": "11:42",
          "avatarColor": "emerald",
          "classification": "important"
        },
        {
          "sender": "Nike",
          "subject": "👟 Novos tênis acabaram de chegar",
          "preview": "Seja o primeiro a comprar os modelos de edição limitada — membros têm acesso antecipado...",
          "time": "11:20",
          "avatarColor": "red",
          "classification": "distraction"
        }
      ]
    },
    "unsubscribeReport": {
      "windowTitle": "Caixa de entrada",
      "weekHeader": "Esta semana",
      "weekFooter": "Percebemos que você arquivou estes sem ler...",
      "archivedBadge": "arquivado · não lido",
      "archivedEmails": [
        {
          "sender": "Medium Daily Digest",
          "subject": "Hoje no mundo das startups: 10 leituras imperdíveis",
          "time": "seg 08:00"
        },
        {
          "sender": "TechCrunch",
          "subject": "Resumo diário: rodada de investimentos em IA",
          "time": "ter 08:00"
        },
        {
          "sender": "Product Hunt Weekly",
          "subject": "Os 10 melhores produtos da semana",
          "time": "qua 08:00"
        },
        {
          "sender": "Substack Reads",
          "subject": "Sua lista de leitura personalizada",
          "time": "qui 08:00"
        }
      ],
      "reportEmail": {
        "label": "Resumo semanal",
        "sender": "Assistente this+that",
        "subject": "📊 Relatório semanal de cancelamento de inscrições",
        "preview": "Você arquivou 26 e-mails de 4 remetentes sem lê-los — toque para revisar",
        "time": "segunda-feira, 09:00"
      },
      "modal": {
        "title": "📊 Relatório semanal de cancelamento de inscrições",
        "subtitle": "Você arquivou 26 e-mails destes remetentes esta semana sem lê-los.",
        "unsubscribeButton": "Cancelar inscrição",
        "unsubscribedState": "✓ Inscrição cancelada",
        "footerHint": "Toque para cancelar a inscrição · leva 1 segundo"
      },
      "senders": [
        {
          "name": "Medium Daily Digest",
          "archivedCount": 8,
          "openedCount": 0,
          "avatarColor": "orange"
        },
        {
          "name": "TechCrunch",
          "archivedCount": 7,
          "openedCount": 0,
          "avatarColor": "rose"
        },
        {
          "name": "Product Hunt Weekly",
          "archivedCount": 5,
          "openedCount": 1,
          "avatarColor": "violet"
        },
        {
          "name": "Substack Reads",
          "archivedCount": 6,
          "openedCount": 0,
          "avatarColor": "sky"
        }
      ],
      "senderSubtitle": "{{archivedCount}} e-mails arquivados · {{openedCount}} abertos"
    },
    "chaosArrival": {
      "windowTitle": "Caixa de entrada",
      "timestampLabel": "segunda-feira, 09:02",
      "counterSuffix": "novos esta manhã",
      "inboxLabel": "Caixa de entrada",
      "emptyStateSubtitle": "Você está em dia",
      "inboxEmails": [
        {
          "id": "inbox-1",
          "sender": "Nadia Osei",
          "subject": "Revisão do orçamento do Q4",
          "preview": "Retomando a discussão de ontem sobre alocação...",
          "time": "08:44",
          "avatarColor": "rose"
        },
        {
          "id": "inbox-2",
          "sender": "Amazon",
          "subject": "Seu pedido foi enviado",
          "preview": "Seu pacote está a caminho — acompanhe aqui",
          "time": "08:30",
          "avatarColor": "amber"
        },
        {
          "id": "inbox-3",
          "sender": "ceo@acme.com",
          "subject": "Apresentação do conselho — revisão final necessária",
          "preview": "Por favor, revise e devolva até quinta, fim do dia",
          "time": "08:15",
          "avatarColor": "emerald"
        },
        {
          "id": "inbox-4",
          "sender": "Equipe Jurídica",
          "subject": "Prazo do contrato é hoje",
          "preview": "Por favor, devolva suas anotações no NDA até o meio-dia...",
          "time": "07:58",
          "avatarColor": "violet"
        },
        {
          "id": "inbox-5",
          "sender": "GitHub",
          "subject": "Novo pull request precisa da sua revisão",
          "preview": "Nadia Osei abriu um PR em your-repo/main",
          "time": "09:00",
          "avatarColor": "gray"
        },
        {
          "id": "inbox-6",
          "sender": "Figma",
          "subject": "Dana compartilhou um arquivo com você",
          "preview": "Design system v2 — abrir no Figma",
          "time": "09:01",
          "avatarColor": "teal"
        },
        {
          "id": "inbox-7",
          "sender": "Notion",
          "subject": "Você foi mencionado em uma página",
          "preview": "Tom mencionou você em Planejamento do Roadmap do Q4",
          "time": "09:02",
          "avatarColor": "pink"
        }
      ],
      "chatNotifications": [
        {
          "id": "chat-1",
          "platform": "slack",
          "sender": "Sarah",
          "preview": "O deploy falhou — alguém está vendo isso?",
          "time": "08:47"
        },
        {
          "id": "chat-2",
          "platform": "slack",
          "sender": "Mike",
          "preview": "Arquivo do Figma atualizado, preciso de aprovação",
          "time": "08:51"
        },
        {
          "id": "chat-3",
          "platform": "teams",
          "sender": "Dana",
          "preview": "Documento do roadmap pronto para revisão",
          "time": "08:53"
        },
        {
          "id": "chat-4",
          "platform": "slack",
          "sender": "Alex",
          "preview": "PR travado — preciso de um segundo revisor",
          "time": "08:55"
        },
        {
          "id": "chat-5",
          "platform": "teams",
          "sender": "Jordan",
          "preview": "Atenção — o CEO quer uma demo na sexta",
          "time": "09:00"
        },
        {
          "id": "chat-6",
          "platform": "slack",
          "sender": "Riley",
          "preview": "Pode revisar o novo fluxo de onboarding?",
          "time": "09:01"
        }
      ],
      "meetingInvite": {
        "title": "Revisão de design · 15 min",
        "subtitle": "Com Sarah, Mike + 3 pessoas",
        "time": "hoje às 10:00"
      }
    },
    "doBox": {
      "inboxWindowTitle": "Caixa de entrada",
      "doBoxWindowTitle": "DoBox",
      "convertToTaskBadge": "✨ Convertendo em tarefa...",
      "linkedBadge": "✓ Vinculada ao e-mail",
      "acceptButton": "Aceitar",
      "newEmailLabel": "NOVO",
      "suggestionsSection": "Sugestões de tarefas",
      "tasksSection": "Tarefas",
      "inboxEmails": [
        {
          "sender": "John Martinez",
          "subject": "Reunião amanhã às 14h",
          "preview": "Só confirmando nossa conversa amanhã à tarde...",
          "time": "13:15",
          "avatarColor": "violet"
        },
        {
          "sender": "Equipe Jurídica",
          "subject": "Contrato aguardando revisão",
          "preview": "Por favor, revise o contrato em anexo e envie...",
          "time": "11:42",
          "avatarColor": "emerald"
        },
        {
          "sender": "Anna Williams",
          "subject": "Documentos de kickoff do projeto",
          "preview": "Em anexo estão os documentos de kickoff da nova iniciativa...",
          "time": "10:55",
          "avatarColor": "sky"
        }
      ],
      "priority": {
        "urgent": "Urgente",
        "high": "Alta",
        "medium": "Média",
        "low": "Baixa"
      },
      "existingEntries": [
        {
          "title": "Revisar contrato jurídico",
          "description": "Assinatura pendente até o fim do dia",
          "priority": "high",
          "due": "Hoje",
          "dueStatus": "overdue",
          "labels": [
            {
              "title": "Jurídico",
              "hexColor": "#8b5cf6"
            },
            {
              "title": "Urgente",
              "hexColor": "#ef4444"
            }
          ],
          "participants": [
            {
              "initials": "LT"
            },
            {
              "initials": "CS"
            }
          ]
        },
        {
          "title": "Preparar slides do standup da equipe",
          "description": "Sync semanal com produto e design",
          "priority": "medium",
          "due": "Qua",
          "dueStatus": "soon",
          "labels": [
            {
              "title": "Equipe",
              "hexColor": "#f59e0b"
            }
          ],
          "participants": [
            {
              "initials": "AW"
            }
          ]
        }
      ],
      "newEntry": {
        "title": "Revisão do orçamento do Q4",
        "description": "Dar input sobre a alocação do Q4 até sexta",
        "priority": "high",
        "due": "Sex",
        "dueStatus": "normal",
        "labels": [
          {
            "title": "Finanças",
            "hexColor": "#10b981"
          },
          {
            "title": "Revisão",
            "hexColor": "#3b82f6"
          }
        ],
        "participants": [
          {
            "initials": "SC"
          }
        ]
      },
      "newEmail": {
        "sender": "Nadia Osei",
        "subject": "Revisão do orçamento do Q4",
        "preview": "Oi! Preciso do seu input sobre a alocação do Q4 até sexta...",
        "time": "Agora mesmo",
        "avatarColor": "pink"
      }
    },
    "flows": {
      "windowTitle": "Flows",
      "dialogTitle": "✨ Gerador de Flows com IA",
      "dialogPlaceholder": "Descreva o fluxo que você quer criar…",
      "examplePrompts": [
        "Resumo diário",
        "Etiquetar e-mails automaticamente",
        "Resumo do Slack",
        "Follow-ups"
      ],
      "promptText": "Quando eu receber um e-mail do meu CEO, crie um rascunho de resposta e me avise no Slack",
      "generateButton": "Gerar",
      "generatingLabel": "Gerando seu fluxo…",
      "trigger": {
        "label": "Novo e-mail do CEO"
      },
      "step1": {
        "label": "Etapa 1",
        "title": "Rascunhar resposta"
      },
      "step2": {
        "label": "Etapa 2",
        "title": "Notificar no Slack"
      },
      "step3": {
        "label": "Etapa 3",
        "title": "Adicionar etiqueta: Importante"
      },
      "sidePanel": {
        "title": "Adicionar etapa",
        "steps": [
          "Resumir",
          "Adicionar etiqueta",
          "Arquivar",
          "Perguntar à IA",
          "Enviar no Slack",
          "Criar tarefa"
        ]
      },
      "addStepPlaceholder": "+ Adicionar etapa",
      "saveButton": "Salvar",
      "savedToast": "Fluxo salvo"
    },
    "destillation": {
      "windowTitle": "Caixa de entrada",
      "timestampLabel": "segunda-feira, 09:02",
      "inboxLabel": "Caixa de entrada",
      "counterBefore": {
        "value": "120",
        "suffix": "novos esta manhã"
      },
      "counterAfter": {
        "suffix": "acionáveis"
      },
      "doBoxPaneTitle": "DoBox · agora mesmo",
      "priority": {
        "urgent": "Urgente",
        "high": "Alta",
        "medium": "Média",
        "low": "Baixa"
      },
      "echoEmails": [
        {
          "id": "echo-1",
          "sender": "Nadia Osei",
          "subject": "Revisão do orçamento do Q4",
          "preview": "Retomando a discussão de ontem sobre alocação…",
          "time": "08:44",
          "avatarColor": "rose"
        },
        {
          "id": "echo-2",
          "sender": "ceo@acme.com",
          "subject": "Apresentação do conselho — revisão final necessária",
          "preview": "Por favor, revise e devolva até quinta, fim do dia",
          "time": "08:15",
          "avatarColor": "emerald"
        },
        {
          "id": "echo-3",
          "sender": "Equipe Jurídica",
          "subject": "Prazo do contrato é hoje",
          "preview": "Por favor, devolva suas anotações no NDA até o meio-dia…",
          "time": "07:58",
          "avatarColor": "violet"
        },
        {
          "id": "echo-4",
          "sender": "Figma",
          "subject": "Dana compartilhou um arquivo com você",
          "preview": "Design system v2 — abrir no Figma",
          "time": "09:01",
          "avatarColor": "teal"
        },
        {
          "id": "echo-5",
          "sender": "Notion",
          "subject": "Você foi mencionado em uma página",
          "preview": "Tom mencionou você em Planejamento do Roadmap do Q4",
          "time": "09:02",
          "avatarColor": "pink"
        }
      ],
      "echoChats": [
        {
          "id": "echat-1",
          "platform": "slack",
          "sender": "Mike",
          "preview": "Arquivo do Figma atualizado, preciso de aprovação",
          "time": "08:51"
        },
        {
          "id": "echat-2",
          "platform": "slack",
          "sender": "Sarah",
          "preview": "O deploy falhou — alguém está vendo isso?",
          "time": "08:47"
        },
        {
          "id": "echat-3",
          "platform": "teams",
          "sender": "Dana",
          "preview": "Documento do roadmap pronto para revisão",
          "time": "08:53"
        },
        {
          "id": "echat-4",
          "platform": "teams",
          "sender": "Jordan",
          "preview": "O CEO quer uma demo na sexta",
          "time": "09:00"
        }
      ],
      "echoMeetingInvite": {
        "title": "Revisão de design · 15 min",
        "subtitle": "Com Sarah, Mike + 3 pessoas",
        "time": "hoje às 10:00"
      },
      "doBoxTasks": [
        {
          "id": "dt-1",
          "title": "Responder a Nadia Osei",
          "context": "De: e-mail Revisão do orçamento do Q4",
          "priority": "high"
        },
        {
          "id": "dt-2",
          "title": "Revisar thread do #design",
          "context": "De: Slack #design",
          "priority": "medium"
        },
        {
          "id": "dt-3",
          "title": "Preparar slides do conselho",
          "context": "De: reunião de revisão de design",
          "priority": "urgent"
        },
        {
          "id": "dt-4",
          "title": "Fazer follow-up com o CEO",
          "context": "De: ceo@acme.com",
          "priority": "urgent"
        },
        {
          "id": "dt-5",
          "title": "Responder a Jordan",
          "context": "De: Liderança no Teams",
          "priority": "high"
        }
      ]
    }
  },
  "commentsAndActivity": {
    "title": "Comentários e atividade",
    "toggle": {
      "show": "Mostrar detalhes",
      "hide": "Ocultar detalhes"
    },
    "activity": {
      "created": "criou esta tarefa",
      "deleted": "excluiu esta tarefa",
      "restored": "restaurou esta tarefa",
      "moved": "moveu esta tarefa para outro grupo de tarefas",
      "nameOverflow": "{{names}} e mais {{count}}",
      "changed": {
        "subject": "renomeou esta tarefa",
        "description": {
          "set": "adicionou uma descrição a esta tarefa",
          "cleared": "removeu a descrição desta tarefa",
          "updated": "atualizou a descrição desta tarefa"
        },
        "priority": {
          "set": "definiu a prioridade desta tarefa como {{value}}",
          "cleared": "removeu a prioridade desta tarefa",
          "updated": "alterou a prioridade desta tarefa para {{value}}"
        },
        "dueAt": {
          "set": "definiu o prazo desta tarefa para {{value}}",
          "cleared": "removeu o prazo desta tarefa",
          "updated": "alterou o prazo desta tarefa para {{value}}"
        },
        "resolvedAt": {
          "set": "marcou esta tarefa como concluída",
          "cleared": "reabriu esta tarefa"
        },
        "isSuggestion": {
          "accepted": "aceitou esta tarefa como sugestão"
        },
        "taskLabelIds": {
          "added": "adicionou a etiqueta {{names}} a esta tarefa",
          "removed": "removeu a etiqueta {{names}} desta tarefa",
          "updated": "atualizou as etiquetas desta tarefa"
        },
        "participantIds": {
          "added": "adicionou {{names}} a esta tarefa",
          "removed": "removeu {{names}} desta tarefa",
          "updated": "atualizou os participantes desta tarefa"
        },
        "communicationIds": {
          "updated": "vinculou novas comunicações a esta tarefa"
        },
        "agentSetupMcpWrite": "aprovou uma ação de agente nesta tarefa: {{tool}}"
      },
      "fallback": "atualizou esta tarefa"
    }
  },
  "billing": {
    "pageTitle": "Cobrança e planos",
    "pageDescription": "Gerencie sua assinatura, os membros da equipe e as faturas.",
    "comingSoon": "Esta funcionalidade estará disponível em breve.",
    "cycleToggle": {
      "monthly": "Mensal",
      "annual": "Anual",
      "discount": "−{{percent}}%",
      "annualNote": "Cobrado anualmente · Economize 20%",
      "monthlyNote": "Cobrado mensalmente"
    },
    "noActivePlan": {
      "title": "Cobrança e planos",
      "subtitle": "Escolha o plano que combina com o jeito de trabalhar da sua equipe."
    },
    "plans": {
      "priceUnit": "/usuário/mês",
      "priceUnitAnnual": "/usuário/mês, cobrado anualmente",
      "team": {
        "name": "this+that",
        "cta": "Começar agora",
        "features": {
          "fullProduct": "Produto completo: Workflows, Brain, Assistant, DoBox, Contacts e todas as integrações",
          "channels": "Gmail, Outlook, Slack, Microsoft Teams, Google Chat e WhatsApp Business (Instagram e Facebook Messenger aguardando aprovação)",
          "sharedTasks": "Visão compartilhada de tarefas e atribuição de tarefas",
          "sharedContacts": "Contatos compartilhados, para que a próxima pessoa a assumir uma conta comece a partir de um registro já reconciliado",
          "crossTeamWorkflows": "Workflows que funcionam entre os membros da equipe",
          "mcpServers": "20 servidores MCP integrados + conecte os seus"
        }
      },
      "enterprise": {
        "name": "Enterprise",
        "tagline": "Para organizações maiores, com requisitos próprios de segurança, compras e suporte.",
        "priceLabel": "Fale conosco",
        "cta": "Falar com vendas",
        "features": {
          "everythingAbove": "Tudo do plano acima",
          "sso": "SSO (SAML)",
          "scim": "Provisionamento SCIM",
          "customTerms": "Termos e preços sob medida para a organização"
        }
      }
    },
    "hero": {
      "currentPlanBadge": "Plano atual",
      "renewsAt": "Renova em {{date}}",
      "managedBy": "Gerenciado por {{email}}",
      "priceMeta": "/ ano · {{seats}} assentos × ${{pricePerSeat}}",
      "managePlan": "Gerenciar plano",
      "switchToMonthly": "Mudar para mensal",
      "switchToAnnual": "Mudar para anual",
      "cancel": "Cancelar"
    },
    "stats": {
      "paidSeats": "Assentos pagos",
      "seatsAvailable": "{{count}} assentos disponíveis",
      "doBoxSuggestions": "Sugestões do DoBox neste mês",
      "doBoxSuggestionsHint": "Ilimitadas no Team",
      "nextInvoice": "Próxima fatura"
    },
    "members": {
      "title": "Membros do plano",
      "inviteButton": "+ Convidar membro",
      "removeAriaLabel": "Remover {{name}} do plano",
      "roles": {
        "admin": "Admin",
        "member": "Membro",
        "viewer": "Visualizador"
      },
      "seatTypes": {
        "team": "Team",
        "free": "Gratuito"
      }
    },
    "paymentMethod": {
      "title": "Forma de pagamento",
      "expires": "Expira em {{exp}}",
      "updateButton": "Atualizar"
    },
    "invoices": {
      "title": "Faturas recentes",
      "viewAll": "Ver todas",
      "downloadAriaLabel": "Baixar fatura de {{date}}",
      "statuses": {
        "paid": "Paga",
        "pending": "Pendente",
        "failed": "Falhou"
      },
      "empty": "Nenhuma fatura ainda.",
      "viewAriaLabel": "Ver fatura de {{date}}"
    },
    "page": {
      "planName": "this+that",
      "tagline": "O produto completo, com preço por pessoa. Convide seus colegas.",
      "upgradeCta": "Começar agora",
      "manage": {
        "badge": "Plano atual",
        "subtitle": "Gerencie sua assinatura, os assentos e a forma de pagamento no Stripe.",
        "manageCta": "Gerenciar assinatura"
      },
      "enterprise": {
        "badge": "Em breve",
        "cta": "Falar com vendas"
      },
      "memberNotice": {
        "title": "A cobrança é gerenciada pelo dono da equipe",
        "subtitleWithOwner": "Peça para {{ownerName}} fazer upgrade do this+that para continuar usando.",
        "subtitleGeneric": "Peça para o dono da sua equipe fazer upgrade do this+that para continuar usando."
      },
      "noTeam": {
        "title": "Nenhuma equipe selecionada",
        "subtitle": "Entre em uma equipe ou crie uma para gerenciar a cobrança."
      }
    },
    "trialBanner": {
      "calm": {
        "title_one": "Trial · {{count}} dia restante",
        "title_other": "Trial · {{count}} dias restantes",
        "subtitle": "Acesso completo até {{date}}",
        "cta": "Escolher um plano"
      },
      "warning": {
        "title_one": "{{count}} dia até o fim do trial",
        "title_other": "{{count}} dias até o fim do trial",
        "subtitle": "Depois disso, o app trava até seu time escolher um plano",
        "cta": "Escolher um plano"
      },
      "urgent": {
        "title": "Seu trial termina amanhã",
        "subtitleWithPrice": "{{price}} /usuário/mês depois disso",
        "subtitle": "Escolha um plano para manter o acesso",
        "cta": "Escolher um plano"
      },
      "expired": {
        "title": "O trial terminou",
        "subtitle": "Escolha um plano para liberar o time",
        "cta": "Escolher um plano"
      },
      "memberSubtitle": "Peça ao dono do time para escolher um plano",
      "dismiss": "Dispensar"
    },
    "faq": {
      "eyebrow": "FAQ",
      "title": "Perguntas comuns",
      "items": {
        "betaEnd": {
          "question": "O que acontece quando o beta acaba?",
          "answer": "O beta acaba em 1º de setembro e ninguém é cobrado nesse dia. Toda conta já existente entra num teste grátis de 30 dias a partir de 1º de setembro, então a cobrança só pode começar um mês depois. Contas criadas depois disso ganham 30 dias a partir do cadastro. Você escolhe um plano quando o seu teste termina, e os seus dados ficam salvos de todo jeito, então você retoma de onde parou sem sincronizar de novo."
        },
        "switchInterval": {
          "question": "Posso trocar entre mensal e anual?",
          "answer": "Sim, quando quiser. Se você trocar para anual no meio do ciclo, ajustamos a diferença proporcionalmente."
        },
        "whoIsUser": {
          "question": "Quem conta como usuário?",
          "answer": "Qualquer pessoa com a própria conta this+that que conecte o e-mail ou as mensagens dela. Caixas compartilhadas não contam como usuários extras."
        },
        "workflowUsage": {
          "question": "E se eu precisar de mais do que o uso de fluxos incluído?",
          "answer": "Vamos te procurar antes de você chegar ao limite incluído, para você decidir se acrescenta uso ou ajusta os seus fluxos."
        },
        "reliability": {
          "question": "O this+that é confiável o bastante para o nosso time rodar nele?",
          "answer": "Sim. Rodamos na AWS, e nos comprometemos com 99,5% de disponibilidade a cada mês. Os compromissos de disponibilidade definem como medimos isso e as duas exclusões. Você confere o status do sistema ao vivo e incidentes passados a qualquer momento em <status>status.thisandthat.chat</status>, e a nossa <security>página de segurança</security> cobre criptografia, tratamento de dados e conformidade."
        },
        "brainMigration": {
          "question": "Preciso mover o meu wiki ou o meu Notion para o Brain?",
          "answer": "Não, você não precisa migrar nada para ter valor. O serviço singular do Brain é a camada operacional que as suas outras ferramentas não guardam: o que está acontecendo com um cliente, quem sabe o quê, o contexto enterrado nas suas correntes. Para conhecimento canônico como preço e manuais, os times têm a melhor experiência mantendo isso no Brain, onde o assistente e os fluxos leem e escrevem diretamente."
        }
      }
    }
  },
  "credits": {
    "balanceRow": {
      "addLink": "+ Adicionar",
      "noWallet": "Créditos em breve",
      "tooltip": "{{balance}} de {{total}} créditos"
    },
    "status": {
      "healthy": "{{pct}}% restante",
      "low": "Saldo baixo",
      "empty": "Sem créditos"
    },
    "amountOf": "de {{total}}",
    "unit_one": "crédito",
    "unit_other": "créditos",
    "chip": {
      "ariaLabel": "Ver saldo de créditos",
      "tagYou": "Você",
      "tagTeam": "Time"
    },
    "popover": {
      "personalTitle": "Seus créditos",
      "personalSubtitle": "Saldo pessoal",
      "teamTitle": "Créditos do time",
      "teamSubtitle_one": "Compartilhado entre {{count}} membro",
      "teamSubtitle_other": "Compartilhado entre {{count}} membros",
      "rows": {
        "plan": "Plano do mês",
        "purchased": "Comprados",
        "usedThisMonth": "Usados no mês"
      },
      "renewsOn": "renova em {{date}}",
      "buyButton": "Adicionar créditos",
      "buyButtonTeam": "Adicionar créditos ao time",
      "noWallet": "Seus créditos vão aparecer aqui em breve."
    },
    "buyModal": {
      "title": "Adicionar créditos",
      "titleTeam": "Adicionar créditos ao time",
      "packCredits_one": "{{credits}} crédito",
      "packCredits_other": "{{credits}} créditos",
      "loadError": "Não foi possível carregar os pacotes de créditos.",
      "purchaseError": "Não foi possível iniciar a compra. Tente novamente."
    },
    "page": {
      "title": "Créditos",
      "subtitle": "Acompanhe o uso e adicione créditos",
      "scope": {
        "personal": "Pessoal",
        "team": "Time",
        "ariaLabel": "Selecionar escopo de créditos"
      },
      "balance": {
        "personalLabel": "Seu saldo",
        "teamLabel_one": "Saldo do time · {{count}} membro",
        "teamLabel_other": "Saldo do time · {{count}} membros",
        "teamLabelLoading": "Saldo do time",
        "teamUnavailable": "Saldo do time indisponível."
      },
      "statement": {
        "title": "Extrato",
        "filtersAriaLabel": "Filtrar o extrato",
        "filters": {
          "all": "Todos",
          "flows": "Flows",
          "assistant": "Assistant",
          "agents": "Agentes",
          "purchases": "Compras"
        },
        "table": {
          "description": "Descrição",
          "by": "Por",
          "date": "Data",
          "credits": "Créditos"
        },
        "empty": "Nenhuma transação neste filtro.",
        "loadError": "Não foi possível carregar o extrato.",
        "loadMore": "Carregar mais"
      },
      "tag": {
        "flow": "Flow",
        "assistant": "Assistant",
        "agent": "Agente",
        "purchase": "Compra",
        "plan": "Plano",
        "credit": "Ajuste",
        "other": "Outro"
      },
      "nameFallback": {
        "flow": "Flow removido",
        "assistant": "Conversa removida",
        "agent": "Agente removido",
        "purchase": "Compra",
        "plan": "Plano mensal",
        "credit": "Ajuste de créditos",
        "other": "Transação"
      },
      "drawer": {
        "close": "Fechar",
        "breakdownTitle": "Onde os créditos foram gastos",
        "paymentTitle": "Pagamento",
        "meta": {
          "modelCalls": "Chamadas de modelo",
          "reference": "ID",
          "balanceAfter": "Saldo após"
        }
      },
      "breakdown": {
        "trigger": "Gatilho e leitura de dados",
        "agentTask": "Processamento com IA",
        "summarize": "Resumo",
        "integrationAction": "Ações em integrações",
        "message": "Mensagens enviadas",
        "brainSearch": "Busca no Brain",
        "reasoning": "Raciocínio e planejamento",
        "toolCall": "Ferramentas usadas",
        "response": "Resposta final"
      }
    }
  },
  "calendarInvite": {
    "header": {
      "source": "Google Calendar · Convite de {{organizer}}"
    },
    "status": {
      "awaiting": "Aguardando sua resposta",
      "accepted": "Aceito",
      "declined": "Recusado",
      "tentative": "Provisório"
    },
    "action": {
      "yes": "Sim",
      "maybe": "Talvez",
      "no": "Não",
      "proposeNewTime": "Novo horário"
    },
    "conferenceLink": {
      "googleMeet": "Google Meet"
    },
    "guests": {
      "total_one": "{{count}} convidado",
      "total_other": "{{count}} convidados",
      "yes": "sim",
      "maybe": "talvez",
      "no": "não",
      "awaiting": "aguardando",
      "showMore_one": "Mostrar mais {{count}} convidado",
      "showMore_other": "Mostrar mais {{count}} convidados",
      "showLess": "Mostrar menos"
    },
    "guestBadge": {
      "organizer": "ORGANIZADOR",
      "you": "VOCÊ"
    },
    "proposeNewTime": {
      "title": "Propor um novo horário",
      "startLabel": "Novo horário de início",
      "endLabel": "Novo horário de término",
      "submit": "Propor",
      "error": "Não foi possível propor o novo horário. Tente novamente.",
      "unavailableReason": "Propor um novo horário não está disponível para este convite porque ele foi recebido antes desse recurso existir.",
      "invalidRange": "O horário de término deve ser depois do horário de início."
    }
  },
  "floatingAssistant": {
    "panel": {
      "title": "Assistente this+that",
      "minimize": "Minimizar",
      "close": "Fechar",
      "openGallery": "Abrir suas imagens",
      "openStandalone": "Abrir como página completa",
      "ariaLabel": "Painel do assistente this+that",
      "resizeHandle": "Arraste para redimensionar o painel do assistente"
    },
    "watching": {
      "label": "Observando:",
      "inbox": "Caixa de entrada · Hoje",
      "inboxPreview": "Caixa de entrada · E-mail",
      "dobox": "DoBox · Tarefas",
      "doboxPreview": "DoBox · Entrada",
      "slackInbox": "Caixa de entrada · Slack",
      "teamsInbox": "Caixa de entrada · Teams",
      "inboxSent": "Caixa de entrada · Enviados",
      "inboxDraft": "Caixa de entrada · Rascunhos",
      "inboxSpam": "Caixa de entrada · Spam",
      "inboxTrash": "Caixa de entrada · Lixeira",
      "inboxAll": "Caixa de entrada · Tudo",
      "inboxLabels": "Caixa de entrada · Etiquetas",
      "inboxSearch": "Caixa de entrada · Busca",
      "flows": "Flows",
      "billing": "Cobrança",
      "account": "Conta",
      "assistant": "Assistente",
      "brain": "Brain",
      "unknown": "App"
    },
    "suggestions": {
      "communicationReport": "Relatório de comunicação",
      "calendarToday": "O que tenho na agenda hoje?",
      "whatDidIMiss": "O que perdi durante a noite?",
      "draftsInProgress": "Rascunhos em andamento",
      "summarizePendingTasks": "Resumir minhas tarefas pendentes",
      "whatNeedsAttention": "O que precisa da minha atenção hoje?",
      "replyPendingDMs": "Responder DMs pendentes",
      "slackChannelsOverview": "Visão geral dos canais do Slack",
      "summarizeActiveFlows": "Resumir meus fluxos ativos"
    },
    "pill": {
      "label": "Assistente",
      "ariaLabel": "Abrir assistente this+that",
      "ariaLabelAttention": "Assistente this+that — precisa da sua atenção"
    }
  },
  "assistantInputBar": {
    "slashPillLabel": "Digite um comando",
    "atPillLabel": "Mencionar alguém",
    "sendButtonLabel": "Enviar"
  },
  "brain": {
    "deepLinkTeamSwitch": {
      "switched": "Equipe ativa alterada para {{teamName}} para abrir este item",
      "switchedGeneric": "Equipe ativa alterada para abrir este item",
      "noAccess": "Você não tem acesso à equipe deste item"
    },
    "sidebar": {
      "heading": "Conhecimento",
      "loading": "Carregando…",
      "loadError": "Não foi possível carregar os espaços de conhecimento",
      "empty": "Nenhum espaço de conhecimento ainda",
      "compose": {
        "button": "Novo espaço",
        "menu": {
          "newPage": "Nova página",
          "newSpace": "Novo espaço"
        }
      },
      "spaceActions": {
        "menuAriaLabel": "Ações do espaço",
        "createPage": "Criar página",
        "rename": "Renomear espaço",
        "delete": "Excluir espaço",
        "renameInputAriaLabel": "Nome do espaço",
        "systemSpaceTooltip": "Espaços do sistema não podem ser renomeados nem excluídos",
        "renameSuccessToast": "Espaço renomeado",
        "renameErrorToast": "Não foi possível renomear o espaço"
      },
      "pageActions": {
        "menuAriaLabel": "Ações da página",
        "createPage": "Criar página",
        "rename": "Renomear página",
        "delete": "Excluir página",
        "renameInputAriaLabel": "Título da página",
        "renameSuccessToast": "Página renomeada",
        "renameErrorToast": "Não foi possível renomear a página",
        "deleteErrorToast": "Não foi possível excluir a página",
        "move": "Mover página",
        "favorite": "Adicionar aos favoritos",
        "unfavorite": "Remover dos favoritos",
        "systemPageTooltip": "Páginas do sistema não podem ser renomeadas, movidas nem excluídas.",
        "systemPageAriaLabel": "Página do sistema"
      },
      "deletePage": {
        "confirmTitle": "Excluir a página \"{{title}}\"?",
        "confirmDescription": "Isso excluirá a página permanentemente. Esta ação não pode ser desfeita.",
        "confirmDescriptionWithChildren": "Isso excluirá permanentemente a página e suas {{count}} páginas filhas. Esta ação não pode ser desfeita.",
        "confirmAction": "Excluir",
        "cancel": "Cancelar",
        "successToast": "Página excluída",
        "errorToast": "Não foi possível excluir a página"
      },
      "deleteSpace": {
        "confirmTitle": "Excluir o espaço \"{{name}}\"?",
        "confirmDescription": "Isso excluirá permanentemente o espaço e TODAS as suas páginas. Esta ação não pode ser desfeita.",
        "confirmAction": "Excluir",
        "cancel": "Cancelar",
        "successToast": "Espaço excluído",
        "errorToast": "Não foi possível excluir o espaço"
      },
      "groups": {
        "systemSpaces": "Espaços do sistema",
        "teamSpaces": "Espaços da equipe",
        "userSpaces": "Espaços pessoais",
        "teamSpacesEmpty": "Adicionar espaço da equipe.",
        "userSpacesEmpty": "Adicionar espaço pessoal."
      },
      "spaceHeader": {
        "pageCount_one": "{{count}} página",
        "pageCount_other": "{{count}} páginas"
      },
      "spaceSection": {
        "empty": "Nenhuma página",
        "loadError": "Não foi possível carregar as páginas",
        "retry": "Tentar novamente"
      },
      "back": "Voltar",
      "backToApp": "Voltar ao app",
      "home": "Início",
      "dragHint": {
        "invalidDrop": "Não é possível soltar aqui"
      },
      "nav": {
        "favorites": "Favoritos"
      }
    },
    "modals": {
      "createSpace": {
        "title": "Criar novo espaço",
        "nameLabel": "Nome",
        "namePlaceholder": "Nome do espaço",
        "nameRequired": "O nome é obrigatório",
        "ownerTypeLabel": "Tipo",
        "ownerTypeTeam": "Equipe",
        "ownerTypeUser": "Pessoal",
        "cancel": "Cancelar",
        "create": "Criar",
        "successToast": "Espaço criado",
        "errorToast": "Falha ao criar o espaço"
      },
      "createPage": {
        "title": "Criar nova página",
        "titleLabel": "Título",
        "titlePlaceholder": "Título da página",
        "titleRequired": "O título é obrigatório",
        "spaceLabel": "Espaço",
        "spaceRequired": "O espaço é obrigatório",
        "parentLabel": "Página pai",
        "parentRoot": "(Sem página pai — página raiz)",
        "cancel": "Cancelar",
        "create": "Criar",
        "successToast": "Página criada",
        "errorToast": "Falha ao criar a página",
        "ownerTypeTeam": "Equipe",
        "ownerTypeUser": "Usuário"
      },
      "renamePage": {
        "title": "Renomear página",
        "titleLabel": "Título da página",
        "titlePlaceholder": "Digite o título da página",
        "titleRequired": "O título é obrigatório",
        "cancel": "Cancelar",
        "save": "Salvar"
      },
      "movePage": {
        "title": "Mover a página “{{title}}”",
        "subtitle": "Escolha um novo local para esta página",
        "targetLabel": "Mover para",
        "rootOption": "{{spaceName}} (raiz)",
        "cancel": "Cancelar",
        "submit": "Mover",
        "successToast": "Página movida",
        "errors": {
          "crossOwnerTeamToUser": "Páginas de equipe não podem ser movidas para espaços pessoais",
          "crossOwnerOther": "Não é possível mover páginas entre proprietários diferentes",
          "targetIsDescendant": "Não é possível mover para dentro de uma página filha",
          "noOp": "A página já está neste local",
          "exceedsDepth": "Mover excederia a profundidade máxima de aninhamento",
          "tooLarge": "Subárvore grande demais para mover em uma única operação ({{pageCount}} páginas)",
          "inProgress": "Esta página já está sendo movida — tente novamente em instantes",
          "versionConflict": "A página foi editada em outro lugar — recarregue e tente novamente",
          "atCapacity": "O espaço de destino atingiu a capacidade máxima de páginas",
          "generic": "Não foi possível mover a página"
        },
        "tooltip": {
          "disabledTeamToUser": "Páginas de equipe não podem ser movidas para espaços pessoais",
          "disabledCrossUser": "Apenas o proprietário da página pode movê-la",
          "disabledCrossTeam": "Páginas só podem ser movidas dentro da mesma equipe",
          "disabledIsDescendant": "Não é possível mover para dentro de uma página filha",
          "disabledIsSelf": "Não é possível soltar sobre ela mesma",
          "disabledExceedsDepth": "Excederia a profundidade máxima de aninhamento",
          "disabledNoOp": "Já está neste local",
          "disabledNoPermission": "Você não tem permissão para mover páginas para cá",
          "disabledSourceNoPermission": "Você não tem permissão para mover esta página",
          "disabledSystemParent": "Páginas do sistema não podem conter subpáginas",
          "disabledAtCapacity": "O espaço de destino atingiu a capacidade máxima de páginas",
          "disabledTooLarge": "Esta página tem subpáginas demais para mover em uma única operação"
        },
        "recentLabel": "Recentes",
        "recentChipAriaLabel": "Mover para {{label}}",
        "movingTo": "Movendo para",
        "selectDestination": "Selecione um destino",
        "currentPill": "Atual"
      },
      "pageHistory": {
        "title": "Histórico de versões",
        "subtitle": "{{title}} · {{count}} versões",
        "detailTitle": "v{{version}} · {{tab}}",
        "detailSubtitle": "{{title}} · {{relative}}",
        "backAriaLabel": "Voltar para as versões",
        "versionsHeader": "Versões",
        "currentBadge": "Atual",
        "restore": "Restaurar",
        "restoreThisVersion": "Restaurar esta versão",
        "restoreConfirmTitle": "Restaurar esta versão?",
        "restoreConfirmDescription": "Isso substitui o conteúdo atual da página pela {{version}} e cria uma nova versão. Seu conteúdo atual permanece no histórico.",
        "cancel": "Cancelar",
        "loadMore": "Carregar mais",
        "loadMoreError": "Não foi possível carregar mais — tentar novamente",
        "versionsLoading": "Carregando versões…",
        "versionsError": "Falha ao carregar as versões",
        "versionsEmpty": "Nenhuma versão encontrada",
        "diffLoading": "Carregando diff…",
        "diffError": "Falha ao carregar o diff",
        "diffTooLarge": "Este diff é grande demais para ser exibido",
        "diffEmpty": "Nenhuma alteração nesta versão",
        "restoreConflict": "Esta página mudou enquanto você via o histórico. A lista foi atualizada — tente novamente.",
        "restoreError": "Não foi possível restaurar esta versão. Tente novamente.",
        "initialVersion": "Versão inicial",
        "viewing": "Visualizando {{version}}",
        "footerCurrent": "esta é a versão atual",
        "footerRestore": "restaurar substitui o rascunho atual",
        "tabs": {
          "changes": "Alterações",
          "fullFile": "Arquivo completo"
        }
      }
    },
    "page": {
      "empty": "Selecione uma página para ver o conteúdo",
      "loading": "Carregando página…",
      "notFound": "Página não encontrada",
      "renameTitleHint": "Clique para renomear esta página",
      "loadErrorTitle": "Não foi possível carregar esta página",
      "loadErrorSubtitle": "Não conseguimos buscar o conteúdo dela.",
      "loadErrorCta": "Recarregar",
      "version": "v{{version}}",
      "updatedRelative": "Atualizada {{relative}}",
      "createdByCaption": "Criada por",
      "creationDetails": "Detalhes da criação",
      "byAgentOnBehalf": "{{agent}} em nome de {{user}}",
      "unknownUser": "um usuário que não faz mais parte da equipe",
      "actions": {
        "edit": "Editar",
        "done": "Concluído",
        "saving": "Salvando…",
        "discard": "Descartar",
        "readOnly": "Somente leitura",
        "history": "Histórico",
        "disabledWhileUnsaved": "Salve ou descarte suas alterações primeiro"
      },
      "status": {
        "idle": "Atualizada",
        "saving": "Salvando…",
        "saved": "Salva",
        "error": "Falha ao salvar: {{error}}",
        "contentRejected": "Falha ao salvar: o conteúdo contém elementos não permitidos"
      },
      "conflict": {
        "title": "Rascunho desatualizado",
        "body": "Outro usuário atualizou esta página (agora na v{{version}}). Suas edições locais não foram aplicadas.",
        "discardLocal": "Descartar minhas alterações"
      },
      "contentRejected": {
        "title": "Esta página não pode ser salva",
        "intro": "Remova os itens abaixo da página e salve novamente:",
        "dismiss": "Fechar",
        "issue": {
          "forbiddenTag": "Tag HTML <{{detail}}>",
          "eventHandler": "Atributo de evento \"{{detail}}\"",
          "dangerousUri": "Link com o esquema {{detail}}"
        }
      },
      "editor": {
        "bold": "Negrito",
        "italic": "Itálico",
        "strike": "Tachado",
        "heading1": "Título 1",
        "heading2": "Título 2",
        "heading3": "Título 3",
        "bulletList": "Lista com marcadores",
        "orderedList": "Lista numerada",
        "codeBlock": "Bloco de código",
        "blockquote": "Citação",
        "inlineCode": "Código inline",
        "toolbarAriaLabel": "Formatação de texto",
        "expandToolbar": "Mostrar mais opções de formatação",
        "collapseToolbar": "Mostrar menos opções de formatação",
        "insertGeneratedImage": {
          "button": "Inserir imagem",
          "modalTitle": "Inserir imagem",
          "error": "Imagem inserida, mas não foi possível registrar o uso — ela ainda será exibida corretamente."
        },
        "insertImage": "Inserir imagem",
        "attachFile": "Anexar arquivo",
        "aiAssistant": {
          "toolbarLabel": "Assistente de escrita com IA",
          "toolbarPillLabel": "IA",
          "slashMenu": {
            "ariaLabel": "Ações de escrita com IA",
            "empty": "Nenhuma ação encontrada",
            "sectionWriteWithAi": "Escrever com IA",
            "sectionFormat": "Formatar",
            "continueWriting": "Continuar escrevendo",
            "draftFromPrompt": "Redigir a partir de um comando",
            "draftFromPromptHint": "{{shortcut}}",
            "notesToTable": "Transformar notas em tabela",
            "askYourSpaces": "Perguntar aos seus espaços",
            "summarizePage": "Resumir esta página",
            "heading2": "Título 2",
            "bulletedList": "Lista com marcadores",
            "quote": "Citação"
          },
          "inlinePrompt": {
            "placeholderDraft": "Diga à IA o que escrever…",
            "placeholderAskSpaces": "Pergunte algo aos seus espaços…",
            "placeholderRewrite": "Diga à IA como reescrever a seleção…",
            "orbAriaLabel": "Assistente de IA",
            "send": "Enviar",
            "contextLabel": "Contexto",
            "thisPageChip": "Esta página",
            "escHint": "Esc para cancelar"
          },
          "status": {
            "orbAriaLabel": "A IA está escrevendo",
            "writing": "Escrevendo…",
            "stop": "Parar"
          },
          "selectionBubble": {
            "ariaLabel": "Ações de IA para a seleção",
            "improve": "Melhorar",
            "shorter": "Encurtar",
            "tone": "Tom",
            "translate": "Traduzir",
            "fixGrammar": "Corrigir gramática",
            "askAi": "Perguntar à IA",
            "askAiShortcut": "{{shortcut}}"
          },
          "toneLabel": {
            "formal": "Formal",
            "friendly": "Amigável",
            "direct": "Direto",
            "confident": "Confiante"
          },
          "languageLabel": {
            "ptBr": "Português (BR)",
            "es": "Espanhol",
            "enUs": "Inglês (EUA)"
          },
          "toast": {
            "undo": "Desfazer",
            "error": "A IA não conseguiu gerar uma resposta. Tente novamente.",
            "addedBlocks_one": "{{count}} bloco adicionado",
            "addedBlocks_other": "{{count}} blocos adicionados",
            "answered": "Respondido a partir dos seus espaços",
            "rewritten": "Reescrito",
            "toneApplied": "Tom: {{tone}}",
            "translated": "Traduzido para {{language}}",
            "grammarFixed": "Gramática corrigida",
            "sourcesOverflow": "{{first}} +{{count}}"
          }
        }
      },
      "attachments": {
        "heading": "Anexos",
        "chip": {
          "uploading": "Enviando…",
          "unknownFile": "Arquivo desconhecido",
          "downloadAriaLabel": "Baixar {{name}}",
          "editAriaLabel": "Selecionar {{name}}",
          "fileInputLabel": "Anexar um arquivo a esta página"
        },
        "uploadButton": "Anexar arquivo",
        "uploading": "Enviando…",
        "uploadAriaLabel": "Anexar um arquivo a esta página",
        "empty": "Nenhum anexo ainda",
        "listAriaLabel": "Anexos da página",
        "openAriaLabel": "Abrir {{fileName}} em uma nova aba",
        "openInViewerAriaLabel": "Abrir {{fileName}}",
        "removeAriaLabel": "Remover {{fileName}}",
        "removeConfirm": "Remover \"{{fileName}}\"? Isso não pode ser desfeito.",
        "countBadgeAriaLabel": "{{count}} anexo",
        "countBadgeAriaLabel_other": "{{count}} anexos",
        "widget": {
          "triggerAriaLabel": "Gerenciar anexos",
          "title": "Anexos",
          "addFile": "Adicionar arquivo",
          "dropzoneHint": "Solte os arquivos aqui para anexar",
          "dropzoneActive": "Solte para anexar",
          "uploadError": "Falha no envio"
        },
        "errors": {
          "scanPending": "O arquivo ainda está sendo verificado contra ameaças. Tente novamente em instantes.",
          "infected": "O arquivo foi bloqueado por motivos de segurança.",
          "invalidType": "O arquivo não corresponde ao tipo declarado.",
          "uploadFailed": "Falha ao enviar o anexo. Tente novamente.",
          "removeFailed": "Falha ao remover o anexo. Tente novamente."
        }
      },
      "images": {
        "brokenImageAlt": "Imagem indisponível",
        "imageAlt": "Imagem no conteúdo",
        "fileInputLabel": "Inserir imagem",
        "errors": {
          "scanPending": "A imagem ainda está sendo verificada contra ameaças. Tente novamente em instantes.",
          "infected": "A imagem foi bloqueada por motivos de segurança.",
          "invalidType": "O arquivo não corresponde ao tipo declarado.",
          "uploadFailed": "Falha ao enviar a imagem. Tente novamente."
        },
        "uploading": "Enviando…",
        "resizeAriaLabel": "Redimensionar imagem"
      },
      "backToSpace": "Voltar para {{space}}",
      "unsavedChanges": {
        "title": "Alterações não salvas",
        "description": "Você tem alterações não salvas. Deseja salvá-las antes de sair?",
        "save": "Salvar",
        "discard": "Descartar"
      }
    },
    "home": {
      "greetingMorning": "Bom dia, {{name}}",
      "greetingAfternoon": "Boa tarde, {{name}}",
      "greetingEvening": "Boa noite, {{name}}",
      "greetingNoName": "Boas-vindas ao seu Brain",
      "searchPlaceholder": "Buscar páginas…",
      "clearSearch": "Limpar busca",
      "recentlyUpdated": "Atualizadas recentemente",
      "yourSpaces": "Seus espaços",
      "newSpace": "+ Novo espaço",
      "newPage": "Nova página",
      "pagesCount_one": "{{count}} página",
      "pagesCount_other": "{{count}} páginas",
      "updatedRelative": "Atualizada {{relative}}",
      "teamBadge": "Equipe",
      "userBadge": "Pessoal",
      "emptyTitle": "Seu Brain está pronto",
      "emptySubtitle": "Crie seu primeiro espaço de conhecimento para começar a organizar notas, documentos e ideias com sua equipe.",
      "emptyCta": "Criar seu primeiro espaço",
      "searchNoResults": "Nenhuma página encontrada para “{{query}}”",
      "searchNoResultsTitle": "Nenhum resultado encontrado",
      "pageCardAriaLabel": "Abrir a página {{title}} em {{space}}",
      "spaceCardAriaLabel": "Abrir o espaço {{name}}",
      "searching": "Buscando…",
      "searchErrorFallback": "A busca semântica está indisponível — mostrando correspondências por título.",
      "bestMatch": "Melhor resultado",
      "searchResultsAriaLabel": "Resultados da busca por “{{query}}”",
      "favorites": "Favoritos",
      "seeAllFavorites": "Ver todos",
      "loadErrorTitle": "Não foi possível carregar seus espaços",
      "loadErrorSubtitle": "Não conseguimos acessá-los agora. Nada foi perdido.",
      "loadErrorCta": "Recarregar"
    },
    "space": {
      "pagesCount_one": "{{count}} página",
      "pagesCount_other": "{{count}} páginas",
      "membersCount_one": "{{count}} membro",
      "membersCount_other": "{{count}} membros",
      "pagesSectionLabel": "Páginas neste espaço",
      "empty": "Nenhuma página neste espaço ainda",
      "notFound": "Espaço não encontrado",
      "renameTitleHint": "Clique para renomear este espaço",
      "pageCardAriaLabel": "Abrir a página {{title}}",
      "back": "Voltar",
      "loadErrorTitle": "Não foi possível abrir este espaço",
      "loadErrorSubtitle": "As páginas dele não carregaram desta vez.",
      "loadErrorCta": "Recarregar",
      "pagesLoadError": "Não foi possível carregar estas páginas",
      "pagesLoadErrorRetry": "Tentar novamente"
    },
    "mention": {
      "sectionPeople": "Pessoas",
      "sectionTasks": "Tarefas",
      "sectionPages": "Páginas",
      "pickerAriaLabel": "Mencionar uma pessoa, tarefa ou página",
      "youSuffix": "(Você)",
      "empty": "Nenhum membro da equipe correspondente",
      "emptyTasks": "Nenhuma tarefa correspondente",
      "emptyPages": "Nenhuma página correspondente",
      "taskStatusOpen": "Aberta",
      "taskStatusDone": "Concluída",
      "taskCardOpenButton": "Abrir",
      "taskCardLoading": "Carregando tarefa…",
      "taskCardError": "Não foi possível carregar a tarefa",
      "taskCardNotFound": "Tarefa não encontrada",
      "pageCardOpenButton": "Abrir",
      "pageCardLoading": "Carregando página…",
      "pageCardError": "Não foi possível carregar a página",
      "pageCardNotFound": "Página não encontrada"
    },
    "members": {
      "manageMembers": "Gerenciar membros",
      "members": "Membros",
      "addMembers": "Adicionar membros",
      "owner": "Proprietário",
      "removeMember": "Remover membro",
      "roleLabel": "Função",
      "roles": {
        "viewer": "Visualizador",
        "editor": "Editor",
        "manager": "Gerente"
      },
      "visibility": {
        "label": "Visibilidade",
        "team": "Equipe",
        "teamDescription": "Todos os membros da equipe podem acessar este espaço",
        "restricted": "Restrito",
        "restrictedDescription": "Apenas membros convidados podem acessar este espaço"
      },
      "leave": "Sair do espaço",
      "leaveConfirmTitle": "Sair de \"{{name}}\"?",
      "leaveConfirmDescription": "Você perderá o acesso a este espaço. Você pode ser convidado novamente depois.",
      "transferOwnership": "Transferir propriedade",
      "transferConfirmTitle": "Transferir a propriedade de \"{{name}}\"?",
      "transferConfirmDescription": "{{newOwnerName}} se tornará o novo proprietário e terá controle total deste espaço.",
      "save": "Salvar",
      "cancel": "Cancelar",
      "unknownMember": "Membro desconhecido",
      "errors": {
        "versionConflict": "Este espaço foi atualizado em outro lugar — recarregue e tente novamente",
        "forbidden": "Você não tem permissão para realizar esta ação",
        "notOwner": "Apenas o proprietário do espaço pode realizar esta ação",
        "participantAlreadyExists": "Este membro já foi adicionado",
        "cannotLeaveTeamSpace": "Você não pode sair de um espaço visível para toda a equipe",
        "generic": "Algo deu errado — tente novamente"
      }
    },
    "favorites": {
      "title": "Favoritos",
      "empty": "Nenhum favorito ainda",
      "emptyHint": "Favorite uma página para encontrá-la aqui rapidamente.",
      "toggleAdd": "Adicionar aos favoritos",
      "toggleRemove": "Remover dos favoritos",
      "errorGeneric": "Não foi possível atualizar os favoritos. Tente novamente.",
      "limitReached": "Você atingiu o limite de {{limit}} favoritos."
    }
  },
  "publishedArtifact": {
    "loading": "Carregando…",
    "notFound": {
      "title": "Página não encontrada ou não está mais disponível",
      "body": "Este artefato pode ter sido despublicado ou o link pode estar incorreto."
    },
    "bridge": {
      "actionError": "Não foi possível concluir a ação. Tente novamente."
    }
  },
  "generatedImages": {
    "page": {
      "title": "Suas Imagens",
      "subtitle": "Imagens que você enviou"
    },
    "gallery": {
      "empty": {
        "title": "Você ainda não tem nenhuma imagem.",
        "cta": "Abrir Assistente",
        "pickerHint": "Envie uma imagem no Assistente e depois volte aqui para inseri-la."
      },
      "loadMore": "Carregar mais",
      "error": "Não foi possível carregar as imagens. Tente novamente.",
      "retry": "Tentar novamente",
      "selectAria": "Selecionar imagem",
      "viewAria": "Ver imagem",
      "imageAlt": "Imagem armazenada",
      "delete": {
        "confirmTitle": "Excluir esta imagem?",
        "confirmBody": "Esta imagem será excluída permanentemente, inclusive em todos os lugares onde você a inseriu anteriormente. Essa ação não pode ser desfeita.",
        "error": "Não foi possível excluir a imagem. Tente novamente."
      }
    }
  },
  "calendarPage": {
    "toolbar": {
      "today": "Hoje",
      "prev": "Anterior",
      "next": "Próximo",
      "create": "Criar",
      "viewSwitcherLabel": "Visualização",
      "openMonthPicker": "Abrir seletor de mês",
      "mode": {
        "month": "Mês",
        "week": "Semana",
        "day": "Dia",
        "agenda": "Agenda"
      }
    },
    "miniCal": {
      "prevMonth": "Mês anterior",
      "nextMonth": "Próximo mês"
    },
    "rail": {
      "myCalendars": "Minhas agendas"
    },
    "monthView": {
      "more": "mais {{count}}"
    },
    "timeGrid": {
      "allDay": "Dia inteiro",
      "moreCount": "mais {{count}}",
      "showLess": "Mostrar menos"
    },
    "mobileDayStrip": {
      "dayLabel": "{{dow}} {{date}}"
    },
    "mobileMonthPicker": {
      "openAriaLabel": "Abrir seletor de mês",
      "closeAriaLabel": "Fechar seletor de mês"
    },
    "agendaView": {
      "empty": "Nenhum evento nos próximos 30 dias.",
      "allDay": "Dia inteiro"
    },
    "eventModal": {
      "titleNew": "Novo evento",
      "titleEdit": "Editar evento",
      "close": "Fechar",
      "titlePlaceholder": "Adicionar título",
      "calendarLabel": "Agenda",
      "allDay": "Dia inteiro",
      "whenLabel": "Quando",
      "dragRangeHint": "Arraste para selecionar vários dias",
      "timeLabel": "Horário",
      "startLabel": "Início",
      "endLabel": "Término",
      "locationLabel": "Local / link",
      "locationPlaceholder": "Adicione uma sala, um endereço ou um link de chamada",
      "descriptionLabel": "Descrição",
      "descriptionPlaceholder": "Adicione uma descrição",
      "addMeet": "Adicionar videoconferência do Google Meet",
      "addTeamsMeeting": "Adicionar reunião do Teams",
      "delete": "Excluir",
      "cancel": "Cancelar",
      "createAction": "Criar",
      "saveAction": "Salvar",
      "untitled": "Evento sem título",
      "guestsLabel": "Convidados",
      "guestsPlaceholder": "Adicionar convidados",
      "recurrenceLabel": "Repetição",
      "recurrenceLoading": "Carregando repetição",
      "recurrence": {
        "none": "Não se repete",
        "daily": "Todos os dias",
        "weekly": "Toda semana: {{weekday}}",
        "weekdays": "Todo dia útil (seg–sex)",
        "monthly": "Mensalmente",
        "yearly": "Anualmente"
      }
    },
    "emptyState": {
      "title": "Nenhuma agenda conectada",
      "description": "Conecte uma agenda do Google ou do Outlook para ver e gerenciar seus eventos aqui."
    },
    "errors": {
      "saveFailed": "Não foi possível salvar o evento. Tente novamente.",
      "deleteFailed": "Não foi possível excluir o evento. Tente novamente.",
      "fetchFailed": "Não foi possível carregar suas agendas. Tente reconectar sua conta.",
      "reconnectLink": "Reconectar",
      "retryButton": "Tentar novamente",
      "rsvpFailed": "Não foi possível atualizar sua resposta. Tente novamente.",
      "copyFailed": "Não foi possível copiar para a área de transferência."
    },
    "eventDetails": {
      "allDay": "Dia inteiro",
      "joinMeet": "Participar com o Google Meet",
      "joinMeeting": "Participar da reunião",
      "copyLink": "Copiar link da reunião",
      "copySuccess": "Link da reunião copiado",
      "guests": "{{count}} convidado",
      "guests_other": "{{count}} convidados",
      "guestYes": "{{count}} sim",
      "guestAwaiting": "{{count}} aguardando",
      "guestNo": "{{count}} não",
      "guestMaybe": "{{count}} talvez",
      "organizer": "Organizador",
      "rsvpLabel": "Vai participar?",
      "rsvpYes": "Sim",
      "rsvpNo": "Não",
      "rsvpMaybe": "Talvez",
      "rsvpLoading": "Atualizando resposta",
      "editLabel": "Editar evento",
      "deleteLabel": "Excluir evento",
      "closeLabel": "Fechar",
      "recurring": "Repete-se"
    },
    "recurrenceScope": {
      "editTitle": "Editar evento recorrente",
      "deleteTitle": "Excluir evento recorrente",
      "thisEvent": "Este evento",
      "allEvents": "Todos os eventos",
      "cancel": "Cancelar",
      "ok": "OK"
    }
  },
  "contacts": {
    "title": "Contatos",
    "newContact": "Novo contato",
    "countBadge": {
      "exact": "{{count}}",
      "plus": "{{count}}+"
    },
    "scope": {
      "personal": "Meus contatos",
      "team": "Equipe"
    },
    "search": {
      "placeholder": "Buscar por nome, e-mail, cargo…"
    },
    "filters": {
      "all": "Todos",
      "google": "Google",
      "outlook": "Outlook",
      "slack": "Slack",
      "landingPage": "Landing page"
    },
    "list": {
      "empty": "Nenhum contato ainda.",
      "noResults": "Nenhum contato corresponde à sua busca."
    },
    "detail": {
      "back": "Voltar",
      "sourceVia": "via {{source}}",
      "sourceViaMultiple": "via {{sources}}",
      "empty": "Selecione um contato para ver os detalhes.",
      "emailsTitle": "E-mails",
      "phonesTitle": "Telefones",
      "overflowCount": "+{{count}}",
      "primaryValue": "Principal",
      "removedByTeamMate": "Este contato foi removido por um colega de equipe.",
      "mergedByTeamMate": "Este contato foi mesclado com outro por um colega de equipe.",
      "eventRemoved": "Este evento foi removido.",
      "copyValue": "Copiar",
      "copiedValue": "Copiado",
      "copyValueNamed": "Copiar {{value}}",
      "copiedValueNamed": "Copiado {{value}}"
    },
    "source": {
      "google": "Google",
      "outlook": "Outlook",
      "slack": "Slack",
      "manual": "Manual",
      "landingPage": "Landing page",
      "thisThat": "this+that"
    },
    "actions": {
      "mergeWith": "Mesclar com…",
      "sendEmail": "Enviar e-mail",
      "chooseEmail": "Escolha um e-mail",
      "delete": "Excluir",
      "addToTeam": "Adicionar à equipe"
    },
    "notes": {
      "label": "Notas",
      "saving": "Salvando…",
      "saved": "Salvo",
      "placeholder": "Adicione notas sobre este contato…",
      "remoteUpdate": {
        "message": "Um colega de equipe atualizou estas notas.",
        "action": "Ver a versão do colega",
        "actionHint": "Descarta as alterações que você ainda não salvou."
      }
    },
    "messages": {
      "title": "Mensagens recentes",
      "titleShared": "Suas interações",
      "count_one": "{{count}} mensagem",
      "count_other": "{{count}} mensagens",
      "empty": "Nenhuma mensagem recente.",
      "untitled": "Sem título",
      "you": "Você",
      "platform": "via {{platform}}",
      "openFailed": "Este e-mail não está mais disponível.",
      "opening": "Abrindo…",
      "sentBy": "Enviado",
      "receivedFrom": "Recebido",
      "loadingMore": "Carregando mais mensagens…",
      "loadFailed": "Não foi possível carregar as mensagens. Tente novamente.",
      "capReached": "Mostrando as {{count}} mensagens mais recentes. Paramos de carregar as mais antigas aqui.",
      "newMessageArrived_one": "Chegou {{count}} mensagem nova",
      "newMessageArrived_other": "Chegaram {{count}} mensagens novas",
      "emptyEmail": "Nenhum e-mail com este contato.",
      "emptySlack": "Nenhuma mensagem do Slack com este contato.",
      "filters": {
        "ariaLabel": "Filtrar mensagens por plataforma",
        "all": "Todas",
        "email": "E-mails",
        "slack": "Slack"
      }
    },
    "timeline": {
      "title": "Eventos",
      "count_one": "{{count}} evento",
      "count_other": "{{count}} eventos",
      "empty": "Nenhum evento registrado ainda.",
      "loadingMore": "Carregando mais eventos…",
      "emptyHint": "Os flows registram eventos aqui conforme as coisas acontecem.",
      "emptyAction": "Adicione um você mesmo",
      "add": "Adicionar evento"
    },
    "eventCreate": {
      "title": "Novo evento",
      "titleLabel": "Título",
      "titlePlaceholder": "O que aconteceu",
      "descriptionLabel": "Descrição",
      "descriptionOptional": "opcional",
      "descriptionPlaceholder": "Algo que valha a pena lembrar",
      "whenLabel": "Quando",
      "whenDateLabel": "Data do evento",
      "whenTimeLabel": "Hora do evento",
      "cancel": "Cancelar",
      "submit": "Salvar evento",
      "error": "Não foi possível salvar este evento. Tente novamente."
    },
    "eventDetails": {
      "ariaLabel": "Detalhes do evento",
      "close": "Fechar",
      "flowSubtitle": "Como este evento chegou aqui.",
      "thisEvent": "este evento",
      "noFlow": "Este evento não foi registrado por um fluxo.",
      "teamVisibility": "Visível para todos no time deste contato.",
      "openFlow": "Abrir fluxo",
      "edit": "Editar evento",
      "titleLabel": "Título do evento",
      "descriptionLabel": "Descrição do evento",
      "descriptionPlaceholder": "Adicionar uma descrição",
      "cancelEdit": "Cancelar",
      "saveEdit": "Salvar",
      "delete": "Excluir",
      "deleteTitle": "Excluir evento",
      "deleteBody": "Isso vai excluir este evento permanentemente. Esta ação não pode ser desfeita.",
      "deleteBodyTeam": "Este contato pertence a um time, então excluir este evento remove ele para todos do time. Esta ação não pode ser desfeita.",
      "deleteConfirm": "Excluir",
      "deleteCancel": "Cancelar",
      "updateError": "Não foi possível atualizar este evento. Tente novamente.",
      "deleteError": "Não foi possível excluir este evento. Tente novamente.",
      "trigger": {
        "EMAIL": "E-mail recebido",
        "SLACK": "Mensagem do Slack",
        "GOOGLE_CHAT": "Mensagem do Google Chat",
        "INSTAGRAM": "Mensagem do Instagram",
        "SCHEDULE": "Agendamento",
        "DOBOX": "Item da DoBox",
        "MANUAL": "Execução manual",
        "TELEGRAM": "Mensagem do Telegram",
        "WHATSAPP": "Mensagem do WhatsApp",
        "KNOWLEDGE": "Atualização de conhecimento",
        "GITHUB": "Evento do GitHub",
        "PEOPLE": "Evento de contato",
        "GOOGLE_BUSINESS": "Atualização do Google Business"
      }
    },
    "create": {
      "title": "Novo contato",
      "name": "Nome",
      "emails": "E-mail",
      "addEmail": "Adicionar outro e-mail",
      "emailPlaceholder": "jane@example.com",
      "phone": "Telefone",
      "addPhone": "Adicionar outro telefone",
      "phonePlaceholder": "+55 11 99999 9999",
      "jobTitle": "Cargo",
      "teamLabel": "Equipe",
      "teamPersonalOption": "Contato pessoal",
      "submit": "Criar contato",
      "cancel": "Cancelar",
      "nameRequired": "O nome é obrigatório.",
      "emailInvalid": "Digite um e-mail válido.",
      "teamCopySuccess": "{{name}} foi criado e adicionado a {{team}}.",
      "teamCopyConflict": "{{name}} foi criado, mas já existe um contato com este e-mail em {{team}}.",
      "teamOnlyContext": "Criando em {{team}}",
      "teamOnlySuccess": "{{name}} foi criado em {{team}}.",
      "teamOnlyConflict": "Já existe um contato com este e-mail em {{team}}."
    },
    "edit": {
      "title": "Editar contato",
      "submit": "Salvar alterações",
      "button": "Editar"
    },
    "delete": {
      "title": "Excluir contato",
      "body": "Isso excluirá este contato permanentemente. Esta ação não pode ser desfeita.",
      "confirm": "Excluir",
      "cancel": "Cancelar"
    },
    "merge": {
      "picker": {
        "title": "Mesclar com outro contato",
        "subtitle": "Escolha quem combinar com {{name}}",
        "searchPlaceholder": "Buscar contatos",
        "selectedCount": "{{count}} selecionado(s)",
        "limitWarning": "Você pode mesclar até {{max}} contatos de uma vez"
      },
      "confirm": {
        "title": "Mesclar {{count}} contatos em um",
        "info": "Os e-mails e a atividade de todas as contas são combinados em uma única linha do tempo unificada. A foto da integração de e-mail se torna o avatar principal. A mesclagem é permanente e não pode ser desfeita.",
        "warnNoEmail": "Estes contatos não compartilham um endereço de e-mail, então não podemos verificar se são a mesma pessoa. Mescle apenas se tiver certeza.",
        "submit": "Mesclar contatos"
      },
      "unifyingTimeline": "Unificando o histórico — os eventos e as mensagens dos contatos mesclados aparecerão aqui em breve.",
      "errors": {
        "limit": "Você não pode mesclar tantos contatos de uma vez.",
        "shareLimit": "Um destes contatos está compartilhado com equipes demais para ser mesclado.",
        "notFound": "Um destes contatos não existe mais.",
        "notOwned": "Você só pode mesclar contatos que são seus.",
        "generic": "Algo deu errado ao mesclar. Tente novamente."
      }
    },
    "addToTeam": {
      "title": "Adicionar {{name}} a uma equipe",
      "description": "Isso cria uma cópia independente do contato para a equipe. A cópia não ficará sincronizada com seu contato pessoal, e essa ação não pode ser desfeita.",
      "teamLabel": "Equipe",
      "selectPlaceholder": "Selecione uma equipe",
      "noTeams": "Você ainda não faz parte de nenhuma equipe.",
      "copyGroupLabel": "Copiar além dos dados de contato",
      "copyNotes": "Notas",
      "copyEvents": "Eventos da timeline",
      "discloseBase": "A equipe {{team}} vai ver todos os dados de contato.",
      "discloseWithNotes": "A equipe {{team}} vai ver todos os dados de contato e suas notas.",
      "discloseWithEvents": "A equipe {{team}} vai ver todos os dados de contato e os eventos da timeline.",
      "discloseWithBoth": "A equipe {{team}} vai ver todos os dados de contato, suas notas e os eventos da timeline.",
      "conflictMessage": "Este contato já está na equipe.",
      "conflictKnownName": "Já adicionado como {{name}}.",
      "viewExisting": "Ver contato existente",
      "confirm": "Adicionar à equipe",
      "success": "{{name}} foi adicionado a {{team}}.",
      "successWithEvents": "{{name}} foi adicionado a {{team}}. Os eventos estão sendo copiados.",
      "errors": {
        "forbidden": "Você não tem permissão para adicionar contatos a esta equipe.",
        "notFound": "Este contato não está mais disponível.",
        "contactsLimit": "Não foi possível copiar este contato — ele tem e-mails ou telefones demais.",
        "generic": "Não foi possível adicionar o contato à equipe. Tente novamente."
      }
    },
    "errors": {
      "load": "Não foi possível carregar os contatos. Tente novamente.",
      "save": "Não foi possível salvar suas alterações. Tente novamente.",
      "create": "Não foi possível criar o contato. Tente novamente.",
      "update": "Não foi possível atualizar o contato. Tente novamente.",
      "versionConflict": "Este contato foi alterado por outra pessoa. Recarregamos a versão mais recente.",
      "delete": "Não foi possível excluir o contato. Tente novamente.",
      "search": "Não foi possível buscar os contatos. Tente novamente.",
      "notFound": "Esse contato não existe mais ou não está compartilhado com você.",
      "nameRequired": "Um contato precisa ter um nome.",
      "tooLong": "Esse valor é longo demais. Encurte-o, por favor.",
      "teamForbidden": "Nada foi criado — você não faz mais parte dessa equipe. Escolha outra equipe ou crie o contato apenas nos seus contatos pessoais."
    },
    "deepLinkTeamSwitch": {
      "switched": "Switched active team to {{teamName}} to view this contact",
      "switchedGeneric": "Switched active team to view this contact"
    },
    "firstRunBanner": {
      "title": "Sua lista de contatos se mantém sozinha",
      "subtitle": "Os contatos chegam das contas que você conecta, e seus flows mantêm cada um atualizado — notas, telefones e uma linha do tempo do que realmente aconteceu. Você nunca digita um contato duas vezes.",
      "status": {
        "noAccount": "Nenhuma conta conectada ainda — Google, Outlook, Slack ou Teams.",
        "noAccountFootnote": "A sincronização roda automaticamente. Ela também traz pessoas para quem você escreve mas nunca salvou.",
        "reading": "Sincronizando contatos de {{sources}}",
        "manage": "Gerenciar",
        "connectedFootnote": "Pessoas novas aparecem automaticamente, inclusive para quem você manda e-mail.",
        "justConnected": "{{platform}} conectado. A primeira sincronização já está em andamento."
      },
      "action": {
        "connectAccount": "Conectar uma conta",
        "connectAccountHint": "Google, Outlook, Slack ou Teams.",
        "manageAccounts": "Gerenciar contas",
        "manageAccountsHint": "Os contatos sincronizam automaticamente. Não há sincronização manual.",
        "doneHide": "Pronto, ocultar",
        "connectAnother": "Conectar outra",
        "hide": "Ocultar isto"
      },
      "discovery": {
        "heading": "Tem mais aqui",
        "subheading": "toque em um para ver funcionando",
        "cards": {
          "events": {
            "title": "Eventos",
            "description": "Um flow registra o que aconteceu"
          },
          "automations": {
            "title": "Automações",
            "description": "Novo contato, resolvido"
          },
          "team": {
            "title": "Contatos do time",
            "description": "Uma lista que o time compartilha"
          },
          "agents": {
            "title": "Agentes",
            "description": "Passe um contato adiante"
          }
        }
      },
      "panel": {
        "close": "Fechar",
        "events": {
          "lede": "Todo contato tem uma linha do tempo. Você não escreve nela — o flow que tocou o contato registra o que fez e de onde veio.",
          "mockTitle1": "Notas atualizadas",
          "mockTimestamp1": "há 2 dias",
          "mockProvenance1": "Como este evento chegou aqui — Lead Researcher · Novo contato · leu o contato, pesquisou pessoas, atualizou notas",
          "mockTitle2": "Telefone adicionado",
          "mockTimestamp2": "há 5 dias",
          "mockProvenance2": "Como este evento chegou aqui — Ops Intake Router · Novo contato · leu o contato, atualizou telefones, criou evento",
          "cta": "Abrir um contato"
        },
        "automations": {
          "lede": "Um novo contato pode disparar um flow. Este já está pronto para ligar:",
          "chipTrigger": "Novo contato",
          "chipStep1": "O agente pesquisa a pessoa",
          "chipStep2": "Escreve as notas",
          "chipStep3": "Registra um evento",
          "footnote": "O gatilho dispara quando um contato pessoal é criado — por uma sincronização, um formulário de landing page ou por você.",
          "cta": "Ativar nos Flows"
        },
        "team": {
          "lede": "Sua lista é sua. Copie um contato para a lista do time e todo mundo trabalha com o mesmo registro.",
          "segmentMy": "Meus contatos",
          "segmentTeam": "Time",
          "row1Name": "Alex Rivera",
          "row1Meta": "Head of Operations · copiado por você",
          "row2Name": "Ana Ribeiro",
          "row2Meta": "Product Consultant · copiado por Ana Ribeiro",
          "footnote": "A cópia do time é um registro separado. Editá-la não muda seu contato pessoal.",
          "cta": "Convide seu time",
          "secondaryCta": "Ver a lista do time"
        },
        "agents": {
          "lede": "Passe um contato para um agente e ele trabalha o registro sozinho, depois deixa o rastro na linha do tempo.",
          "chip1": "Lê o contato",
          "chip2": "Pesquisa suas pessoas",
          "chip3": "Escreve as notas",
          "chip4": "Registra um evento",
          "footnote": "Agentes reais já fazem isso: Lead Researcher, Meeting Prep Assistant, Payment Change Verifier, Vendor Document Chaser, Ops Intake Router.",
          "cta": "Gerenciar agentes"
        }
      },
      "footer": {
        "fillsFrom": "O Contacts também cresce a partir de",
        "chipGoogleOutlook": "Sincronização Google e Outlook",
        "chipSlack": "Slack",
        "chipLandingPage": "Formulários de landing page",
        "chipFlows": "Flows",
        "chipManualEntry": "Cadastro manual"
      }
    }
  },
  "teamHub": {
    "roles": {
      "owner": "Proprietário",
      "admin": "Administrador",
      "consultant": "Consultor",
      "member": "Membro",
      "viewer": "Visualizador",
      "pending": "Pendente"
    },
    "overview": {
      "title": "Central de equipes",
      "subtitle": "Gerencie as equipes das quais você faz parte, acompanhe os membros e colabore em um só lugar.",
      "searchPlaceholder": "Buscar equipes",
      "createTeam": "Criar equipe",
      "createCompact": "Criar",
      "yourTeams": "SUAS EQUIPES",
      "pendingInvites": "CONVITES PENDENTES",
      "teamCount_one": "{{count}} equipe",
      "teamCount_other": "{{count}} equipes",
      "countLine": "{{teamCount}} · {{inviteCount}}",
      "inviteMeta_one": "Convite de {{inviter}} · entrando como {{role}} · {{count}} membro",
      "inviteMeta_other": "Convite de {{inviter}} · entrando como {{role}} · {{count}} membros",
      "inviteMetaRelative": "Convite de {{inviter}} · {{time}}",
      "joinAs": "Entrar como",
      "ownerLabel": "Proprietário · {{name}}",
      "ownerYou": "Proprietário · Você",
      "ownerYouUntilHandoff": "Proprietário · Você, até a transferência",
      "memberCount_one": "{{count}} membro",
      "memberCount_other": "{{count}} membros",
      "manage": "Gerenciar",
      "accept": "Aceitar",
      "decline": "Recusar",
      "teamCardAriaLabel": "Equipe {{name}}",
      "newClientWorkspace": "Novo workspace de cliente",
      "clientWorkspaceTag": "Workspace de cliente",
      "statusInSetup": "Em montagem",
      "statusDelivered": "Entregue · {{date}}",
      "sections": {
        "yourTeams": {
          "label": "Suas equipes",
          "description": "Equipes das quais você faz parte"
        },
        "inSetup": {
          "label": "Workspaces de cliente · em montagem",
          "description": "Você é o dono até a transferência"
        },
        "delivered": {
          "label": "Workspaces de cliente · entregues",
          "description": "Pertence ao cliente · você mantém acesso de administrador"
        },
        "pendingInvites": {
          "label": "Convites pendentes",
          "description": "Aguardando sua resposta"
        }
      },
      "empty": {
        "noTeams": {
          "title": "Você ainda não está em nenhuma equipe",
          "text": "Crie uma ou aceite um convite.",
          "action": "Criar equipe"
        },
        "noneInSetup": {
          "title": "Nada em montagem",
          "text": "Comece um workspace para montar para um cliente.",
          "action": "Novo workspace"
        },
        "noneDelivered": {
          "title": "Nada entregue ainda",
          "text": "Os workspaces aparecem aqui após a transferência."
        }
      }
    },
    "detail": {
      "allTeams": "Todas as equipes",
      "inviteMembers": "Convidar membros",
      "editTeam": "Editar equipe",
      "switchTeam": "Trocar de equipe",
      "switchShort": "Trocar",
      "metaMembers_one": "{{count}} membro",
      "metaMembers_other": "{{count}} membros",
      "metaPending": "{{count}} pendente(s)",
      "metaOwner": "Proprietário {{owner}}",
      "metaOwnedByYouUntilHandoff": "Sua até a transferência"
    },
    "members": {
      "tabMembers": "Membros",
      "tabPending": "Pendentes",
      "tabBilling": "Faturamento",
      "searchMembers": "Buscar membros",
      "searchInvites": "Buscar convites",
      "colName": "NOME",
      "colEmail": "E-MAIL",
      "colTitle": "CARGO",
      "colRole": "PAPEL",
      "emptyMembers": "Nenhum membro encontrado",
      "emptyPending": "Nenhum convite pendente",
      "pending": "PENDENTE",
      "you": "VOCÊ",
      "noSeat": "Sem assento",
      "groupTeam": "Equipe",
      "groupConsultants": "Consultores",
      "groupSeatsNote": "{{seatsUsed}} de {{seatsTotal}} assentos",
      "groupConsultantsNote": "Acesso de administrador · não cobrado · sem uso de assento",
      "invitedAs": "Convidado como {{role}}",
      "removeConfirmTitle": "Remover membro",
      "removeConfirmDescription": "Remover {{name}} desta equipe? Essa pessoa perderá o acesso à caixa de entrada compartilhada e às tarefas da equipe.",
      "removeConfirmAction": "Remover",
      "cancelConfirmTitle": "Cancelar convite",
      "cancelConfirmDescription": "Cancelar o convite para {{email}}? Essa pessoa não poderá mais entrar com este convite."
    },
    "handoff": {
      "title": "Transferência",
      "subtitleOnce": "Uma vez por workspace · não pode ser desfeita",
      "subtitleCompleted": "Concluída em {{date}}",
      "cta": "Transferir para o cliente…",
      "steps": {
        "setup": "Montagem",
        "ownerInvite": "Convite do dono",
        "delivered": "Entregue"
      },
      "status": {
        "settingUp": "Em montagem",
        "ownerInviteSent": "Convite de dono enviado",
        "delivered": "Entregue"
      },
      "settingUp": {
        "intro": "Este workspace é seu durante a montagem e organização. Quando estiver pronto, convide o cliente como novo dono. No momento em que aceitar:",
        "bullets": [
          "O cliente se torna o dono",
          "Você continua como consultor com acesso de administrador, sem usar assento",
          "O período de avaliação é reiniciado para o cliente",
          "Nenhum outro consultor pode ser adicionado"
        ]
      },
      "awaiting": {
        "invitedAs": "Convidado como {{role}} · {{time}}",
        "copy": "Nada muda até que aceitem. Você continua dono do workspace e pode seguir trabalhando nele. Por enquanto, você ainda pode adicionar consultores.",
        "cancel": "Cancelar convite",
        "resend": "Reenviar convite"
      },
      "delivered": {
        "acceptedOn": "Aceito em {{date}} · o período de avaliação foi reiniciado nesse dia",
        "copyConsultant": "Você tem acesso de administrador como consultor e não usa um assento. Sair do workspace está na zona de perigo abaixo.",
        "copyOwner": "Agora você é o dono deste workspace. Os consultores mantêm acesso de administrador para te ajudar, sem usar um assento.",
        "lockedNote": "Não é mais possível adicionar consultores a este workspace.",
        "dismissAriaLabel": "Dispensar cartão de transferência",
        "dismissError": "Não foi possível dispensar este cartão. Tente novamente."
      }
    },
    "undo": {
      "accepted": "Você entrou em {{team}}",
      "declined": "Convite para {{team}} recusado",
      "roleChanged": "{{name}} agora é {{role}}",
      "error": "Algo deu errado. Tente novamente.",
      "resent": "Convite reenviado para {{email}}",
      "resending": "Reenviando convite para {{email}}..."
    },
    "memberMenu": {
      "ariaLabel": "Ações do membro",
      "makeAdmin": "Tornar administrador",
      "setMember": "Definir como membro",
      "setViewer": "Definir como visualizador",
      "remove": "Remover da equipe",
      "resend": "Reenviar convite",
      "cancel": "Cancelar convite"
    },
    "dangerZone": {
      "deleteTitle": "Excluir esta equipe",
      "deleteDescription": "Remove permanentemente a equipe e todos os seus dados. Isso não pode ser desfeito.",
      "deleteAction": "Excluir equipe",
      "leaveTitle": "Sair desta equipe",
      "leaveDescription": "Você perderá o acesso à caixa de entrada compartilhada e às tarefas desta equipe.",
      "leaveAction": "Sair da equipe",
      "deleteConfirmDescription": "Isso remove permanentemente {{teamName}} e todos os seus dados compartilhados para todos os membros. Esta ação não pode ser desfeita.",
      "leaveConfirmDescription": "Tem certeza de que deseja sair de {{teamName}}? Você perderá o acesso à caixa de entrada compartilhada e às tarefas da equipe. Isso não pode ser desfeito.",
      "confirmCancel": "Cancelar"
    },
    "inviteModal": {
      "title": "Convidar membros",
      "subtitle": "Cada pessoa receberá um e-mail para entrar em {{teamName}}",
      "emailLabel": "Endereço de e-mail",
      "emailPlaceholder": "nome@empresa.com",
      "roleLabel": "Função",
      "addAnother": "Adicionar outro",
      "send": "Enviar convite",
      "sendMultiple": "Enviar {{count}} convites",
      "removeInvitee": "Remover {{email}}",
      "consultantHint": "Pode convidar membros, editar o workspace e transferi-lo com você."
    },
    "inviteRoles": {
      "owner": {
        "name": "Proprietário",
        "description": "Propriedade total do workspace, incluindo a cobrança"
      },
      "admin": {
        "name": "Administrador",
        "description": "Gerenciar membros, configurações e cobrança"
      },
      "member": {
        "name": "Membro",
        "description": "Criar, atribuir e colaborar em tarefas"
      },
      "viewer": {
        "name": "Visualizador",
        "description": "Visualizar tarefas e atividades da equipe, sem editar"
      },
      "consultant": {
        "name": "Consultor",
        "description": "Acesso de administrador para ajudar a montar o espaço, sem ocupar um assento"
      }
    },
    "modal": {
      "createTitleTeam": "Criar uma equipe",
      "createSubtitleTeam": "Configure agora — você pode convidar pessoas logo em seguida.",
      "createTitleClient": "Criar um workspace de cliente",
      "createSubtitleClient": "Você monta como consultor e transfere para o cliente.",
      "editTitle": "Editar equipe",
      "editSubtitle": "Atualize o nome e a cor do ícone da sua equipe.",
      "typeSelector": {
        "label": "Para quem é isso?",
        "team": {
          "title": "Minha equipe",
          "description": "Você é o dono e ocupa um assento."
        },
        "client": {
          "title": "Um cliente",
          "description": "Você monta como consultor e depois transfere."
        }
      },
      "nameLabelTeam": "Nome da equipe",
      "namePlaceholderTeam": "ex.: Marketing Ops",
      "nameLabelClient": "Nome do cliente ou workspace",
      "namePlaceholderClient": "ex.: Acme Corp",
      "colorLabel": "Cor do ícone",
      "previewFallbackTeam": "Nova equipe",
      "previewFallbackClient": "Novo workspace de cliente",
      "previewMetaTeamCreate": "Proprietário · Você · 1 membro",
      "previewMetaClientCreate": "Consultor · Você · O cliente se torna dono na transferência",
      "save": "Salvar alterações",
      "createTeam": "Criar equipe",
      "createClientWorkspace": "Criar workspace de cliente",
      "handoff": {
        "title": "Transferir {{teamName}}",
        "subtitle": "Convide o cliente como o novo dono.",
        "emailLabel": "Email do cliente",
        "emailPlaceholder": "nome@cliente.com",
        "emailHint": "Ele(a) receberá um convite para entrar como Dono.",
        "consequences": {
          "title": "Quando aceitarem",
          "bullets": [
            "Eles se tornam donos e você se torna consultor com acesso de administrador",
            "O período de avaliação deles é reiniciado",
            "Nenhum outro consultor pode ser adicionado"
          ]
        },
        "confirmLabel": "Entendo que isso acontece somente uma vez e não pode ser desfeito.",
        "submit": "Enviar convite de dono"
      }
    },
    "toasts": {
      "created": "Equipe criada com sucesso.",
      "consultingCreated": "Espaço do cliente criado.",
      "updated": "Equipe atualizada com sucesso.",
      "deleted": "Equipe excluída.",
      "left": "Você saiu da equipe.",
      "invitesSent": "Convites enviados.",
      "invitesSentPartial": "{{sent}} de {{total}} convites enviados.",
      "inviteCancelled": "Convite cancelado.",
      "inviteResent": "Convite reenviado.",
      "inviteResendThrottled": "Este convite já foi enviado recentemente. Tente novamente em alguns minutos.",
      "memberRemoved": "Membro removido.",
      "roleUpdated": "Função atualizada.",
      "errorCreate": "Falha ao criar a equipe. Tente novamente.",
      "errorUpdate": "Falha ao atualizar a equipe. Tente novamente.",
      "errorDelete": "Falha ao excluir a equipe. Tente novamente.",
      "errorLeave": "Falha ao sair da equipe. Tente novamente.",
      "errorInvitesSend": "Falha ao enviar os convites. Tente novamente.",
      "errorInviteCancel": "Falha ao cancelar o convite. Tente novamente.",
      "errorInviteResend": "Falha ao reenviar o convite. Tente novamente.",
      "errorRemoveMember": "Falha ao remover o membro. Tente novamente.",
      "errorRoleUpdate": "Falha ao atualizar a função. Tente novamente.",
      "errorLoad": "Falha ao carregar os dados da equipe. Tente novamente.",
      "errorAcceptInvite": "Falha ao aceitar o convite. Tente novamente.",
      "errorDeclineInvite": "Falha ao recusar o convite. Tente novamente.",
      "declined": "Convite recusado.",
      "inviteFailure": {
        "MISSING_EMAIL": "É necessário um endereço de e-mail para enviar o convite.",
        "SELF_INVITE": "Você não pode convidar a si mesmo para um time.",
        "ROLE_NOT_ASSIGNABLE": "Esse papel não pode ser concedido por convite.",
        "TEAM_NOT_ACCESSIBLE": "Você não tem permissão para convidar membros para este time.",
        "ALREADY_MEMBER": "Esta pessoa já é membro do time.",
        "INVITEE_NOT_CONSULTANT": "Esta pessoa não possui a designação de consultor da plataforma.",
        "UNKNOWN": "Não foi possível enviar o convite. Tente novamente."
      },
      "inviteReopenedNotSent": "Convite reaberto para {{email}}, mas nenhum e-mail foi enviado — ele já havia sido enviado recentemente.",
      "invitesFailedDetail": "Não foi possível convidar {{email}}: {{reason}}",
      "invitesSentPartialDetail": "{{sent}} de {{total}} convites enviados. {{failures}}",
      "inviteAlreadyPending": "O convite para {{email}} já está pendente — foi enviado recentemente, então nenhum novo e-mail saiu."
    },
    "billing": {
      "status": {
        "active": "Ativo",
        "trialing": "Teste",
        "pastDue": "Pagamento pendente"
      },
      "pastDueBanner": {
        "title": "Não conseguimos processar seu último pagamento",
        "genericReason": "Atualize sua forma de pagamento para manter sua assinatura ativa.",
        "retryNotice": "Tentaremos novamente em {{date}}.",
        "cta": "Atualizar forma de pagamento"
      },
      "planCard": {
        "changePlan": "Mudar de plano",
        "manageInStripe": "Gerenciar faturamento no Stripe",
        "trialEndsNotice": "Seu período de teste termina em {{date}}.",
        "cancelScheduledNotice": "Seu plano será cancelado em {{date}}. Você manterá o acesso até lá.",
        "nextInvoice": "Próxima fatura: {{amount}} em {{date}}",
        "currentPeriod": "Período atual: {{start}} – {{end}}",
        "billingContact": "Contato de faturamento: {{email}}",
        "priceSuffix": "/usuário/{{interval}}"
      },
      "seats": {
        "title": "Assentos",
        "editorsBreakdown": "{{count}} editores cobrados",
        "prorationNote": "Adicionar ou remover membros atualiza sua fatura de forma proporcional (prorata).",
        "usedOf": "{{used}} de {{total}} usados",
        "inUse": "Assentos em uso",
        "consultants": "Consultores",
        "consultantsSuffix": "sem assento",
        "consultantNote": "Consultores têm acesso de administrador, mas não usam assento e não são cobrados. Só membros adicionados pela sua equipe contam para o plano."
      },
      "starter": {
        "title": "Você está no plano Starter",
        "subtitle": "Faça upgrade para o Team e desbloqueie sugestões ilimitadas do DoBox e muito mais.",
        "trial": {
          "title_one": "Seu período de teste termina em {{count}} dia",
          "title_other": "Seu período de teste termina em {{count}} dias",
          "subtitle": "Adicione um cartão antes de {{date}} para manter os recursos do Team."
        },
        "expired": {
          "notice": "Seu período de teste expirou. Faça upgrade quando quiser para desbloquear os recursos do Team novamente."
        }
      },
      "cancel": {
        "sectionTitle": "Cancelar assinatura",
        "sectionDescription": "Cancele sua assinatura do Team. Você perderá o acesso aos recursos do Team no fim do período de faturamento.",
        "action": "Cancelar assinatura",
        "confirmTitle": "Cancelar assinatura",
        "confirmDescription": "Você manterá o acesso aos recursos do Team até {{date}}, quando sua equipe passará para o Starter.",
        "confirmDescriptionNoDate": "Você manterá o acesso aos recursos do Team até o fim do período de faturamento atual, quando sua equipe passará para o Starter.",
        "confirmAction": "Cancelar assinatura"
      },
      "finalizing": {
        "title": "Finalizando seu upgrade...",
        "message": "Isso pode levar alguns segundos enquanto confirmamos seu pagamento."
      },
      "toasts": {
        "checkoutError": "Não foi possível iniciar o checkout. Tente novamente.",
        "portalError": "Não foi possível abrir o portal de faturamento. Tente novamente.",
        "cancelSuccess": "Sua assinatura será cancelada no fim do período de faturamento.",
        "cancelError": "Falha ao cancelar sua assinatura. Tente novamente.",
        "loadError": "Falha ao carregar os detalhes de faturamento. Tente novamente."
      }
    }
  },
  "churn": {
    "title": "Cancelamentos",
    "subtitle": "Por que as pessoas excluíram a conta, e o que tinham construído até ali.",
    "loading": "Carregando exclusões…",
    "empty": "Nenhuma conta excluída neste período.",
    "emptyBody": "Só contas de teste foram excluídas nessas datas. Ative contas internas e de teste para inspecioná-las.",
    "error": "Não foi possível carregar as exclusões de conta.",
    "rangeCaption": "{{start}} – {{end}} · segue o período do cabeçalho",
    "filters": {
      "includeTestAccounts": "Incluir contas internas e de teste"
    },
    "kpis": {
      "deletions": "Exclusões",
      "deletionsSub": "{{count}} conta de teste",
      "deletionsSub_other": "{{count}} contas de teste",
      "topReason": "Motivo principal",
      "topReasonSub": "{{percent}}%",
      "source": "Origem",
      "sourceSub": "{{count}} de {{total}}"
    },
    "reasons": {
      "cardTitle": "Motivos informados",
      "multiReason": "uma exclusão pode ter vários motivos",
      "count": "{{count}} · {{percent}}%",
      "tooExpensive": "Muito caro",
      "missingIntegration": "Faltava uma integração",
      "aiNotUseful": "A IA não foi útil",
      "tooComplex": "Complexo demais",
      "switchingTool": "Mudando para outra ferramenta",
      "notUsingEnough": "Não usava o suficiente",
      "privacy": "Preocupações com privacidade",
      "other": "Outro",
      "noReasonGiven": "Sem motivo informado"
    },
    "sources": {
      "userModal": "Modal de exclusão",
      "clerkWebhook": "Webhook do Clerk",
      "admin": "Admin",
      "unattributed": "Sem atribuição"
    },
    "counts": {
      "agentConversations": "conversas",
      "agentExecutionHistory": "histórico de execução",
      "agentRuns": "execuções de agente",
      "agentTemplates": "templates",
      "aiUsage": "uso de IA",
      "artifacts": "artefatos",
      "chatSessions": "chats",
      "communicationAgents": "flows",
      "contacts": "contatos",
      "doBoxConfigs": "DoBox configs",
      "emailCounters": "contadores",
      "evalConfig": "eval config",
      "flowExecution": "execuções de flow",
      "flowGenerationJobs": "jobs de flow",
      "flowGroups": "flow groups",
      "generatedImages": "imagens",
      "google": "Google",
      "integrationRequests": "pedidos de integração",
      "knowledgeFavorites": "favoritos",
      "knowledgeSpaces": "espaços",
      "localDevices": "dispositivos",
      "mcpConnections": "MCP",
      "meetingPolls": "enquetes",
      "metaCredentials": "Meta",
      "microsoft": "Microsoft",
      "notifications": "notificações",
      "outlookFolderCache": "Outlook cache",
      "peopleAndActivity": "pessoas",
      "pushSubscriptions": "push",
      "scanJobs": "scan jobs",
      "scheduledEmails": "e-mails agendados",
      "sessions": "sessões",
      "slack": "Slack",
      "slackWorkspaceCache": "Slack cache",
      "snoozedEmails": "e-mails adiados",
      "taskGroups": "task groups",
      "teamInvites": "convites",
      "teamRequests": "pedidos",
      "telegram": "Telegram",
      "unreadItems": "não lidos",
      "userAttachments": "anexos",
      "userCommunicationsSwept": "mensagens restantes",
      "webSocketConnections": "conexões",
      "workflowRecommendations": "recomendações"
    },
    "billingState": {
      "ACTIVE": "Pagante",
      "TRIALING": "Trial Stripe",
      "PAST_DUE": "Em atraso",
      "STARTER": "Gratuito",
      "APP_TRIAL": "Em trial",
      "APP_TRIAL_EXPIRED": "Trial expirado"
    },
    "table": {
      "title": "Exclusões",
      "purgedNote": "dados purgados na exclusão · contagens são o último snapshot",
      "noSnapshot": "Sem snapshot",
      "testAccount": "teste",
      "unknown": "Desconhecido",
      "none": "Nenhum",
      "teams": "Times",
      "owner": "dono",
      "doBox": "DoBox",
      "doBoxSummary": "{{total}} no total · {{resolved}} resolvidas · {{open}} em aberto",
      "doBoxSplit": "{{agent}} pela IA · {{manual}} manuais",
      "removed": "Removido na exclusão",
      "expandRow": "Expandir detalhes da exclusão",
      "collapseRow": "Recolher detalhes da exclusão"
    },
    "erase": {
      "action": "Apagar",
      "confirm": "Apagar este registro",
      "cancel": "Cancelar",
      "success": "Registro apagado.",
      "error": "Não foi possível apagar o registro. Tente novamente."
    }
  },
  "assistantMemory": {
    "title": "Memória do assistente",
    "unavailable": {
      "title": "A memória do assistente ainda não está disponível"
    },
    "tabs": {
      "rules": "Regras",
      "history": "Histórico",
      "routines": "Rotinas",
      "permissions": "Permissões"
    },
    "emptyState": {
      "rules": {
        "title": "Nenhuma regra lembrada ainda",
        "subtitle": "As regras que você pedir para o assistente sempre seguir aparecem aqui."
      },
      "history": {
        "title": "Nenhum histórico ainda",
        "subtitle": "Os resultados que o assistente registra ao trabalhar aparecem aqui."
      }
    },
    "loadMore": "Carregar mais",
    "loadError": "Não foi possível carregar a memória do assistente",
    "row": {
      "summaryLabel": "Resumo",
      "updated": "Atualizada {{time}}"
    },
    "actions": {
      "ariaLabel": "Ações da decisão",
      "edit": "Editar",
      "save": "Salvar",
      "cancel": "Cancelar",
      "confirm": "Confirmar",
      "pause": "Pausar",
      "resume": "Retomar",
      "forget": "Esquecer",
      "forgetConfirmQuestion": "Esquecer esta decisão? Isso não pode ser desfeito.",
      "forgetContact": "Esquecer tudo sobre {{contact}}",
      "forgetContactConfirmQuestion": "Esquecer tudo sobre {{contact}}? Isso não pode ser desfeito.",
      "neverSuggest": "Nunca sugerir para este contato",
      "defaultContact": "este contato"
    },
    "edit": {
      "placeholder": "O que o assistente deve sempre fazer?",
      "emptyError": "A instrução não pode ficar vazia"
    },
    "toast": {
      "editSuccess": "Regra atualizada",
      "editError": "Não foi possível atualizar esta regra",
      "pauseSuccess": "Regra pausada",
      "pauseError": "Não foi possível pausar esta regra",
      "resumeSuccess": "Regra retomada",
      "resumeError": "Não foi possível retomar esta regra",
      "forgetSuccess": "Esquecida",
      "forgetError": "Não foi possível esquecer esta decisão",
      "forgetContactSuccess_one": "{{count}} decisão esquecida sobre este contato",
      "forgetContactSuccess": "{{count}} decisões esquecidas sobre este contato",
      "forgetContactError": "Não foi possível esquecer as decisões sobre este contato",
      "neverSuggestSuccess": "Não vou mais sugerir para este contato",
      "neverSuggestError": "Não foi possível salvar isso"
    }
  }
}
